/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Basis-Entrypoint, registriert die verschiedenen Module auf der Seite
	 */
	
	/* Fehler-Logging */
	if (typeof window.Raven !== "undefined") {
	  Raven.setTagsContext({ app: "bootstrap" });
	  /* The magic variable will be replaced by the build system with a real hash */
	  if ('__RELEASE__CONTEXT__' !== (function () {
	    return '__RELEASE_' + '_CONTEXT__';
	  })()) {
	    Raven.setReleaseContext('__RELEASE__CONTEXT__');
	    window.Tramino.ReservaAppRelease = '__RELEASE__CONTEXT__';
	  } else {
	    Raven.setReleaseContext('staging');
	    window.Tramino.ReservaAppRelease = 'staging';
	  }
	
	  /* Make sure window.Tramino exists */
	  if (typeof window.Tramino === "undefined") {
	    var err = new Error("Missing window.Tramino");
	    Raven.captureException(err);
	    throw err;
	  }
	}
	
	/* Im Backend haben wir standardmäßg keine Sprache */
	if (!window.Tramino.lang) {
	  window.Tramino.lang = "de";
	}
	
	/* Schrottige Browser fixen, muss weit oben stehen */
	__webpack_require__(1);
	
	/* Module fürs Init */
	var $ = __webpack_require__(6);
	window._ = __webpack_require__(7);
	
	/* Alte Browser komplett blocken um Sentry-Fehler zu vermeiden */
	var old_ua = false;
	var ua = navigator.userAgent;
	
	if (ua.indexOf('BingPreview') !== -1) {
	  old_ua = "Dieser Browser ist nicht unterstützt.";
	}
	if (ua.indexOf('MSIE 8.0') !== -1) {
	  old_ua = "Der Internet Explorer 8.0 wird nicht mehr von Microsoft unterstützt. Bitte aktualisieren Sie diesen oder installieren Sie Firefox/Chrome auf Ihrem PC.";
	}
	
	/* Eingeloggte User haben immer ein Recht auf Schmerz */
	if (Tramino.user) old_ua = false;
	
	var IBE_compat = false;
	if (typeof window.InitIBEGlobal !== "undefined") {
	  IBE_compat = true;
	}
	
	if (!old_ua) {
	
	  /* Exportierte Module */
	  if (typeof window.moment === "undefined") {
	    window.moment = __webpack_require__(8);
	  }
	
	  if (!IBE_compat) {
	    // Prevent name clash with old IBE
	    window.ReservaApp = __webpack_require__(16);
	  }
	  window.BrowserApp = __webpack_require__(48);
	  window.TraminoCollectible = __webpack_require__(81);
	  window.TraminoSiteSearch = __webpack_require__(82);
	  window.Translator = __webpack_require__(18).singleton;
	  window.ScrollSpy = __webpack_require__(83);
	  window.MiniEngine = __webpack_require__(84);
	  window.ClientRatings = __webpack_require__(94);
	  window.TraminoClientsMap = __webpack_require__(37);
	  window.SafeStorage = __webpack_require__(23);
	  window.PriceTable = __webpack_require__(92);
	  window.ReservaInterestFilter = __webpack_require__(97);
	
	  //window.DateDisplaySingle = require('./display-test/main');
	  __webpack_require__(98);
	
	  window.__ = window.Translator.get;
	  window._P = window.Translator.plural;
	
	  /* Analytics */
	  var TraminoAnalytics = __webpack_require__(102);
	  window.TraminoAnalytics = new TraminoAnalytics($);
	
	  /* Storage täglich leeren um Probleme zu vermeiden */
	  if (!IBE_compat) {
	    var DateTime = __webpack_require__(40);
	    var lastClear = SafeStorage.local.get("LastClear");
	    var midnight = DateTime.resetTimeFields(new Date());
	
	    if (!lastClear || parseInt(lastClear, 10) < midnight) {
	      SafeStorage.local.clear();
	      SafeStorage.local.set("LastClear", +new Date());
	    }
	  }
	
	  /* Zusätzliche Referenzen für Entwickler */
	  window.TemplateCache = __webpack_require__(25);
	
	  if (typeof window.Backbone === "undefined") {
	    window.Backbone = __webpack_require__(20);
	  }
	
	  window.ReservaRegistry = __webpack_require__(26);
	  ReservaRegistry.setAll(__webpack_require__(103));
	
	  /* Templates laden */
	  __webpack_require__(52).register();
	
	  /* Übersetzer in allen Templates verfügbar machen */
	  var TemplateCache = __webpack_require__(25);
	  Translator.registerHelpers(TemplateCache);
	  Translator.learn("de", __webpack_require__(104));
	  Translator.learn("en", __webpack_require__(105));
	  Translator.learn("fr", __webpack_require__(106));
	
	  TemplateCache.helper("registry", function (key) {
	    return window.ReservaRegistry.get(key);
	  });
	  TemplateCache.helper("Customer", window.ReservaRegistry.get("Customer"));
	
	  /* Fix for development */
	  if (Tramino.lang === "no") {
	    Tramino.lang = "de";
	  }
	
	  /* Standardsprache für den Übersetzer */
	  Translator.setLanguage(Tramino.lang);
	
	  /* Und für Zeitangaben */
	  var locale = window.Tramino.lang;
	  if (!locale) locale = "de";
	  if (locale === "en") locale = "en-gb";
	  var active_locale = moment.locale(locale);
	  if (locale !== active_locale) {}
	
	  $(document).ready(function () {
	    /* Scrollspy Modul */
	    ScrollSpy.init();
	
	    /* Analytics */
	    $('div.analytics_static').each(function () {
	      var data = $(this).data();
	      if (data.page && data.betrieb && data.type) {
	        window.TraminoAnalytics.page = parseInt(data.page, 10);
	        window.TraminoAnalytics.send(parseInt(data.betrieb, 10), data.type, true);
	      } else {
	        var e = new Error("[TA] Found .analytics_static node but missing data-page, data-betrieb or data-type");
	        if (typeof window.Raven !== "undefined") {
	          Raven.captureException(e);
	        } else {
	          throw e;
	        }
	      }
	    });
	
	    /* SiteSearch */
	    __webpack_require__(107)();
	  });
	} else {
	  if (window.console && console.log) window['con' + 'sole'].log("Browser is marked as non-compatible, ignoring it");
	
	  $(document).ready(function () {
	    /* Falls wir in der vollen Gastgebersuche sind, zeigen wir unsere Warnung an */
	    var container = $('.ibe-container #tab-list');
	    if (container.length) {
	      container.html("<p><b>Ihr Webbrowser ist veraltet und kann von uns leider nicht mehr unterstützt werden:</b><br><br>" + old_ua + "</p>");
	    }
	
	    /* Sonstige Buttons besser anzeigen */
	    $('#reserva_datepicker_display').text("Nicht unterstützt");
	    $('#reserva_people_display').text("Nicht unterstützt");
	  });
	}

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Enthält Polyfills um Schrottige Browser auf Trab zu bringen
	 */
	
	/**
	 * Function.bind is not available in IE8/Android 2.3
	 */
	'use strict';
	
	if (!Function.prototype.bind) {
	  Function.prototype.bind = function (oThis) {
	    if (typeof this !== 'function') {
	      // closest thing possible to the ECMAScript 5
	      // internal IsCallable function
	      throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
	    }
	
	    var aArgs = Array.prototype.slice.call(arguments, 1),
	        fToBind = this,
	        fNOP = function fNOP() {},
	        fBound = function fBound() {
	      return fToBind.apply(this instanceof fNOP && oThis ? this : oThis, aArgs.concat(Array.prototype.slice.call(arguments)));
	    };
	
	    fNOP.prototype = this.prototype;
	    fBound.prototype = new fNOP();
	
	    return fBound;
	  };
	}
	
	/**
	 * Promises ist noch ein relativ neues Feature
	 */
	if (typeof window.Promise === "undefined") {
	  window.Promise = __webpack_require__(2);
	}
	
	/**
	 * Falls der Browser keine Konsole hat
	 * Nur für Entwickler-Builds wichtig, in Produktion werden alle console.log durch webpack entfernt.
	 */
	var method,
	    methods = ['assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error', 'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log', 'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd', 'timeStamp', 'trace', 'warn'],
	    length = methods.length,
	    console = window.console = window.console || {};
	while (length--) {
	  method = methods[length];
	  !console[method] && (console[method] = function () {});
	}

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate) {(function(root) {
	
		// Store setTimeout reference so promise-polyfill will be unaffected by
		// other code modifying setTimeout (like sinon.useFakeTimers())
		var setTimeoutFunc = setTimeout;
	
		// Use polyfill for setImmediate for performance gains
		var asap = (typeof setImmediate === 'function' && setImmediate) ||
			function(fn) { setTimeoutFunc(fn, 1); };
	
		// Polyfill for Function.prototype.bind
		function bind(fn, thisArg) {
			return function() {
				fn.apply(thisArg, arguments);
			}
		}
	
		var isArray = Array.isArray || function(value) { return Object.prototype.toString.call(value) === "[object Array]" };
	
		function Promise(fn) {
			if (typeof this !== 'object') throw new TypeError('Promises must be constructed via new');
			if (typeof fn !== 'function') throw new TypeError('not a function');
			this._state = null;
			this._value = null;
			this._deferreds = []
	
			doResolve(fn, bind(resolve, this), bind(reject, this))
		}
	
		function handle(deferred) {
			var me = this;
			if (this._state === null) {
				this._deferreds.push(deferred);
				return
			}
			asap(function() {
				var cb = me._state ? deferred.onFulfilled : deferred.onRejected
				if (cb === null) {
					(me._state ? deferred.resolve : deferred.reject)(me._value);
					return;
				}
				var ret;
				try {
					ret = cb(me._value);
				}
				catch (e) {
					deferred.reject(e);
					return;
				}
				deferred.resolve(ret);
			})
		}
	
		function resolve(newValue) {
			try { //Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
				if (newValue === this) throw new TypeError('A promise cannot be resolved with itself.');
				if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
					var then = newValue.then;
					if (typeof then === 'function') {
						doResolve(bind(then, newValue), bind(resolve, this), bind(reject, this));
						return;
					}
				}
				this._state = true;
				this._value = newValue;
				finale.call(this);
			} catch (e) { reject.call(this, e); }
		}
	
		function reject(newValue) {
			this._state = false;
			this._value = newValue;
			finale.call(this);
		}
	
		function finale() {
			for (var i = 0, len = this._deferreds.length; i < len; i++) {
				handle.call(this, this._deferreds[i]);
			}
			this._deferreds = null;
		}
	
		function Handler(onFulfilled, onRejected, resolve, reject){
			this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
			this.onRejected = typeof onRejected === 'function' ? onRejected : null;
			this.resolve = resolve;
			this.reject = reject;
		}
	
		/**
		 * Take a potentially misbehaving resolver function and make sure
		 * onFulfilled and onRejected are only called once.
		 *
		 * Makes no guarantees about asynchrony.
		 */
		function doResolve(fn, onFulfilled, onRejected) {
			var done = false;
			try {
				fn(function (value) {
					if (done) return;
					done = true;
					onFulfilled(value);
				}, function (reason) {
					if (done) return;
					done = true;
					onRejected(reason);
				})
			} catch (ex) {
				if (done) return;
				done = true;
				onRejected(ex);
			}
		}
	
		Promise.prototype['catch'] = function (onRejected) {
			return this.then(null, onRejected);
		};
	
		Promise.prototype.then = function(onFulfilled, onRejected) {
			var me = this;
			return new Promise(function(resolve, reject) {
				handle.call(me, new Handler(onFulfilled, onRejected, resolve, reject));
			})
		};
	
		Promise.all = function () {
			var args = Array.prototype.slice.call(arguments.length === 1 && isArray(arguments[0]) ? arguments[0] : arguments);
	
			return new Promise(function (resolve, reject) {
				if (args.length === 0) return resolve([]);
				var remaining = args.length;
				function res(i, val) {
					try {
						if (val && (typeof val === 'object' || typeof val === 'function')) {
							var then = val.then;
							if (typeof then === 'function') {
								then.call(val, function (val) { res(i, val) }, reject);
								return;
							}
						}
						args[i] = val;
						if (--remaining === 0) {
							resolve(args);
						}
					} catch (ex) {
						reject(ex);
					}
				}
				for (var i = 0; i < args.length; i++) {
					res(i, args[i]);
				}
			});
		};
	
		Promise.resolve = function (value) {
			if (value && typeof value === 'object' && value.constructor === Promise) {
				return value;
			}
	
			return new Promise(function (resolve) {
				resolve(value);
			});
		};
	
		Promise.reject = function (value) {
			return new Promise(function (resolve, reject) {
				reject(value);
			});
		};
	
		Promise.race = function (values) {
			return new Promise(function (resolve, reject) {
				for(var i = 0, len = values.length; i < len; i++) {
					values[i].then(resolve, reject);
				}
			});
		};
	
		/**
		 * Set the immediate function to execute callbacks
		 * @param fn {function} Function to execute
		 * @private
		 */
		Promise._setImmediateFn = function _setImmediateFn(fn) {
			asap = fn;
		};
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = Promise;
		} else if (!root.Promise) {
			root.Promise = Promise;
		}
	
	})(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3).setImmediate))

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(4);
	exports.setImmediate = setImmediate;
	exports.clearImmediate = clearImmediate;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(5)))

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 6 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = window.$;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
	//     http://underscorejs.org
	//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	//     Underscore may be freely distributed under the MIT license.
	
	(function() {
	
	  // Baseline setup
	  // --------------
	
	  // Establish the root object, `window` in the browser, or `exports` on the server.
	  var root = this;
	
	  // Save the previous value of the `_` variable.
	  var previousUnderscore = root._;
	
	  // Save bytes in the minified (but not gzipped) version:
	  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;
	
	  // Create quick reference variables for speed access to core prototypes.
	  var
	    push             = ArrayProto.push,
	    slice            = ArrayProto.slice,
	    toString         = ObjProto.toString,
	    hasOwnProperty   = ObjProto.hasOwnProperty;
	
	  // All **ECMAScript 5** native function implementations that we hope to use
	  // are declared here.
	  var
	    nativeIsArray      = Array.isArray,
	    nativeKeys         = Object.keys,
	    nativeBind         = FuncProto.bind,
	    nativeCreate       = Object.create;
	
	  // Naked function reference for surrogate-prototype-swapping.
	  var Ctor = function(){};
	
	  // Create a safe reference to the Underscore object for use below.
	  var _ = function(obj) {
	    if (obj instanceof _) return obj;
	    if (!(this instanceof _)) return new _(obj);
	    this._wrapped = obj;
	  };
	
	  // Export the Underscore object for **Node.js**, with
	  // backwards-compatibility for the old `require()` API. If we're in
	  // the browser, add `_` as a global object.
	  if (true) {
	    if (typeof module !== 'undefined' && module.exports) {
	      exports = module.exports = _;
	    }
	    exports._ = _;
	  } else {
	    root._ = _;
	  }
	
	  // Current version.
	  _.VERSION = '1.8.3';
	
	  // Internal function that returns an efficient (for current engines) version
	  // of the passed-in callback, to be repeatedly applied in other Underscore
	  // functions.
	  var optimizeCb = function(func, context, argCount) {
	    if (context === void 0) return func;
	    switch (argCount == null ? 3 : argCount) {
	      case 1: return function(value) {
	        return func.call(context, value);
	      };
	      case 2: return function(value, other) {
	        return func.call(context, value, other);
	      };
	      case 3: return function(value, index, collection) {
	        return func.call(context, value, index, collection);
	      };
	      case 4: return function(accumulator, value, index, collection) {
	        return func.call(context, accumulator, value, index, collection);
	      };
	    }
	    return function() {
	      return func.apply(context, arguments);
	    };
	  };
	
	  // A mostly-internal function to generate callbacks that can be applied
	  // to each element in a collection, returning the desired result — either
	  // identity, an arbitrary callback, a property matcher, or a property accessor.
	  var cb = function(value, context, argCount) {
	    if (value == null) return _.identity;
	    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
	    if (_.isObject(value)) return _.matcher(value);
	    return _.property(value);
	  };
	  _.iteratee = function(value, context) {
	    return cb(value, context, Infinity);
	  };
	
	  // An internal function for creating assigner functions.
	  var createAssigner = function(keysFunc, undefinedOnly) {
	    return function(obj) {
	      var length = arguments.length;
	      if (length < 2 || obj == null) return obj;
	      for (var index = 1; index < length; index++) {
	        var source = arguments[index],
	            keys = keysFunc(source),
	            l = keys.length;
	        for (var i = 0; i < l; i++) {
	          var key = keys[i];
	          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
	        }
	      }
	      return obj;
	    };
	  };
	
	  // An internal function for creating a new object that inherits from another.
	  var baseCreate = function(prototype) {
	    if (!_.isObject(prototype)) return {};
	    if (nativeCreate) return nativeCreate(prototype);
	    Ctor.prototype = prototype;
	    var result = new Ctor;
	    Ctor.prototype = null;
	    return result;
	  };
	
	  var property = function(key) {
	    return function(obj) {
	      return obj == null ? void 0 : obj[key];
	    };
	  };
	
	  // Helper for collection methods to determine whether a collection
	  // should be iterated as an array or as an object
	  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
	  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
	  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
	  var getLength = property('length');
	  var isArrayLike = function(collection) {
	    var length = getLength(collection);
	    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
	  };
	
	  // Collection Functions
	  // --------------------
	
	  // The cornerstone, an `each` implementation, aka `forEach`.
	  // Handles raw objects in addition to array-likes. Treats all
	  // sparse array-likes as if they were dense.
	  _.each = _.forEach = function(obj, iteratee, context) {
	    iteratee = optimizeCb(iteratee, context);
	    var i, length;
	    if (isArrayLike(obj)) {
	      for (i = 0, length = obj.length; i < length; i++) {
	        iteratee(obj[i], i, obj);
	      }
	    } else {
	      var keys = _.keys(obj);
	      for (i = 0, length = keys.length; i < length; i++) {
	        iteratee(obj[keys[i]], keys[i], obj);
	      }
	    }
	    return obj;
	  };
	
	  // Return the results of applying the iteratee to each element.
	  _.map = _.collect = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length,
	        results = Array(length);
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      results[index] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  };
	
	  // Create a reducing function iterating left or right.
	  function createReduce(dir) {
	    // Optimized iterator function as using arguments.length
	    // in the main function will deoptimize the, see #1991.
	    function iterator(obj, iteratee, memo, keys, index, length) {
	      for (; index >= 0 && index < length; index += dir) {
	        var currentKey = keys ? keys[index] : index;
	        memo = iteratee(memo, obj[currentKey], currentKey, obj);
	      }
	      return memo;
	    }
	
	    return function(obj, iteratee, memo, context) {
	      iteratee = optimizeCb(iteratee, context, 4);
	      var keys = !isArrayLike(obj) && _.keys(obj),
	          length = (keys || obj).length,
	          index = dir > 0 ? 0 : length - 1;
	      // Determine the initial value if none is provided.
	      if (arguments.length < 3) {
	        memo = obj[keys ? keys[index] : index];
	        index += dir;
	      }
	      return iterator(obj, iteratee, memo, keys, index, length);
	    };
	  }
	
	  // **Reduce** builds up a single result from a list of values, aka `inject`,
	  // or `foldl`.
	  _.reduce = _.foldl = _.inject = createReduce(1);
	
	  // The right-associative version of reduce, also known as `foldr`.
	  _.reduceRight = _.foldr = createReduce(-1);
	
	  // Return the first value which passes a truth test. Aliased as `detect`.
	  _.find = _.detect = function(obj, predicate, context) {
	    var key;
	    if (isArrayLike(obj)) {
	      key = _.findIndex(obj, predicate, context);
	    } else {
	      key = _.findKey(obj, predicate, context);
	    }
	    if (key !== void 0 && key !== -1) return obj[key];
	  };
	
	  // Return all the elements that pass a truth test.
	  // Aliased as `select`.
	  _.filter = _.select = function(obj, predicate, context) {
	    var results = [];
	    predicate = cb(predicate, context);
	    _.each(obj, function(value, index, list) {
	      if (predicate(value, index, list)) results.push(value);
	    });
	    return results;
	  };
	
	  // Return all the elements for which a truth test fails.
	  _.reject = function(obj, predicate, context) {
	    return _.filter(obj, _.negate(cb(predicate)), context);
	  };
	
	  // Determine whether all of the elements match a truth test.
	  // Aliased as `all`.
	  _.every = _.all = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (!predicate(obj[currentKey], currentKey, obj)) return false;
	    }
	    return true;
	  };
	
	  // Determine if at least one element in the object matches a truth test.
	  // Aliased as `any`.
	  _.some = _.any = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (predicate(obj[currentKey], currentKey, obj)) return true;
	    }
	    return false;
	  };
	
	  // Determine if the array or object contains a given item (using `===`).
	  // Aliased as `includes` and `include`.
	  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
	    if (!isArrayLike(obj)) obj = _.values(obj);
	    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
	    return _.indexOf(obj, item, fromIndex) >= 0;
	  };
	
	  // Invoke a method (with arguments) on every item in a collection.
	  _.invoke = function(obj, method) {
	    var args = slice.call(arguments, 2);
	    var isFunc = _.isFunction(method);
	    return _.map(obj, function(value) {
	      var func = isFunc ? method : value[method];
	      return func == null ? func : func.apply(value, args);
	    });
	  };
	
	  // Convenience version of a common use case of `map`: fetching a property.
	  _.pluck = function(obj, key) {
	    return _.map(obj, _.property(key));
	  };
	
	  // Convenience version of a common use case of `filter`: selecting only objects
	  // containing specific `key:value` pairs.
	  _.where = function(obj, attrs) {
	    return _.filter(obj, _.matcher(attrs));
	  };
	
	  // Convenience version of a common use case of `find`: getting the first object
	  // containing specific `key:value` pairs.
	  _.findWhere = function(obj, attrs) {
	    return _.find(obj, _.matcher(attrs));
	  };
	
	  // Return the maximum element (or element-based computation).
	  _.max = function(obj, iteratee, context) {
	    var result = -Infinity, lastComputed = -Infinity,
	        value, computed;
	    if (iteratee == null && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value > result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Return the minimum element (or element-based computation).
	  _.min = function(obj, iteratee, context) {
	    var result = Infinity, lastComputed = Infinity,
	        value, computed;
	    if (iteratee == null && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value < result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed < lastComputed || computed === Infinity && result === Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Shuffle a collection, using the modern version of the
	  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
	  _.shuffle = function(obj) {
	    var set = isArrayLike(obj) ? obj : _.values(obj);
	    var length = set.length;
	    var shuffled = Array(length);
	    for (var index = 0, rand; index < length; index++) {
	      rand = _.random(0, index);
	      if (rand !== index) shuffled[index] = shuffled[rand];
	      shuffled[rand] = set[index];
	    }
	    return shuffled;
	  };
	
	  // Sample **n** random values from a collection.
	  // If **n** is not specified, returns a single random element.
	  // The internal `guard` argument allows it to work with `map`.
	  _.sample = function(obj, n, guard) {
	    if (n == null || guard) {
	      if (!isArrayLike(obj)) obj = _.values(obj);
	      return obj[_.random(obj.length - 1)];
	    }
	    return _.shuffle(obj).slice(0, Math.max(0, n));
	  };
	
	  // Sort the object's values by a criterion produced by an iteratee.
	  _.sortBy = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    return _.pluck(_.map(obj, function(value, index, list) {
	      return {
	        value: value,
	        index: index,
	        criteria: iteratee(value, index, list)
	      };
	    }).sort(function(left, right) {
	      var a = left.criteria;
	      var b = right.criteria;
	      if (a !== b) {
	        if (a > b || a === void 0) return 1;
	        if (a < b || b === void 0) return -1;
	      }
	      return left.index - right.index;
	    }), 'value');
	  };
	
	  // An internal function used for aggregate "group by" operations.
	  var group = function(behavior) {
	    return function(obj, iteratee, context) {
	      var result = {};
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index) {
	        var key = iteratee(value, index, obj);
	        behavior(result, value, key);
	      });
	      return result;
	    };
	  };
	
	  // Groups the object's values by a criterion. Pass either a string attribute
	  // to group by, or a function that returns the criterion.
	  _.groupBy = group(function(result, value, key) {
	    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
	  });
	
	  // Indexes the object's values by a criterion, similar to `groupBy`, but for
	  // when you know that your index values will be unique.
	  _.indexBy = group(function(result, value, key) {
	    result[key] = value;
	  });
	
	  // Counts instances of an object that group by a certain criterion. Pass
	  // either a string attribute to count by, or a function that returns the
	  // criterion.
	  _.countBy = group(function(result, value, key) {
	    if (_.has(result, key)) result[key]++; else result[key] = 1;
	  });
	
	  // Safely create a real, live array from anything iterable.
	  _.toArray = function(obj) {
	    if (!obj) return [];
	    if (_.isArray(obj)) return slice.call(obj);
	    if (isArrayLike(obj)) return _.map(obj, _.identity);
	    return _.values(obj);
	  };
	
	  // Return the number of elements in an object.
	  _.size = function(obj) {
	    if (obj == null) return 0;
	    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
	  };
	
	  // Split a collection into two arrays: one whose elements all satisfy the given
	  // predicate, and one whose elements all do not satisfy the predicate.
	  _.partition = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var pass = [], fail = [];
	    _.each(obj, function(value, key, obj) {
	      (predicate(value, key, obj) ? pass : fail).push(value);
	    });
	    return [pass, fail];
	  };
	
	  // Array Functions
	  // ---------------
	
	  // Get the first element of an array. Passing **n** will return the first N
	  // values in the array. Aliased as `head` and `take`. The **guard** check
	  // allows it to work with `_.map`.
	  _.first = _.head = _.take = function(array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[0];
	    return _.initial(array, array.length - n);
	  };
	
	  // Returns everything but the last entry of the array. Especially useful on
	  // the arguments object. Passing **n** will return all the values in
	  // the array, excluding the last N.
	  _.initial = function(array, n, guard) {
	    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
	  };
	
	  // Get the last element of an array. Passing **n** will return the last N
	  // values in the array.
	  _.last = function(array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[array.length - 1];
	    return _.rest(array, Math.max(0, array.length - n));
	  };
	
	  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
	  // Especially useful on the arguments object. Passing an **n** will return
	  // the rest N values in the array.
	  _.rest = _.tail = _.drop = function(array, n, guard) {
	    return slice.call(array, n == null || guard ? 1 : n);
	  };
	
	  // Trim out all falsy values from an array.
	  _.compact = function(array) {
	    return _.filter(array, _.identity);
	  };
	
	  // Internal implementation of a recursive `flatten` function.
	  var flatten = function(input, shallow, strict, startIndex) {
	    var output = [], idx = 0;
	    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
	      var value = input[i];
	      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
	        //flatten current level of array or arguments object
	        if (!shallow) value = flatten(value, shallow, strict);
	        var j = 0, len = value.length;
	        output.length += len;
	        while (j < len) {
	          output[idx++] = value[j++];
	        }
	      } else if (!strict) {
	        output[idx++] = value;
	      }
	    }
	    return output;
	  };
	
	  // Flatten out an array, either recursively (by default), or just one level.
	  _.flatten = function(array, shallow) {
	    return flatten(array, shallow, false);
	  };
	
	  // Return a version of the array that does not contain the specified value(s).
	  _.without = function(array) {
	    return _.difference(array, slice.call(arguments, 1));
	  };
	
	  // Produce a duplicate-free version of the array. If the array has already
	  // been sorted, you have the option of using a faster algorithm.
	  // Aliased as `unique`.
	  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
	    if (!_.isBoolean(isSorted)) {
	      context = iteratee;
	      iteratee = isSorted;
	      isSorted = false;
	    }
	    if (iteratee != null) iteratee = cb(iteratee, context);
	    var result = [];
	    var seen = [];
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var value = array[i],
	          computed = iteratee ? iteratee(value, i, array) : value;
	      if (isSorted) {
	        if (!i || seen !== computed) result.push(value);
	        seen = computed;
	      } else if (iteratee) {
	        if (!_.contains(seen, computed)) {
	          seen.push(computed);
	          result.push(value);
	        }
	      } else if (!_.contains(result, value)) {
	        result.push(value);
	      }
	    }
	    return result;
	  };
	
	  // Produce an array that contains the union: each distinct element from all of
	  // the passed-in arrays.
	  _.union = function() {
	    return _.uniq(flatten(arguments, true, true));
	  };
	
	  // Produce an array that contains every item shared between all the
	  // passed-in arrays.
	  _.intersection = function(array) {
	    var result = [];
	    var argsLength = arguments.length;
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var item = array[i];
	      if (_.contains(result, item)) continue;
	      for (var j = 1; j < argsLength; j++) {
	        if (!_.contains(arguments[j], item)) break;
	      }
	      if (j === argsLength) result.push(item);
	    }
	    return result;
	  };
	
	  // Take the difference between one array and a number of other arrays.
	  // Only the elements present in just the first array will remain.
	  _.difference = function(array) {
	    var rest = flatten(arguments, true, true, 1);
	    return _.filter(array, function(value){
	      return !_.contains(rest, value);
	    });
	  };
	
	  // Zip together multiple lists into a single array -- elements that share
	  // an index go together.
	  _.zip = function() {
	    return _.unzip(arguments);
	  };
	
	  // Complement of _.zip. Unzip accepts an array of arrays and groups
	  // each array's elements on shared indices
	  _.unzip = function(array) {
	    var length = array && _.max(array, getLength).length || 0;
	    var result = Array(length);
	
	    for (var index = 0; index < length; index++) {
	      result[index] = _.pluck(array, index);
	    }
	    return result;
	  };
	
	  // Converts lists into objects. Pass either a single array of `[key, value]`
	  // pairs, or two parallel arrays of the same length -- one of keys, and one of
	  // the corresponding values.
	  _.object = function(list, values) {
	    var result = {};
	    for (var i = 0, length = getLength(list); i < length; i++) {
	      if (values) {
	        result[list[i]] = values[i];
	      } else {
	        result[list[i][0]] = list[i][1];
	      }
	    }
	    return result;
	  };
	
	  // Generator function to create the findIndex and findLastIndex functions
	  function createPredicateIndexFinder(dir) {
	    return function(array, predicate, context) {
	      predicate = cb(predicate, context);
	      var length = getLength(array);
	      var index = dir > 0 ? 0 : length - 1;
	      for (; index >= 0 && index < length; index += dir) {
	        if (predicate(array[index], index, array)) return index;
	      }
	      return -1;
	    };
	  }
	
	  // Returns the first index on an array-like that passes a predicate test
	  _.findIndex = createPredicateIndexFinder(1);
	  _.findLastIndex = createPredicateIndexFinder(-1);
	
	  // Use a comparator function to figure out the smallest index at which
	  // an object should be inserted so as to maintain order. Uses binary search.
	  _.sortedIndex = function(array, obj, iteratee, context) {
	    iteratee = cb(iteratee, context, 1);
	    var value = iteratee(obj);
	    var low = 0, high = getLength(array);
	    while (low < high) {
	      var mid = Math.floor((low + high) / 2);
	      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
	    }
	    return low;
	  };
	
	  // Generator function to create the indexOf and lastIndexOf functions
	  function createIndexFinder(dir, predicateFind, sortedIndex) {
	    return function(array, item, idx) {
	      var i = 0, length = getLength(array);
	      if (typeof idx == 'number') {
	        if (dir > 0) {
	            i = idx >= 0 ? idx : Math.max(idx + length, i);
	        } else {
	            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
	        }
	      } else if (sortedIndex && idx && length) {
	        idx = sortedIndex(array, item);
	        return array[idx] === item ? idx : -1;
	      }
	      if (item !== item) {
	        idx = predicateFind(slice.call(array, i, length), _.isNaN);
	        return idx >= 0 ? idx + i : -1;
	      }
	      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
	        if (array[idx] === item) return idx;
	      }
	      return -1;
	    };
	  }
	
	  // Return the position of the first occurrence of an item in an array,
	  // or -1 if the item is not included in the array.
	  // If the array is large and already in sort order, pass `true`
	  // for **isSorted** to use binary search.
	  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
	  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);
	
	  // Generate an integer Array containing an arithmetic progression. A port of
	  // the native Python `range()` function. See
	  // [the Python documentation](http://docs.python.org/library/functions.html#range).
	  _.range = function(start, stop, step) {
	    if (stop == null) {
	      stop = start || 0;
	      start = 0;
	    }
	    step = step || 1;
	
	    var length = Math.max(Math.ceil((stop - start) / step), 0);
	    var range = Array(length);
	
	    for (var idx = 0; idx < length; idx++, start += step) {
	      range[idx] = start;
	    }
	
	    return range;
	  };
	
	  // Function (ahem) Functions
	  // ------------------
	
	  // Determines whether to execute a function as a constructor
	  // or a normal function with the provided arguments
	  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
	    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
	    var self = baseCreate(sourceFunc.prototype);
	    var result = sourceFunc.apply(self, args);
	    if (_.isObject(result)) return result;
	    return self;
	  };
	
	  // Create a function bound to a given object (assigning `this`, and arguments,
	  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
	  // available.
	  _.bind = function(func, context) {
	    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
	    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
	    var args = slice.call(arguments, 2);
	    var bound = function() {
	      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
	    };
	    return bound;
	  };
	
	  // Partially apply a function by creating a version that has had some of its
	  // arguments pre-filled, without changing its dynamic `this` context. _ acts
	  // as a placeholder, allowing any combination of arguments to be pre-filled.
	  _.partial = function(func) {
	    var boundArgs = slice.call(arguments, 1);
	    var bound = function() {
	      var position = 0, length = boundArgs.length;
	      var args = Array(length);
	      for (var i = 0; i < length; i++) {
	        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
	      }
	      while (position < arguments.length) args.push(arguments[position++]);
	      return executeBound(func, bound, this, this, args);
	    };
	    return bound;
	  };
	
	  // Bind a number of an object's methods to that object. Remaining arguments
	  // are the method names to be bound. Useful for ensuring that all callbacks
	  // defined on an object belong to it.
	  _.bindAll = function(obj) {
	    var i, length = arguments.length, key;
	    if (length <= 1) throw new Error('bindAll must be passed function names');
	    for (i = 1; i < length; i++) {
	      key = arguments[i];
	      obj[key] = _.bind(obj[key], obj);
	    }
	    return obj;
	  };
	
	  // Memoize an expensive function by storing its results.
	  _.memoize = function(func, hasher) {
	    var memoize = function(key) {
	      var cache = memoize.cache;
	      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
	      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
	      return cache[address];
	    };
	    memoize.cache = {};
	    return memoize;
	  };
	
	  // Delays a function for the given number of milliseconds, and then calls
	  // it with the arguments supplied.
	  _.delay = function(func, wait) {
	    var args = slice.call(arguments, 2);
	    return setTimeout(function(){
	      return func.apply(null, args);
	    }, wait);
	  };
	
	  // Defers a function, scheduling it to run after the current call stack has
	  // cleared.
	  _.defer = _.partial(_.delay, _, 1);
	
	  // Returns a function, that, when invoked, will only be triggered at most once
	  // during a given window of time. Normally, the throttled function will run
	  // as much as it can, without ever going more than once per `wait` duration;
	  // but if you'd like to disable the execution on the leading edge, pass
	  // `{leading: false}`. To disable execution on the trailing edge, ditto.
	  _.throttle = function(func, wait, options) {
	    var context, args, result;
	    var timeout = null;
	    var previous = 0;
	    if (!options) options = {};
	    var later = function() {
	      previous = options.leading === false ? 0 : _.now();
	      timeout = null;
	      result = func.apply(context, args);
	      if (!timeout) context = args = null;
	    };
	    return function() {
	      var now = _.now();
	      if (!previous && options.leading === false) previous = now;
	      var remaining = wait - (now - previous);
	      context = this;
	      args = arguments;
	      if (remaining <= 0 || remaining > wait) {
	        if (timeout) {
	          clearTimeout(timeout);
	          timeout = null;
	        }
	        previous = now;
	        result = func.apply(context, args);
	        if (!timeout) context = args = null;
	      } else if (!timeout && options.trailing !== false) {
	        timeout = setTimeout(later, remaining);
	      }
	      return result;
	    };
	  };
	
	  // Returns a function, that, as long as it continues to be invoked, will not
	  // be triggered. The function will be called after it stops being called for
	  // N milliseconds. If `immediate` is passed, trigger the function on the
	  // leading edge, instead of the trailing.
	  _.debounce = function(func, wait, immediate) {
	    var timeout, args, context, timestamp, result;
	
	    var later = function() {
	      var last = _.now() - timestamp;
	
	      if (last < wait && last >= 0) {
	        timeout = setTimeout(later, wait - last);
	      } else {
	        timeout = null;
	        if (!immediate) {
	          result = func.apply(context, args);
	          if (!timeout) context = args = null;
	        }
	      }
	    };
	
	    return function() {
	      context = this;
	      args = arguments;
	      timestamp = _.now();
	      var callNow = immediate && !timeout;
	      if (!timeout) timeout = setTimeout(later, wait);
	      if (callNow) {
	        result = func.apply(context, args);
	        context = args = null;
	      }
	
	      return result;
	    };
	  };
	
	  // Returns the first function passed as an argument to the second,
	  // allowing you to adjust arguments, run code before and after, and
	  // conditionally execute the original function.
	  _.wrap = function(func, wrapper) {
	    return _.partial(wrapper, func);
	  };
	
	  // Returns a negated version of the passed-in predicate.
	  _.negate = function(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    };
	  };
	
	  // Returns a function that is the composition of a list of functions, each
	  // consuming the return value of the function that follows.
	  _.compose = function() {
	    var args = arguments;
	    var start = args.length - 1;
	    return function() {
	      var i = start;
	      var result = args[start].apply(this, arguments);
	      while (i--) result = args[i].call(this, result);
	      return result;
	    };
	  };
	
	  // Returns a function that will only be executed on and after the Nth call.
	  _.after = function(times, func) {
	    return function() {
	      if (--times < 1) {
	        return func.apply(this, arguments);
	      }
	    };
	  };
	
	  // Returns a function that will only be executed up to (but not including) the Nth call.
	  _.before = function(times, func) {
	    var memo;
	    return function() {
	      if (--times > 0) {
	        memo = func.apply(this, arguments);
	      }
	      if (times <= 1) func = null;
	      return memo;
	    };
	  };
	
	  // Returns a function that will be executed at most one time, no matter how
	  // often you call it. Useful for lazy initialization.
	  _.once = _.partial(_.before, 2);
	
	  // Object Functions
	  // ----------------
	
	  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
	  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
	  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
	                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	
	  function collectNonEnumProps(obj, keys) {
	    var nonEnumIdx = nonEnumerableProps.length;
	    var constructor = obj.constructor;
	    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;
	
	    // Constructor is a special case.
	    var prop = 'constructor';
	    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);
	
	    while (nonEnumIdx--) {
	      prop = nonEnumerableProps[nonEnumIdx];
	      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
	        keys.push(prop);
	      }
	    }
	  }
	
	  // Retrieve the names of an object's own properties.
	  // Delegates to **ECMAScript 5**'s native `Object.keys`
	  _.keys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    if (nativeKeys) return nativeKeys(obj);
	    var keys = [];
	    for (var key in obj) if (_.has(obj, key)) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };
	
	  // Retrieve all the property names of an object.
	  _.allKeys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    var keys = [];
	    for (var key in obj) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };
	
	  // Retrieve the values of an object's properties.
	  _.values = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var values = Array(length);
	    for (var i = 0; i < length; i++) {
	      values[i] = obj[keys[i]];
	    }
	    return values;
	  };
	
	  // Returns the results of applying the iteratee to each element of the object
	  // In contrast to _.map it returns an object
	  _.mapObject = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys =  _.keys(obj),
	          length = keys.length,
	          results = {},
	          currentKey;
	      for (var index = 0; index < length; index++) {
	        currentKey = keys[index];
	        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
	      }
	      return results;
	  };
	
	  // Convert an object into a list of `[key, value]` pairs.
	  _.pairs = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var pairs = Array(length);
	    for (var i = 0; i < length; i++) {
	      pairs[i] = [keys[i], obj[keys[i]]];
	    }
	    return pairs;
	  };
	
	  // Invert the keys and values of an object. The values must be serializable.
	  _.invert = function(obj) {
	    var result = {};
	    var keys = _.keys(obj);
	    for (var i = 0, length = keys.length; i < length; i++) {
	      result[obj[keys[i]]] = keys[i];
	    }
	    return result;
	  };
	
	  // Return a sorted list of the function names available on the object.
	  // Aliased as `methods`
	  _.functions = _.methods = function(obj) {
	    var names = [];
	    for (var key in obj) {
	      if (_.isFunction(obj[key])) names.push(key);
	    }
	    return names.sort();
	  };
	
	  // Extend a given object with all the properties in passed-in object(s).
	  _.extend = createAssigner(_.allKeys);
	
	  // Assigns a given object with all the own properties in the passed-in object(s)
	  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
	  _.extendOwn = _.assign = createAssigner(_.keys);
	
	  // Returns the first key on an object that passes a predicate test
	  _.findKey = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = _.keys(obj), key;
	    for (var i = 0, length = keys.length; i < length; i++) {
	      key = keys[i];
	      if (predicate(obj[key], key, obj)) return key;
	    }
	  };
	
	  // Return a copy of the object only containing the whitelisted properties.
	  _.pick = function(object, oiteratee, context) {
	    var result = {}, obj = object, iteratee, keys;
	    if (obj == null) return result;
	    if (_.isFunction(oiteratee)) {
	      keys = _.allKeys(obj);
	      iteratee = optimizeCb(oiteratee, context);
	    } else {
	      keys = flatten(arguments, false, false, 1);
	      iteratee = function(value, key, obj) { return key in obj; };
	      obj = Object(obj);
	    }
	    for (var i = 0, length = keys.length; i < length; i++) {
	      var key = keys[i];
	      var value = obj[key];
	      if (iteratee(value, key, obj)) result[key] = value;
	    }
	    return result;
	  };
	
	   // Return a copy of the object without the blacklisted properties.
	  _.omit = function(obj, iteratee, context) {
	    if (_.isFunction(iteratee)) {
	      iteratee = _.negate(iteratee);
	    } else {
	      var keys = _.map(flatten(arguments, false, false, 1), String);
	      iteratee = function(value, key) {
	        return !_.contains(keys, key);
	      };
	    }
	    return _.pick(obj, iteratee, context);
	  };
	
	  // Fill in a given object with default properties.
	  _.defaults = createAssigner(_.allKeys, true);
	
	  // Creates an object that inherits from the given prototype object.
	  // If additional properties are provided then they will be added to the
	  // created object.
	  _.create = function(prototype, props) {
	    var result = baseCreate(prototype);
	    if (props) _.extendOwn(result, props);
	    return result;
	  };
	
	  // Create a (shallow-cloned) duplicate of an object.
	  _.clone = function(obj) {
	    if (!_.isObject(obj)) return obj;
	    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
	  };
	
	  // Invokes interceptor with the obj, and then returns obj.
	  // The primary purpose of this method is to "tap into" a method chain, in
	  // order to perform operations on intermediate results within the chain.
	  _.tap = function(obj, interceptor) {
	    interceptor(obj);
	    return obj;
	  };
	
	  // Returns whether an object has a given set of `key:value` pairs.
	  _.isMatch = function(object, attrs) {
	    var keys = _.keys(attrs), length = keys.length;
	    if (object == null) return !length;
	    var obj = Object(object);
	    for (var i = 0; i < length; i++) {
	      var key = keys[i];
	      if (attrs[key] !== obj[key] || !(key in obj)) return false;
	    }
	    return true;
	  };
	
	
	  // Internal recursive comparison function for `isEqual`.
	  var eq = function(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b) return a !== 0 || 1 / a === 1 / b;
	    // A strict comparison is necessary because `null == undefined`.
	    if (a == null || b == null) return a === b;
	    // Unwrap any wrapped objects.
	    if (a instanceof _) a = a._wrapped;
	    if (b instanceof _) b = b._wrapped;
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className !== toString.call(b)) return false;
	    switch (className) {
	      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
	      case '[object RegExp]':
	      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	      case '[object String]':
	        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	        // equivalent to `new String("5")`.
	        return '' + a === '' + b;
	      case '[object Number]':
	        // `NaN`s are equivalent, but non-reflexive.
	        // Object(NaN) is equivalent to NaN
	        if (+a !== +a) return +b !== +b;
	        // An `egal` comparison is performed for other numeric values.
	        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	      case '[object Date]':
	      case '[object Boolean]':
	        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	        // millisecond representations. Note that invalid dates with millisecond representations
	        // of `NaN` are not equivalent.
	        return +a === +b;
	    }
	
	    var areArrays = className === '[object Array]';
	    if (!areArrays) {
	      if (typeof a != 'object' || typeof b != 'object') return false;
	
	      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
	      // from different frames are.
	      var aCtor = a.constructor, bCtor = b.constructor;
	      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
	                               _.isFunction(bCtor) && bCtor instanceof bCtor)
	                          && ('constructor' in a && 'constructor' in b)) {
	        return false;
	      }
	    }
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	
	    // Initializing stack of traversed objects.
	    // It's done here since we only need them for objects and arrays comparison.
	    aStack = aStack || [];
	    bStack = bStack || [];
	    var length = aStack.length;
	    while (length--) {
	      // Linear search. Performance is inversely proportional to the number of
	      // unique nested structures.
	      if (aStack[length] === a) return bStack[length] === b;
	    }
	
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	
	    // Recursively compare objects and arrays.
	    if (areArrays) {
	      // Compare array lengths to determine if a deep comparison is necessary.
	      length = a.length;
	      if (length !== b.length) return false;
	      // Deep compare the contents, ignoring non-numeric properties.
	      while (length--) {
	        if (!eq(a[length], b[length], aStack, bStack)) return false;
	      }
	    } else {
	      // Deep compare objects.
	      var keys = _.keys(a), key;
	      length = keys.length;
	      // Ensure that both objects contain the same number of properties before comparing deep equality.
	      if (_.keys(b).length !== length) return false;
	      while (length--) {
	        // Deep compare each member
	        key = keys[length];
	        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
	      }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return true;
	  };
	
	  // Perform a deep comparison to check if two objects are equal.
	  _.isEqual = function(a, b) {
	    return eq(a, b);
	  };
	
	  // Is a given array, string, or object empty?
	  // An "empty" object has no enumerable own-properties.
	  _.isEmpty = function(obj) {
	    if (obj == null) return true;
	    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
	    return _.keys(obj).length === 0;
	  };
	
	  // Is a given value a DOM element?
	  _.isElement = function(obj) {
	    return !!(obj && obj.nodeType === 1);
	  };
	
	  // Is a given value an array?
	  // Delegates to ECMA5's native Array.isArray
	  _.isArray = nativeIsArray || function(obj) {
	    return toString.call(obj) === '[object Array]';
	  };
	
	  // Is a given variable an object?
	  _.isObject = function(obj) {
	    var type = typeof obj;
	    return type === 'function' || type === 'object' && !!obj;
	  };
	
	  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
	  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
	    _['is' + name] = function(obj) {
	      return toString.call(obj) === '[object ' + name + ']';
	    };
	  });
	
	  // Define a fallback version of the method in browsers (ahem, IE < 9), where
	  // there isn't any inspectable "Arguments" type.
	  if (!_.isArguments(arguments)) {
	    _.isArguments = function(obj) {
	      return _.has(obj, 'callee');
	    };
	  }
	
	  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
	  // IE 11 (#1621), and in Safari 8 (#1929).
	  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
	    _.isFunction = function(obj) {
	      return typeof obj == 'function' || false;
	    };
	  }
	
	  // Is a given object a finite number?
	  _.isFinite = function(obj) {
	    return isFinite(obj) && !isNaN(parseFloat(obj));
	  };
	
	  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
	  _.isNaN = function(obj) {
	    return _.isNumber(obj) && obj !== +obj;
	  };
	
	  // Is a given value a boolean?
	  _.isBoolean = function(obj) {
	    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
	  };
	
	  // Is a given value equal to null?
	  _.isNull = function(obj) {
	    return obj === null;
	  };
	
	  // Is a given variable undefined?
	  _.isUndefined = function(obj) {
	    return obj === void 0;
	  };
	
	  // Shortcut function for checking if an object has a given property directly
	  // on itself (in other words, not on a prototype).
	  _.has = function(obj, key) {
	    return obj != null && hasOwnProperty.call(obj, key);
	  };
	
	  // Utility Functions
	  // -----------------
	
	  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
	  // previous owner. Returns a reference to the Underscore object.
	  _.noConflict = function() {
	    root._ = previousUnderscore;
	    return this;
	  };
	
	  // Keep the identity function around for default iteratees.
	  _.identity = function(value) {
	    return value;
	  };
	
	  // Predicate-generating functions. Often useful outside of Underscore.
	  _.constant = function(value) {
	    return function() {
	      return value;
	    };
	  };
	
	  _.noop = function(){};
	
	  _.property = property;
	
	  // Generates a function for a given object that returns a given property.
	  _.propertyOf = function(obj) {
	    return obj == null ? function(){} : function(key) {
	      return obj[key];
	    };
	  };
	
	  // Returns a predicate for checking whether an object has a given set of
	  // `key:value` pairs.
	  _.matcher = _.matches = function(attrs) {
	    attrs = _.extendOwn({}, attrs);
	    return function(obj) {
	      return _.isMatch(obj, attrs);
	    };
	  };
	
	  // Run a function **n** times.
	  _.times = function(n, iteratee, context) {
	    var accum = Array(Math.max(0, n));
	    iteratee = optimizeCb(iteratee, context, 1);
	    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
	    return accum;
	  };
	
	  // Return a random integer between min and max (inclusive).
	  _.random = function(min, max) {
	    if (max == null) {
	      max = min;
	      min = 0;
	    }
	    return min + Math.floor(Math.random() * (max - min + 1));
	  };
	
	  // A (possibly faster) way to get the current timestamp as an integer.
	  _.now = Date.now || function() {
	    return new Date().getTime();
	  };
	
	   // List of HTML entities for escaping.
	  var escapeMap = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#x27;',
	    '`': '&#x60;'
	  };
	  var unescapeMap = _.invert(escapeMap);
	
	  // Functions for escaping and unescaping strings to/from HTML interpolation.
	  var createEscaper = function(map) {
	    var escaper = function(match) {
	      return map[match];
	    };
	    // Regexes for identifying a key that needs to be escaped
	    var source = '(?:' + _.keys(map).join('|') + ')';
	    var testRegexp = RegExp(source);
	    var replaceRegexp = RegExp(source, 'g');
	    return function(string) {
	      string = string == null ? '' : '' + string;
	      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
	    };
	  };
	  _.escape = createEscaper(escapeMap);
	  _.unescape = createEscaper(unescapeMap);
	
	  // If the value of the named `property` is a function then invoke it with the
	  // `object` as context; otherwise, return it.
	  _.result = function(object, property, fallback) {
	    var value = object == null ? void 0 : object[property];
	    if (value === void 0) {
	      value = fallback;
	    }
	    return _.isFunction(value) ? value.call(object) : value;
	  };
	
	  // Generate a unique integer id (unique within the entire client session).
	  // Useful for temporary DOM ids.
	  var idCounter = 0;
	  _.uniqueId = function(prefix) {
	    var id = ++idCounter + '';
	    return prefix ? prefix + id : id;
	  };
	
	  // By default, Underscore uses ERB-style template delimiters, change the
	  // following template settings to use alternative delimiters.
	  _.templateSettings = {
	    evaluate    : /<%([\s\S]+?)%>/g,
	    interpolate : /<%=([\s\S]+?)%>/g,
	    escape      : /<%-([\s\S]+?)%>/g
	  };
	
	  // When customizing `templateSettings`, if you don't want to define an
	  // interpolation, evaluation or escaping regex, we need one that is
	  // guaranteed not to match.
	  var noMatch = /(.)^/;
	
	  // Certain characters need to be escaped so that they can be put into a
	  // string literal.
	  var escapes = {
	    "'":      "'",
	    '\\':     '\\',
	    '\r':     'r',
	    '\n':     'n',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;
	
	  var escapeChar = function(match) {
	    return '\\' + escapes[match];
	  };
	
	  // JavaScript micro-templating, similar to John Resig's implementation.
	  // Underscore templating handles arbitrary delimiters, preserves whitespace,
	  // and correctly escapes quotes within interpolated code.
	  // NB: `oldSettings` only exists for backwards compatibility.
	  _.template = function(text, settings, oldSettings) {
	    if (!settings && oldSettings) settings = oldSettings;
	    settings = _.defaults({}, settings, _.templateSettings);
	
	    // Combine delimiters into one regular expression via alternation.
	    var matcher = RegExp([
	      (settings.escape || noMatch).source,
	      (settings.interpolate || noMatch).source,
	      (settings.evaluate || noMatch).source
	    ].join('|') + '|$', 'g');
	
	    // Compile the template source, escaping string literals appropriately.
	    var index = 0;
	    var source = "__p+='";
	    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
	      source += text.slice(index, offset).replace(escaper, escapeChar);
	      index = offset + match.length;
	
	      if (escape) {
	        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
	      } else if (interpolate) {
	        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
	      } else if (evaluate) {
	        source += "';\n" + evaluate + "\n__p+='";
	      }
	
	      // Adobe VMs need the match returned to produce the correct offest.
	      return match;
	    });
	    source += "';\n";
	
	    // If a variable is not specified, place data values in local scope.
	    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';
	
	    source = "var __t,__p='',__j=Array.prototype.join," +
	      "print=function(){__p+=__j.call(arguments,'');};\n" +
	      source + 'return __p;\n';
	
	    try {
	      var render = new Function(settings.variable || 'obj', '_', source);
	    } catch (e) {
	      e.source = source;
	      throw e;
	    }
	
	    var template = function(data) {
	      return render.call(this, data, _);
	    };
	
	    // Provide the compiled source as a convenience for precompilation.
	    var argument = settings.variable || 'obj';
	    template.source = 'function(' + argument + '){\n' + source + '}';
	
	    return template;
	  };
	
	  // Add a "chain" function. Start chaining a wrapped Underscore object.
	  _.chain = function(obj) {
	    var instance = _(obj);
	    instance._chain = true;
	    return instance;
	  };
	
	  // OOP
	  // ---------------
	  // If Underscore is called as a function, it returns a wrapped object that
	  // can be used OO-style. This wrapper holds altered versions of all the
	  // underscore functions. Wrapped objects may be chained.
	
	  // Helper function to continue chaining intermediate results.
	  var result = function(instance, obj) {
	    return instance._chain ? _(obj).chain() : obj;
	  };
	
	  // Add your own custom functions to the Underscore object.
	  _.mixin = function(obj) {
	    _.each(_.functions(obj), function(name) {
	      var func = _[name] = obj[name];
	      _.prototype[name] = function() {
	        var args = [this._wrapped];
	        push.apply(args, arguments);
	        return result(this, func.apply(_, args));
	      };
	    });
	  };
	
	  // Add all of the Underscore functions to the wrapper object.
	  _.mixin(_);
	
	  // Add all mutator Array functions to the wrapper.
	  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      var obj = this._wrapped;
	      method.apply(obj, arguments);
	      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
	      return result(this, obj);
	    };
	  });
	
	  // Add all accessor Array functions to the wrapper.
	  _.each(['concat', 'join', 'slice'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      return result(this, method.apply(this._wrapped, arguments));
	    };
	  });
	
	  // Extracts the result from a wrapped and chained object.
	  _.prototype.value = function() {
	    return this._wrapped;
	  };
	
	  // Provide unwrapping proxy for some methods used in engine operations
	  // such as arithmetic and JSON stringification.
	  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;
	
	  _.prototype.toString = function() {
	    return '' + this._wrapped;
	  };
	
	  // AMD registration happens at the end for compatibility with AMD loaders
	  // that may not enforce next-turn semantics on modules. Even though general
	  // practice for AMD registration is to be anonymous, underscore registers
	  // as a named module because, like jQuery, it is a base library that is
	  // popular enough to be bundled in a third party lib, but not be part of
	  // an AMD load request. Those cases could generate an error when an
	  // anonymous define() is called outside of a loader request.
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	}.call(this));


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.20.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	var hookCallback;
	
	function hooks () {
	    return hookCallback.apply(null, arguments);
	}
	
	// This is done to register the method called with moment()
	// without creating circular dependencies.
	function setHookCallback (callback) {
	    hookCallback = callback;
	}
	
	function isArray(input) {
	    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	}
	
	function isObject(input) {
	    // IE8 will treat undefined and null as object if it wasn't for
	    // input != null
	    return input != null && Object.prototype.toString.call(input) === '[object Object]';
	}
	
	function isObjectEmpty(obj) {
	    if (Object.getOwnPropertyNames) {
	        return (Object.getOwnPropertyNames(obj).length === 0);
	    } else {
	        var k;
	        for (k in obj) {
	            if (obj.hasOwnProperty(k)) {
	                return false;
	            }
	        }
	        return true;
	    }
	}
	
	function isUndefined(input) {
	    return input === void 0;
	}
	
	function isNumber(input) {
	    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	}
	
	function isDate(input) {
	    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	}
	
	function map(arr, fn) {
	    var res = [], i;
	    for (i = 0; i < arr.length; ++i) {
	        res.push(fn(arr[i], i));
	    }
	    return res;
	}
	
	function hasOwnProp(a, b) {
	    return Object.prototype.hasOwnProperty.call(a, b);
	}
	
	function extend(a, b) {
	    for (var i in b) {
	        if (hasOwnProp(b, i)) {
	            a[i] = b[i];
	        }
	    }
	
	    if (hasOwnProp(b, 'toString')) {
	        a.toString = b.toString;
	    }
	
	    if (hasOwnProp(b, 'valueOf')) {
	        a.valueOf = b.valueOf;
	    }
	
	    return a;
	}
	
	function createUTC (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, true).utc();
	}
	
	function defaultParsingFlags() {
	    // We need to deep clone this object.
	    return {
	        empty           : false,
	        unusedTokens    : [],
	        unusedInput     : [],
	        overflow        : -2,
	        charsLeftOver   : 0,
	        nullInput       : false,
	        invalidMonth    : null,
	        invalidFormat   : false,
	        userInvalidated : false,
	        iso             : false,
	        parsedDateParts : [],
	        meridiem        : null,
	        rfc2822         : false,
	        weekdayMismatch : false
	    };
	}
	
	function getParsingFlags(m) {
	    if (m._pf == null) {
	        m._pf = defaultParsingFlags();
	    }
	    return m._pf;
	}
	
	var some;
	if (Array.prototype.some) {
	    some = Array.prototype.some;
	} else {
	    some = function (fun) {
	        var t = Object(this);
	        var len = t.length >>> 0;
	
	        for (var i = 0; i < len; i++) {
	            if (i in t && fun.call(this, t[i], i, t)) {
	                return true;
	            }
	        }
	
	        return false;
	    };
	}
	
	function isValid(m) {
	    if (m._isValid == null) {
	        var flags = getParsingFlags(m);
	        var parsedParts = some.call(flags.parsedDateParts, function (i) {
	            return i != null;
	        });
	        var isNowValid = !isNaN(m._d.getTime()) &&
	            flags.overflow < 0 &&
	            !flags.empty &&
	            !flags.invalidMonth &&
	            !flags.invalidWeekday &&
	            !flags.weekdayMismatch &&
	            !flags.nullInput &&
	            !flags.invalidFormat &&
	            !flags.userInvalidated &&
	            (!flags.meridiem || (flags.meridiem && parsedParts));
	
	        if (m._strict) {
	            isNowValid = isNowValid &&
	                flags.charsLeftOver === 0 &&
	                flags.unusedTokens.length === 0 &&
	                flags.bigHour === undefined;
	        }
	
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        }
	        else {
	            return isNowValid;
	        }
	    }
	    return m._isValid;
	}
	
	function createInvalid (flags) {
	    var m = createUTC(NaN);
	    if (flags != null) {
	        extend(getParsingFlags(m), flags);
	    }
	    else {
	        getParsingFlags(m).userInvalidated = true;
	    }
	
	    return m;
	}
	
	// Plugins that add properties should also add the key here (null value),
	// so we can properly clone ourselves.
	var momentProperties = hooks.momentProperties = [];
	
	function copyConfig(to, from) {
	    var i, prop, val;
	
	    if (!isUndefined(from._isAMomentObject)) {
	        to._isAMomentObject = from._isAMomentObject;
	    }
	    if (!isUndefined(from._i)) {
	        to._i = from._i;
	    }
	    if (!isUndefined(from._f)) {
	        to._f = from._f;
	    }
	    if (!isUndefined(from._l)) {
	        to._l = from._l;
	    }
	    if (!isUndefined(from._strict)) {
	        to._strict = from._strict;
	    }
	    if (!isUndefined(from._tzm)) {
	        to._tzm = from._tzm;
	    }
	    if (!isUndefined(from._isUTC)) {
	        to._isUTC = from._isUTC;
	    }
	    if (!isUndefined(from._offset)) {
	        to._offset = from._offset;
	    }
	    if (!isUndefined(from._pf)) {
	        to._pf = getParsingFlags(from);
	    }
	    if (!isUndefined(from._locale)) {
	        to._locale = from._locale;
	    }
	
	    if (momentProperties.length > 0) {
	        for (i = 0; i < momentProperties.length; i++) {
	            prop = momentProperties[i];
	            val = from[prop];
	            if (!isUndefined(val)) {
	                to[prop] = val;
	            }
	        }
	    }
	
	    return to;
	}
	
	var updateInProgress = false;
	
	// Moment prototype object
	function Moment(config) {
	    copyConfig(this, config);
	    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	    if (!this.isValid()) {
	        this._d = new Date(NaN);
	    }
	    // Prevent infinite loop in case updateOffset creates new moment
	    // objects.
	    if (updateInProgress === false) {
	        updateInProgress = true;
	        hooks.updateOffset(this);
	        updateInProgress = false;
	    }
	}
	
	function isMoment (obj) {
	    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	}
	
	function absFloor (number) {
	    if (number < 0) {
	        // -0 -> 0
	        return Math.ceil(number) || 0;
	    } else {
	        return Math.floor(number);
	    }
	}
	
	function toInt(argumentForCoercion) {
	    var coercedNumber = +argumentForCoercion,
	        value = 0;
	
	    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	        value = absFloor(coercedNumber);
	    }
	
	    return value;
	}
	
	// compare two arrays, return the number of differences
	function compareArrays(array1, array2, dontConvert) {
	    var len = Math.min(array1.length, array2.length),
	        lengthDiff = Math.abs(array1.length - array2.length),
	        diffs = 0,
	        i;
	    for (i = 0; i < len; i++) {
	        if ((dontConvert && array1[i] !== array2[i]) ||
	            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	            diffs++;
	        }
	    }
	    return diffs + lengthDiff;
	}
	
	function warn(msg) {
	    if (hooks.suppressDeprecationWarnings === false &&
	            (typeof console !==  'undefined') && console.warn) {
	        console.warn('Deprecation warning: ' + msg);
	    }
	}
	
	function deprecate(msg, fn) {
	    var firstTime = true;
	
	    return extend(function () {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(null, msg);
	        }
	        if (firstTime) {
	            var args = [];
	            var arg;
	            for (var i = 0; i < arguments.length; i++) {
	                arg = '';
	                if (typeof arguments[i] === 'object') {
	                    arg += '\n[' + i + '] ';
	                    for (var key in arguments[0]) {
	                        arg += key + ': ' + arguments[0][key] + ', ';
	                    }
	                    arg = arg.slice(0, -2); // Remove trailing comma and space
	                } else {
	                    arg = arguments[i];
	                }
	                args.push(arg);
	            }
	            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	            firstTime = false;
	        }
	        return fn.apply(this, arguments);
	    }, fn);
	}
	
	var deprecations = {};
	
	function deprecateSimple(name, msg) {
	    if (hooks.deprecationHandler != null) {
	        hooks.deprecationHandler(name, msg);
	    }
	    if (!deprecations[name]) {
	        warn(msg);
	        deprecations[name] = true;
	    }
	}
	
	hooks.suppressDeprecationWarnings = false;
	hooks.deprecationHandler = null;
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	function set (config) {
	    var prop, i;
	    for (i in config) {
	        prop = config[i];
	        if (isFunction(prop)) {
	            this[i] = prop;
	        } else {
	            this['_' + i] = prop;
	        }
	    }
	    this._config = config;
	    // Lenient ordinal parsing accepts just a number in addition to
	    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    this._dayOfMonthOrdinalParseLenient = new RegExp(
	        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	            '|' + (/\d{1,2}/).source);
	}
	
	function mergeConfigs(parentConfig, childConfig) {
	    var res = extend({}, parentConfig), prop;
	    for (prop in childConfig) {
	        if (hasOwnProp(childConfig, prop)) {
	            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                res[prop] = {};
	                extend(res[prop], parentConfig[prop]);
	                extend(res[prop], childConfig[prop]);
	            } else if (childConfig[prop] != null) {
	                res[prop] = childConfig[prop];
	            } else {
	                delete res[prop];
	            }
	        }
	    }
	    for (prop in parentConfig) {
	        if (hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])) {
	            // make sure changes to properties don't modify parent config
	            res[prop] = extend({}, res[prop]);
	        }
	    }
	    return res;
	}
	
	function Locale(config) {
	    if (config != null) {
	        this.set(config);
	    }
	}
	
	var keys;
	
	if (Object.keys) {
	    keys = Object.keys;
	} else {
	    keys = function (obj) {
	        var i, res = [];
	        for (i in obj) {
	            if (hasOwnProp(obj, i)) {
	                res.push(i);
	            }
	        }
	        return res;
	    };
	}
	
	var defaultCalendar = {
	    sameDay : '[Today at] LT',
	    nextDay : '[Tomorrow at] LT',
	    nextWeek : 'dddd [at] LT',
	    lastDay : '[Yesterday at] LT',
	    lastWeek : '[Last] dddd [at] LT',
	    sameElse : 'L'
	};
	
	function calendar (key, mom, now) {
	    var output = this._calendar[key] || this._calendar['sameElse'];
	    return isFunction(output) ? output.call(mom, now) : output;
	}
	
	var defaultLongDateFormat = {
	    LTS  : 'h:mm:ss A',
	    LT   : 'h:mm A',
	    L    : 'MM/DD/YYYY',
	    LL   : 'MMMM D, YYYY',
	    LLL  : 'MMMM D, YYYY h:mm A',
	    LLLL : 'dddd, MMMM D, YYYY h:mm A'
	};
	
	function longDateFormat (key) {
	    var format = this._longDateFormat[key],
	        formatUpper = this._longDateFormat[key.toUpperCase()];
	
	    if (format || !formatUpper) {
	        return format;
	    }
	
	    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	        return val.slice(1);
	    });
	
	    return this._longDateFormat[key];
	}
	
	var defaultInvalidDate = 'Invalid date';
	
	function invalidDate () {
	    return this._invalidDate;
	}
	
	var defaultOrdinal = '%d';
	var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	function ordinal (number) {
	    return this._ordinal.replace('%d', number);
	}
	
	var defaultRelativeTime = {
	    future : 'in %s',
	    past   : '%s ago',
	    s  : 'a few seconds',
	    ss : '%d seconds',
	    m  : 'a minute',
	    mm : '%d minutes',
	    h  : 'an hour',
	    hh : '%d hours',
	    d  : 'a day',
	    dd : '%d days',
	    M  : 'a month',
	    MM : '%d months',
	    y  : 'a year',
	    yy : '%d years'
	};
	
	function relativeTime (number, withoutSuffix, string, isFuture) {
	    var output = this._relativeTime[string];
	    return (isFunction(output)) ?
	        output(number, withoutSuffix, string, isFuture) :
	        output.replace(/%d/i, number);
	}
	
	function pastFuture (diff, output) {
	    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	}
	
	var aliases = {};
	
	function addUnitAlias (unit, shorthand) {
	    var lowerCase = unit.toLowerCase();
	    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	}
	
	function normalizeUnits(units) {
	    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	}
	
	function normalizeObjectUnits(inputObject) {
	    var normalizedInput = {},
	        normalizedProp,
	        prop;
	
	    for (prop in inputObject) {
	        if (hasOwnProp(inputObject, prop)) {
	            normalizedProp = normalizeUnits(prop);
	            if (normalizedProp) {
	                normalizedInput[normalizedProp] = inputObject[prop];
	            }
	        }
	    }
	
	    return normalizedInput;
	}
	
	var priorities = {};
	
	function addUnitPriority(unit, priority) {
	    priorities[unit] = priority;
	}
	
	function getPrioritizedUnits(unitsObj) {
	    var units = [];
	    for (var u in unitsObj) {
	        units.push({unit: u, priority: priorities[u]});
	    }
	    units.sort(function (a, b) {
	        return a.priority - b.priority;
	    });
	    return units;
	}
	
	function zeroFill(number, targetLength, forceSign) {
	    var absNumber = '' + Math.abs(number),
	        zerosToFill = targetLength - absNumber.length,
	        sign = number >= 0;
	    return (sign ? (forceSign ? '+' : '') : '-') +
	        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	}
	
	var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	var formatFunctions = {};
	
	var formatTokenFunctions = {};
	
	// token:    'M'
	// padded:   ['MM', 2]
	// ordinal:  'Mo'
	// callback: function () { this.month() + 1 }
	function addFormatToken (token, padded, ordinal, callback) {
	    var func = callback;
	    if (typeof callback === 'string') {
	        func = function () {
	            return this[callback]();
	        };
	    }
	    if (token) {
	        formatTokenFunctions[token] = func;
	    }
	    if (padded) {
	        formatTokenFunctions[padded[0]] = function () {
	            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	        };
	    }
	    if (ordinal) {
	        formatTokenFunctions[ordinal] = function () {
	            return this.localeData().ordinal(func.apply(this, arguments), token);
	        };
	    }
	}
	
	function removeFormattingTokens(input) {
	    if (input.match(/\[[\s\S]/)) {
	        return input.replace(/^\[|\]$/g, '');
	    }
	    return input.replace(/\\/g, '');
	}
	
	function makeFormatFunction(format) {
	    var array = format.match(formattingTokens), i, length;
	
	    for (i = 0, length = array.length; i < length; i++) {
	        if (formatTokenFunctions[array[i]]) {
	            array[i] = formatTokenFunctions[array[i]];
	        } else {
	            array[i] = removeFormattingTokens(array[i]);
	        }
	    }
	
	    return function (mom) {
	        var output = '', i;
	        for (i = 0; i < length; i++) {
	            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	        }
	        return output;
	    };
	}
	
	// format date using native date object
	function formatMoment(m, format) {
	    if (!m.isValid()) {
	        return m.localeData().invalidDate();
	    }
	
	    format = expandFormat(format, m.localeData());
	    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	    return formatFunctions[format](m);
	}
	
	function expandFormat(format, locale) {
	    var i = 5;
	
	    function replaceLongDateFormatTokens(input) {
	        return locale.longDateFormat(input) || input;
	    }
	
	    localFormattingTokens.lastIndex = 0;
	    while (i >= 0 && localFormattingTokens.test(format)) {
	        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	        localFormattingTokens.lastIndex = 0;
	        i -= 1;
	    }
	
	    return format;
	}
	
	var match1         = /\d/;            //       0 - 9
	var match2         = /\d\d/;          //      00 - 99
	var match3         = /\d{3}/;         //     000 - 999
	var match4         = /\d{4}/;         //    0000 - 9999
	var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	var match1to2      = /\d\d?/;         //       0 - 99
	var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	var match1to3      = /\d{1,3}/;       //       0 - 999
	var match1to4      = /\d{1,4}/;       //       0 - 9999
	var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	var matchUnsigned  = /\d+/;           //       0 - inf
	var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	// any word (or two) characters or numbers including two/three word month in arabic.
	// includes scottish gaelic two word and hyphenated months
	var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
	
	
	var regexes = {};
	
	function addRegexToken (token, regex, strictRegex) {
	    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	        return (isStrict && strictRegex) ? strictRegex : regex;
	    };
	}
	
	function getParseRegexForToken (token, config) {
	    if (!hasOwnProp(regexes, token)) {
	        return new RegExp(unescapeFormat(token));
	    }
	
	    return regexes[token](config._strict, config._locale);
	}
	
	// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	function unescapeFormat(s) {
	    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	        return p1 || p2 || p3 || p4;
	    }));
	}
	
	function regexEscape(s) {
	    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	}
	
	var tokens = {};
	
	function addParseToken (token, callback) {
	    var i, func = callback;
	    if (typeof token === 'string') {
	        token = [token];
	    }
	    if (isNumber(callback)) {
	        func = function (input, array) {
	            array[callback] = toInt(input);
	        };
	    }
	    for (i = 0; i < token.length; i++) {
	        tokens[token[i]] = func;
	    }
	}
	
	function addWeekParseToken (token, callback) {
	    addParseToken(token, function (input, array, config, token) {
	        config._w = config._w || {};
	        callback(input, config._w, config, token);
	    });
	}
	
	function addTimeToArrayFromToken(token, input, config) {
	    if (input != null && hasOwnProp(tokens, token)) {
	        tokens[token](input, config._a, config, token);
	    }
	}
	
	var YEAR = 0;
	var MONTH = 1;
	var DATE = 2;
	var HOUR = 3;
	var MINUTE = 4;
	var SECOND = 5;
	var MILLISECOND = 6;
	var WEEK = 7;
	var WEEKDAY = 8;
	
	// FORMATTING
	
	addFormatToken('Y', 0, 0, function () {
	    var y = this.year();
	    return y <= 9999 ? '' + y : '+' + y;
	});
	
	addFormatToken(0, ['YY', 2], 0, function () {
	    return this.year() % 100;
	});
	
	addFormatToken(0, ['YYYY',   4],       0, 'year');
	addFormatToken(0, ['YYYYY',  5],       0, 'year');
	addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	// ALIASES
	
	addUnitAlias('year', 'y');
	
	// PRIORITIES
	
	addUnitPriority('year', 1);
	
	// PARSING
	
	addRegexToken('Y',      matchSigned);
	addRegexToken('YY',     match1to2, match2);
	addRegexToken('YYYY',   match1to4, match4);
	addRegexToken('YYYYY',  match1to6, match6);
	addRegexToken('YYYYYY', match1to6, match6);
	
	addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	addParseToken('YYYY', function (input, array) {
	    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	});
	addParseToken('YY', function (input, array) {
	    array[YEAR] = hooks.parseTwoDigitYear(input);
	});
	addParseToken('Y', function (input, array) {
	    array[YEAR] = parseInt(input, 10);
	});
	
	// HELPERS
	
	function daysInYear(year) {
	    return isLeapYear(year) ? 366 : 365;
	}
	
	function isLeapYear(year) {
	    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	}
	
	// HOOKS
	
	hooks.parseTwoDigitYear = function (input) {
	    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	};
	
	// MOMENTS
	
	var getSetYear = makeGetSet('FullYear', true);
	
	function getIsLeapYear () {
	    return isLeapYear(this.year());
	}
	
	function makeGetSet (unit, keepTime) {
	    return function (value) {
	        if (value != null) {
	            set$1(this, unit, value);
	            hooks.updateOffset(this, keepTime);
	            return this;
	        } else {
	            return get(this, unit);
	        }
	    };
	}
	
	function get (mom, unit) {
	    return mom.isValid() ?
	        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	}
	
	function set$1 (mom, unit, value) {
	    if (mom.isValid() && !isNaN(value)) {
	        if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
	            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
	        }
	        else {
	            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	        }
	    }
	}
	
	// MOMENTS
	
	function stringGet (units) {
	    units = normalizeUnits(units);
	    if (isFunction(this[units])) {
	        return this[units]();
	    }
	    return this;
	}
	
	
	function stringSet (units, value) {
	    if (typeof units === 'object') {
	        units = normalizeObjectUnits(units);
	        var prioritized = getPrioritizedUnits(units);
	        for (var i = 0; i < prioritized.length; i++) {
	            this[prioritized[i].unit](units[prioritized[i].unit]);
	        }
	    } else {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units](value);
	        }
	    }
	    return this;
	}
	
	function mod(n, x) {
	    return ((n % x) + x) % x;
	}
	
	var indexOf;
	
	if (Array.prototype.indexOf) {
	    indexOf = Array.prototype.indexOf;
	} else {
	    indexOf = function (o) {
	        // I know
	        var i;
	        for (i = 0; i < this.length; ++i) {
	            if (this[i] === o) {
	                return i;
	            }
	        }
	        return -1;
	    };
	}
	
	function daysInMonth(year, month) {
	    if (isNaN(year) || isNaN(month)) {
	        return NaN;
	    }
	    var modMonth = mod(month, 12);
	    year += (month - modMonth) / 12;
	    return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
	}
	
	// FORMATTING
	
	addFormatToken('M', ['MM', 2], 'Mo', function () {
	    return this.month() + 1;
	});
	
	addFormatToken('MMM', 0, 0, function (format) {
	    return this.localeData().monthsShort(this, format);
	});
	
	addFormatToken('MMMM', 0, 0, function (format) {
	    return this.localeData().months(this, format);
	});
	
	// ALIASES
	
	addUnitAlias('month', 'M');
	
	// PRIORITY
	
	addUnitPriority('month', 8);
	
	// PARSING
	
	addRegexToken('M',    match1to2);
	addRegexToken('MM',   match1to2, match2);
	addRegexToken('MMM',  function (isStrict, locale) {
	    return locale.monthsShortRegex(isStrict);
	});
	addRegexToken('MMMM', function (isStrict, locale) {
	    return locale.monthsRegex(isStrict);
	});
	
	addParseToken(['M', 'MM'], function (input, array) {
	    array[MONTH] = toInt(input) - 1;
	});
	
	addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	    var month = config._locale.monthsParse(input, token, config._strict);
	    // if we didn't find a month name, mark the date as invalid.
	    if (month != null) {
	        array[MONTH] = month;
	    } else {
	        getParsingFlags(config).invalidMonth = input;
	    }
	});
	
	// LOCALES
	
	var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	function localeMonths (m, format) {
	    if (!m) {
	        return isArray(this._months) ? this._months :
	            this._months['standalone'];
	    }
	    return isArray(this._months) ? this._months[m.month()] :
	        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	function localeMonthsShort (m, format) {
	    if (!m) {
	        return isArray(this._monthsShort) ? this._monthsShort :
	            this._monthsShort['standalone'];
	    }
	    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	function handleStrictParse(monthName, format, strict) {
	    var i, ii, mom, llc = monthName.toLocaleLowerCase();
	    if (!this._monthsParse) {
	        // this is not used
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	        for (i = 0; i < 12; ++i) {
	            mom = createUTC([2000, i]);
	            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'MMM') {
	            ii = indexOf.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'MMM') {
	            ii = indexOf.call(this._shortMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._longMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeMonthsParse (monthName, format, strict) {
	    var i, mom, regex;
	
	    if (this._monthsParseExact) {
	        return handleStrictParse.call(this, monthName, format, strict);
	    }
	
	    if (!this._monthsParse) {
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	    }
	
	    // TODO: add sorting
	    // Sorting makes sure if one month (or abbr) is a prefix of another
	    // see sorting in computeMonthsParse
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        if (strict && !this._longMonthsParse[i]) {
	            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	        }
	        if (!strict && !this._monthsParse[i]) {
	            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (!strict && this._monthsParse[i].test(monthName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function setMonth (mom, value) {
	    var dayOfMonth;
	
	    if (!mom.isValid()) {
	        // No op
	        return mom;
	    }
	
	    if (typeof value === 'string') {
	        if (/^\d+$/.test(value)) {
	            value = toInt(value);
	        } else {
	            value = mom.localeData().monthsParse(value);
	            // TODO: Another silent failure?
	            if (!isNumber(value)) {
	                return mom;
	            }
	        }
	    }
	
	    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	    return mom;
	}
	
	function getSetMonth (value) {
	    if (value != null) {
	        setMonth(this, value);
	        hooks.updateOffset(this, true);
	        return this;
	    } else {
	        return get(this, 'Month');
	    }
	}
	
	function getDaysInMonth () {
	    return daysInMonth(this.year(), this.month());
	}
	
	var defaultMonthsShortRegex = matchWord;
	function monthsShortRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsShortStrictRegex;
	        } else {
	            return this._monthsShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsShortRegex')) {
	            this._monthsShortRegex = defaultMonthsShortRegex;
	        }
	        return this._monthsShortStrictRegex && isStrict ?
	            this._monthsShortStrictRegex : this._monthsShortRegex;
	    }
	}
	
	var defaultMonthsRegex = matchWord;
	function monthsRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsStrictRegex;
	        } else {
	            return this._monthsRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            this._monthsRegex = defaultMonthsRegex;
	        }
	        return this._monthsStrictRegex && isStrict ?
	            this._monthsStrictRegex : this._monthsRegex;
	    }
	}
	
	function computeMonthsParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom;
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        shortPieces.push(this.monthsShort(mom, ''));
	        longPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.monthsShort(mom, ''));
	    }
	    // Sorting makes sure if one month (or abbr) is a prefix of another it
	    // will match the longer piece.
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 12; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	    }
	    for (i = 0; i < 24; i++) {
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._monthsShortRegex = this._monthsRegex;
	    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	}
	
	function createDate (y, m, d, h, M, s, ms) {
	    // can't just apply() to create a date:
	    // https://stackoverflow.com/q/181348
	    var date = new Date(y, m, d, h, M, s, ms);
	
	    // the date constructor remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	        date.setFullYear(y);
	    }
	    return date;
	}
	
	function createUTCDate (y) {
	    var date = new Date(Date.UTC.apply(null, arguments));
	
	    // the Date.UTC function remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	        date.setUTCFullYear(y);
	    }
	    return date;
	}
	
	// start-of-first-week - start-of-year
	function firstWeekOffset(year, dow, doy) {
	    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	        fwd = 7 + dow - doy,
	        // first-week day local weekday -- which local weekday is fwd
	        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	    return -fwdlw + fwd - 1;
	}
	
	// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	    var localWeekday = (7 + weekday - dow) % 7,
	        weekOffset = firstWeekOffset(year, dow, doy),
	        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	        resYear, resDayOfYear;
	
	    if (dayOfYear <= 0) {
	        resYear = year - 1;
	        resDayOfYear = daysInYear(resYear) + dayOfYear;
	    } else if (dayOfYear > daysInYear(year)) {
	        resYear = year + 1;
	        resDayOfYear = dayOfYear - daysInYear(year);
	    } else {
	        resYear = year;
	        resDayOfYear = dayOfYear;
	    }
	
	    return {
	        year: resYear,
	        dayOfYear: resDayOfYear
	    };
	}
	
	function weekOfYear(mom, dow, doy) {
	    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	        resWeek, resYear;
	
	    if (week < 1) {
	        resYear = mom.year() - 1;
	        resWeek = week + weeksInYear(resYear, dow, doy);
	    } else if (week > weeksInYear(mom.year(), dow, doy)) {
	        resWeek = week - weeksInYear(mom.year(), dow, doy);
	        resYear = mom.year() + 1;
	    } else {
	        resYear = mom.year();
	        resWeek = week;
	    }
	
	    return {
	        week: resWeek,
	        year: resYear
	    };
	}
	
	function weeksInYear(year, dow, doy) {
	    var weekOffset = firstWeekOffset(year, dow, doy),
	        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	}
	
	// FORMATTING
	
	addFormatToken('w', ['ww', 2], 'wo', 'week');
	addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	// ALIASES
	
	addUnitAlias('week', 'w');
	addUnitAlias('isoWeek', 'W');
	
	// PRIORITIES
	
	addUnitPriority('week', 5);
	addUnitPriority('isoWeek', 5);
	
	// PARSING
	
	addRegexToken('w',  match1to2);
	addRegexToken('ww', match1to2, match2);
	addRegexToken('W',  match1to2);
	addRegexToken('WW', match1to2, match2);
	
	addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	    week[token.substr(0, 1)] = toInt(input);
	});
	
	// HELPERS
	
	// LOCALES
	
	function localeWeek (mom) {
	    return weekOfYear(mom, this._week.dow, this._week.doy).week;
	}
	
	var defaultLocaleWeek = {
	    dow : 0, // Sunday is the first day of the week.
	    doy : 6  // The week that contains Jan 1st is the first week of the year.
	};
	
	function localeFirstDayOfWeek () {
	    return this._week.dow;
	}
	
	function localeFirstDayOfYear () {
	    return this._week.doy;
	}
	
	// MOMENTS
	
	function getSetWeek (input) {
	    var week = this.localeData().week(this);
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	function getSetISOWeek (input) {
	    var week = weekOfYear(this, 1, 4).week;
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	// FORMATTING
	
	addFormatToken('d', 0, 'do', 'day');
	
	addFormatToken('dd', 0, 0, function (format) {
	    return this.localeData().weekdaysMin(this, format);
	});
	
	addFormatToken('ddd', 0, 0, function (format) {
	    return this.localeData().weekdaysShort(this, format);
	});
	
	addFormatToken('dddd', 0, 0, function (format) {
	    return this.localeData().weekdays(this, format);
	});
	
	addFormatToken('e', 0, 0, 'weekday');
	addFormatToken('E', 0, 0, 'isoWeekday');
	
	// ALIASES
	
	addUnitAlias('day', 'd');
	addUnitAlias('weekday', 'e');
	addUnitAlias('isoWeekday', 'E');
	
	// PRIORITY
	addUnitPriority('day', 11);
	addUnitPriority('weekday', 11);
	addUnitPriority('isoWeekday', 11);
	
	// PARSING
	
	addRegexToken('d',    match1to2);
	addRegexToken('e',    match1to2);
	addRegexToken('E',    match1to2);
	addRegexToken('dd',   function (isStrict, locale) {
	    return locale.weekdaysMinRegex(isStrict);
	});
	addRegexToken('ddd',   function (isStrict, locale) {
	    return locale.weekdaysShortRegex(isStrict);
	});
	addRegexToken('dddd',   function (isStrict, locale) {
	    return locale.weekdaysRegex(isStrict);
	});
	
	addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	    var weekday = config._locale.weekdaysParse(input, token, config._strict);
	    // if we didn't get a weekday name, mark the date as invalid
	    if (weekday != null) {
	        week.d = weekday;
	    } else {
	        getParsingFlags(config).invalidWeekday = input;
	    }
	});
	
	addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	    week[token] = toInt(input);
	});
	
	// HELPERS
	
	function parseWeekday(input, locale) {
	    if (typeof input !== 'string') {
	        return input;
	    }
	
	    if (!isNaN(input)) {
	        return parseInt(input, 10);
	    }
	
	    input = locale.weekdaysParse(input);
	    if (typeof input === 'number') {
	        return input;
	    }
	
	    return null;
	}
	
	function parseIsoWeekday(input, locale) {
	    if (typeof input === 'string') {
	        return locale.weekdaysParse(input) % 7 || 7;
	    }
	    return isNaN(input) ? null : input;
	}
	
	// LOCALES
	
	var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	function localeWeekdays (m, format) {
	    if (!m) {
	        return isArray(this._weekdays) ? this._weekdays :
	            this._weekdays['standalone'];
	    }
	    return isArray(this._weekdays) ? this._weekdays[m.day()] :
	        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	}
	
	var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	function localeWeekdaysShort (m) {
	    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	}
	
	var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	function localeWeekdaysMin (m) {
	    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	}
	
	function handleStrictParse$1(weekdayName, format, strict) {
	    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._minWeekdaysParse = [];
	
	        for (i = 0; i < 7; ++i) {
	            mom = createUTC([2000, 1]).day(i);
	            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'dddd') {
	            ii = indexOf.call(this._weekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'dddd') {
	            ii = indexOf.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeWeekdaysParse (weekdayName, format, strict) {
	    var i, mom, regex;
	
	    if (this._weekdaysParseExact) {
	        return handleStrictParse$1.call(this, weekdayName, format, strict);
	    }
	
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._minWeekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._fullWeekdaysParse = [];
	    }
	
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	
	        mom = createUTC([2000, 1]).day(i);
	        if (strict && !this._fullWeekdaysParse[i]) {
	            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	        }
	        if (!this._weekdaysParse[i]) {
	            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function getSetDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	    if (input != null) {
	        input = parseWeekday(input, this.localeData());
	        return this.add(input - day, 'd');
	    } else {
	        return day;
	    }
	}
	
	function getSetLocaleDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	    return input == null ? weekday : this.add(input - weekday, 'd');
	}
	
	function getSetISODayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	
	    // behaves the same as moment#day except
	    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	    // as a setter, sunday should belong to the previous week.
	
	    if (input != null) {
	        var weekday = parseIsoWeekday(input, this.localeData());
	        return this.day(this.day() % 7 ? weekday : weekday - 7);
	    } else {
	        return this.day() || 7;
	    }
	}
	
	var defaultWeekdaysRegex = matchWord;
	function weekdaysRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysStrictRegex;
	        } else {
	            return this._weekdaysRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            this._weekdaysRegex = defaultWeekdaysRegex;
	        }
	        return this._weekdaysStrictRegex && isStrict ?
	            this._weekdaysStrictRegex : this._weekdaysRegex;
	    }
	}
	
	var defaultWeekdaysShortRegex = matchWord;
	function weekdaysShortRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysShortStrictRegex;
	        } else {
	            return this._weekdaysShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	        }
	        return this._weekdaysShortStrictRegex && isStrict ?
	            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	    }
	}
	
	var defaultWeekdaysMinRegex = matchWord;
	function weekdaysMinRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysMinStrictRegex;
	        } else {
	            return this._weekdaysMinRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	        }
	        return this._weekdaysMinStrictRegex && isStrict ?
	            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	    }
	}
	
	
	function computeWeekdaysParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom, minp, shortp, longp;
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, 1]).day(i);
	        minp = this.weekdaysMin(mom, '');
	        shortp = this.weekdaysShort(mom, '');
	        longp = this.weekdays(mom, '');
	        minPieces.push(minp);
	        shortPieces.push(shortp);
	        longPieces.push(longp);
	        mixedPieces.push(minp);
	        mixedPieces.push(shortp);
	        mixedPieces.push(longp);
	    }
	    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	    // will match the longer piece.
	    minPieces.sort(cmpLenRev);
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 7; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._weekdaysShortRegex = this._weekdaysRegex;
	    this._weekdaysMinRegex = this._weekdaysRegex;
	
	    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	function hFormat() {
	    return this.hours() % 12 || 12;
	}
	
	function kFormat() {
	    return this.hours() || 24;
	}
	
	addFormatToken('H', ['HH', 2], 0, 'hour');
	addFormatToken('h', ['hh', 2], 0, hFormat);
	addFormatToken('k', ['kk', 2], 0, kFormat);
	
	addFormatToken('hmm', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('hmmss', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	addFormatToken('Hmm', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('Hmmss', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	function meridiem (token, lowercase) {
	    addFormatToken(token, 0, 0, function () {
	        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	    });
	}
	
	meridiem('a', true);
	meridiem('A', false);
	
	// ALIASES
	
	addUnitAlias('hour', 'h');
	
	// PRIORITY
	addUnitPriority('hour', 13);
	
	// PARSING
	
	function matchMeridiem (isStrict, locale) {
	    return locale._meridiemParse;
	}
	
	addRegexToken('a',  matchMeridiem);
	addRegexToken('A',  matchMeridiem);
	addRegexToken('H',  match1to2);
	addRegexToken('h',  match1to2);
	addRegexToken('k',  match1to2);
	addRegexToken('HH', match1to2, match2);
	addRegexToken('hh', match1to2, match2);
	addRegexToken('kk', match1to2, match2);
	
	addRegexToken('hmm', match3to4);
	addRegexToken('hmmss', match5to6);
	addRegexToken('Hmm', match3to4);
	addRegexToken('Hmmss', match5to6);
	
	addParseToken(['H', 'HH'], HOUR);
	addParseToken(['k', 'kk'], function (input, array, config) {
	    var kInput = toInt(input);
	    array[HOUR] = kInput === 24 ? 0 : kInput;
	});
	addParseToken(['a', 'A'], function (input, array, config) {
	    config._isPm = config._locale.isPM(input);
	    config._meridiem = input;
	});
	addParseToken(['h', 'hh'], function (input, array, config) {
	    array[HOUR] = toInt(input);
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('Hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	});
	addParseToken('Hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	});
	
	// LOCALES
	
	function localeIsPM (input) {
	    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	    // Using charAt should be more compatible.
	    return ((input + '').toLowerCase().charAt(0) === 'p');
	}
	
	var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	function localeMeridiem (hours, minutes, isLower) {
	    if (hours > 11) {
	        return isLower ? 'pm' : 'PM';
	    } else {
	        return isLower ? 'am' : 'AM';
	    }
	}
	
	
	// MOMENTS
	
	// Setting the hour should keep the time, because the user explicitly
	// specified which hour he wants. So trying to maintain the same hour (in
	// a new timezone) makes sense. Adding/subtracting hours does not follow
	// this rule.
	var getSetHour = makeGetSet('Hours', true);
	
	// months
	// week
	// weekdays
	// meridiem
	var baseConfig = {
	    calendar: defaultCalendar,
	    longDateFormat: defaultLongDateFormat,
	    invalidDate: defaultInvalidDate,
	    ordinal: defaultOrdinal,
	    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	    relativeTime: defaultRelativeTime,
	
	    months: defaultLocaleMonths,
	    monthsShort: defaultLocaleMonthsShort,
	
	    week: defaultLocaleWeek,
	
	    weekdays: defaultLocaleWeekdays,
	    weekdaysMin: defaultLocaleWeekdaysMin,
	    weekdaysShort: defaultLocaleWeekdaysShort,
	
	    meridiemParse: defaultLocaleMeridiemParse
	};
	
	// internal storage for locale config files
	var locales = {};
	var localeFamilies = {};
	var globalLocale;
	
	function normalizeLocale(key) {
	    return key ? key.toLowerCase().replace('_', '-') : key;
	}
	
	// pick the locale from the array
	// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	function chooseLocale(names) {
	    var i = 0, j, next, locale, split;
	
	    while (i < names.length) {
	        split = normalizeLocale(names[i]).split('-');
	        j = split.length;
	        next = normalizeLocale(names[i + 1]);
	        next = next ? next.split('-') : null;
	        while (j > 0) {
	            locale = loadLocale(split.slice(0, j).join('-'));
	            if (locale) {
	                return locale;
	            }
	            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                //the next array item is better than a shallower substring of this one
	                break;
	            }
	            j--;
	        }
	        i++;
	    }
	    return null;
	}
	
	function loadLocale(name) {
	    var oldLocale = null;
	    // TODO: Find a better way to register and load all the locales in Node
	    if (!locales[name] && (typeof module !== 'undefined') &&
	            module && module.exports) {
	        try {
	            oldLocale = globalLocale._abbr;
	            var aliasedRequire = require;
	            __webpack_require__(10)("./" + name);
	            getSetGlobalLocale(oldLocale);
	        } catch (e) {}
	    }
	    return locales[name];
	}
	
	// This function will load locale and then set the global locale.  If
	// no arguments are passed in, it will simply return the current global
	// locale key.
	function getSetGlobalLocale (key, values) {
	    var data;
	    if (key) {
	        if (isUndefined(values)) {
	            data = getLocale(key);
	        }
	        else {
	            data = defineLocale(key, values);
	        }
	
	        if (data) {
	            // moment.duration._locale = moment._locale = data;
	            globalLocale = data;
	        }
	    }
	
	    return globalLocale._abbr;
	}
	
	function defineLocale (name, config) {
	    if (config !== null) {
	        var parentConfig = baseConfig;
	        config.abbr = name;
	        if (locales[name] != null) {
	            deprecateSimple('defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                    'an existing locale. moment.defineLocale(localeName, ' +
	                    'config) should only be used for creating a new locale ' +
	                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	            parentConfig = locales[name]._config;
	        } else if (config.parentLocale != null) {
	            if (locales[config.parentLocale] != null) {
	                parentConfig = locales[config.parentLocale]._config;
	            } else {
	                if (!localeFamilies[config.parentLocale]) {
	                    localeFamilies[config.parentLocale] = [];
	                }
	                localeFamilies[config.parentLocale].push({
	                    name: name,
	                    config: config
	                });
	                return null;
	            }
	        }
	        locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	        if (localeFamilies[name]) {
	            localeFamilies[name].forEach(function (x) {
	                defineLocale(x.name, x.config);
	            });
	        }
	
	        // backwards compat for now: also set the locale
	        // make sure we set the locale AFTER all child locales have been
	        // created, so we won't end up with the child locale set.
	        getSetGlobalLocale(name);
	
	
	        return locales[name];
	    } else {
	        // useful for testing
	        delete locales[name];
	        return null;
	    }
	}
	
	function updateLocale(name, config) {
	    if (config != null) {
	        var locale, tmpLocale, parentConfig = baseConfig;
	        // MERGE
	        tmpLocale = loadLocale(name);
	        if (tmpLocale != null) {
	            parentConfig = tmpLocale._config;
	        }
	        config = mergeConfigs(parentConfig, config);
	        locale = new Locale(config);
	        locale.parentLocale = locales[name];
	        locales[name] = locale;
	
	        // backwards compat for now: also set the locale
	        getSetGlobalLocale(name);
	    } else {
	        // pass null for config to unupdate, useful for tests
	        if (locales[name] != null) {
	            if (locales[name].parentLocale != null) {
	                locales[name] = locales[name].parentLocale;
	            } else if (locales[name] != null) {
	                delete locales[name];
	            }
	        }
	    }
	    return locales[name];
	}
	
	// returns locale data
	function getLocale (key) {
	    var locale;
	
	    if (key && key._locale && key._locale._abbr) {
	        key = key._locale._abbr;
	    }
	
	    if (!key) {
	        return globalLocale;
	    }
	
	    if (!isArray(key)) {
	        //short-circuit everything else
	        locale = loadLocale(key);
	        if (locale) {
	            return locale;
	        }
	        key = [key];
	    }
	
	    return chooseLocale(key);
	}
	
	function listLocales() {
	    return keys(locales);
	}
	
	function checkOverflow (m) {
	    var overflow;
	    var a = m._a;
	
	    if (a && getParsingFlags(m).overflow === -2) {
	        overflow =
	            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	            -1;
	
	        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	            overflow = DATE;
	        }
	        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	            overflow = WEEK;
	        }
	        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	            overflow = WEEKDAY;
	        }
	
	        getParsingFlags(m).overflow = overflow;
	    }
	
	    return m;
	}
	
	// Pick the first defined of two or three arguments.
	function defaults(a, b, c) {
	    if (a != null) {
	        return a;
	    }
	    if (b != null) {
	        return b;
	    }
	    return c;
	}
	
	function currentDateArray(config) {
	    // hooks is actually the exported moment object
	    var nowValue = new Date(hooks.now());
	    if (config._useUTC) {
	        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	    }
	    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	}
	
	// convert an array to a date.
	// the array should mirror the parameters below
	// note: all values past the year are optional and will default to the lowest possible value.
	// [year, month, day , hour, minute, second, millisecond]
	function configFromArray (config) {
	    var i, date, input = [], currentDate, expectedWeekday, yearToUse;
	
	    if (config._d) {
	        return;
	    }
	
	    currentDate = currentDateArray(config);
	
	    //compute day of the year from weeks and weekdays
	    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	        dayOfYearFromWeekInfo(config);
	    }
	
	    //if the day of the year is set, figure out what it is
	    if (config._dayOfYear != null) {
	        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	            getParsingFlags(config)._overflowDayOfYear = true;
	        }
	
	        date = createUTCDate(yearToUse, 0, config._dayOfYear);
	        config._a[MONTH] = date.getUTCMonth();
	        config._a[DATE] = date.getUTCDate();
	    }
	
	    // Default to current date.
	    // * if no year, month, day of month are given, default to today
	    // * if day of month is given, default month and year
	    // * if month is given, default only year
	    // * if year is given, don't default anything
	    for (i = 0; i < 3 && config._a[i] == null; ++i) {
	        config._a[i] = input[i] = currentDate[i];
	    }
	
	    // Zero out whatever was not defaulted, including time
	    for (; i < 7; i++) {
	        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	    }
	
	    // Check for 24:00:00.000
	    if (config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0) {
	        config._nextDay = true;
	        config._a[HOUR] = 0;
	    }
	
	    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	    expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
	
	    // Apply timezone offset from input. The actual utcOffset can be changed
	    // with parseZone.
	    if (config._tzm != null) {
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	    }
	
	    if (config._nextDay) {
	        config._a[HOUR] = 24;
	    }
	
	    // check for mismatching day of week
	    if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
	        getParsingFlags(config).weekdayMismatch = true;
	    }
	}
	
	function dayOfYearFromWeekInfo(config) {
	    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	    w = config._w;
	    if (w.GG != null || w.W != null || w.E != null) {
	        dow = 1;
	        doy = 4;
	
	        // TODO: We need to take the current isoWeekYear, but that depends on
	        // how we interpret now (local, utc, fixed offset). So create
	        // a now version of current config (take local/utc/offset flags, and
	        // create now).
	        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	        week = defaults(w.W, 1);
	        weekday = defaults(w.E, 1);
	        if (weekday < 1 || weekday > 7) {
	            weekdayOverflow = true;
	        }
	    } else {
	        dow = config._locale._week.dow;
	        doy = config._locale._week.doy;
	
	        var curWeek = weekOfYear(createLocal(), dow, doy);
	
	        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	        // Default to current week.
	        week = defaults(w.w, curWeek.week);
	
	        if (w.d != null) {
	            // weekday -- low day numbers are considered next week
	            weekday = w.d;
	            if (weekday < 0 || weekday > 6) {
	                weekdayOverflow = true;
	            }
	        } else if (w.e != null) {
	            // local weekday -- counting starts from begining of week
	            weekday = w.e + dow;
	            if (w.e < 0 || w.e > 6) {
	                weekdayOverflow = true;
	            }
	        } else {
	            // default to begining of week
	            weekday = dow;
	        }
	    }
	    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	        getParsingFlags(config)._overflowWeeks = true;
	    } else if (weekdayOverflow != null) {
	        getParsingFlags(config)._overflowWeekday = true;
	    } else {
	        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	        config._a[YEAR] = temp.year;
	        config._dayOfYear = temp.dayOfYear;
	    }
	}
	
	// iso 8601 regex
	// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	var isoDates = [
	    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	    ['YYYY-DDD', /\d{4}-\d{3}/],
	    ['YYYY-MM', /\d{4}-\d\d/, false],
	    ['YYYYYYMMDD', /[+-]\d{10}/],
	    ['YYYYMMDD', /\d{8}/],
	    // YYYYMM is NOT allowed by the standard
	    ['GGGG[W]WWE', /\d{4}W\d{3}/],
	    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	    ['YYYYDDD', /\d{7}/]
	];
	
	// iso time formats and regexes
	var isoTimes = [
	    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	    ['HH:mm', /\d\d:\d\d/],
	    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	    ['HHmmss', /\d\d\d\d\d\d/],
	    ['HHmm', /\d\d\d\d/],
	    ['HH', /\d\d/]
	];
	
	var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	// date from iso format
	function configFromISO(config) {
	    var i, l,
	        string = config._i,
	        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	        allowTime, dateFormat, timeFormat, tzFormat;
	
	    if (match) {
	        getParsingFlags(config).iso = true;
	
	        for (i = 0, l = isoDates.length; i < l; i++) {
	            if (isoDates[i][1].exec(match[1])) {
	                dateFormat = isoDates[i][0];
	                allowTime = isoDates[i][2] !== false;
	                break;
	            }
	        }
	        if (dateFormat == null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[3]) {
	            for (i = 0, l = isoTimes.length; i < l; i++) {
	                if (isoTimes[i][1].exec(match[3])) {
	                    // match[2] should be 'T' or space
	                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                    break;
	                }
	            }
	            if (timeFormat == null) {
	                config._isValid = false;
	                return;
	            }
	        }
	        if (!allowTime && timeFormat != null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[4]) {
	            if (tzRegex.exec(match[4])) {
	                tzFormat = 'Z';
	            } else {
	                config._isValid = false;
	                return;
	            }
	        }
	        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	        configFromStringAndFormat(config);
	    } else {
	        config._isValid = false;
	    }
	}
	
	// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
	
	function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	    var result = [
	        untruncateYear(yearStr),
	        defaultLocaleMonthsShort.indexOf(monthStr),
	        parseInt(dayStr, 10),
	        parseInt(hourStr, 10),
	        parseInt(minuteStr, 10)
	    ];
	
	    if (secondStr) {
	        result.push(parseInt(secondStr, 10));
	    }
	
	    return result;
	}
	
	function untruncateYear(yearStr) {
	    var year = parseInt(yearStr, 10);
	    if (year <= 49) {
	        return 2000 + year;
	    } else if (year <= 999) {
	        return 1900 + year;
	    }
	    return year;
	}
	
	function preprocessRFC2822(s) {
	    // Remove comments and folding whitespace and replace multiple-spaces with a single space
	    return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').trim();
	}
	
	function checkWeekday(weekdayStr, parsedInput, config) {
	    if (weekdayStr) {
	        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	            weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
	        if (weekdayProvided !== weekdayActual) {
	            getParsingFlags(config).weekdayMismatch = true;
	            config._isValid = false;
	            return false;
	        }
	    }
	    return true;
	}
	
	var obsOffsets = {
	    UT: 0,
	    GMT: 0,
	    EDT: -4 * 60,
	    EST: -5 * 60,
	    CDT: -5 * 60,
	    CST: -6 * 60,
	    MDT: -6 * 60,
	    MST: -7 * 60,
	    PDT: -7 * 60,
	    PST: -8 * 60
	};
	
	function calculateOffset(obsOffset, militaryOffset, numOffset) {
	    if (obsOffset) {
	        return obsOffsets[obsOffset];
	    } else if (militaryOffset) {
	        // the only allowed military tz is Z
	        return 0;
	    } else {
	        var hm = parseInt(numOffset, 10);
	        var m = hm % 100, h = (hm - m) / 100;
	        return h * 60 + m;
	    }
	}
	
	// date and time from ref 2822 format
	function configFromRFC2822(config) {
	    var match = rfc2822.exec(preprocessRFC2822(config._i));
	    if (match) {
	        var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
	        if (!checkWeekday(match[1], parsedArray, config)) {
	            return;
	        }
	
	        config._a = parsedArray;
	        config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	        config._d = createUTCDate.apply(null, config._a);
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	        getParsingFlags(config).rfc2822 = true;
	    } else {
	        config._isValid = false;
	    }
	}
	
	// date from iso format or fallback
	function configFromString(config) {
	    var matched = aspNetJsonRegex.exec(config._i);
	
	    if (matched !== null) {
	        config._d = new Date(+matched[1]);
	        return;
	    }
	
	    configFromISO(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    configFromRFC2822(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    // Final attempt, use Input Fallback
	    hooks.createFromInputFallback(config);
	}
	
	hooks.createFromInputFallback = deprecate(
	    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	    'discouraged and will be removed in an upcoming major release. Please refer to ' +
	    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	    function (config) {
	        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	    }
	);
	
	// constant that refers to the ISO standard
	hooks.ISO_8601 = function () {};
	
	// constant that refers to the RFC 2822 form
	hooks.RFC_2822 = function () {};
	
	// date from string and format string
	function configFromStringAndFormat(config) {
	    // TODO: Move this to another part of the creation flow to prevent circular deps
	    if (config._f === hooks.ISO_8601) {
	        configFromISO(config);
	        return;
	    }
	    if (config._f === hooks.RFC_2822) {
	        configFromRFC2822(config);
	        return;
	    }
	    config._a = [];
	    getParsingFlags(config).empty = true;
	
	    // This array is used to make a Date, either with `new Date` or `Date.UTC`
	    var string = '' + config._i,
	        i, parsedInput, tokens, token, skipped,
	        stringLength = string.length,
	        totalParsedInputLength = 0;
	
	    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	    for (i = 0; i < tokens.length; i++) {
	        token = tokens[i];
	        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	        // console.log('token', token, 'parsedInput', parsedInput,
	        //         'regex', getParseRegexForToken(token, config));
	        if (parsedInput) {
	            skipped = string.substr(0, string.indexOf(parsedInput));
	            if (skipped.length > 0) {
	                getParsingFlags(config).unusedInput.push(skipped);
	            }
	            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	            totalParsedInputLength += parsedInput.length;
	        }
	        // don't parse if it's not a known token
	        if (formatTokenFunctions[token]) {
	            if (parsedInput) {
	                getParsingFlags(config).empty = false;
	            }
	            else {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	            addTimeToArrayFromToken(token, parsedInput, config);
	        }
	        else if (config._strict && !parsedInput) {
	            getParsingFlags(config).unusedTokens.push(token);
	        }
	    }
	
	    // add remaining unparsed input length to the string
	    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	    if (string.length > 0) {
	        getParsingFlags(config).unusedInput.push(string);
	    }
	
	    // clear _12h flag if hour is <= 12
	    if (config._a[HOUR] <= 12 &&
	        getParsingFlags(config).bigHour === true &&
	        config._a[HOUR] > 0) {
	        getParsingFlags(config).bigHour = undefined;
	    }
	
	    getParsingFlags(config).parsedDateParts = config._a.slice(0);
	    getParsingFlags(config).meridiem = config._meridiem;
	    // handle meridiem
	    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	    configFromArray(config);
	    checkOverflow(config);
	}
	
	
	function meridiemFixWrap (locale, hour, meridiem) {
	    var isPm;
	
	    if (meridiem == null) {
	        // nothing to do
	        return hour;
	    }
	    if (locale.meridiemHour != null) {
	        return locale.meridiemHour(hour, meridiem);
	    } else if (locale.isPM != null) {
	        // Fallback
	        isPm = locale.isPM(meridiem);
	        if (isPm && hour < 12) {
	            hour += 12;
	        }
	        if (!isPm && hour === 12) {
	            hour = 0;
	        }
	        return hour;
	    } else {
	        // this is not supposed to happen
	        return hour;
	    }
	}
	
	// date from string and array of format strings
	function configFromStringAndArray(config) {
	    var tempConfig,
	        bestMoment,
	
	        scoreToBeat,
	        i,
	        currentScore;
	
	    if (config._f.length === 0) {
	        getParsingFlags(config).invalidFormat = true;
	        config._d = new Date(NaN);
	        return;
	    }
	
	    for (i = 0; i < config._f.length; i++) {
	        currentScore = 0;
	        tempConfig = copyConfig({}, config);
	        if (config._useUTC != null) {
	            tempConfig._useUTC = config._useUTC;
	        }
	        tempConfig._f = config._f[i];
	        configFromStringAndFormat(tempConfig);
	
	        if (!isValid(tempConfig)) {
	            continue;
	        }
	
	        // if there is any input that was not parsed add a penalty for that format
	        currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	        //or tokens
	        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	        getParsingFlags(tempConfig).score = currentScore;
	
	        if (scoreToBeat == null || currentScore < scoreToBeat) {
	            scoreToBeat = currentScore;
	            bestMoment = tempConfig;
	        }
	    }
	
	    extend(config, bestMoment || tempConfig);
	}
	
	function configFromObject(config) {
	    if (config._d) {
	        return;
	    }
	
	    var i = normalizeObjectUnits(config._i);
	    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	        return obj && parseInt(obj, 10);
	    });
	
	    configFromArray(config);
	}
	
	function createFromConfig (config) {
	    var res = new Moment(checkOverflow(prepareConfig(config)));
	    if (res._nextDay) {
	        // Adding is smart enough around DST
	        res.add(1, 'd');
	        res._nextDay = undefined;
	    }
	
	    return res;
	}
	
	function prepareConfig (config) {
	    var input = config._i,
	        format = config._f;
	
	    config._locale = config._locale || getLocale(config._l);
	
	    if (input === null || (format === undefined && input === '')) {
	        return createInvalid({nullInput: true});
	    }
	
	    if (typeof input === 'string') {
	        config._i = input = config._locale.preparse(input);
	    }
	
	    if (isMoment(input)) {
	        return new Moment(checkOverflow(input));
	    } else if (isDate(input)) {
	        config._d = input;
	    } else if (isArray(format)) {
	        configFromStringAndArray(config);
	    } else if (format) {
	        configFromStringAndFormat(config);
	    }  else {
	        configFromInput(config);
	    }
	
	    if (!isValid(config)) {
	        config._d = null;
	    }
	
	    return config;
	}
	
	function configFromInput(config) {
	    var input = config._i;
	    if (isUndefined(input)) {
	        config._d = new Date(hooks.now());
	    } else if (isDate(input)) {
	        config._d = new Date(input.valueOf());
	    } else if (typeof input === 'string') {
	        configFromString(config);
	    } else if (isArray(input)) {
	        config._a = map(input.slice(0), function (obj) {
	            return parseInt(obj, 10);
	        });
	        configFromArray(config);
	    } else if (isObject(input)) {
	        configFromObject(config);
	    } else if (isNumber(input)) {
	        // from milliseconds
	        config._d = new Date(input);
	    } else {
	        hooks.createFromInputFallback(config);
	    }
	}
	
	function createLocalOrUTC (input, format, locale, strict, isUTC) {
	    var c = {};
	
	    if (locale === true || locale === false) {
	        strict = locale;
	        locale = undefined;
	    }
	
	    if ((isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)) {
	        input = undefined;
	    }
	    // object construction must be done this way.
	    // https://github.com/moment/moment/issues/1423
	    c._isAMomentObject = true;
	    c._useUTC = c._isUTC = isUTC;
	    c._l = locale;
	    c._i = input;
	    c._f = format;
	    c._strict = strict;
	
	    return createFromConfig(c);
	}
	
	function createLocal (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, false);
	}
	
	var prototypeMin = deprecate(
	    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other < this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	var prototypeMax = deprecate(
	    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other > this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	// Pick a moment m from moments so that m[fn](other) is true for all
	// other. This relies on the function fn to be transitive.
	//
	// moments should either be an array of moment objects or an array, whose
	// first element is an array of moment objects.
	function pickBy(fn, moments) {
	    var res, i;
	    if (moments.length === 1 && isArray(moments[0])) {
	        moments = moments[0];
	    }
	    if (!moments.length) {
	        return createLocal();
	    }
	    res = moments[0];
	    for (i = 1; i < moments.length; ++i) {
	        if (!moments[i].isValid() || moments[i][fn](res)) {
	            res = moments[i];
	        }
	    }
	    return res;
	}
	
	// TODO: Use [].sort instead?
	function min () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isBefore', args);
	}
	
	function max () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isAfter', args);
	}
	
	var now = function () {
	    return Date.now ? Date.now() : +(new Date());
	};
	
	var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	function isDurationValid(m) {
	    for (var key in m) {
	        if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	            return false;
	        }
	    }
	
	    var unitHasDecimal = false;
	    for (var i = 0; i < ordering.length; ++i) {
	        if (m[ordering[i]]) {
	            if (unitHasDecimal) {
	                return false; // only allow non-integers for smallest unit
	            }
	            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                unitHasDecimal = true;
	            }
	        }
	    }
	
	    return true;
	}
	
	function isValid$1() {
	    return this._isValid;
	}
	
	function createInvalid$1() {
	    return createDuration(NaN);
	}
	
	function Duration (duration) {
	    var normalizedInput = normalizeObjectUnits(duration),
	        years = normalizedInput.year || 0,
	        quarters = normalizedInput.quarter || 0,
	        months = normalizedInput.month || 0,
	        weeks = normalizedInput.week || 0,
	        days = normalizedInput.day || 0,
	        hours = normalizedInput.hour || 0,
	        minutes = normalizedInput.minute || 0,
	        seconds = normalizedInput.second || 0,
	        milliseconds = normalizedInput.millisecond || 0;
	
	    this._isValid = isDurationValid(normalizedInput);
	
	    // representation for dateAddRemove
	    this._milliseconds = +milliseconds +
	        seconds * 1e3 + // 1000
	        minutes * 6e4 + // 1000 * 60
	        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	    // Because of dateAddRemove treats 24 hours as different from a
	    // day when working around DST, we need to store them separately
	    this._days = +days +
	        weeks * 7;
	    // It is impossible to translate months into days without knowing
	    // which months you are are talking about, so we have to store
	    // it separately.
	    this._months = +months +
	        quarters * 3 +
	        years * 12;
	
	    this._data = {};
	
	    this._locale = getLocale();
	
	    this._bubble();
	}
	
	function isDuration (obj) {
	    return obj instanceof Duration;
	}
	
	function absRound (number) {
	    if (number < 0) {
	        return Math.round(-1 * number) * -1;
	    } else {
	        return Math.round(number);
	    }
	}
	
	// FORMATTING
	
	function offset (token, separator) {
	    addFormatToken(token, 0, 0, function () {
	        var offset = this.utcOffset();
	        var sign = '+';
	        if (offset < 0) {
	            offset = -offset;
	            sign = '-';
	        }
	        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	    });
	}
	
	offset('Z', ':');
	offset('ZZ', '');
	
	// PARSING
	
	addRegexToken('Z',  matchShortOffset);
	addRegexToken('ZZ', matchShortOffset);
	addParseToken(['Z', 'ZZ'], function (input, array, config) {
	    config._useUTC = true;
	    config._tzm = offsetFromString(matchShortOffset, input);
	});
	
	// HELPERS
	
	// timezone chunker
	// '+10:00' > ['10',  '00']
	// '-1530'  > ['-15', '30']
	var chunkOffset = /([\+\-]|\d\d)/gi;
	
	function offsetFromString(matcher, string) {
	    var matches = (string || '').match(matcher);
	
	    if (matches === null) {
	        return null;
	    }
	
	    var chunk   = matches[matches.length - 1] || [];
	    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	    var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	    return minutes === 0 ?
	      0 :
	      parts[0] === '+' ? minutes : -minutes;
	}
	
	// Return a moment from input, that is local/utc/zone equivalent to model.
	function cloneWithOffset(input, model) {
	    var res, diff;
	    if (model._isUTC) {
	        res = model.clone();
	        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	        // Use low-level api, because this fn is low-level api.
	        res._d.setTime(res._d.valueOf() + diff);
	        hooks.updateOffset(res, false);
	        return res;
	    } else {
	        return createLocal(input).local();
	    }
	}
	
	function getDateOffset (m) {
	    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	    // https://github.com/moment/moment/pull/1871
	    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	}
	
	// HOOKS
	
	// This function will be called whenever a moment is mutated.
	// It is intended to keep the offset in sync with the timezone.
	hooks.updateOffset = function () {};
	
	// MOMENTS
	
	// keepLocalTime = true means only change the timezone, without
	// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	// +0200, so we adjust the time as needed, to be valid.
	//
	// Keeping the time actually adds/subtracts (one hour)
	// from the actual represented time. That is why we call updateOffset
	// a second time. In case it wants us to change the offset again
	// _changeInProgress == true case, then we have to adjust, because
	// there is no such time in the given timezone.
	function getSetOffset (input, keepLocalTime, keepMinutes) {
	    var offset = this._offset || 0,
	        localAdjust;
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    if (input != null) {
	        if (typeof input === 'string') {
	            input = offsetFromString(matchShortOffset, input);
	            if (input === null) {
	                return this;
	            }
	        } else if (Math.abs(input) < 16 && !keepMinutes) {
	            input = input * 60;
	        }
	        if (!this._isUTC && keepLocalTime) {
	            localAdjust = getDateOffset(this);
	        }
	        this._offset = input;
	        this._isUTC = true;
	        if (localAdjust != null) {
	            this.add(localAdjust, 'm');
	        }
	        if (offset !== input) {
	            if (!keepLocalTime || this._changeInProgress) {
	                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	            } else if (!this._changeInProgress) {
	                this._changeInProgress = true;
	                hooks.updateOffset(this, true);
	                this._changeInProgress = null;
	            }
	        }
	        return this;
	    } else {
	        return this._isUTC ? offset : getDateOffset(this);
	    }
	}
	
	function getSetZone (input, keepLocalTime) {
	    if (input != null) {
	        if (typeof input !== 'string') {
	            input = -input;
	        }
	
	        this.utcOffset(input, keepLocalTime);
	
	        return this;
	    } else {
	        return -this.utcOffset();
	    }
	}
	
	function setOffsetToUTC (keepLocalTime) {
	    return this.utcOffset(0, keepLocalTime);
	}
	
	function setOffsetToLocal (keepLocalTime) {
	    if (this._isUTC) {
	        this.utcOffset(0, keepLocalTime);
	        this._isUTC = false;
	
	        if (keepLocalTime) {
	            this.subtract(getDateOffset(this), 'm');
	        }
	    }
	    return this;
	}
	
	function setOffsetToParsedOffset () {
	    if (this._tzm != null) {
	        this.utcOffset(this._tzm, false, true);
	    } else if (typeof this._i === 'string') {
	        var tZone = offsetFromString(matchOffset, this._i);
	        if (tZone != null) {
	            this.utcOffset(tZone);
	        }
	        else {
	            this.utcOffset(0, true);
	        }
	    }
	    return this;
	}
	
	function hasAlignedHourOffset (input) {
	    if (!this.isValid()) {
	        return false;
	    }
	    input = input ? createLocal(input).utcOffset() : 0;
	
	    return (this.utcOffset() - input) % 60 === 0;
	}
	
	function isDaylightSavingTime () {
	    return (
	        this.utcOffset() > this.clone().month(0).utcOffset() ||
	        this.utcOffset() > this.clone().month(5).utcOffset()
	    );
	}
	
	function isDaylightSavingTimeShifted () {
	    if (!isUndefined(this._isDSTShifted)) {
	        return this._isDSTShifted;
	    }
	
	    var c = {};
	
	    copyConfig(c, this);
	    c = prepareConfig(c);
	
	    if (c._a) {
	        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	        this._isDSTShifted = this.isValid() &&
	            compareArrays(c._a, other.toArray()) > 0;
	    } else {
	        this._isDSTShifted = false;
	    }
	
	    return this._isDSTShifted;
	}
	
	function isLocal () {
	    return this.isValid() ? !this._isUTC : false;
	}
	
	function isUtcOffset () {
	    return this.isValid() ? this._isUTC : false;
	}
	
	function isUtc () {
	    return this.isValid() ? this._isUTC && this._offset === 0 : false;
	}
	
	// ASP.NET json date format regex
	var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	// and further modified to allow for strings containing both week and day
	var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	function createDuration (input, key) {
	    var duration = input,
	        // matching against regexp is expensive, do it on demand
	        match = null,
	        sign,
	        ret,
	        diffRes;
	
	    if (isDuration(input)) {
	        duration = {
	            ms : input._milliseconds,
	            d  : input._days,
	            M  : input._months
	        };
	    } else if (isNumber(input)) {
	        duration = {};
	        if (key) {
	            duration[key] = input;
	        } else {
	            duration.milliseconds = input;
	        }
	    } else if (!!(match = aspNetRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y  : 0,
	            d  : toInt(match[DATE])                         * sign,
	            h  : toInt(match[HOUR])                         * sign,
	            m  : toInt(match[MINUTE])                       * sign,
	            s  : toInt(match[SECOND])                       * sign,
	            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	        };
	    } else if (!!(match = isoRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
	        duration = {
	            y : parseIso(match[2], sign),
	            M : parseIso(match[3], sign),
	            w : parseIso(match[4], sign),
	            d : parseIso(match[5], sign),
	            h : parseIso(match[6], sign),
	            m : parseIso(match[7], sign),
	            s : parseIso(match[8], sign)
	        };
	    } else if (duration == null) {// checks for null or undefined
	        duration = {};
	    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	        duration = {};
	        duration.ms = diffRes.milliseconds;
	        duration.M = diffRes.months;
	    }
	
	    ret = new Duration(duration);
	
	    if (isDuration(input) && hasOwnProp(input, '_locale')) {
	        ret._locale = input._locale;
	    }
	
	    return ret;
	}
	
	createDuration.fn = Duration.prototype;
	createDuration.invalid = createInvalid$1;
	
	function parseIso (inp, sign) {
	    // We'd normally use ~~inp for this, but unfortunately it also
	    // converts floats to ints.
	    // inp may be undefined, so careful calling replace on it.
	    var res = inp && parseFloat(inp.replace(',', '.'));
	    // apply sign while we're at it
	    return (isNaN(res) ? 0 : res) * sign;
	}
	
	function positiveMomentsDifference(base, other) {
	    var res = {milliseconds: 0, months: 0};
	
	    res.months = other.month() - base.month() +
	        (other.year() - base.year()) * 12;
	    if (base.clone().add(res.months, 'M').isAfter(other)) {
	        --res.months;
	    }
	
	    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	    return res;
	}
	
	function momentsDifference(base, other) {
	    var res;
	    if (!(base.isValid() && other.isValid())) {
	        return {milliseconds: 0, months: 0};
	    }
	
	    other = cloneWithOffset(other, base);
	    if (base.isBefore(other)) {
	        res = positiveMomentsDifference(base, other);
	    } else {
	        res = positiveMomentsDifference(other, base);
	        res.milliseconds = -res.milliseconds;
	        res.months = -res.months;
	    }
	
	    return res;
	}
	
	// TODO: remove 'name' arg after deprecation is removed
	function createAdder(direction, name) {
	    return function (val, period) {
	        var dur, tmp;
	        //invert the arguments, but complain about it
	        if (period !== null && !isNaN(+period)) {
	            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	            tmp = val; val = period; period = tmp;
	        }
	
	        val = typeof val === 'string' ? +val : val;
	        dur = createDuration(val, period);
	        addSubtract(this, dur, direction);
	        return this;
	    };
	}
	
	function addSubtract (mom, duration, isAdding, updateOffset) {
	    var milliseconds = duration._milliseconds,
	        days = absRound(duration._days),
	        months = absRound(duration._months);
	
	    if (!mom.isValid()) {
	        // No op
	        return;
	    }
	
	    updateOffset = updateOffset == null ? true : updateOffset;
	
	    if (months) {
	        setMonth(mom, get(mom, 'Month') + months * isAdding);
	    }
	    if (days) {
	        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	    }
	    if (milliseconds) {
	        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	    }
	    if (updateOffset) {
	        hooks.updateOffset(mom, days || months);
	    }
	}
	
	var add      = createAdder(1, 'add');
	var subtract = createAdder(-1, 'subtract');
	
	function getCalendarFormat(myMoment, now) {
	    var diff = myMoment.diff(now, 'days', true);
	    return diff < -6 ? 'sameElse' :
	            diff < -1 ? 'lastWeek' :
	            diff < 0 ? 'lastDay' :
	            diff < 1 ? 'sameDay' :
	            diff < 2 ? 'nextDay' :
	            diff < 7 ? 'nextWeek' : 'sameElse';
	}
	
	function calendar$1 (time, formats) {
	    // We want to compare the start of today, vs this.
	    // Getting start-of-today depends on whether we're local/utc/offset or not.
	    var now = time || createLocal(),
	        sod = cloneWithOffset(now, this).startOf('day'),
	        format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	}
	
	function clone () {
	    return new Moment(this);
	}
	
	function isAfter (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() > localInput.valueOf();
	    } else {
	        return localInput.valueOf() < this.clone().startOf(units).valueOf();
	    }
	}
	
	function isBefore (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() < localInput.valueOf();
	    } else {
	        return this.clone().endOf(units).valueOf() < localInput.valueOf();
	    }
	}
	
	function isBetween (from, to, units, inclusivity) {
	    inclusivity = inclusivity || '()';
	    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	}
	
	function isSame (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input),
	        inputMs;
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(units || 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() === localInput.valueOf();
	    } else {
	        inputMs = localInput.valueOf();
	        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	    }
	}
	
	function isSameOrAfter (input, units) {
	    return this.isSame(input, units) || this.isAfter(input,units);
	}
	
	function isSameOrBefore (input, units) {
	    return this.isSame(input, units) || this.isBefore(input,units);
	}
	
	function diff (input, units, asFloat) {
	    var that,
	        zoneDelta,
	        delta, output;
	
	    if (!this.isValid()) {
	        return NaN;
	    }
	
	    that = cloneWithOffset(input, this);
	
	    if (!that.isValid()) {
	        return NaN;
	    }
	
	    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	    units = normalizeUnits(units);
	
	    switch (units) {
	        case 'year': output = monthDiff(this, that) / 12; break;
	        case 'month': output = monthDiff(this, that); break;
	        case 'quarter': output = monthDiff(this, that) / 3; break;
	        case 'second': output = (this - that) / 1e3; break; // 1000
	        case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
	        case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
	        case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
	        case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
	        default: output = this - that;
	    }
	
	    return asFloat ? output : absFloor(output);
	}
	
	function monthDiff (a, b) {
	    // difference in months
	    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	        // b is in (anchor - 1 month, anchor + 1 month)
	        anchor = a.clone().add(wholeMonthDiff, 'months'),
	        anchor2, adjust;
	
	    if (b - anchor < 0) {
	        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor - anchor2);
	    } else {
	        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor2 - anchor);
	    }
	
	    //check for negative zero, return zero if negative zero
	    return -(wholeMonthDiff + adjust) || 0;
	}
	
	hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	function toString () {
	    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	}
	
	function toISOString(keepOffset) {
	    if (!this.isValid()) {
	        return null;
	    }
	    var utc = keepOffset !== true;
	    var m = utc ? this.clone().utc() : this;
	    if (m.year() < 0 || m.year() > 9999) {
	        return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
	    }
	    if (isFunction(Date.prototype.toISOString)) {
	        // native implementation is ~50x faster, use it when we can
	        if (utc) {
	            return this.toDate().toISOString();
	        } else {
	            return new Date(this._d.valueOf()).toISOString().replace('Z', formatMoment(m, 'Z'));
	        }
	    }
	    return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
	}
	
	/**
	 * Return a human readable representation of a moment that can
	 * also be evaluated to get a new moment which is the same
	 *
	 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	 */
	function inspect () {
	    if (!this.isValid()) {
	        return 'moment.invalid(/* ' + this._i + ' */)';
	    }
	    var func = 'moment';
	    var zone = '';
	    if (!this.isLocal()) {
	        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	        zone = 'Z';
	    }
	    var prefix = '[' + func + '("]';
	    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	    var suffix = zone + '[")]';
	
	    return this.format(prefix + year + datetime + suffix);
	}
	
	function format (inputString) {
	    if (!inputString) {
	        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	    }
	    var output = formatMoment(this, inputString);
	    return this.localeData().postformat(output);
	}
	
	function from (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function fromNow (withoutSuffix) {
	    return this.from(createLocal(), withoutSuffix);
	}
	
	function to (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function toNow (withoutSuffix) {
	    return this.to(createLocal(), withoutSuffix);
	}
	
	// If passed a locale key, it will set the locale for this
	// instance.  Otherwise, it will return the locale configuration
	// variables for this instance.
	function locale (key) {
	    var newLocaleData;
	
	    if (key === undefined) {
	        return this._locale._abbr;
	    } else {
	        newLocaleData = getLocale(key);
	        if (newLocaleData != null) {
	            this._locale = newLocaleData;
	        }
	        return this;
	    }
	}
	
	var lang = deprecate(
	    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	    function (key) {
	        if (key === undefined) {
	            return this.localeData();
	        } else {
	            return this.locale(key);
	        }
	    }
	);
	
	function localeData () {
	    return this._locale;
	}
	
	function startOf (units) {
	    units = normalizeUnits(units);
	    // the following switch intentionally omits break keywords
	    // to utilize falling through the cases.
	    switch (units) {
	        case 'year':
	            this.month(0);
	            /* falls through */
	        case 'quarter':
	        case 'month':
	            this.date(1);
	            /* falls through */
	        case 'week':
	        case 'isoWeek':
	        case 'day':
	        case 'date':
	            this.hours(0);
	            /* falls through */
	        case 'hour':
	            this.minutes(0);
	            /* falls through */
	        case 'minute':
	            this.seconds(0);
	            /* falls through */
	        case 'second':
	            this.milliseconds(0);
	    }
	
	    // weeks are a special case
	    if (units === 'week') {
	        this.weekday(0);
	    }
	    if (units === 'isoWeek') {
	        this.isoWeekday(1);
	    }
	
	    // quarters are also special
	    if (units === 'quarter') {
	        this.month(Math.floor(this.month() / 3) * 3);
	    }
	
	    return this;
	}
	
	function endOf (units) {
	    units = normalizeUnits(units);
	    if (units === undefined || units === 'millisecond') {
	        return this;
	    }
	
	    // 'date' is an alias for 'day', so it should be considered as such.
	    if (units === 'date') {
	        units = 'day';
	    }
	
	    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	}
	
	function valueOf () {
	    return this._d.valueOf() - ((this._offset || 0) * 60000);
	}
	
	function unix () {
	    return Math.floor(this.valueOf() / 1000);
	}
	
	function toDate () {
	    return new Date(this.valueOf());
	}
	
	function toArray () {
	    var m = this;
	    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	}
	
	function toObject () {
	    var m = this;
	    return {
	        years: m.year(),
	        months: m.month(),
	        date: m.date(),
	        hours: m.hours(),
	        minutes: m.minutes(),
	        seconds: m.seconds(),
	        milliseconds: m.milliseconds()
	    };
	}
	
	function toJSON () {
	    // new Date(NaN).toJSON() === null
	    return this.isValid() ? this.toISOString() : null;
	}
	
	function isValid$2 () {
	    return isValid(this);
	}
	
	function parsingFlags () {
	    return extend({}, getParsingFlags(this));
	}
	
	function invalidAt () {
	    return getParsingFlags(this).overflow;
	}
	
	function creationData() {
	    return {
	        input: this._i,
	        format: this._f,
	        locale: this._locale,
	        isUTC: this._isUTC,
	        strict: this._strict
	    };
	}
	
	// FORMATTING
	
	addFormatToken(0, ['gg', 2], 0, function () {
	    return this.weekYear() % 100;
	});
	
	addFormatToken(0, ['GG', 2], 0, function () {
	    return this.isoWeekYear() % 100;
	});
	
	function addWeekYearFormatToken (token, getter) {
	    addFormatToken(0, [token, token.length], 0, getter);
	}
	
	addWeekYearFormatToken('gggg',     'weekYear');
	addWeekYearFormatToken('ggggg',    'weekYear');
	addWeekYearFormatToken('GGGG',  'isoWeekYear');
	addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	// ALIASES
	
	addUnitAlias('weekYear', 'gg');
	addUnitAlias('isoWeekYear', 'GG');
	
	// PRIORITY
	
	addUnitPriority('weekYear', 1);
	addUnitPriority('isoWeekYear', 1);
	
	
	// PARSING
	
	addRegexToken('G',      matchSigned);
	addRegexToken('g',      matchSigned);
	addRegexToken('GG',     match1to2, match2);
	addRegexToken('gg',     match1to2, match2);
	addRegexToken('GGGG',   match1to4, match4);
	addRegexToken('gggg',   match1to4, match4);
	addRegexToken('GGGGG',  match1to6, match6);
	addRegexToken('ggggg',  match1to6, match6);
	
	addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	    week[token.substr(0, 2)] = toInt(input);
	});
	
	addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	    week[token] = hooks.parseTwoDigitYear(input);
	});
	
	// MOMENTS
	
	function getSetWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy);
	}
	
	function getSetISOWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input, this.isoWeek(), this.isoWeekday(), 1, 4);
	}
	
	function getISOWeeksInYear () {
	    return weeksInYear(this.year(), 1, 4);
	}
	
	function getWeeksInYear () {
	    var weekInfo = this.localeData()._week;
	    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	}
	
	function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	    var weeksTarget;
	    if (input == null) {
	        return weekOfYear(this, dow, doy).year;
	    } else {
	        weeksTarget = weeksInYear(input, dow, doy);
	        if (week > weeksTarget) {
	            week = weeksTarget;
	        }
	        return setWeekAll.call(this, input, week, weekday, dow, doy);
	    }
	}
	
	function setWeekAll(weekYear, week, weekday, dow, doy) {
	    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	    this.year(date.getUTCFullYear());
	    this.month(date.getUTCMonth());
	    this.date(date.getUTCDate());
	    return this;
	}
	
	// FORMATTING
	
	addFormatToken('Q', 0, 'Qo', 'quarter');
	
	// ALIASES
	
	addUnitAlias('quarter', 'Q');
	
	// PRIORITY
	
	addUnitPriority('quarter', 7);
	
	// PARSING
	
	addRegexToken('Q', match1);
	addParseToken('Q', function (input, array) {
	    array[MONTH] = (toInt(input) - 1) * 3;
	});
	
	// MOMENTS
	
	function getSetQuarter (input) {
	    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	}
	
	// FORMATTING
	
	addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	// ALIASES
	
	addUnitAlias('date', 'D');
	
	// PRIOROITY
	addUnitPriority('date', 9);
	
	// PARSING
	
	addRegexToken('D',  match1to2);
	addRegexToken('DD', match1to2, match2);
	addRegexToken('Do', function (isStrict, locale) {
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    return isStrict ?
	      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	      locale._dayOfMonthOrdinalParseLenient;
	});
	
	addParseToken(['D', 'DD'], DATE);
	addParseToken('Do', function (input, array) {
	    array[DATE] = toInt(input.match(match1to2)[0]);
	});
	
	// MOMENTS
	
	var getSetDayOfMonth = makeGetSet('Date', true);
	
	// FORMATTING
	
	addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	// ALIASES
	
	addUnitAlias('dayOfYear', 'DDD');
	
	// PRIORITY
	addUnitPriority('dayOfYear', 4);
	
	// PARSING
	
	addRegexToken('DDD',  match1to3);
	addRegexToken('DDDD', match3);
	addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	    config._dayOfYear = toInt(input);
	});
	
	// HELPERS
	
	// MOMENTS
	
	function getSetDayOfYear (input) {
	    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	}
	
	// FORMATTING
	
	addFormatToken('m', ['mm', 2], 0, 'minute');
	
	// ALIASES
	
	addUnitAlias('minute', 'm');
	
	// PRIORITY
	
	addUnitPriority('minute', 14);
	
	// PARSING
	
	addRegexToken('m',  match1to2);
	addRegexToken('mm', match1to2, match2);
	addParseToken(['m', 'mm'], MINUTE);
	
	// MOMENTS
	
	var getSetMinute = makeGetSet('Minutes', false);
	
	// FORMATTING
	
	addFormatToken('s', ['ss', 2], 0, 'second');
	
	// ALIASES
	
	addUnitAlias('second', 's');
	
	// PRIORITY
	
	addUnitPriority('second', 15);
	
	// PARSING
	
	addRegexToken('s',  match1to2);
	addRegexToken('ss', match1to2, match2);
	addParseToken(['s', 'ss'], SECOND);
	
	// MOMENTS
	
	var getSetSecond = makeGetSet('Seconds', false);
	
	// FORMATTING
	
	addFormatToken('S', 0, 0, function () {
	    return ~~(this.millisecond() / 100);
	});
	
	addFormatToken(0, ['SS', 2], 0, function () {
	    return ~~(this.millisecond() / 10);
	});
	
	addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	addFormatToken(0, ['SSSS', 4], 0, function () {
	    return this.millisecond() * 10;
	});
	addFormatToken(0, ['SSSSS', 5], 0, function () {
	    return this.millisecond() * 100;
	});
	addFormatToken(0, ['SSSSSS', 6], 0, function () {
	    return this.millisecond() * 1000;
	});
	addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	    return this.millisecond() * 10000;
	});
	addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	    return this.millisecond() * 100000;
	});
	addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	    return this.millisecond() * 1000000;
	});
	
	
	// ALIASES
	
	addUnitAlias('millisecond', 'ms');
	
	// PRIORITY
	
	addUnitPriority('millisecond', 16);
	
	// PARSING
	
	addRegexToken('S',    match1to3, match1);
	addRegexToken('SS',   match1to3, match2);
	addRegexToken('SSS',  match1to3, match3);
	
	var token;
	for (token = 'SSSS'; token.length <= 9; token += 'S') {
	    addRegexToken(token, matchUnsigned);
	}
	
	function parseMs(input, array) {
	    array[MILLISECOND] = toInt(('0.' + input) * 1000);
	}
	
	for (token = 'S'; token.length <= 9; token += 'S') {
	    addParseToken(token, parseMs);
	}
	// MOMENTS
	
	var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	// FORMATTING
	
	addFormatToken('z',  0, 0, 'zoneAbbr');
	addFormatToken('zz', 0, 0, 'zoneName');
	
	// MOMENTS
	
	function getZoneAbbr () {
	    return this._isUTC ? 'UTC' : '';
	}
	
	function getZoneName () {
	    return this._isUTC ? 'Coordinated Universal Time' : '';
	}
	
	var proto = Moment.prototype;
	
	proto.add               = add;
	proto.calendar          = calendar$1;
	proto.clone             = clone;
	proto.diff              = diff;
	proto.endOf             = endOf;
	proto.format            = format;
	proto.from              = from;
	proto.fromNow           = fromNow;
	proto.to                = to;
	proto.toNow             = toNow;
	proto.get               = stringGet;
	proto.invalidAt         = invalidAt;
	proto.isAfter           = isAfter;
	proto.isBefore          = isBefore;
	proto.isBetween         = isBetween;
	proto.isSame            = isSame;
	proto.isSameOrAfter     = isSameOrAfter;
	proto.isSameOrBefore    = isSameOrBefore;
	proto.isValid           = isValid$2;
	proto.lang              = lang;
	proto.locale            = locale;
	proto.localeData        = localeData;
	proto.max               = prototypeMax;
	proto.min               = prototypeMin;
	proto.parsingFlags      = parsingFlags;
	proto.set               = stringSet;
	proto.startOf           = startOf;
	proto.subtract          = subtract;
	proto.toArray           = toArray;
	proto.toObject          = toObject;
	proto.toDate            = toDate;
	proto.toISOString       = toISOString;
	proto.inspect           = inspect;
	proto.toJSON            = toJSON;
	proto.toString          = toString;
	proto.unix              = unix;
	proto.valueOf           = valueOf;
	proto.creationData      = creationData;
	
	// Year
	proto.year       = getSetYear;
	proto.isLeapYear = getIsLeapYear;
	
	// Week Year
	proto.weekYear    = getSetWeekYear;
	proto.isoWeekYear = getSetISOWeekYear;
	
	// Quarter
	proto.quarter = proto.quarters = getSetQuarter;
	
	// Month
	proto.month       = getSetMonth;
	proto.daysInMonth = getDaysInMonth;
	
	// Week
	proto.week           = proto.weeks        = getSetWeek;
	proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	proto.weeksInYear    = getWeeksInYear;
	proto.isoWeeksInYear = getISOWeeksInYear;
	
	// Day
	proto.date       = getSetDayOfMonth;
	proto.day        = proto.days             = getSetDayOfWeek;
	proto.weekday    = getSetLocaleDayOfWeek;
	proto.isoWeekday = getSetISODayOfWeek;
	proto.dayOfYear  = getSetDayOfYear;
	
	// Hour
	proto.hour = proto.hours = getSetHour;
	
	// Minute
	proto.minute = proto.minutes = getSetMinute;
	
	// Second
	proto.second = proto.seconds = getSetSecond;
	
	// Millisecond
	proto.millisecond = proto.milliseconds = getSetMillisecond;
	
	// Offset
	proto.utcOffset            = getSetOffset;
	proto.utc                  = setOffsetToUTC;
	proto.local                = setOffsetToLocal;
	proto.parseZone            = setOffsetToParsedOffset;
	proto.hasAlignedHourOffset = hasAlignedHourOffset;
	proto.isDST                = isDaylightSavingTime;
	proto.isLocal              = isLocal;
	proto.isUtcOffset          = isUtcOffset;
	proto.isUtc                = isUtc;
	proto.isUTC                = isUtc;
	
	// Timezone
	proto.zoneAbbr = getZoneAbbr;
	proto.zoneName = getZoneName;
	
	// Deprecations
	proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	function createUnix (input) {
	    return createLocal(input * 1000);
	}
	
	function createInZone () {
	    return createLocal.apply(null, arguments).parseZone();
	}
	
	function preParsePostFormat (string) {
	    return string;
	}
	
	var proto$1 = Locale.prototype;
	
	proto$1.calendar        = calendar;
	proto$1.longDateFormat  = longDateFormat;
	proto$1.invalidDate     = invalidDate;
	proto$1.ordinal         = ordinal;
	proto$1.preparse        = preParsePostFormat;
	proto$1.postformat      = preParsePostFormat;
	proto$1.relativeTime    = relativeTime;
	proto$1.pastFuture      = pastFuture;
	proto$1.set             = set;
	
	// Month
	proto$1.months            =        localeMonths;
	proto$1.monthsShort       =        localeMonthsShort;
	proto$1.monthsParse       =        localeMonthsParse;
	proto$1.monthsRegex       = monthsRegex;
	proto$1.monthsShortRegex  = monthsShortRegex;
	
	// Week
	proto$1.week = localeWeek;
	proto$1.firstDayOfYear = localeFirstDayOfYear;
	proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	// Day of Week
	proto$1.weekdays       =        localeWeekdays;
	proto$1.weekdaysMin    =        localeWeekdaysMin;
	proto$1.weekdaysShort  =        localeWeekdaysShort;
	proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	proto$1.weekdaysRegex       =        weekdaysRegex;
	proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	// Hours
	proto$1.isPM = localeIsPM;
	proto$1.meridiem = localeMeridiem;
	
	function get$1 (format, index, field, setter) {
	    var locale = getLocale();
	    var utc = createUTC().set(setter, index);
	    return locale[field](utc, format);
	}
	
	function listMonthsImpl (format, index, field) {
	    if (isNumber(format)) {
	        index = format;
	        format = undefined;
	    }
	
	    format = format || '';
	
	    if (index != null) {
	        return get$1(format, index, field, 'month');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 12; i++) {
	        out[i] = get$1(format, i, field, 'month');
	    }
	    return out;
	}
	
	// ()
	// (5)
	// (fmt, 5)
	// (fmt)
	// (true)
	// (true, 5)
	// (true, fmt, 5)
	// (true, fmt)
	function listWeekdaysImpl (localeSorted, format, index, field) {
	    if (typeof localeSorted === 'boolean') {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    } else {
	        format = localeSorted;
	        index = format;
	        localeSorted = false;
	
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    }
	
	    var locale = getLocale(),
	        shift = localeSorted ? locale._week.dow : 0;
	
	    if (index != null) {
	        return get$1(format, (index + shift) % 7, field, 'day');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 7; i++) {
	        out[i] = get$1(format, (i + shift) % 7, field, 'day');
	    }
	    return out;
	}
	
	function listMonths (format, index) {
	    return listMonthsImpl(format, index, 'months');
	}
	
	function listMonthsShort (format, index) {
	    return listMonthsImpl(format, index, 'monthsShort');
	}
	
	function listWeekdays (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	}
	
	function listWeekdaysShort (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	}
	
	function listWeekdaysMin (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	}
	
	getSetGlobalLocale('en', {
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (toInt(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	// Side effect imports
	hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	var mathAbs = Math.abs;
	
	function abs () {
	    var data           = this._data;
	
	    this._milliseconds = mathAbs(this._milliseconds);
	    this._days         = mathAbs(this._days);
	    this._months       = mathAbs(this._months);
	
	    data.milliseconds  = mathAbs(data.milliseconds);
	    data.seconds       = mathAbs(data.seconds);
	    data.minutes       = mathAbs(data.minutes);
	    data.hours         = mathAbs(data.hours);
	    data.months        = mathAbs(data.months);
	    data.years         = mathAbs(data.years);
	
	    return this;
	}
	
	function addSubtract$1 (duration, input, value, direction) {
	    var other = createDuration(input, value);
	
	    duration._milliseconds += direction * other._milliseconds;
	    duration._days         += direction * other._days;
	    duration._months       += direction * other._months;
	
	    return duration._bubble();
	}
	
	// supports only 2.0-style add(1, 's') or add(duration)
	function add$1 (input, value) {
	    return addSubtract$1(this, input, value, 1);
	}
	
	// supports only 2.0-style subtract(1, 's') or subtract(duration)
	function subtract$1 (input, value) {
	    return addSubtract$1(this, input, value, -1);
	}
	
	function absCeil (number) {
	    if (number < 0) {
	        return Math.floor(number);
	    } else {
	        return Math.ceil(number);
	    }
	}
	
	function bubble () {
	    var milliseconds = this._milliseconds;
	    var days         = this._days;
	    var months       = this._months;
	    var data         = this._data;
	    var seconds, minutes, hours, years, monthsFromDays;
	
	    // if we have a mix of positive and negative values, bubble down first
	    // check: https://github.com/moment/moment/issues/2166
	    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	            (milliseconds <= 0 && days <= 0 && months <= 0))) {
	        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	        days = 0;
	        months = 0;
	    }
	
	    // The following code bubbles up values, see the tests for
	    // examples of what that means.
	    data.milliseconds = milliseconds % 1000;
	
	    seconds           = absFloor(milliseconds / 1000);
	    data.seconds      = seconds % 60;
	
	    minutes           = absFloor(seconds / 60);
	    data.minutes      = minutes % 60;
	
	    hours             = absFloor(minutes / 60);
	    data.hours        = hours % 24;
	
	    days += absFloor(hours / 24);
	
	    // convert days to months
	    monthsFromDays = absFloor(daysToMonths(days));
	    months += monthsFromDays;
	    days -= absCeil(monthsToDays(monthsFromDays));
	
	    // 12 months -> 1 year
	    years = absFloor(months / 12);
	    months %= 12;
	
	    data.days   = days;
	    data.months = months;
	    data.years  = years;
	
	    return this;
	}
	
	function daysToMonths (days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    // 400 years have 12 months === 4800
	    return days * 4800 / 146097;
	}
	
	function monthsToDays (months) {
	    // the reverse of daysToMonths
	    return months * 146097 / 4800;
	}
	
	function as (units) {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    var days;
	    var months;
	    var milliseconds = this._milliseconds;
	
	    units = normalizeUnits(units);
	
	    if (units === 'month' || units === 'year') {
	        days   = this._days   + milliseconds / 864e5;
	        months = this._months + daysToMonths(days);
	        return units === 'month' ? months : months / 12;
	    } else {
	        // handle milliseconds separately because of floating point math errors (issue #1867)
	        days = this._days + Math.round(monthsToDays(this._months));
	        switch (units) {
	            case 'week'   : return days / 7     + milliseconds / 6048e5;
	            case 'day'    : return days         + milliseconds / 864e5;
	            case 'hour'   : return days * 24    + milliseconds / 36e5;
	            case 'minute' : return days * 1440  + milliseconds / 6e4;
	            case 'second' : return days * 86400 + milliseconds / 1000;
	            // Math.floor prevents floating point math errors here
	            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	            default: throw new Error('Unknown unit ' + units);
	        }
	    }
	}
	
	// TODO: Use this.as('ms')?
	function valueOf$1 () {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    return (
	        this._milliseconds +
	        this._days * 864e5 +
	        (this._months % 12) * 2592e6 +
	        toInt(this._months / 12) * 31536e6
	    );
	}
	
	function makeAs (alias) {
	    return function () {
	        return this.as(alias);
	    };
	}
	
	var asMilliseconds = makeAs('ms');
	var asSeconds      = makeAs('s');
	var asMinutes      = makeAs('m');
	var asHours        = makeAs('h');
	var asDays         = makeAs('d');
	var asWeeks        = makeAs('w');
	var asMonths       = makeAs('M');
	var asYears        = makeAs('y');
	
	function clone$1 () {
	    return createDuration(this);
	}
	
	function get$2 (units) {
	    units = normalizeUnits(units);
	    return this.isValid() ? this[units + 's']() : NaN;
	}
	
	function makeGetter(name) {
	    return function () {
	        return this.isValid() ? this._data[name] : NaN;
	    };
	}
	
	var milliseconds = makeGetter('milliseconds');
	var seconds      = makeGetter('seconds');
	var minutes      = makeGetter('minutes');
	var hours        = makeGetter('hours');
	var days         = makeGetter('days');
	var months       = makeGetter('months');
	var years        = makeGetter('years');
	
	function weeks () {
	    return absFloor(this.days() / 7);
	}
	
	var round = Math.round;
	var thresholds = {
	    ss: 44,         // a few seconds to seconds
	    s : 45,         // seconds to minute
	    m : 45,         // minutes to hour
	    h : 22,         // hours to day
	    d : 26,         // days to month
	    M : 11          // months to year
	};
	
	// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	}
	
	function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	    var duration = createDuration(posNegDuration).abs();
	    var seconds  = round(duration.as('s'));
	    var minutes  = round(duration.as('m'));
	    var hours    = round(duration.as('h'));
	    var days     = round(duration.as('d'));
	    var months   = round(duration.as('M'));
	    var years    = round(duration.as('y'));
	
	    var a = seconds <= thresholds.ss && ['s', seconds]  ||
	            seconds < thresholds.s   && ['ss', seconds] ||
	            minutes <= 1             && ['m']           ||
	            minutes < thresholds.m   && ['mm', minutes] ||
	            hours   <= 1             && ['h']           ||
	            hours   < thresholds.h   && ['hh', hours]   ||
	            days    <= 1             && ['d']           ||
	            days    < thresholds.d   && ['dd', days]    ||
	            months  <= 1             && ['M']           ||
	            months  < thresholds.M   && ['MM', months]  ||
	            years   <= 1             && ['y']           || ['yy', years];
	
	    a[2] = withoutSuffix;
	    a[3] = +posNegDuration > 0;
	    a[4] = locale;
	    return substituteTimeAgo.apply(null, a);
	}
	
	// This function allows you to set the rounding function for relative time strings
	function getSetRelativeTimeRounding (roundingFunction) {
	    if (roundingFunction === undefined) {
	        return round;
	    }
	    if (typeof(roundingFunction) === 'function') {
	        round = roundingFunction;
	        return true;
	    }
	    return false;
	}
	
	// This function allows you to set a threshold for relative time strings
	function getSetRelativeTimeThreshold (threshold, limit) {
	    if (thresholds[threshold] === undefined) {
	        return false;
	    }
	    if (limit === undefined) {
	        return thresholds[threshold];
	    }
	    thresholds[threshold] = limit;
	    if (threshold === 's') {
	        thresholds.ss = limit - 1;
	    }
	    return true;
	}
	
	function humanize (withSuffix) {
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var locale = this.localeData();
	    var output = relativeTime$1(this, !withSuffix, locale);
	
	    if (withSuffix) {
	        output = locale.pastFuture(+this, output);
	    }
	
	    return locale.postformat(output);
	}
	
	var abs$1 = Math.abs;
	
	function sign(x) {
	    return ((x > 0) - (x < 0)) || +x;
	}
	
	function toISOString$1() {
	    // for ISO strings we do not use the normal bubbling rules:
	    //  * milliseconds bubble up until they become hours
	    //  * days do not bubble at all
	    //  * months bubble up until they become years
	    // This is because there is no context-free conversion between hours and days
	    // (think of clock changes)
	    // and also not between days and months (28-31 days per month)
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var seconds = abs$1(this._milliseconds) / 1000;
	    var days         = abs$1(this._days);
	    var months       = abs$1(this._months);
	    var minutes, hours, years;
	
	    // 3600 seconds -> 60 minutes -> 1 hour
	    minutes           = absFloor(seconds / 60);
	    hours             = absFloor(minutes / 60);
	    seconds %= 60;
	    minutes %= 60;
	
	    // 12 months -> 1 year
	    years  = absFloor(months / 12);
	    months %= 12;
	
	
	    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	    var Y = years;
	    var M = months;
	    var D = days;
	    var h = hours;
	    var m = minutes;
	    var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	    var total = this.asSeconds();
	
	    if (!total) {
	        // this is the same as C#'s (Noda) and python (isodate)...
	        // but not other JS (goog.date)
	        return 'P0D';
	    }
	
	    var totalSign = total < 0 ? '-' : '';
	    var ymSign = sign(this._months) !== sign(total) ? '-' : '';
	    var daysSign = sign(this._days) !== sign(total) ? '-' : '';
	    var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	    return totalSign + 'P' +
	        (Y ? ymSign + Y + 'Y' : '') +
	        (M ? ymSign + M + 'M' : '') +
	        (D ? daysSign + D + 'D' : '') +
	        ((h || m || s) ? 'T' : '') +
	        (h ? hmsSign + h + 'H' : '') +
	        (m ? hmsSign + m + 'M' : '') +
	        (s ? hmsSign + s + 'S' : '');
	}
	
	var proto$2 = Duration.prototype;
	
	proto$2.isValid        = isValid$1;
	proto$2.abs            = abs;
	proto$2.add            = add$1;
	proto$2.subtract       = subtract$1;
	proto$2.as             = as;
	proto$2.asMilliseconds = asMilliseconds;
	proto$2.asSeconds      = asSeconds;
	proto$2.asMinutes      = asMinutes;
	proto$2.asHours        = asHours;
	proto$2.asDays         = asDays;
	proto$2.asWeeks        = asWeeks;
	proto$2.asMonths       = asMonths;
	proto$2.asYears        = asYears;
	proto$2.valueOf        = valueOf$1;
	proto$2._bubble        = bubble;
	proto$2.clone          = clone$1;
	proto$2.get            = get$2;
	proto$2.milliseconds   = milliseconds;
	proto$2.seconds        = seconds;
	proto$2.minutes        = minutes;
	proto$2.hours          = hours;
	proto$2.days           = days;
	proto$2.weeks          = weeks;
	proto$2.months         = months;
	proto$2.years          = years;
	proto$2.humanize       = humanize;
	proto$2.toISOString    = toISOString$1;
	proto$2.toString       = toISOString$1;
	proto$2.toJSON         = toISOString$1;
	proto$2.locale         = locale;
	proto$2.localeData     = localeData;
	
	// Deprecations
	proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	proto$2.lang = lang;
	
	// Side effect imports
	
	// FORMATTING
	
	addFormatToken('X', 0, 0, 'unix');
	addFormatToken('x', 0, 0, 'valueOf');
	
	// PARSING
	
	addRegexToken('x', matchSigned);
	addRegexToken('X', matchTimestamp);
	addParseToken('X', function (input, array, config) {
	    config._d = new Date(parseFloat(input, 10) * 1000);
	});
	addParseToken('x', function (input, array, config) {
	    config._d = new Date(toInt(input));
	});
	
	// Side effect imports
	
	
	hooks.version = '2.20.1';
	
	setHookCallback(createLocal);
	
	hooks.fn                    = proto;
	hooks.min                   = min;
	hooks.max                   = max;
	hooks.now                   = now;
	hooks.utc                   = createUTC;
	hooks.unix                  = createUnix;
	hooks.months                = listMonths;
	hooks.isDate                = isDate;
	hooks.locale                = getSetGlobalLocale;
	hooks.invalid               = createInvalid;
	hooks.duration              = createDuration;
	hooks.isMoment              = isMoment;
	hooks.weekdays              = listWeekdays;
	hooks.parseZone             = createInZone;
	hooks.localeData            = getLocale;
	hooks.isDuration            = isDuration;
	hooks.monthsShort           = listMonthsShort;
	hooks.weekdaysMin           = listWeekdaysMin;
	hooks.defineLocale          = defineLocale;
	hooks.updateLocale          = updateLocale;
	hooks.locales               = listLocales;
	hooks.weekdaysShort         = listWeekdaysShort;
	hooks.normalizeUnits        = normalizeUnits;
	hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
	hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	hooks.calendarFormat        = getCalendarFormat;
	hooks.prototype             = proto;
	
	// currently HTML5 input type only supports 24-hour formats
	hooks.HTML5_FMT = {
	    DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
	    DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
	    DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
	    DATE: 'YYYY-MM-DD',                             // <input type="date" />
	    TIME: 'HH:mm',                                  // <input type="time" />
	    TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
	    TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
	    WEEK: 'YYYY-[W]WW',                             // <input type="week" />
	    MONTH: 'YYYY-MM'                                // <input type="month" />
	};
	
	return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)(module)))

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./de": 11,
		"./de-at": 12,
		"./de-at.js": 12,
		"./de-ch": 13,
		"./de-ch.js": 13,
		"./de.js": 11,
		"./en-gb.js": 14,
		"./fr.js": 15
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 10;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var de = moment.defineLocale('de', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        ss : '%d Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return de;
	
	})));


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deAt = moment.defineLocale('de-at', {
	    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        ss : '%d Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deAt;
	
	})));


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// based on: https://www.bk.admin.ch/dokumentation/sprachen/04915/05016/index.html?lang=de#
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deCh = moment.defineLocale('de-ch', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        ss : '%d Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deCh;
	
	})));


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enGb = moment.defineLocale('en-gb', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        ss : '%d seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enGb;
	
	})));


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fr = moment.defineLocale('fr', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        ss : '%d secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // TODO: Return 'e' when day of month > 1. Move this case inside
	            // block for masculine words below.
	            // See https://github.com/moment/moment/issues/3375
	            case 'D':
	                return number + (number === 1 ? 'er' : '');
	
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fr;
	
	})));


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__) {"use strict";
	
	// General modules
	var $ = __webpack_require__(6);
	var _ = __webpack_require__(7);
	var Backbone = __webpack_require__(20);
	var Promise = __webpack_require__(2);
	var ajax = __webpack_require__(21);
	
	var MiniTimer = __webpack_require__(22);
	var SafeStorage = __webpack_require__(23);
	var TemplateCache = __webpack_require__(25);
	var Registry = __webpack_require__(26);
	var getQueryParameters = __webpack_require__(27);
	
	// App modules
	var Result = __webpack_require__(28);
	var ResultStore = __webpack_require__(29);
	var SidebarView = __webpack_require__(30);
	var SortOrderView = __webpack_require__(31);
	var ResultView = __webpack_require__(32);
	var FilterInfoView = __webpack_require__(33);
	
	var FormModel = __webpack_require__(34);
	var ReservaEngineClient = __webpack_require__(36);
	var TraminoClientsMap = __webpack_require__(37);
	
	// Included modules
	var ReservaDaysModel = __webpack_require__(38);
	
	var ReservaApp = Backbone.Model.extend({
	
	    /* Schlüssel, die beim Reset ignoriert werden sollen */
	    resetIgnore: ['item', 'form', 'client', 'selectedTags', 'config', 'tags_groups', 'isTouchDevice', 'autoHideWidgets', 'queryToken', 'defaultstartin', 'defaultdays'],
	
	    defaults: function defaults() {
	        return {
	            /* Parameters */
	            item: null,
	            client: null,
	            config: {}, /* Geht alles an die Registry */
	            form: null,
	            queryToken: null,
	            tags_groups: [], /* Wird an die API durchgereicht */
	            autoHideWidgets: true,
	            defaultstartin: 14,
	            defaultdays: 7,
	
	            /* State */
	            selectedTags: [],
	            searchQuery: "", /* Aktuelle Suchanfrage */
	            sortBy: 'auto', /* auto, stars, ratings, price */
	            sortArrayIndex: '0', /* 0, 1, 2, 3 */
	            tagsCount: {}, /* Mapping of tag_id => Count */
	            tab: "list", /* list, map */
	            isTouchDevice: false, /* Sind wir auf Mobile? */
	            favoritesOnly: false, /* Nur Favoriten anzeigen? */
	            filterInfos: [],
	            lastSearch: null,
	            minPrice: null,
	            maxPrice: null
	        };
	    },
	
	    //
	    // Lifecycle Methods
	    //
	
	    /**
	     * Grundsätzlichen Zustand der Anwendung intialisieren.
	     */
	    initialize: function initialize() {
	        /* Achtung: Der Code muss unabhängig von der Seite sein, etwa wenn nur die Widgets gebraucht werden */
	        this.queryParameters = getQueryParameters();
	        this.resetWorld();
	
	        var tags_groups = this.get("tags_groups");
	        if (!Array.isArray(tags_groups)) {
	            if (tags_groups === "") {
	                this.set("tags_groups", []);
	            } else {
	                this.set("tags_groups", tags_groups.split(',').filter(function (t) {
	                    return !!t;
	                }));
	            }
	        }
	
	        // Initialize registry values, used for global static configuration
	        _.each(this.get("config"), function (value, key) {
	            Registry.set(key, value);
	        });
	
	        // How many items are rendered by batch
	        this.renderBatchSize = 9;
	
	        // Model for the input form (mostly used by the dropdowns)
	        this.formModel = new FormModel({
	            select_mode: this.attributes.select_mode
	        });
	
	        // Limit days in the calendar when a package was selected (not in resetWorld as this never changes)
	        this.daysModel = new ReservaDaysModel();
	
	        /* Wir führen einmal ein history.pushState aus bei der Suche, um die Suchparameter aus der URL zu putzen.
	          Dies behebt ein Problem was auftritt, wenn die User von Detaileinträgen zurück gehen
	          und dadurch wieder Standardwerte aus der URL geladen werden. */
	        this.hasPushedState = false;
	
	        /* Widget default status */
	        this.datepicker_initialized = false;
	        this.peopleselect_initialized = false;
	
	        sessionStorage.setItem("last_width", $(window).width());
	
	        _.bindAll(this, "processResults", "promiseError", "renderResults", "renderMoreResults", "scrollHandler", "search", "updateFavButton", "updateMapMarkers", "viewAnalytics");
	
	        __webpack_require__(39)(this);
	
	        this.viewAnalyticsThrottled = _.throttle(this.viewAnalytics, 100);
	
	        /* If it looks like a duck, assume it's one */
	        var isSomethingMobile = navigator.userAgent.match(/iPad|iPhone|Android|Windows Phone/i) !== null;
	        if (isSomethingMobile) {
	            this.set("isTouchDevice", true);
	            this.formModel.set("isTouchDevice", true);
	        } else {
	            /* Touch device detection */
	            var handler = (function () {
	                this.set("isTouchDevice", true);
	                this.formModel.set("isTouchDevice", true);
	                $(document).off('touchstart', handler);
	            }).bind(this);
	            $(document).on('touchstart', handler);
	        }
	
	        /* Template Helfer-Funktionen */
	        TemplateCache.helper("tagSelected", (function (tag_id) {
	            tag_id = parseInt(tag_id, 10);
	            return this.get("selectedTags").indexOf(tag_id) !== -1;
	        }).bind(this));
	
	        TemplateCache.helper("hasTag", (function (result, tag_id) {
	            var found = false;
	            for (var i = 0; i < result.classes.length; i++) {
	                if (!result.classes[i].tags) continue;
	
	                if (result.classes[i].tags.indexOf(tag_id) !== -1) {
	                    found = true;
	                    break;
	                }
	            }
	            return found;
	        }).bind(this));
	
	        TemplateCache.helper("tagName", (function (tag_id) {
	            return this.tagNames[tag_id];
	        }).bind(this));
	    },
	
	    /**
	     * Zustand der Anwendung zurücksetzen. Notwendig bevor neue Suchanfragen gestellt werden können.
	     */
	    resetWorld: function resetWorld() {
	        this.resetting = true;
	
	        // Reset renderer state
	        this.lastRenderIndex = 0;
	
	        // Collection of all retrieved results
	        this.resultStore = new ResultStore();
	
	        // Mapping of client_id => ResultView
	        _(this.resultViews).invoke('remove');
	        this.resultViews = {};
	
	        // List of tag groups (sidebar data source)
	        this.tagGroups = [];
	
	        // Mapping of tag_id => [ class_id, ... ]
	        this.tagMapping = {};
	
	        // Mapping of class => [ tag_id, ...]
	        this.classTagMapping = {};
	
	        // Mapping of tag => name
	        this.tagNames = {};
	
	        // Mapping of tag => name (for fast lookup)
	        this.importantTags = {};
	
	        // ReservaEngineClient object      
	        this.result = null;
	
	        // TraminoClientsMap object
	        this.map = null;
	
	        // Lock for renderMoreResults
	        this.renderMoreResultsLock = false;
	
	        // List of filtered results
	        this.searchResults = [];
	
	        // Reset Model state
	        var defaults = this.defaults();
	        for (var i = 0, key; key = this.resetIgnore[i]; ++i) {
	            delete defaults[key];
	        }
	        this.set(defaults);
	
	        // Previous search parameters
	        this.prevSearchDate = null;
	        this.prevSearchPeople = null;
	
	        // Reset form
	        var searchQueryInput = $('input[name="searchQuery"]');
	        searchQueryInput.val('');
	        searchQueryInput.on('keydown', function (e) {
	            if (e.keyCode == 13) {
	                e.preventDefault();
	            }
	        });
	        this.searchQueryInput = searchQueryInput;
	
	        this.resetting = false;
	
	        sessionStorage.setItem("last_width", $(window).width());
	    },
	
	    /**
	     * App starten
	     *
	     * @param run_options {Object} Zusätzliche Optionen für die Widgets
	     */
	    run: function run(run_options) {
	        if (window.ReservaAppExecuted) {
	            throw new Error("ReservaApp was run twice on a page. This is not supported and creates strange problems.");
	        }
	        window.ReservaAppExecuted = true;
	
	        run_options = run_options || {};
	
	        /* fixOversize suport */
	        if ($.fixoversize) {
	            this.on("change:tags", function () {
	                $.fixoversize("update");
	            });
	        }
	
	        /* Formular finden */
	        if (!this.attributes.form || !this.attributes.form.length) {
	            this.attributes.form = $('.ibe-container form');
	        }
	
	        /* Per URL vorgegebenen Formularparameter */
	        if (typeof this.queryParameters.from !== "undefined" && typeof this.queryParameters.select_mode === "undefined") {
	            this.queryParameters.select_mode = "exact";
	        }
	
	        this.formModel.setSafe(this.queryParameters);
	        this.formModel.bindToForm(this.attributes.form);
	
	        if (typeof window.Raven !== "undefined") {
	            Raven.setTagsContext({ app: "engine" });
	        }
	
	        /* Werbung aus dem DOM sammeln */
	        this.banners = $('.banner-inner');
	
	        /* Bei Änderung der Suchfilter */
	        this.on('change:selectedTags change:minPrice change:maxPrice', function (e) {
	            this.filterResults();
	            this.renderResults();
	            this.updateMapMarkers();
	            this.scrollUp();
	        });
	
	        /* Gastgeber-Filter */
	        var searchQueryInput = $('input[name="searchQuery"]');
	        searchQueryInput.on('keyup', _.debounce((function () {
	            var searchQuery = searchQueryInput.val().replace(/^\s+|\s+$/g, "");
	            this.set("searchQuery", searchQuery);
	        }).bind(this), 300));
	
	        this.on('change:searchQuery', (function (e) {
	            // Stichwortsuche
	            this.filterResults();
	            this.renderResults();
	        }).bind(this));
	
	        /* Scroll-Handler fürs Nach-Rendern von Ergebnissen */
	        $(window).on('scroll', _.throttle(this.scrollHandler, 300));
	
	        /* Beim Resize des Fensters Ergebnis-Liste neu rendern */
	        $(window).on('resize', function () {
	            var last_width = sessionStorage.getItem("last_width");
	
	            if ($(window).width() !== last_width) {
	                _.debounce(this.renderResults, 1000);
	            }
	        });
	
	        /* Beim Submit des Formulars die Suche per AJAX ausführen */
	        this.attributes.form.on('submit', (function (e) {
	            e.preventDefault();
	            this.hideDatepicker();
	            this.hidePeopleSelect();
	            this.search();
	        }).bind(this));
	
	        /* Suche zurücksetzen */
	        $('.ibe-container .reset-engine').on('click', (function (e) {
	            e.preventDefault();
	            localStorage.clear();sessionStorage.clear();
	            location.reload(); // YOLO
	        }).bind(this));
	
	        /* Suchen bei Auswahl eines Datums */
	        this.on("DatePicker.dateSelected", (function () {
	            this.formModel.set("select_mode", "exact"); /* Fixes a really obscure bug */
	            this.hideDatepicker();
	            this.search();
	        }).bind(this));
	
	        /* Views vorbereiten */
	        this.sidebarView = new SidebarView({
	            el: document.getElementById('engine-sidebar'),
	            model: this
	        });
	        this.sortOrderView = new SortOrderView({
	            el: document.getElementById('sort_order'),
	            model: this
	        });
	        this.filterInfoView = new FilterInfoView({
	            el: document.getElementById('search-filter-info'),
	            model: this
	        });
	        this.$list = $('#results-list');
	
	        /* Rest der UI rendern */
	        this.sortOrderView.render();
	
	        /* Is Storage broken? */
	        if (SafeStorage.local.hasCookiesDisabled) {
	            //Raven.captureMessage("CookiesDisabled");
	        }
	        if (SafeStorage.local.looksLikePrivateMode) {}
	        //Raven.captureMessage("PrivateMode");
	
	        /* Standard-Widgets initialisieren */
	        if (!this.datepicker_initialized) {
	            this.initializeDatepicker(run_options.datepicker || {
	                'form': this.attributes.form,
	                'datepicker_display': $('#reserva_datepicker_display'),
	                /* Hack: Use the window jQuery which has jquery-ui included */
	                'datepicker_container': window.$('#reserva_datepicker')
	            });
	        }
	
	        if (this.formModel.get("from")) {
	            this.datepicker.datepicker.datepicker("setDate", this.formModel.get("from"));
	        }
	
	        if (!this.peopleselect_initialized) {
	            this.initializePeopleSelect(run_options.peopleselect || {
	                'people_display': $('#reserva_people_display'),
	                'people_container': $('#reserva-people-select')
	            });
	        }
	
	        /* Haben wir ein Item? */
	        this.on('change:item', this.loadItemDays);
	        if (this.get("item")) {
	            this.loadItemDays().then(this.search);
	        } else {
	            /* Sobald alles bereit ist die Suche durchführen */
	            this.search();
	        }
	
	        /* Button für die Favoriten */
	        if (window.TraminoFavoriten) {
	            TraminoFavoriten.on('change:items', (function (e) {
	                this.updateFavButton();
	                if (this.get("favoritesOnly")) {
	                    this.filterResults();
	                    this.renderResults();
	                }
	            }).bind(this));
	            this.updateFavButton();
	        }
	
	        /* Tabs für Liste und Karte initialisieren */
	        var buttons = $('.result-tabs-buttons span');
	        var tabs = $('.result-tabs .tab');
	        var self = this;
	        buttons.on('click', function (e) {
	            var $this = $(this);
	            //var prevTab = self.get("tab");
	            var tab = $this.data('href');
	
	            self.set("tab", tab);
	
	            window.TraminoAnalytics.sendOnce(null, "reserva", "tab", tab);
	
	            // Buttons aktivieren
	            buttons.removeClass('active');
	            $this.addClass('active');
	
	            var $target = $('#tab-' + tab);
	            tabs.removeClass('active');
	            $target.addClass('active');
	
	            // Wir sparen Zeit, wenn wir Google Maps nur einmal initialisieren und dann wiederverwerten
	            if (tab === "geo" && !self.map) {
	                // Karte erzeugen, aber noch keine Marker definieren.
	                $('#partner-map').html("Einen Moment bitte, Karte wird geladen...");
	                self.map = new TraminoClientsMap({
	                    target: 'partner-map',
	                    autofit: true,
	                    onClick: function onClick(e, marker, betrieb) {
	                        var view = self.resultViews[betrieb.id].clone();
	                        view.render();
	                        self.map.displayInfo(marker, view.el);
	                    }
	                });
	                self.map.init().then(function () {
	                    // Marker vom Server laden und einfügen
	                    if (!self.result) {
	                        return;
	
	                        // This happens when a user clicks on the tab when the results are not ready yet. Idiot.
	                    }
	                    self.updateMapMarkers();
	                })['catch'](self.promiseError);
	            }
	
	            /* Sortierung bei der Karte ausblenden */
	            if (tab === "geo") {
	                $('.tabs .right').hide();
	            } else {
	                $('.tabs .right').show();
	            }
	        });
	
	        /* Favoriten Filter */
	        $('.fav-group span').on('click', function (e) {
	            var current = $(this);
	            var href = current.data().href;
	
	            if (href === "all") {
	                self.set("favoritesOnly", false);
	            }
	            if (href === "favs") {
	                self.set("favoritesOnly", true);
	            }
	        });
	
	        this.on('change:favoritesOnly', (function (e) {
	            var state = e.attributes.favoritesOnly;
	            var fav_group = $('.fav-group');
	            if (state) {
	                fav_group.find('span[data-href="all"]').removeClass('active');
	                fav_group.find('span[data-href="favs"]').addClass('active');
	            } else {
	                fav_group.find('span[data-href="all"]').addClass('active');
	                fav_group.find('span[data-href="favs"]').removeClass('active');
	            }
	
	            self.filterResults();
	            self.renderResults();
	            self.updateMapMarkers();
	        }).bind(this));
	    },
	
	    /**
	     * Favoriten-Button aktualisieren
	     */
	    updateFavButton: function updateFavButton(e) {
	        if (!window.TraminoFavoriten) return;
	
	        var count = 0;
	        var favs = TraminoFavoriten.getItemsMap();
	        this.resultStore.each(function (result) {
	            // n = 0 - 800
	            if (!result.get("visible")) return;
	            if (typeof favs["clients-" + result.get("id")] !== "undefined") {
	                count++;
	            }
	        });
	        $('.fav-group span[data-href="favs"]').text(count === 0 ? __("favorites") : count === 1 ? __("one_favorite") : count + " " + __("favorites"));
	    },
	
	    /**
	     * Marker auf der Karte aktualisieren
	     */
	    updateMapMarkers: function updateMapMarkers() {
	        if (!this.map) return;
	        this.map.clearMarkers();
	        var clients = this.resultStore.getVisible().map(function (result) {
	            return {
	                id: result.id,
	                name: result.get("name"),
	                lat: result.get("lat"),
	                lng: result.get("lng")
	            };
	        });
	        this.map.addMarkers(clients);
	    },
	
	    /**
	     * Nicht anderweitig abgefangene Promise-Fehler behandeln
	     */
	    promiseError: function promiseError(e) {
	        var extra = {};
	
	        if (typeof e.readyState !== "undefined") {
	            // Looks like a jqXHR object
	            extra.status = e.status;
	            extra.statusText = e.statusText;
	            extra.responseText = e.responseText;
	            e = new Error("AJAX call failed");
	        }
	
	        if (typeof window.Raven !== "undefined") {
	            Raven.captureException(e, { extra: extra });
	        }
	
	        if (this.$list && this.$list.length > 0) {
	            this.$list.html(TemplateCache.render("result-error", {
	                error: e.statusText || e.message || e.error || e.toString(),
	                showError: window.Tramino.user && window.Tramino.user > 0
	            }));
	        } else {
	            // Can happen on the miniengine
	        }
	    },
	
	    //
	    // Model methods
	    //
	
	    loadTags: function loadTags() {
	        var timer = MiniTimer("Load Tags");
	
	        var handler = (function (response) {
	            timer();timer = MiniTimer("Parse Tags");
	
	            this.tagGroups = [];
	            this.tagMapping = {};
	            this.classTagMapping = {};
	            this.tagNames = {};
	
	            var currentGroupName = null;
	            var currentTags = [];
	
	            for (var i = 0, result; result = response.tags_info[i]; ++i) {
	                // result = { order, group, id, tag, [classes] }
	                if (!currentGroupName) currentGroupName = result.group;
	                if (currentGroupName != result.group) {
	                    this.tagGroups.push({
	                        index: i,
	                        name: currentGroupName,
	                        tags: currentTags
	                    });
	                    currentGroupName = result.group;
	                    currentTags = [];
	                }
	
	                currentTags.push({
	                    id: result.id,
	                    tag: result.tag,
	                    info: result.info,
	                    count: null });
	                /* null = Unknown count */
	                this.tagNames[result.id] = result.tag;
	
	                var classes = result.classes.split(',');
	
	                /* Wir erzeugen hier ein Mapping von tag_id => Array von Klassen.
	                   Dies ermöglicht es uns später, schnell anhand der ausgewählten Tags die Ergebnisse zu filtern */
	                for (var j = 0, class_id; class_id = classes[j]; ++j) {
	                    if (typeof this.tagMapping[result.id] === "undefined") {
	                        this.tagMapping[result.id] = [];
	                    }
	                    this.tagMapping[result.id].push(parseInt(class_id, 10)); // result.id = tag.id
	
	                    if (typeof this.classTagMapping[class_id] === "undefined") {
	                        this.classTagMapping[class_id] = [];
	                    }
	                    this.classTagMapping[class_id].push(parseInt(result.id, 10)); // result.id = tag.id
	                }
	            }
	
	            this.tagGroups.push({
	                name: currentGroupName,
	                tags: currentTags
	            });
	
	            this.trigger("change:tags");
	
	            timer();
	        }).bind(this);
	
	        var lang = window.Tramino.lang;
	        var tags_groups = this.get("tags_groups") ? this.get("tags_groups").join(",") : "";
	        var cache_key = 'engine.tags.' + lang + '.' + tags_groups;
	        var cache = SafeStorage.session.get(cache_key);
	
	        if (cache && false) {
	            return Promise.resolve(JSON.parse(cache)).then(handler)['catch'](this.promiseError);
	        } else {
	            var params = {
	                lang: lang
	            };
	            if (tags_groups) {
	                params.groups = tags_groups;
	            }
	
	            return ajax('/api/engine/tags/', { params: params }).then(function (response) {
	                SafeStorage.session.set(cache_key, JSON.stringify(response), 3600 * 1000);
	                return response;
	            }).then(handler)['catch'](this.promiseError);
	        }
	    },
	
	    /**
	     * Lock the search engine. Prevents many funny and strange bugs which happens
	     * when multiple searches are running concurrently.
	     */
	    lockSearch: function lockSearch() {
	        if (this.searchLocked) {
	            Raven.captureException(new Error("SearchAlreadyLocked"));
	            return false;
	        }
	        this.searchLocked = true;
	        $('.search input[type=submit]').attr('disabled', true).addClass('locked');
	
	        this.searchQueryInput.hide();
	        return true;
	    },
	
	    /**
	     * Release the search engine again
	     */
	    releaseSearch: function releaseSearch(ignore) {
	        if (!this.searchLocked && !ignore) {
	            Raven.captureException(new Error("UnlockAlreadyUnlockedSearch"));
	            return false;
	        }
	        this.searchLocked = false;
	        $('.search input[type=submit]').attr('disabled', false).removeClass('locked');
	
	        this.searchQueryInput.show();
	        return true;
	    },
	
	    /**
	     * Handler bei der ersten Suche registrieren
	     */
	    registerFirstSearchHandler: function registerFirstSearchHandler() {
	        var _this = this;
	
	        /* Bei Formular-Änderungen den Such-Button pulsieren lassen */
	
	        this.allowPulse = true;
	        this.formModel.on('change', function (e) {
	            if (!_this.allowPulse) return;
	            if (typeof e.changed.to !== "undefined" || typeof e.changed.from !== "undefined") return;
	
	            $('.ibe-container .search input[type=submit]').effect('highlight', 2000).effect('highlight', 2000);
	
	            _this.allowPulse = false;
	
	            setTimeout(function () {
	                _this.allowPulse = true;
	            }, 4000);
	        });
	    },
	
	    /**
	     * Suche durchführen. Setzt die Anwendung zurück, führt eine Abfrage aus und lädt weitere Ergebnisse nach.
	     */
	    search: function search() {
	        if (!this.lockSearch()) return;
	
	        if (this.get("lastSearch") === null) {
	            this.registerFirstSearchHandler();
	        }
	
	        var timer = MiniTimer("Execute Search");
	        var formData = this.formModel.getForm();
	        formData.lang = window.Tramino.lang;
	        formData.querytoken = this.get("queryToken");
	
	        var errors = this.formModel.validate(formData);
	        if (errors && errors.length > 0) {
	            this.releaseSearch();
	            this.$list.html(TemplateCache.render("result-error-validate", {
	                errors: errors
	            }));
	            this.$list.find('.btn-reset').on('click', (function () {
	                localStorage.clear();
	                sessionStorage.clear();
	                location.reload(); // YOLO
	            }).bind(this));
	            return;
	        }
	
	        /* Wenn der User anfängt ein Datum auszuwählen und dann direkt auf Suchen klickt. */
	        if (this.formModel.get("to") === null && this.formModel.get("select_mode") !== "none") {
	            this.datepicker.runAwayScreaming();
	            this.showDatepicker();
	            return;
	        }
	
	        this.$list.html(TemplateCache.render("loader-results"));
	
	        if (!this.hasPushedState && typeof history.pushState !== "undefined" && !this.queryParameters.expected_clients) {
	            try {
	                history.pushState(null, null, location.href.split('?')[0]);
	            } catch (e) {/* Ignore this problem */}
	            this.hasPushedState = true;
	        }
	
	        /* Reset the application state */
	        this.resetWorld();
	        this.set("lastSearch", formData);
	
	        this.updatePeopleDisplay();
	        this.prevSearchDate = this.datepickerButton.text();
	        this.prevSearchPeople = this.peopleButton.text();
	
	        this.loadTags().then((function () {
	
	            ReservaEngineClient.search(formData).then((function (result) {
	                this.resultStore = new ResultStore();
	                this.result = result;
	
	                if ((Tramino.user === "10" || Tramino.user === "1") && !navigator.userAgent.match(/MSIE/)) {
	                    var benchmark = result.response.refs.benchmark;
	                    var ApiBench = __webpack_require__(45);
	                    var server = location.hostname.indexOf(".dev") === -1 ? 'https://live.tramino.de' : 'http://live.tramino.dev';
	                    ajax(benchmark.replace('{live}', server)).then((function (response) {
	                        ApiBench.init();
	                        ApiBench.render(response);
	                    }).bind(this))['catch'](this.promiseError);
	                }
	
	                // Erste Ergebnisse rendern, dann gleich mehr anfordern
	                this.processResults(result.getInitialResults());
	
	                /* Falls wir Tags aus der URL erhalten haben, diese anwenden */
	                var requestedTags = this.queryParameters.tags;
	                if (requestedTags) {
	                    this.set("selectedTags", _.map(requestedTags.split(','), function (x) {
	                        return parseInt(x, 10);
	                    }));
	                }
	
	                // Gleich die restlichen Ergebnisse anfordern
	                if (result.more_results) {
	                    var timer2 = MiniTimer("Load rest of results");
	                    result.loadMore().then((function (results) {
	                        this.processResults(results);
	                        timer2();
	
	                        this.releaseSearch();
	                    }).bind(this))['catch'](this.promiseError);
	                } else {
	                    this.releaseSearch();
	                }
	
	                timer();
	            }).bind(this), (function (e) {
	                this.$list.html(TemplateCache.render("result-error", {
	                    error: e.statusText || e.message || e.toString(),
	                    showError: window.Tramino.user && window.Tramino.user > 0
	                }));
	
	                // e = jqXHR object
	                if (typeof window.Raven !== "undefined") {
	                    var error = new Error(e.statusText || e.message || e.toString());
	                    Raven.captureException(error, {
	                        extra: {
	                            formData: formData
	                        }
	                    });
	                }
	
	                /* Die User sollen weiterhin suchen dürfen */
	                this.releaseSearch();
	            }).bind(this))['catch'](this.promiseError);
	        }).bind(this))['catch'](this.promiseError);
	    },
	
	    /**
	     * Einkommende Ergebnisse verarbeiten:
	     * - In den resultStore packen
	     * - Views erzeugen
	     * - Tags filtern (visible status)
	     * - Sortieren
	     * - Anzeigen
	     */
	    processResults: function processResults(results) {
	        var timer = MiniTimer("processResults");
	        var first_batch = this.resultStore.length === 0;
	        for (var i = 0, result; result = results[i]; ++i) {
	            // n = 1-20
	            // Standard-State setzen
	            result.visible = false;
	            result.viewSent = false;
	            result.name_lower = result.name.toLowerCase();
	            result.name_search = (result.name_search || "").toLowerCase();
	
	            // Sortierparameter auftrennen
	            var sort = result.sort ? result.sort : [0, 0, 0, 0, 0];
	            result.sort_auto = parseFloat(sort[0]);
	            result.sort_stars = parseFloat(sort[1]);
	            result.sort_ratings = parseFloat(sort[2]);
	            result.sort_price = parseFloat(sort[3]);
	            result.sort_booking = parseFloat(sort[4]);
	
	            _.each(result.classes, (function (item) {
	                var sort = item.sort ? item.sort : [0, 0, 0, 0, 0];
	                item.sort_auto = parseFloat(sort[0]);
	                item.sort_stars = parseFloat(sort[1]);
	                item.sort_ratings = parseFloat(sort[2]);
	                item.sort_price = parseFloat(sort[3]);
	                item.sort_booking = parseFloat(sort[4]);
	                item.name_lower = item.name.toLowerCase();
	                item.tags = this.classTagMapping[item.id];
	
	                if (typeof item.tags === "undefined") {
	                    item.tags = [];
	                }
	            }).bind(this));
	
	            var model = new Result(result);
	            var view = new ResultView({
	                model: model
	            });
	            view.app = this;
	
	            this.resultStore.add(model);
	            this.resultViews[result.id] = view;
	        }
	
	        /* @todo Remove this until the bug is fixed */
	        if (window.Tramino.root && this.queryParameters.expected_clients && !first_batch) {
	            var expected_clients = this.queryParameters.expected_clients.split(',').map(function (c) {
	                return parseInt(c, 10);
	            });
	            var missing_clients = [];
	            for (var i = 0; i < expected_clients.length; i++) {
	                var client_id = expected_clients[i];
	                if (!this.resultViews[client_id]) {
	                    missing_clients.push(client_id);
	                }
	            }
	
	            if (missing_clients.length > 0) {
	                $('#search-filter-info').after('<div class="search-filter-info"><span class=\'tag\'>[Debug] Folgende Clients wurden erwartet, aber fehlen im Ergebnis: ' + missing_clients.join(", ") + '</span></div>');
	            }
	        }
	
	        this.sortResults();
	        this.filterResults();
	        if (first_batch) {
	            this.renderResults();
	            this.updateMapMarkers();
	        }
	        timer("added " + results.length + " results");
	    },
	
	    /**
	     * Ergebnisse anhand der aktuellen Bedingungen filtern:
	     * - Nach Tags eingrenzen
	     * - Nur Favoriten/ausgewählte Kategorien anzeigen
	     * - Preis Min/Max
	     * - Stichwortsuche
	     *
	     * Die Suche nach Namen erfolgt gesondert bei renderResultsSearch wegen der besonderen Darstellung.
	     */
	    filterResults: function filterResults() {
	        var _this2 = this;
	
	        var app = this;
	        var selectedTags = this.get("selectedTags");
	        var classTagMapping = this.classTagMapping;
	        var tagMapping = this.tagMapping;
	        var timer = MiniTimer("filterResults");
	        var filter_infos = [{ text: this.prevSearchDate, closeable: false, onclick: function onclick() {
	                _this2.hidePeopleSelect();_this2.showDatepicker();
	            } }, { text: this.prevSearchPeople, closeable: false, onclick: function onclick() {
	                _this2.hideDatepicker();_this2.showPeopleSelect();
	            } }];
	
	        if (this.resultStore.length === 0) {
	            /* Wenn es nix zu sortieren gibt, brauchen wir uns keine Arbeit machen */
	            return;
	        }
	
	        /* Am Anfang ist erstmal alles sichtbar */
	        this.resultStore.each(function (result) {
	            // n = 0 - 800
	            var classes = result.get('classes');
	            result.attributes.visible = true;
	            _.each(classes, function (klass) {
	                // n = 0 - ~30
	                klass.visible = true;
	            });
	        });
	
	        /* Danach filtern wir die Tags */
	        if (selectedTags.length > 0) {
	            var tagNames;
	            var tagIds;
	            var i;
	
	            (function () {
	                tagNames = [];
	                tagIds = {};
	
	                for (i = 0; i < selectedTags.length; ++i) {
	                    var _name = _this2.tagNames[selectedTags[i]];
	                    tagNames.push(_name);
	                    tagIds[_name] = selectedTags[i];
	                }
	                _.each(tagNames, function (t) {
	                    filter_infos.push({
	                        text: t,
	                        onclick: function onclick() {
	                            app.toggleTag(tagIds[t]);
	                        }
	                    });
	                });
	
	                // Sichtbarkeit berechnen
	                var count = 0;
	                _this2.resultStore.each((function (result) {
	                    // n = 0 - 800
	                    // result = Backbone.Model
	                    var classes = result.get('classes');
	                    var visible_classes = 0;
	
	                    /* Für jede Klasse prüfen wir, ob sie sichtbar ist */
	                    _.each(classes, function (klass) {
	                        // n = 0 - ~30
	                        var visible = true;
	
	                        for (var i = 0, tag_id; tag_id = selectedTags[i]; ++i) {
	                            // n = 0 - 4
	                            var classes_with_this_tag = tagMapping[tag_id];
	
	                            if (!classes_with_this_tag) {
	                                return;
	
	                                /* This is okay because the interest-filter might send us tags we don't know about. We'll just ignore them for now. */
	                            }
	
	                            if (classes_with_this_tag.indexOf(parseInt(klass.id, 10)) === -1) {
	                                visible = false;
	                            }
	                        }
	
	                        if (visible) visible_classes++;
	                        klass.visible = visible;
	                    });
	
	                    if (visible_classes > 0) {
	                        count++;
	                    } else {
	                        result.attributes.visible = false;
	                    }
	                }).bind(_this2));
	
	                if (count === 0) {
	                    _this2.set("selectedTags", []);
	                }
	            })();
	        } else {
	            // Es werden alle Ergebnisse und Klassen angezeigt
	            this.resultStore.each(function (result) {
	                // n = 0 - 800
	                result.set("visible", true);
	                _.each(result.get('classes'), function (klass) {
	                    klass.visible = true;
	                });
	            });
	        }
	
	        // Filterung nach Favoriten
	        if (this.get("favoritesOnly")) {
	            var favs = TraminoFavoriten.getItemsMap();
	            this.resultStore.getVisible().each(function (result) {
	                // n = 0 - 800
	                if (typeof favs["clients-" + result.get("id")] === "undefined") {
	                    result.attributes.visible = false;
	                }
	            });
	
	            filter_infos.push({
	                text: "nur Favoriten",
	                onclick: (function () {
	                    this.set("favoritesOnly", false);
	                }).bind(this)
	            });
	        }
	        this.updateFavButton();
	
	        // Filter nach Preis
	        var minPrice = this.get("minPrice");
	        var maxPrice = this.get("maxPrice");
	        if (minPrice !== null || maxPrice !== null) {
	            if (minPrice !== null && maxPrice !== null && minPrice > maxPrice) {
	                this.set({
	                    minPrice: maxPrice,
	                    maxPrice: minPrice
	                });
	                return;
	            }
	
	            this.resultStore.getVisible().each((function (result) {
	                // n = 0 - 800
	                var classes = result.get('classes');
	                var visible_classes = 0;
	
	                _.each(classes, function (klass) {
	                    // n = 0 - ~30
	                    var visible = true;
	
	                    if (minPrice !== null && klass.price < minPrice) visible = false;
	                    if (maxPrice !== null && klass.price > maxPrice) visible = false;
	
	                    if (visible) visible_classes++;
	                    klass.visible = visible;
	                });
	
	                if (visible_classes === 0) {
	                    result.attributes.visible = false;
	                }
	            }).bind(this));
	
	            if (minPrice !== null) {
	                filter_infos.push({
	                    text: "Mindestpreis " + minPrice + " €",
	                    onclick: (function () {
	                        this.set("minPrice", null);
	                    }).bind(this)
	                });
	            }
	            if (maxPrice !== null) {
	                filter_infos.push({
	                    text: "Maximalpreis " + maxPrice + " €",
	                    onclick: (function () {
	                        this.set("maxPrice", null);
	                    }).bind(this)
	                });
	            }
	        }
	
	        // Stichwortsuche
	        this.searchResults = [];
	        var query = this.get("searchQuery").toLowerCase();
	        if (query) {
	            (function () {
	                var useCategorySearch = Registry.get("Engine.CategorySearch", false);
	
	                /* Wir sammeln alle Ergebnisse welche auf die Beschreibung passen und packen diese in eine extra Liste.
	                   Deren Sichtbarkeit wird false, da diese dann über die extra Liste gerendet werden. */
	                _this2.resultStore.getVisible().each((function (result) {
	                    var _this3 = this;
	
	                    // n = 0 - 800
	                    //console.log(result.get("name_search"), result.get("name_search").indexOf(query) !== -1);
	                    if (result.get("name_lower").indexOf(query) !== -1 || result.get("name_search").indexOf(query) !== -1) {
	                        result.attributes.visible = false;
	                        this.searchResults.push(result);
	                    } else if (useCategorySearch) {
	                        (function () {
	                            /* Vielleicht finden wir es anhand der Kategorie */
	                            var found = false;
	                            _.each(result.get("classes"), function (klass) {
	                                if (!found && klass.name_lower.indexOf(query) !== -1) {
	                                    result.attributes.visible = false;
	                                    _this3.searchResults.push(result);
	                                    found = true;
	                                }
	                            });
	                        })();
	                    }
	                }).bind(_this2));
	
	                filter_infos.push({
	                    text: '"' + _this2.get("searchQuery") + '"',
	                    onclick: (function () {
	                        this.set("searchQuery", "");
	                        $('input[name="searchQuery"]').val('');
	                    }).bind(_this2)
	                });
	            })();
	        }
	
	        // Tags zählen
	        var tagCounts = {};
	        _.each(this.tagGroups, function (group) {
	            // n = ~4
	            _.each(group.tags, function (tag) {
	                // n = ~8
	                tagCounts[tag.id] = [];
	            });
	        });
	
	        var count = 0;
	        this.resultStore.getVisible().each(function (result) {
	            // n = 0 - 100
	            _.each(result.get('classes'), function (klass) {
	                if (!klass.visible) return;
	
	                var tags_with_this_classes = classTagMapping[klass.id];
	                _.each(tags_with_this_classes, function (tag_id) {
	                    // Nur Tags zählen, die wir auch in der Sidebar anzeigen
	                    if (tagCounts.hasOwnProperty(tag_id)) {
	                        tagCounts[tag_id].push(result.id);
	                    }
	                });
	            });
	            count++;
	        });
	
	        _.each(this.tagGroups, (function (group) {
	            // n = ~4
	            _.each(group.tags, function (tag) {
	                // n = ~8
	                if (tagCounts[tag.id]) {
	                    tag.count = _.unique(tagCounts[tag.id]).length;
	                } else {
	                    tag.count = 0;
	                }
	            });
	            group.tags = _(group.tags).sortBy(function (tag) {
	                return -tag.count;
	            });
	        }).bind(this));
	
	        this.set("filterInfos", filter_infos);
	
	        this.trigger("change:tags");
	        timer(count + " results are visible");
	    },
	
	    /**
	     * Die Suchergebnisse rendern. Setzt den State auf 0, löscht die aktuelle Liste und erzeugt diese komplett neu.
	     */
	    renderResults: function renderResults() {
	        var timer = MiniTimer("renderResults");
	
	        /* For performance reasons, we keep all result nodes around
	           and just detach and re-attach them to the DOM when necesssary */
	        _.each(this.resultViews, function (view) {
	            view.hide();
	        });
	        this.lastRenderIndex = 0;
	
	        var searchQuery = this.get("searchQuery");
	        if (searchQuery) {
	            this.$list.html("");
	            this.$list.append("<div class='results-divider'>Suchergebnisse</div>");
	
	            var views = this.resultViews;
	            _.each(this.searchResults, (function (result) {
	                var view = views[result.id];
	                if (typeof view === "undefined") {
	                    throw new Error("BUGCHECK: Missing resultView of result #" + result.id);
	                }
	                view.show(this.$list);
	            }).bind(this));
	
	            this.$list.append("<div class='clear'></div>");
	            this.$list.append("<div class='results-divider'>Weitere Gastgeber</div>");
	        }
	
	        if (!this.resetting) {
	            this.renderMoreResults();
	        }
	        timer();
	    },
	
	    /**
	     * Zusätzliche Ergebnisse rendern
	     */
	    renderMoreResults: function renderMoreResults() {
	        var _this4 = this;
	
	        if (this.renderMoreResultsLock) return;
	        this.renderMoreResultsLock = true;
	
	        var timer = MiniTimer("renderMoreResults");
	        var boxesPerRow = 0;
	
	        var visible_models = this.resultStore.getVisible();
	        var models = visible_models.slice(this.lastRenderIndex, this.lastRenderIndex + this.renderBatchSize);
	
	        var noSearchResults = this.searchResults.length === 0;
	        if (models.length === 0 && this.lastRenderIndex === 0 || this.get("searchQuery") && noSearchResults) {
	            this.$list.html(TemplateCache.render('no-results', {
	                favoritesOnly: this.get("favoritesOnly"),
	                searchQuery: this.get("searchQuery")
	            }));
	        } else if (models.length > 0) {
	            (function () {
	
	                // Sicherstellen, dass die Box leer ist falls keine Ergebnisse gerendert wurden
	                if (_this4.$list.find('.result-box').length === 0) {
	                    _this4.$list.html("");
	                }
	
	                var views = _this4.resultViews;
	                _.each(models, (function (result, i) {
	                    if (!result.attributes.visible) return;
	                    var view = views[result.id];
	                    if (typeof view === "undefined") {
	                        throw new Error("BUGCHECK: Missing resultView of result #" + result.id);
	                    }
	
	                    view.render();
	                    view.show(this.$list);
	                    this.lastRenderIndex++;
	
	                    if (!boxesPerRow) {
	                        /* Wir können das erst nach der ersten Box berechnen */
	                        var listWidth = this.$list.width();
	                        var boxWidth = this.$list.find('.result-box').first().width();
	                        boxesPerRow = Math.ceil(listWidth / boxWidth);
	                        if (boxesPerRow > 3) boxesPerRow = 3;
	                    }
	
	                    // Werbung einblenden
	                    var favoritesOnly = this.get("favoritesOnly");
	                    // console.log("AdCheckGeneral", visible_models.length > 6, !favoritesOnly, boxesPerRow > 0);
	                    if (visible_models._wrapped.length > 6 && !favoritesOnly && boxesPerRow > 0) {
	
	                        if (this.banners[0] && this.lastRenderIndex === boxesPerRow * 1) {
	                            // console.log("Render banner row 1", boxesPerRow, this.lastRenderIndex);
	                            $(this.banners[0]).clone().appendTo(this.$list).show();
	                        }
	
	                        if (this.banners[1] && this.lastRenderIndex === boxesPerRow * 3) {
	                            // console.log("Render banner row 2", boxesPerRow, this.lastRenderIndex);
	                            $(this.banners[1]).clone().appendTo(this.$list).show();
	                        }
	
	                        if (this.banners[2] && this.lastRenderIndex === boxesPerRow * 5) {
	                            // console.log("Render banner row 3", boxesPerRow, this.lastRenderIndex);
	                            $(this.banners[2]).clone().appendTo(this.$list).show();
	                        }
	                    }
	
	                    // if ( this.lastRenderIndex <= boxesPerRow && !result.viewSent ) {
	                    //     window.TraminoAnalytics.send(result.get("id"), "view");
	                    //     result.viewSent = true;
	                    // }
	                }).bind(_this4));
	            })();
	        }
	
	        this.renderMoreResultsLock = false;
	        timer();
	
	        if ($.fixoversize && models.length > 0) {
	            $.fixoversize("update");
	        }
	    },
	
	    //
	    // User actions
	    //
	
	    /**
	     * Sortier-Reihenfolge setzen
	     *
	     * @param order {String} Neue Sortier-Reihenfolge (auto, stars, ratings, price)
	     */
	    setSortOrder: function setSortOrder(order) {
	        var previous = this.get("sortBy");
	        if (order == previous) return;
	        var sortArrayIndex = ({
	            'auto': 0,
	            'stars': 1,
	            'ratings': 2,
	            'price': 3,
	            'booking': 4
	        })[order];
	
	        window.TraminoAnalytics.sendOnce(null, "reserva", "sort", order);
	
	        this.set({
	            "sortBy": order,
	            "sortArrayIndex": sortArrayIndex
	        });
	        this.resultStore.comparator = function (result) {
	            return result.attributes.sort[sortArrayIndex];
	        };
	
	        this.sortResults();
	        this.renderResults();
	    },
	
	    /**
	     * Ergebnisse neu sortieren
	     */
	    sortResults: function sortResults() {
	        var timer = MiniTimer("SortResults: " + this.get("sortBy"));
	        var sortArrayIndex = this.get("sortArrayIndex");
	
	        /* Ergebnisse sortieren */
	        this.resultStore.sort();
	
	        /* Auch noch alle Items jeweils einzeln sortieren */
	        this.resultStore.each((function (result) {
	            result.set("classes", _.sortBy(result.get("classes"), function (item) {
	                return item.sort[3];
	            }));
	
	            /* Zusätzlich müssen wir die Ergebnisse neu rendern, da sich die Reihenfolge der Kategorien geändert hat */
	            var view = this.resultViews[result.id];
	            if (view.rendered) {
	                this.resultViews[result.id].render();
	            }
	        }).bind(this));
	        timer();
	    },
	
	    toggleTag: function toggleTag(tag_id) {
	        var tags = this.get("selectedTags");
	        tag_id = parseInt(tag_id, 10);
	        if (_.contains(tags, tag_id)) {
	            tags.splice(tags.indexOf(tag_id), 1);
	        } else {
	            tags.push(tag_id);
	        }
	
	        this.set("selectedTags", tags);
	        // Backbone wont trigger on set cause the array is still the same array object
	        this.trigger("change:selectedTags", this);
	
	        window.TraminoAnalytics.sendOnce(null, "reserva", "tag", tag_id);
	    },
	
	    //
	    // View Methods
	    //
	
	    scrollHandler: function scrollHandler() {
	        if (this.get("tab") !== "list") return;
	        var scrollTop = $(window).scrollTop();
	        var boxes = this.$list.find('.result-box');
	        if (!boxes.length) {
	            // Nothing has been rendered yet
	            return;
	        }
	
	        var lastBoxOffset = boxes.last().offset().top;
	        var viewportBottom = scrollTop + $(window).height() + 100;
	        if (viewportBottom > lastBoxOffset && !this.renderMoreResultsLock) {
	            // Mehr Ergebnisse rendern
	            setTimeout(this.renderMoreResults, 0);
	        }
	
	        // this.viewAnalyticsThrottled();
	    },
	
	    viewAnalytics: function viewAnalytics() {
	        var scrollTop = $(window).scrollTop();
	        var viewportHeight = $(window).height();
	        var boxHeight;
	        this.resultStore.getVisible().each((function (result) {
	            /* Schon gesendet? */
	            if (result.viewSent) return;
	
	            /* Gibt es das View überhaupt? */
	            var view = this.resultViews[result.id];
	            if (!view || !view.rendered) return;
	
	            /* Ist die Box momentan sichtbar? */
	            var offset = view.$box.offset();
	            if (!boxHeight) {
	                boxHeight = view.$box.outerHeight(true);
	            }
	
	            /* Wenn die Box komplett auf dem Bildschirm sichtbar ist, zählen wir den View */
	            if (offset && offset.top <= scrollTop + viewportHeight - boxHeight) {
	                // window.TraminoAnalytics.send(result.get("id"), "view");
	                result.viewSent = true;
	            }
	        }).bind(this));
	    },
	
	    scrollUp: function scrollUp() {
	        var currentScrollTop = $('html').scrollTop();
	        if (currentScrollTop === 0) return; /* Nicht scrollen wenn ganz oben */
	
	        $('html, body').animate({
	            scrollTop: $('.tabs').offset().top - 20
	        }, 400);
	    },
	
	    /**
	     * URL im Browser öffnen inklusive Formular-Parameter
	     */
	    goto: function goto(url) {
	        var append = reservaApp.formModel.getForm();
	        location.href = url + '?' + $.param(append);
	    }
	});
	
	module.exports = ReservaApp;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(18).singleton.get;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Stellt einen allgemein Übersetzer für Strings bereit.
	 *
	 * Das Modul exportiert folgende Funktionen:
	 * - Translator: Klasse für Übersetzer
	 * - singleton: Standardobjekt, reicht für die meisten Fälle aus
	 * 
	 */
	
	'use strict';
	
	var _ = __webpack_require__(7);
	var format = __webpack_require__(19);
	
	/**
	 * Stellt einen allgemein Übersetzer für Strings bereit. Funktionen:
	 * 
	 * - Einfache Work-Übersetzung -> get(word)
	 * - Basierend auf Anzahl -> plural(word, count)
	 */
	var Translator = function Translator() {
		this.dictionary = {};
		this.language = 'de';
	
		this.currencies = {
			'EUR': { prefix: '', suffix: ' €', dec_point: ',', thousands_sep: '.' },
			'GPB': { prefix: '', suffix: ' £', dec_point: '.', thousands_sep: ',' },
			'CHF': { prefix: '', suffix: ' CHF', dec_point: ',', thousands_sep: "'" },
			'USD': { prefix: '$', suffix: '', dec_point: '.', thousands_sep: '.' }
		};
	
		_.bindAll(this, "learn", "setLanguage", "get", "plural", "currency", "currencyHTML");
	};
	
	/**
	 * Dem Übersetzer weitere Strings beibringen.
	 *
	 * @param language {String} Sprachcode (de, en, ...)
	 * @param definitions {Object} Key-Value Mapping von Wörtern. Plural-Versionen mit *_plural.
	 */
	Translator.prototype.learn = function (language, definitions) {
		if (typeof this.dictionary[language] === "undefined") {
			this.dictionary[language] = {};
		}
		_.extend(this.dictionary[language], definitions);
	};
	
	/**
	 * Standardsprache für die get-Funktionen setzen
	 *
	 * @param language {String} Sprachcode (de, en, ...)
	 */
	Translator.prototype.setLanguage = function (language) {
		if (typeof this.dictionary[language] === "undefined") {
			/* Language not defined yet :-( */
			return false;
		}
		this.language = language;
		return true;
	};
	
	/**
	 * Ein einzelnes Wort übersetzen. Gibt das Wort zurück falls keine Definition gefunden.
	 *
	 * @param word {String} Word aus dem Wörterbuch
	 */
	Translator.prototype.get = function (word, replacements) {
		var dict = this.dictionary[this.language];
		var result;
		if (typeof dict !== "undefined" && typeof dict[word] !== "undefined") {
			result = dict[word];
		} else {
			result = word;
		}
	
		if (typeof result === "string" && !_.isEmpty(replacements)) {
			_.each(replacements, function (value, key) {
				result = result.replace('{' + key + '}', value);
			});
		}
	
		return result;
	};
	
	/**
	 * Ein einzelnes Wort übersetzen, basierend auf der Plural-Form. Gibt das Wort + die Anzahl zurück.
	 *
	 * @param word {String} Word aus dem Wörterbuch
	 * @param count {Number} Anzahl
	 */
	Translator.prototype.plural = function (word, count) {
		if (typeof count === "undefined") {
			throw new Error("Translator.plural: count is undefined (wrong method called?)");
		}
	
		if (count === 0 || count > 1) {
			return count + " " + this.get(word + "_plural");
		}
		return count + " " + this.get(word);
	};
	
	/**
	 * Währung formatieren
	 *
	 * @param amount {Number} Wert
	 * @param currency {String} Währung (EUR, GBP, CHF, USD, etc.)
	 */
	Translator.prototype.currency = function (amount, currency, precision) {
		var c = this.currencies[currency];
		precision = typeof precision === "undefined" ? 2 : 0;
		if (!c) {
			throw new Error("Translator: Unkown currency: " + currency);
		}
		return c.prefix + format.number(amount, precision, c.dec_point, c.thousands_sep) + c.suffix;
	};
	
	/**
	 * Währung formatieren. Packt den Präfix oder Suffix in ein span-Element mit der Klasse currency.
	 *
	 * @param amount {Number} Wert
	 * @param currency {String} Währung (EUR, GBP, CHF, USD, etc.)
	 */
	Translator.prototype.currencyHTML = function (amount, currency, precision) {
		var c = this.currencies[currency];
		precision = typeof precision === "undefined" ? 2 : 0;
		if (!c) {
			throw new Error("Translator: Unkown currency: " + currency);
		}
		var prefix = '',
		    suffix = '';
		if (c.prefix != "") prefix = '<span class="currency">' + c.prefix + '</span> ';
		if (c.suffix != "") suffix = ' <span class="currency">' + c.suffix + '</span>';
	
		return prefix + '<span class="digits">' + format.number(amount, precision, c.dec_point, c.thousands_sep) + '</span>' + suffix;
	};
	
	/**
	 * Registriert alle Übersetzer-Funktionen mit einem TemplateCache
	 */
	Translator.prototype.registerHelpers = function (templatecache) {
		templatecache.helper("__", this.get);
		templatecache.helper("___", this.plural);
		templatecache.helper("currency", this.currency);
		templatecache.helper("currencyHTML", this.currencyHTML);
	};
	
	module.exports = {
		Translator: Translator,
		singleton: new Translator()
	};

/***/ }),
/* 19 */
/***/ (function(module, exports) {

	/**
	 * Funktionen zur Formatierung von Nummern
	 */
	
	'use strict';
	
	var number_format = function number_format(number, decimals, dec_point, thousands_sep) {
	    //  discuss at: http://phpjs.org/functions/number_format/
	    // original by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
	    // improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
	    // improved by: davook
	    // improved by: Brett Zamir (http://brett-zamir.me)
	    // improved by: Brett Zamir (http://brett-zamir.me)
	    // improved by: Theriault
	    // improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
	    // bugfixed by: Michael White (http://getsprink.com)
	    // bugfixed by: Benjamin Lupton
	    // bugfixed by: Allan Jensen (http://www.winternet.no)
	    // bugfixed by: Howard Yeend
	    // bugfixed by: Diogo Resende
	    // bugfixed by: Rival
	    // bugfixed by: Brett Zamir (http://brett-zamir.me)
	    //  revised by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
	    //  revised by: Luke Smith (http://lucassmith.name)
	    //    input by: Kheang Hok Chin (http://www.distantia.ca/)
	    //    input by: Jay Klehr
	    //    input by: Amir Habibi (http://www.residence-mixte.com/)
	    //    input by: Amirouche
	    //   example 1: number_format(1234.56);
	    //   returns 1: '1,235'
	    //   example 2: number_format(1234.56, 2, ',', ' ');
	    //   returns 2: '1 234,56'
	    //   example 3: number_format(1234.5678, 2, '.', '');
	    //   returns 3: '1234.57'
	    //   example 4: number_format(67, 2, ',', '.');
	    //   returns 4: '67,00'
	    //   example 5: number_format(1000);
	    //   returns 5: '1,000'
	    //   example 6: number_format(67.311, 2);
	    //   returns 6: '67.31'
	    //   example 7: number_format(1000.55, 1);
	    //   returns 7: '1,000.6'
	    //   example 8: number_format(67000, 5, ',', '.');
	    //   returns 8: '67.000,00000'
	    //   example 9: number_format(0.9, 0);
	    //   returns 9: '1'
	    //  example 10: number_format('1.20', 2);
	    //  returns 10: '1.20'
	    //  example 11: number_format('1.20', 4);
	    //  returns 11: '1.2000'
	    //  example 12: number_format('1.2000', 3);
	    //  returns 12: '1.200'
	    //  example 13: number_format('1 000,50', 2, '.', ' ');
	    //  returns 13: '100 050.00'
	    //  example 14: number_format(1e-8, 8, '.', '');
	    //  returns 14: '0.00000001'
	
	    number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
	    var n = !isFinite(+number) ? 0 : +number,
	        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
	        sep = typeof thousands_sep === 'undefined' ? ',' : thousands_sep,
	        dec = typeof dec_point === 'undefined' ? '.' : dec_point,
	        s = '',
	        toFixedFix = function toFixedFix(n, prec) {
	        var k = Math.pow(10, prec);
	        return '' + (Math.round(n * k) / k).toFixed(prec);
	    };
	
	    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
	    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
	    if (s[0].length > 3) {
	        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
	    }
	    if ((s[1] || '').length < prec) {
	        s[1] = s[1] || '';
	        s[1] += new Array(prec - s[1].length + 1).join('0');
	    }
	    return s.join(dec);
	};
	
	module.exports = {
	    number: number_format
	};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {//     Backbone.js 1.3.3
	
	//     (c) 2010-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	//     Backbone may be freely distributed under the MIT license.
	//     For all details and documentation:
	//     http://backbonejs.org
	
	(function(factory) {
	
	  // Establish the root object, `window` (`self`) in the browser, or `global` on the server.
	  // We use `self` instead of `window` for `WebWorker` support.
	  var root = (typeof self == 'object' && self.self === self && self) ||
	            (typeof global == 'object' && global.global === global && global);
	
	  // Set up Backbone appropriately for the environment. Start with AMD.
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(7), __webpack_require__(6), exports], __WEBPACK_AMD_DEFINE_RESULT__ = function(_, $, exports) {
	      // Export global even in AMD case in case this script is loaded with
	      // others that may still expect a global Backbone.
	      root.Backbone = factory(root, exports, _, $);
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	  // Next for Node.js or CommonJS. jQuery may not be needed as a module.
	  } else if (typeof exports !== 'undefined') {
	    var _ = require('underscore'), $;
	    try { $ = require('jquery'); } catch (e) {}
	    factory(root, exports, _, $);
	
	  // Finally, as a browser global.
	  } else {
	    root.Backbone = factory(root, {}, root._, (root.jQuery || root.Zepto || root.ender || root.$));
	  }
	
	})(function(root, Backbone, _, $) {
	
	  // Initial Setup
	  // -------------
	
	  // Save the previous value of the `Backbone` variable, so that it can be
	  // restored later on, if `noConflict` is used.
	  var previousBackbone = root.Backbone;
	
	  // Create a local reference to a common array method we'll want to use later.
	  var slice = Array.prototype.slice;
	
	  // Current version of the library. Keep in sync with `package.json`.
	  Backbone.VERSION = '1.3.3';
	
	  // For Backbone's purposes, jQuery, Zepto, Ender, or My Library (kidding) owns
	  // the `$` variable.
	  Backbone.$ = $;
	
	  // Runs Backbone.js in *noConflict* mode, returning the `Backbone` variable
	  // to its previous owner. Returns a reference to this Backbone object.
	  Backbone.noConflict = function() {
	    root.Backbone = previousBackbone;
	    return this;
	  };
	
	  // Turn on `emulateHTTP` to support legacy HTTP servers. Setting this option
	  // will fake `"PATCH"`, `"PUT"` and `"DELETE"` requests via the `_method` parameter and
	  // set a `X-Http-Method-Override` header.
	  Backbone.emulateHTTP = false;
	
	  // Turn on `emulateJSON` to support legacy servers that can't deal with direct
	  // `application/json` requests ... this will encode the body as
	  // `application/x-www-form-urlencoded` instead and will send the model in a
	  // form param named `model`.
	  Backbone.emulateJSON = false;
	
	  // Proxy Backbone class methods to Underscore functions, wrapping the model's
	  // `attributes` object or collection's `models` array behind the scenes.
	  //
	  // collection.filter(function(model) { return model.get('age') > 10 });
	  // collection.each(this.addView);
	  //
	  // `Function#apply` can be slow so we use the method's arg count, if we know it.
	  var addMethod = function(length, method, attribute) {
	    switch (length) {
	      case 1: return function() {
	        return _[method](this[attribute]);
	      };
	      case 2: return function(value) {
	        return _[method](this[attribute], value);
	      };
	      case 3: return function(iteratee, context) {
	        return _[method](this[attribute], cb(iteratee, this), context);
	      };
	      case 4: return function(iteratee, defaultVal, context) {
	        return _[method](this[attribute], cb(iteratee, this), defaultVal, context);
	      };
	      default: return function() {
	        var args = slice.call(arguments);
	        args.unshift(this[attribute]);
	        return _[method].apply(_, args);
	      };
	    }
	  };
	  var addUnderscoreMethods = function(Class, methods, attribute) {
	    _.each(methods, function(length, method) {
	      if (_[method]) Class.prototype[method] = addMethod(length, method, attribute);
	    });
	  };
	
	  // Support `collection.sortBy('attr')` and `collection.findWhere({id: 1})`.
	  var cb = function(iteratee, instance) {
	    if (_.isFunction(iteratee)) return iteratee;
	    if (_.isObject(iteratee) && !instance._isModel(iteratee)) return modelMatcher(iteratee);
	    if (_.isString(iteratee)) return function(model) { return model.get(iteratee); };
	    return iteratee;
	  };
	  var modelMatcher = function(attrs) {
	    var matcher = _.matches(attrs);
	    return function(model) {
	      return matcher(model.attributes);
	    };
	  };
	
	  // Backbone.Events
	  // ---------------
	
	  // A module that can be mixed in to *any object* in order to provide it with
	  // a custom event channel. You may bind a callback to an event with `on` or
	  // remove with `off`; `trigger`-ing an event fires all callbacks in
	  // succession.
	  //
	  //     var object = {};
	  //     _.extend(object, Backbone.Events);
	  //     object.on('expand', function(){ alert('expanded'); });
	  //     object.trigger('expand');
	  //
	  var Events = Backbone.Events = {};
	
	  // Regular expression used to split event strings.
	  var eventSplitter = /\s+/;
	
	  // Iterates over the standard `event, callback` (as well as the fancy multiple
	  // space-separated events `"change blur", callback` and jQuery-style event
	  // maps `{event: callback}`).
	  var eventsApi = function(iteratee, events, name, callback, opts) {
	    var i = 0, names;
	    if (name && typeof name === 'object') {
	      // Handle event maps.
	      if (callback !== void 0 && 'context' in opts && opts.context === void 0) opts.context = callback;
	      for (names = _.keys(name); i < names.length ; i++) {
	        events = eventsApi(iteratee, events, names[i], name[names[i]], opts);
	      }
	    } else if (name && eventSplitter.test(name)) {
	      // Handle space-separated event names by delegating them individually.
	      for (names = name.split(eventSplitter); i < names.length; i++) {
	        events = iteratee(events, names[i], callback, opts);
	      }
	    } else {
	      // Finally, standard events.
	      events = iteratee(events, name, callback, opts);
	    }
	    return events;
	  };
	
	  // Bind an event to a `callback` function. Passing `"all"` will bind
	  // the callback to all events fired.
	  Events.on = function(name, callback, context) {
	    return internalOn(this, name, callback, context);
	  };
	
	  // Guard the `listening` argument from the public API.
	  var internalOn = function(obj, name, callback, context, listening) {
	    obj._events = eventsApi(onApi, obj._events || {}, name, callback, {
	      context: context,
	      ctx: obj,
	      listening: listening
	    });
	
	    if (listening) {
	      var listeners = obj._listeners || (obj._listeners = {});
	      listeners[listening.id] = listening;
	    }
	
	    return obj;
	  };
	
	  // Inversion-of-control versions of `on`. Tell *this* object to listen to
	  // an event in another object... keeping track of what it's listening to
	  // for easier unbinding later.
	  Events.listenTo = function(obj, name, callback) {
	    if (!obj) return this;
	    var id = obj._listenId || (obj._listenId = _.uniqueId('l'));
	    var listeningTo = this._listeningTo || (this._listeningTo = {});
	    var listening = listeningTo[id];
	
	    // This object is not listening to any other events on `obj` yet.
	    // Setup the necessary references to track the listening callbacks.
	    if (!listening) {
	      var thisId = this._listenId || (this._listenId = _.uniqueId('l'));
	      listening = listeningTo[id] = {obj: obj, objId: id, id: thisId, listeningTo: listeningTo, count: 0};
	    }
	
	    // Bind callbacks on obj, and keep track of them on listening.
	    internalOn(obj, name, callback, this, listening);
	    return this;
	  };
	
	  // The reducing API that adds a callback to the `events` object.
	  var onApi = function(events, name, callback, options) {
	    if (callback) {
	      var handlers = events[name] || (events[name] = []);
	      var context = options.context, ctx = options.ctx, listening = options.listening;
	      if (listening) listening.count++;
	
	      handlers.push({callback: callback, context: context, ctx: context || ctx, listening: listening});
	    }
	    return events;
	  };
	
	  // Remove one or many callbacks. If `context` is null, removes all
	  // callbacks with that function. If `callback` is null, removes all
	  // callbacks for the event. If `name` is null, removes all bound
	  // callbacks for all events.
	  Events.off = function(name, callback, context) {
	    if (!this._events) return this;
	    this._events = eventsApi(offApi, this._events, name, callback, {
	      context: context,
	      listeners: this._listeners
	    });
	    return this;
	  };
	
	  // Tell this object to stop listening to either specific events ... or
	  // to every object it's currently listening to.
	  Events.stopListening = function(obj, name, callback) {
	    var listeningTo = this._listeningTo;
	    if (!listeningTo) return this;
	
	    var ids = obj ? [obj._listenId] : _.keys(listeningTo);
	
	    for (var i = 0; i < ids.length; i++) {
	      var listening = listeningTo[ids[i]];
	
	      // If listening doesn't exist, this object is not currently
	      // listening to obj. Break out early.
	      if (!listening) break;
	
	      listening.obj.off(name, callback, this);
	    }
	
	    return this;
	  };
	
	  // The reducing API that removes a callback from the `events` object.
	  var offApi = function(events, name, callback, options) {
	    if (!events) return;
	
	    var i = 0, listening;
	    var context = options.context, listeners = options.listeners;
	
	    // Delete all events listeners and "drop" events.
	    if (!name && !callback && !context) {
	      var ids = _.keys(listeners);
	      for (; i < ids.length; i++) {
	        listening = listeners[ids[i]];
	        delete listeners[listening.id];
	        delete listening.listeningTo[listening.objId];
	      }
	      return;
	    }
	
	    var names = name ? [name] : _.keys(events);
	    for (; i < names.length; i++) {
	      name = names[i];
	      var handlers = events[name];
	
	      // Bail out if there are no events stored.
	      if (!handlers) break;
	
	      // Replace events if there are any remaining.  Otherwise, clean up.
	      var remaining = [];
	      for (var j = 0; j < handlers.length; j++) {
	        var handler = handlers[j];
	        if (
	          callback && callback !== handler.callback &&
	            callback !== handler.callback._callback ||
	              context && context !== handler.context
	        ) {
	          remaining.push(handler);
	        } else {
	          listening = handler.listening;
	          if (listening && --listening.count === 0) {
	            delete listeners[listening.id];
	            delete listening.listeningTo[listening.objId];
	          }
	        }
	      }
	
	      // Update tail event if the list has any events.  Otherwise, clean up.
	      if (remaining.length) {
	        events[name] = remaining;
	      } else {
	        delete events[name];
	      }
	    }
	    return events;
	  };
	
	  // Bind an event to only be triggered a single time. After the first time
	  // the callback is invoked, its listener will be removed. If multiple events
	  // are passed in using the space-separated syntax, the handler will fire
	  // once for each event, not once for a combination of all events.
	  Events.once = function(name, callback, context) {
	    // Map the event into a `{event: once}` object.
	    var events = eventsApi(onceMap, {}, name, callback, _.bind(this.off, this));
	    if (typeof name === 'string' && context == null) callback = void 0;
	    return this.on(events, callback, context);
	  };
	
	  // Inversion-of-control versions of `once`.
	  Events.listenToOnce = function(obj, name, callback) {
	    // Map the event into a `{event: once}` object.
	    var events = eventsApi(onceMap, {}, name, callback, _.bind(this.stopListening, this, obj));
	    return this.listenTo(obj, events);
	  };
	
	  // Reduces the event callbacks into a map of `{event: onceWrapper}`.
	  // `offer` unbinds the `onceWrapper` after it has been called.
	  var onceMap = function(map, name, callback, offer) {
	    if (callback) {
	      var once = map[name] = _.once(function() {
	        offer(name, once);
	        callback.apply(this, arguments);
	      });
	      once._callback = callback;
	    }
	    return map;
	  };
	
	  // Trigger one or many events, firing all bound callbacks. Callbacks are
	  // passed the same arguments as `trigger` is, apart from the event name
	  // (unless you're listening on `"all"`, which will cause your callback to
	  // receive the true name of the event as the first argument).
	  Events.trigger = function(name) {
	    if (!this._events) return this;
	
	    var length = Math.max(0, arguments.length - 1);
	    var args = Array(length);
	    for (var i = 0; i < length; i++) args[i] = arguments[i + 1];
	
	    eventsApi(triggerApi, this._events, name, void 0, args);
	    return this;
	  };
	
	  // Handles triggering the appropriate event callbacks.
	  var triggerApi = function(objEvents, name, callback, args) {
	    if (objEvents) {
	      var events = objEvents[name];
	      var allEvents = objEvents.all;
	      if (events && allEvents) allEvents = allEvents.slice();
	      if (events) triggerEvents(events, args);
	      if (allEvents) triggerEvents(allEvents, [name].concat(args));
	    }
	    return objEvents;
	  };
	
	  // A difficult-to-believe, but optimized internal dispatch function for
	  // triggering events. Tries to keep the usual cases speedy (most internal
	  // Backbone events have 3 arguments).
	  var triggerEvents = function(events, args) {
	    var ev, i = -1, l = events.length, a1 = args[0], a2 = args[1], a3 = args[2];
	    switch (args.length) {
	      case 0: while (++i < l) (ev = events[i]).callback.call(ev.ctx); return;
	      case 1: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1); return;
	      case 2: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2); return;
	      case 3: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2, a3); return;
	      default: while (++i < l) (ev = events[i]).callback.apply(ev.ctx, args); return;
	    }
	  };
	
	  // Aliases for backwards compatibility.
	  Events.bind   = Events.on;
	  Events.unbind = Events.off;
	
	  // Allow the `Backbone` object to serve as a global event bus, for folks who
	  // want global "pubsub" in a convenient place.
	  _.extend(Backbone, Events);
	
	  // Backbone.Model
	  // --------------
	
	  // Backbone **Models** are the basic data object in the framework --
	  // frequently representing a row in a table in a database on your server.
	  // A discrete chunk of data and a bunch of useful, related methods for
	  // performing computations and transformations on that data.
	
	  // Create a new model with the specified attributes. A client id (`cid`)
	  // is automatically generated and assigned for you.
	  var Model = Backbone.Model = function(attributes, options) {
	    var attrs = attributes || {};
	    options || (options = {});
	    this.cid = _.uniqueId(this.cidPrefix);
	    this.attributes = {};
	    if (options.collection) this.collection = options.collection;
	    if (options.parse) attrs = this.parse(attrs, options) || {};
	    var defaults = _.result(this, 'defaults');
	    attrs = _.defaults(_.extend({}, defaults, attrs), defaults);
	    this.set(attrs, options);
	    this.changed = {};
	    this.initialize.apply(this, arguments);
	  };
	
	  // Attach all inheritable methods to the Model prototype.
	  _.extend(Model.prototype, Events, {
	
	    // A hash of attributes whose current and previous value differ.
	    changed: null,
	
	    // The value returned during the last failed validation.
	    validationError: null,
	
	    // The default name for the JSON `id` attribute is `"id"`. MongoDB and
	    // CouchDB users may want to set this to `"_id"`.
	    idAttribute: 'id',
	
	    // The prefix is used to create the client id which is used to identify models locally.
	    // You may want to override this if you're experiencing name clashes with model ids.
	    cidPrefix: 'c',
	
	    // Initialize is an empty function by default. Override it with your own
	    // initialization logic.
	    initialize: function(){},
	
	    // Return a copy of the model's `attributes` object.
	    toJSON: function(options) {
	      return _.clone(this.attributes);
	    },
	
	    // Proxy `Backbone.sync` by default -- but override this if you need
	    // custom syncing semantics for *this* particular model.
	    sync: function() {
	      return Backbone.sync.apply(this, arguments);
	    },
	
	    // Get the value of an attribute.
	    get: function(attr) {
	      return this.attributes[attr];
	    },
	
	    // Get the HTML-escaped value of an attribute.
	    escape: function(attr) {
	      return _.escape(this.get(attr));
	    },
	
	    // Returns `true` if the attribute contains a value that is not null
	    // or undefined.
	    has: function(attr) {
	      return this.get(attr) != null;
	    },
	
	    // Special-cased proxy to underscore's `_.matches` method.
	    matches: function(attrs) {
	      return !!_.iteratee(attrs, this)(this.attributes);
	    },
	
	    // Set a hash of model attributes on the object, firing `"change"`. This is
	    // the core primitive operation of a model, updating the data and notifying
	    // anyone who needs to know about the change in state. The heart of the beast.
	    set: function(key, val, options) {
	      if (key == null) return this;
	
	      // Handle both `"key", value` and `{key: value}` -style arguments.
	      var attrs;
	      if (typeof key === 'object') {
	        attrs = key;
	        options = val;
	      } else {
	        (attrs = {})[key] = val;
	      }
	
	      options || (options = {});
	
	      // Run validation.
	      if (!this._validate(attrs, options)) return false;
	
	      // Extract attributes and options.
	      var unset      = options.unset;
	      var silent     = options.silent;
	      var changes    = [];
	      var changing   = this._changing;
	      this._changing = true;
	
	      if (!changing) {
	        this._previousAttributes = _.clone(this.attributes);
	        this.changed = {};
	      }
	
	      var current = this.attributes;
	      var changed = this.changed;
	      var prev    = this._previousAttributes;
	
	      // For each `set` attribute, update or delete the current value.
	      for (var attr in attrs) {
	        val = attrs[attr];
	        if (!_.isEqual(current[attr], val)) changes.push(attr);
	        if (!_.isEqual(prev[attr], val)) {
	          changed[attr] = val;
	        } else {
	          delete changed[attr];
	        }
	        unset ? delete current[attr] : current[attr] = val;
	      }
	
	      // Update the `id`.
	      if (this.idAttribute in attrs) this.id = this.get(this.idAttribute);
	
	      // Trigger all relevant attribute changes.
	      if (!silent) {
	        if (changes.length) this._pending = options;
	        for (var i = 0; i < changes.length; i++) {
	          this.trigger('change:' + changes[i], this, current[changes[i]], options);
	        }
	      }
	
	      // You might be wondering why there's a `while` loop here. Changes can
	      // be recursively nested within `"change"` events.
	      if (changing) return this;
	      if (!silent) {
	        while (this._pending) {
	          options = this._pending;
	          this._pending = false;
	          this.trigger('change', this, options);
	        }
	      }
	      this._pending = false;
	      this._changing = false;
	      return this;
	    },
	
	    // Remove an attribute from the model, firing `"change"`. `unset` is a noop
	    // if the attribute doesn't exist.
	    unset: function(attr, options) {
	      return this.set(attr, void 0, _.extend({}, options, {unset: true}));
	    },
	
	    // Clear all attributes on the model, firing `"change"`.
	    clear: function(options) {
	      var attrs = {};
	      for (var key in this.attributes) attrs[key] = void 0;
	      return this.set(attrs, _.extend({}, options, {unset: true}));
	    },
	
	    // Determine if the model has changed since the last `"change"` event.
	    // If you specify an attribute name, determine if that attribute has changed.
	    hasChanged: function(attr) {
	      if (attr == null) return !_.isEmpty(this.changed);
	      return _.has(this.changed, attr);
	    },
	
	    // Return an object containing all the attributes that have changed, or
	    // false if there are no changed attributes. Useful for determining what
	    // parts of a view need to be updated and/or what attributes need to be
	    // persisted to the server. Unset attributes will be set to undefined.
	    // You can also pass an attributes object to diff against the model,
	    // determining if there *would be* a change.
	    changedAttributes: function(diff) {
	      if (!diff) return this.hasChanged() ? _.clone(this.changed) : false;
	      var old = this._changing ? this._previousAttributes : this.attributes;
	      var changed = {};
	      for (var attr in diff) {
	        var val = diff[attr];
	        if (_.isEqual(old[attr], val)) continue;
	        changed[attr] = val;
	      }
	      return _.size(changed) ? changed : false;
	    },
	
	    // Get the previous value of an attribute, recorded at the time the last
	    // `"change"` event was fired.
	    previous: function(attr) {
	      if (attr == null || !this._previousAttributes) return null;
	      return this._previousAttributes[attr];
	    },
	
	    // Get all of the attributes of the model at the time of the previous
	    // `"change"` event.
	    previousAttributes: function() {
	      return _.clone(this._previousAttributes);
	    },
	
	    // Fetch the model from the server, merging the response with the model's
	    // local attributes. Any changed attributes will trigger a "change" event.
	    fetch: function(options) {
	      options = _.extend({parse: true}, options);
	      var model = this;
	      var success = options.success;
	      options.success = function(resp) {
	        var serverAttrs = options.parse ? model.parse(resp, options) : resp;
	        if (!model.set(serverAttrs, options)) return false;
	        if (success) success.call(options.context, model, resp, options);
	        model.trigger('sync', model, resp, options);
	      };
	      wrapError(this, options);
	      return this.sync('read', this, options);
	    },
	
	    // Set a hash of model attributes, and sync the model to the server.
	    // If the server returns an attributes hash that differs, the model's
	    // state will be `set` again.
	    save: function(key, val, options) {
	      // Handle both `"key", value` and `{key: value}` -style arguments.
	      var attrs;
	      if (key == null || typeof key === 'object') {
	        attrs = key;
	        options = val;
	      } else {
	        (attrs = {})[key] = val;
	      }
	
	      options = _.extend({validate: true, parse: true}, options);
	      var wait = options.wait;
	
	      // If we're not waiting and attributes exist, save acts as
	      // `set(attr).save(null, opts)` with validation. Otherwise, check if
	      // the model will be valid when the attributes, if any, are set.
	      if (attrs && !wait) {
	        if (!this.set(attrs, options)) return false;
	      } else if (!this._validate(attrs, options)) {
	        return false;
	      }
	
	      // After a successful server-side save, the client is (optionally)
	      // updated with the server-side state.
	      var model = this;
	      var success = options.success;
	      var attributes = this.attributes;
	      options.success = function(resp) {
	        // Ensure attributes are restored during synchronous saves.
	        model.attributes = attributes;
	        var serverAttrs = options.parse ? model.parse(resp, options) : resp;
	        if (wait) serverAttrs = _.extend({}, attrs, serverAttrs);
	        if (serverAttrs && !model.set(serverAttrs, options)) return false;
	        if (success) success.call(options.context, model, resp, options);
	        model.trigger('sync', model, resp, options);
	      };
	      wrapError(this, options);
	
	      // Set temporary attributes if `{wait: true}` to properly find new ids.
	      if (attrs && wait) this.attributes = _.extend({}, attributes, attrs);
	
	      var method = this.isNew() ? 'create' : (options.patch ? 'patch' : 'update');
	      if (method === 'patch' && !options.attrs) options.attrs = attrs;
	      var xhr = this.sync(method, this, options);
	
	      // Restore attributes.
	      this.attributes = attributes;
	
	      return xhr;
	    },
	
	    // Destroy this model on the server if it was already persisted.
	    // Optimistically removes the model from its collection, if it has one.
	    // If `wait: true` is passed, waits for the server to respond before removal.
	    destroy: function(options) {
	      options = options ? _.clone(options) : {};
	      var model = this;
	      var success = options.success;
	      var wait = options.wait;
	
	      var destroy = function() {
	        model.stopListening();
	        model.trigger('destroy', model, model.collection, options);
	      };
	
	      options.success = function(resp) {
	        if (wait) destroy();
	        if (success) success.call(options.context, model, resp, options);
	        if (!model.isNew()) model.trigger('sync', model, resp, options);
	      };
	
	      var xhr = false;
	      if (this.isNew()) {
	        _.defer(options.success);
	      } else {
	        wrapError(this, options);
	        xhr = this.sync('delete', this, options);
	      }
	      if (!wait) destroy();
	      return xhr;
	    },
	
	    // Default URL for the model's representation on the server -- if you're
	    // using Backbone's restful methods, override this to change the endpoint
	    // that will be called.
	    url: function() {
	      var base =
	        _.result(this, 'urlRoot') ||
	        _.result(this.collection, 'url') ||
	        urlError();
	      if (this.isNew()) return base;
	      var id = this.get(this.idAttribute);
	      return base.replace(/[^\/]$/, '$&/') + encodeURIComponent(id);
	    },
	
	    // **parse** converts a response into the hash of attributes to be `set` on
	    // the model. The default implementation is just to pass the response along.
	    parse: function(resp, options) {
	      return resp;
	    },
	
	    // Create a new model with identical attributes to this one.
	    clone: function() {
	      return new this.constructor(this.attributes);
	    },
	
	    // A model is new if it has never been saved to the server, and lacks an id.
	    isNew: function() {
	      return !this.has(this.idAttribute);
	    },
	
	    // Check if the model is currently in a valid state.
	    isValid: function(options) {
	      return this._validate({}, _.extend({}, options, {validate: true}));
	    },
	
	    // Run validation against the next complete set of model attributes,
	    // returning `true` if all is well. Otherwise, fire an `"invalid"` event.
	    _validate: function(attrs, options) {
	      if (!options.validate || !this.validate) return true;
	      attrs = _.extend({}, this.attributes, attrs);
	      var error = this.validationError = this.validate(attrs, options) || null;
	      if (!error) return true;
	      this.trigger('invalid', this, error, _.extend(options, {validationError: error}));
	      return false;
	    }
	
	  });
	
	  // Underscore methods that we want to implement on the Model, mapped to the
	  // number of arguments they take.
	  var modelMethods = {keys: 1, values: 1, pairs: 1, invert: 1, pick: 0,
	      omit: 0, chain: 1, isEmpty: 1};
	
	  // Mix in each Underscore method as a proxy to `Model#attributes`.
	  addUnderscoreMethods(Model, modelMethods, 'attributes');
	
	  // Backbone.Collection
	  // -------------------
	
	  // If models tend to represent a single row of data, a Backbone Collection is
	  // more analogous to a table full of data ... or a small slice or page of that
	  // table, or a collection of rows that belong together for a particular reason
	  // -- all of the messages in this particular folder, all of the documents
	  // belonging to this particular author, and so on. Collections maintain
	  // indexes of their models, both in order, and for lookup by `id`.
	
	  // Create a new **Collection**, perhaps to contain a specific type of `model`.
	  // If a `comparator` is specified, the Collection will maintain
	  // its models in sort order, as they're added and removed.
	  var Collection = Backbone.Collection = function(models, options) {
	    options || (options = {});
	    if (options.model) this.model = options.model;
	    if (options.comparator !== void 0) this.comparator = options.comparator;
	    this._reset();
	    this.initialize.apply(this, arguments);
	    if (models) this.reset(models, _.extend({silent: true}, options));
	  };
	
	  // Default options for `Collection#set`.
	  var setOptions = {add: true, remove: true, merge: true};
	  var addOptions = {add: true, remove: false};
	
	  // Splices `insert` into `array` at index `at`.
	  var splice = function(array, insert, at) {
	    at = Math.min(Math.max(at, 0), array.length);
	    var tail = Array(array.length - at);
	    var length = insert.length;
	    var i;
	    for (i = 0; i < tail.length; i++) tail[i] = array[i + at];
	    for (i = 0; i < length; i++) array[i + at] = insert[i];
	    for (i = 0; i < tail.length; i++) array[i + length + at] = tail[i];
	  };
	
	  // Define the Collection's inheritable methods.
	  _.extend(Collection.prototype, Events, {
	
	    // The default model for a collection is just a **Backbone.Model**.
	    // This should be overridden in most cases.
	    model: Model,
	
	    // Initialize is an empty function by default. Override it with your own
	    // initialization logic.
	    initialize: function(){},
	
	    // The JSON representation of a Collection is an array of the
	    // models' attributes.
	    toJSON: function(options) {
	      return this.map(function(model) { return model.toJSON(options); });
	    },
	
	    // Proxy `Backbone.sync` by default.
	    sync: function() {
	      return Backbone.sync.apply(this, arguments);
	    },
	
	    // Add a model, or list of models to the set. `models` may be Backbone
	    // Models or raw JavaScript objects to be converted to Models, or any
	    // combination of the two.
	    add: function(models, options) {
	      return this.set(models, _.extend({merge: false}, options, addOptions));
	    },
	
	    // Remove a model, or a list of models from the set.
	    remove: function(models, options) {
	      options = _.extend({}, options);
	      var singular = !_.isArray(models);
	      models = singular ? [models] : models.slice();
	      var removed = this._removeModels(models, options);
	      if (!options.silent && removed.length) {
	        options.changes = {added: [], merged: [], removed: removed};
	        this.trigger('update', this, options);
	      }
	      return singular ? removed[0] : removed;
	    },
	
	    // Update a collection by `set`-ing a new list of models, adding new ones,
	    // removing models that are no longer present, and merging models that
	    // already exist in the collection, as necessary. Similar to **Model#set**,
	    // the core operation for updating the data contained by the collection.
	    set: function(models, options) {
	      if (models == null) return;
	
	      options = _.extend({}, setOptions, options);
	      if (options.parse && !this._isModel(models)) {
	        models = this.parse(models, options) || [];
	      }
	
	      var singular = !_.isArray(models);
	      models = singular ? [models] : models.slice();
	
	      var at = options.at;
	      if (at != null) at = +at;
	      if (at > this.length) at = this.length;
	      if (at < 0) at += this.length + 1;
	
	      var set = [];
	      var toAdd = [];
	      var toMerge = [];
	      var toRemove = [];
	      var modelMap = {};
	
	      var add = options.add;
	      var merge = options.merge;
	      var remove = options.remove;
	
	      var sort = false;
	      var sortable = this.comparator && at == null && options.sort !== false;
	      var sortAttr = _.isString(this.comparator) ? this.comparator : null;
	
	      // Turn bare objects into model references, and prevent invalid models
	      // from being added.
	      var model, i;
	      for (i = 0; i < models.length; i++) {
	        model = models[i];
	
	        // If a duplicate is found, prevent it from being added and
	        // optionally merge it into the existing model.
	        var existing = this.get(model);
	        if (existing) {
	          if (merge && model !== existing) {
	            var attrs = this._isModel(model) ? model.attributes : model;
	            if (options.parse) attrs = existing.parse(attrs, options);
	            existing.set(attrs, options);
	            toMerge.push(existing);
	            if (sortable && !sort) sort = existing.hasChanged(sortAttr);
	          }
	          if (!modelMap[existing.cid]) {
	            modelMap[existing.cid] = true;
	            set.push(existing);
	          }
	          models[i] = existing;
	
	        // If this is a new, valid model, push it to the `toAdd` list.
	        } else if (add) {
	          model = models[i] = this._prepareModel(model, options);
	          if (model) {
	            toAdd.push(model);
	            this._addReference(model, options);
	            modelMap[model.cid] = true;
	            set.push(model);
	          }
	        }
	      }
	
	      // Remove stale models.
	      if (remove) {
	        for (i = 0; i < this.length; i++) {
	          model = this.models[i];
	          if (!modelMap[model.cid]) toRemove.push(model);
	        }
	        if (toRemove.length) this._removeModels(toRemove, options);
	      }
	
	      // See if sorting is needed, update `length` and splice in new models.
	      var orderChanged = false;
	      var replace = !sortable && add && remove;
	      if (set.length && replace) {
	        orderChanged = this.length !== set.length || _.some(this.models, function(m, index) {
	          return m !== set[index];
	        });
	        this.models.length = 0;
	        splice(this.models, set, 0);
	        this.length = this.models.length;
	      } else if (toAdd.length) {
	        if (sortable) sort = true;
	        splice(this.models, toAdd, at == null ? this.length : at);
	        this.length = this.models.length;
	      }
	
	      // Silently sort the collection if appropriate.
	      if (sort) this.sort({silent: true});
	
	      // Unless silenced, it's time to fire all appropriate add/sort/update events.
	      if (!options.silent) {
	        for (i = 0; i < toAdd.length; i++) {
	          if (at != null) options.index = at + i;
	          model = toAdd[i];
	          model.trigger('add', model, this, options);
	        }
	        if (sort || orderChanged) this.trigger('sort', this, options);
	        if (toAdd.length || toRemove.length || toMerge.length) {
	          options.changes = {
	            added: toAdd,
	            removed: toRemove,
	            merged: toMerge
	          };
	          this.trigger('update', this, options);
	        }
	      }
	
	      // Return the added (or merged) model (or models).
	      return singular ? models[0] : models;
	    },
	
	    // When you have more items than you want to add or remove individually,
	    // you can reset the entire set with a new list of models, without firing
	    // any granular `add` or `remove` events. Fires `reset` when finished.
	    // Useful for bulk operations and optimizations.
	    reset: function(models, options) {
	      options = options ? _.clone(options) : {};
	      for (var i = 0; i < this.models.length; i++) {
	        this._removeReference(this.models[i], options);
	      }
	      options.previousModels = this.models;
	      this._reset();
	      models = this.add(models, _.extend({silent: true}, options));
	      if (!options.silent) this.trigger('reset', this, options);
	      return models;
	    },
	
	    // Add a model to the end of the collection.
	    push: function(model, options) {
	      return this.add(model, _.extend({at: this.length}, options));
	    },
	
	    // Remove a model from the end of the collection.
	    pop: function(options) {
	      var model = this.at(this.length - 1);
	      return this.remove(model, options);
	    },
	
	    // Add a model to the beginning of the collection.
	    unshift: function(model, options) {
	      return this.add(model, _.extend({at: 0}, options));
	    },
	
	    // Remove a model from the beginning of the collection.
	    shift: function(options) {
	      var model = this.at(0);
	      return this.remove(model, options);
	    },
	
	    // Slice out a sub-array of models from the collection.
	    slice: function() {
	      return slice.apply(this.models, arguments);
	    },
	
	    // Get a model from the set by id, cid, model object with id or cid
	    // properties, or an attributes object that is transformed through modelId.
	    get: function(obj) {
	      if (obj == null) return void 0;
	      return this._byId[obj] ||
	        this._byId[this.modelId(obj.attributes || obj)] ||
	        obj.cid && this._byId[obj.cid];
	    },
	
	    // Returns `true` if the model is in the collection.
	    has: function(obj) {
	      return this.get(obj) != null;
	    },
	
	    // Get the model at the given index.
	    at: function(index) {
	      if (index < 0) index += this.length;
	      return this.models[index];
	    },
	
	    // Return models with matching attributes. Useful for simple cases of
	    // `filter`.
	    where: function(attrs, first) {
	      return this[first ? 'find' : 'filter'](attrs);
	    },
	
	    // Return the first model with matching attributes. Useful for simple cases
	    // of `find`.
	    findWhere: function(attrs) {
	      return this.where(attrs, true);
	    },
	
	    // Force the collection to re-sort itself. You don't need to call this under
	    // normal circumstances, as the set will maintain sort order as each item
	    // is added.
	    sort: function(options) {
	      var comparator = this.comparator;
	      if (!comparator) throw new Error('Cannot sort a set without a comparator');
	      options || (options = {});
	
	      var length = comparator.length;
	      if (_.isFunction(comparator)) comparator = _.bind(comparator, this);
	
	      // Run sort based on type of `comparator`.
	      if (length === 1 || _.isString(comparator)) {
	        this.models = this.sortBy(comparator);
	      } else {
	        this.models.sort(comparator);
	      }
	      if (!options.silent) this.trigger('sort', this, options);
	      return this;
	    },
	
	    // Pluck an attribute from each model in the collection.
	    pluck: function(attr) {
	      return this.map(attr + '');
	    },
	
	    // Fetch the default set of models for this collection, resetting the
	    // collection when they arrive. If `reset: true` is passed, the response
	    // data will be passed through the `reset` method instead of `set`.
	    fetch: function(options) {
	      options = _.extend({parse: true}, options);
	      var success = options.success;
	      var collection = this;
	      options.success = function(resp) {
	        var method = options.reset ? 'reset' : 'set';
	        collection[method](resp, options);
	        if (success) success.call(options.context, collection, resp, options);
	        collection.trigger('sync', collection, resp, options);
	      };
	      wrapError(this, options);
	      return this.sync('read', this, options);
	    },
	
	    // Create a new instance of a model in this collection. Add the model to the
	    // collection immediately, unless `wait: true` is passed, in which case we
	    // wait for the server to agree.
	    create: function(model, options) {
	      options = options ? _.clone(options) : {};
	      var wait = options.wait;
	      model = this._prepareModel(model, options);
	      if (!model) return false;
	      if (!wait) this.add(model, options);
	      var collection = this;
	      var success = options.success;
	      options.success = function(m, resp, callbackOpts) {
	        if (wait) collection.add(m, callbackOpts);
	        if (success) success.call(callbackOpts.context, m, resp, callbackOpts);
	      };
	      model.save(null, options);
	      return model;
	    },
	
	    // **parse** converts a response into a list of models to be added to the
	    // collection. The default implementation is just to pass it through.
	    parse: function(resp, options) {
	      return resp;
	    },
	
	    // Create a new collection with an identical list of models as this one.
	    clone: function() {
	      return new this.constructor(this.models, {
	        model: this.model,
	        comparator: this.comparator
	      });
	    },
	
	    // Define how to uniquely identify models in the collection.
	    modelId: function(attrs) {
	      return attrs[this.model.prototype.idAttribute || 'id'];
	    },
	
	    // Private method to reset all internal state. Called when the collection
	    // is first initialized or reset.
	    _reset: function() {
	      this.length = 0;
	      this.models = [];
	      this._byId  = {};
	    },
	
	    // Prepare a hash of attributes (or other model) to be added to this
	    // collection.
	    _prepareModel: function(attrs, options) {
	      if (this._isModel(attrs)) {
	        if (!attrs.collection) attrs.collection = this;
	        return attrs;
	      }
	      options = options ? _.clone(options) : {};
	      options.collection = this;
	      var model = new this.model(attrs, options);
	      if (!model.validationError) return model;
	      this.trigger('invalid', this, model.validationError, options);
	      return false;
	    },
	
	    // Internal method called by both remove and set.
	    _removeModels: function(models, options) {
	      var removed = [];
	      for (var i = 0; i < models.length; i++) {
	        var model = this.get(models[i]);
	        if (!model) continue;
	
	        var index = this.indexOf(model);
	        this.models.splice(index, 1);
	        this.length--;
	
	        // Remove references before triggering 'remove' event to prevent an
	        // infinite loop. #3693
	        delete this._byId[model.cid];
	        var id = this.modelId(model.attributes);
	        if (id != null) delete this._byId[id];
	
	        if (!options.silent) {
	          options.index = index;
	          model.trigger('remove', model, this, options);
	        }
	
	        removed.push(model);
	        this._removeReference(model, options);
	      }
	      return removed;
	    },
	
	    // Method for checking whether an object should be considered a model for
	    // the purposes of adding to the collection.
	    _isModel: function(model) {
	      return model instanceof Model;
	    },
	
	    // Internal method to create a model's ties to a collection.
	    _addReference: function(model, options) {
	      this._byId[model.cid] = model;
	      var id = this.modelId(model.attributes);
	      if (id != null) this._byId[id] = model;
	      model.on('all', this._onModelEvent, this);
	    },
	
	    // Internal method to sever a model's ties to a collection.
	    _removeReference: function(model, options) {
	      delete this._byId[model.cid];
	      var id = this.modelId(model.attributes);
	      if (id != null) delete this._byId[id];
	      if (this === model.collection) delete model.collection;
	      model.off('all', this._onModelEvent, this);
	    },
	
	    // Internal method called every time a model in the set fires an event.
	    // Sets need to update their indexes when models change ids. All other
	    // events simply proxy through. "add" and "remove" events that originate
	    // in other collections are ignored.
	    _onModelEvent: function(event, model, collection, options) {
	      if (model) {
	        if ((event === 'add' || event === 'remove') && collection !== this) return;
	        if (event === 'destroy') this.remove(model, options);
	        if (event === 'change') {
	          var prevId = this.modelId(model.previousAttributes());
	          var id = this.modelId(model.attributes);
	          if (prevId !== id) {
	            if (prevId != null) delete this._byId[prevId];
	            if (id != null) this._byId[id] = model;
	          }
	        }
	      }
	      this.trigger.apply(this, arguments);
	    }
	
	  });
	
	  // Underscore methods that we want to implement on the Collection.
	  // 90% of the core usefulness of Backbone Collections is actually implemented
	  // right here:
	  var collectionMethods = {forEach: 3, each: 3, map: 3, collect: 3, reduce: 0,
	      foldl: 0, inject: 0, reduceRight: 0, foldr: 0, find: 3, detect: 3, filter: 3,
	      select: 3, reject: 3, every: 3, all: 3, some: 3, any: 3, include: 3, includes: 3,
	      contains: 3, invoke: 0, max: 3, min: 3, toArray: 1, size: 1, first: 3,
	      head: 3, take: 3, initial: 3, rest: 3, tail: 3, drop: 3, last: 3,
	      without: 0, difference: 0, indexOf: 3, shuffle: 1, lastIndexOf: 3,
	      isEmpty: 1, chain: 1, sample: 3, partition: 3, groupBy: 3, countBy: 3,
	      sortBy: 3, indexBy: 3, findIndex: 3, findLastIndex: 3};
	
	  // Mix in each Underscore method as a proxy to `Collection#models`.
	  addUnderscoreMethods(Collection, collectionMethods, 'models');
	
	  // Backbone.View
	  // -------------
	
	  // Backbone Views are almost more convention than they are actual code. A View
	  // is simply a JavaScript object that represents a logical chunk of UI in the
	  // DOM. This might be a single item, an entire list, a sidebar or panel, or
	  // even the surrounding frame which wraps your whole app. Defining a chunk of
	  // UI as a **View** allows you to define your DOM events declaratively, without
	  // having to worry about render order ... and makes it easy for the view to
	  // react to specific changes in the state of your models.
	
	  // Creating a Backbone.View creates its initial element outside of the DOM,
	  // if an existing element is not provided...
	  var View = Backbone.View = function(options) {
	    this.cid = _.uniqueId('view');
	    _.extend(this, _.pick(options, viewOptions));
	    this._ensureElement();
	    this.initialize.apply(this, arguments);
	  };
	
	  // Cached regex to split keys for `delegate`.
	  var delegateEventSplitter = /^(\S+)\s*(.*)$/;
	
	  // List of view options to be set as properties.
	  var viewOptions = ['model', 'collection', 'el', 'id', 'attributes', 'className', 'tagName', 'events'];
	
	  // Set up all inheritable **Backbone.View** properties and methods.
	  _.extend(View.prototype, Events, {
	
	    // The default `tagName` of a View's element is `"div"`.
	    tagName: 'div',
	
	    // jQuery delegate for element lookup, scoped to DOM elements within the
	    // current view. This should be preferred to global lookups where possible.
	    $: function(selector) {
	      return this.$el.find(selector);
	    },
	
	    // Initialize is an empty function by default. Override it with your own
	    // initialization logic.
	    initialize: function(){},
	
	    // **render** is the core function that your view should override, in order
	    // to populate its element (`this.el`), with the appropriate HTML. The
	    // convention is for **render** to always return `this`.
	    render: function() {
	      return this;
	    },
	
	    // Remove this view by taking the element out of the DOM, and removing any
	    // applicable Backbone.Events listeners.
	    remove: function() {
	      this._removeElement();
	      this.stopListening();
	      return this;
	    },
	
	    // Remove this view's element from the document and all event listeners
	    // attached to it. Exposed for subclasses using an alternative DOM
	    // manipulation API.
	    _removeElement: function() {
	      this.$el.remove();
	    },
	
	    // Change the view's element (`this.el` property) and re-delegate the
	    // view's events on the new element.
	    setElement: function(element) {
	      this.undelegateEvents();
	      this._setElement(element);
	      this.delegateEvents();
	      return this;
	    },
	
	    // Creates the `this.el` and `this.$el` references for this view using the
	    // given `el`. `el` can be a CSS selector or an HTML string, a jQuery
	    // context or an element. Subclasses can override this to utilize an
	    // alternative DOM manipulation API and are only required to set the
	    // `this.el` property.
	    _setElement: function(el) {
	      this.$el = el instanceof Backbone.$ ? el : Backbone.$(el);
	      this.el = this.$el[0];
	    },
	
	    // Set callbacks, where `this.events` is a hash of
	    //
	    // *{"event selector": "callback"}*
	    //
	    //     {
	    //       'mousedown .title':  'edit',
	    //       'click .button':     'save',
	    //       'click .open':       function(e) { ... }
	    //     }
	    //
	    // pairs. Callbacks will be bound to the view, with `this` set properly.
	    // Uses event delegation for efficiency.
	    // Omitting the selector binds the event to `this.el`.
	    delegateEvents: function(events) {
	      events || (events = _.result(this, 'events'));
	      if (!events) return this;
	      this.undelegateEvents();
	      for (var key in events) {
	        var method = events[key];
	        if (!_.isFunction(method)) method = this[method];
	        if (!method) continue;
	        var match = key.match(delegateEventSplitter);
	        this.delegate(match[1], match[2], _.bind(method, this));
	      }
	      return this;
	    },
	
	    // Add a single event listener to the view's element (or a child element
	    // using `selector`). This only works for delegate-able events: not `focus`,
	    // `blur`, and not `change`, `submit`, and `reset` in Internet Explorer.
	    delegate: function(eventName, selector, listener) {
	      this.$el.on(eventName + '.delegateEvents' + this.cid, selector, listener);
	      return this;
	    },
	
	    // Clears all callbacks previously bound to the view by `delegateEvents`.
	    // You usually don't need to use this, but may wish to if you have multiple
	    // Backbone views attached to the same DOM element.
	    undelegateEvents: function() {
	      if (this.$el) this.$el.off('.delegateEvents' + this.cid);
	      return this;
	    },
	
	    // A finer-grained `undelegateEvents` for removing a single delegated event.
	    // `selector` and `listener` are both optional.
	    undelegate: function(eventName, selector, listener) {
	      this.$el.off(eventName + '.delegateEvents' + this.cid, selector, listener);
	      return this;
	    },
	
	    // Produces a DOM element to be assigned to your view. Exposed for
	    // subclasses using an alternative DOM manipulation API.
	    _createElement: function(tagName) {
	      return document.createElement(tagName);
	    },
	
	    // Ensure that the View has a DOM element to render into.
	    // If `this.el` is a string, pass it through `$()`, take the first
	    // matching element, and re-assign it to `el`. Otherwise, create
	    // an element from the `id`, `className` and `tagName` properties.
	    _ensureElement: function() {
	      if (!this.el) {
	        var attrs = _.extend({}, _.result(this, 'attributes'));
	        if (this.id) attrs.id = _.result(this, 'id');
	        if (this.className) attrs['class'] = _.result(this, 'className');
	        this.setElement(this._createElement(_.result(this, 'tagName')));
	        this._setAttributes(attrs);
	      } else {
	        this.setElement(_.result(this, 'el'));
	      }
	    },
	
	    // Set attributes from a hash on this view's element.  Exposed for
	    // subclasses using an alternative DOM manipulation API.
	    _setAttributes: function(attributes) {
	      this.$el.attr(attributes);
	    }
	
	  });
	
	  // Backbone.sync
	  // -------------
	
	  // Override this function to change the manner in which Backbone persists
	  // models to the server. You will be passed the type of request, and the
	  // model in question. By default, makes a RESTful Ajax request
	  // to the model's `url()`. Some possible customizations could be:
	  //
	  // * Use `setTimeout` to batch rapid-fire updates into a single request.
	  // * Send up the models as XML instead of JSON.
	  // * Persist models via WebSockets instead of Ajax.
	  //
	  // Turn on `Backbone.emulateHTTP` in order to send `PUT` and `DELETE` requests
	  // as `POST`, with a `_method` parameter containing the true HTTP method,
	  // as well as all requests with the body as `application/x-www-form-urlencoded`
	  // instead of `application/json` with the model in a param named `model`.
	  // Useful when interfacing with server-side languages like **PHP** that make
	  // it difficult to read the body of `PUT` requests.
	  Backbone.sync = function(method, model, options) {
	    var type = methodMap[method];
	
	    // Default options, unless specified.
	    _.defaults(options || (options = {}), {
	      emulateHTTP: Backbone.emulateHTTP,
	      emulateJSON: Backbone.emulateJSON
	    });
	
	    // Default JSON-request options.
	    var params = {type: type, dataType: 'json'};
	
	    // Ensure that we have a URL.
	    if (!options.url) {
	      params.url = _.result(model, 'url') || urlError();
	    }
	
	    // Ensure that we have the appropriate request data.
	    if (options.data == null && model && (method === 'create' || method === 'update' || method === 'patch')) {
	      params.contentType = 'application/json';
	      params.data = JSON.stringify(options.attrs || model.toJSON(options));
	    }
	
	    // For older servers, emulate JSON by encoding the request into an HTML-form.
	    if (options.emulateJSON) {
	      params.contentType = 'application/x-www-form-urlencoded';
	      params.data = params.data ? {model: params.data} : {};
	    }
	
	    // For older servers, emulate HTTP by mimicking the HTTP method with `_method`
	    // And an `X-HTTP-Method-Override` header.
	    if (options.emulateHTTP && (type === 'PUT' || type === 'DELETE' || type === 'PATCH')) {
	      params.type = 'POST';
	      if (options.emulateJSON) params.data._method = type;
	      var beforeSend = options.beforeSend;
	      options.beforeSend = function(xhr) {
	        xhr.setRequestHeader('X-HTTP-Method-Override', type);
	        if (beforeSend) return beforeSend.apply(this, arguments);
	      };
	    }
	
	    // Don't process data on a non-GET request.
	    if (params.type !== 'GET' && !options.emulateJSON) {
	      params.processData = false;
	    }
	
	    // Pass along `textStatus` and `errorThrown` from jQuery.
	    var error = options.error;
	    options.error = function(xhr, textStatus, errorThrown) {
	      options.textStatus = textStatus;
	      options.errorThrown = errorThrown;
	      if (error) error.call(options.context, xhr, textStatus, errorThrown);
	    };
	
	    // Make the request, allowing the user to override any Ajax options.
	    var xhr = options.xhr = Backbone.ajax(_.extend(params, options));
	    model.trigger('request', model, xhr, options);
	    return xhr;
	  };
	
	  // Map from CRUD to HTTP for our default `Backbone.sync` implementation.
	  var methodMap = {
	    'create': 'POST',
	    'update': 'PUT',
	    'patch': 'PATCH',
	    'delete': 'DELETE',
	    'read': 'GET'
	  };
	
	  // Set the default implementation of `Backbone.ajax` to proxy through to `$`.
	  // Override this if you'd like to use a different library.
	  Backbone.ajax = function() {
	    return Backbone.$.ajax.apply(Backbone.$, arguments);
	  };
	
	  // Backbone.Router
	  // ---------------
	
	  // Routers map faux-URLs to actions, and fire events when routes are
	  // matched. Creating a new one sets its `routes` hash, if not set statically.
	  var Router = Backbone.Router = function(options) {
	    options || (options = {});
	    if (options.routes) this.routes = options.routes;
	    this._bindRoutes();
	    this.initialize.apply(this, arguments);
	  };
	
	  // Cached regular expressions for matching named param parts and splatted
	  // parts of route strings.
	  var optionalParam = /\((.*?)\)/g;
	  var namedParam    = /(\(\?)?:\w+/g;
	  var splatParam    = /\*\w+/g;
	  var escapeRegExp  = /[\-{}\[\]+?.,\\\^$|#\s]/g;
	
	  // Set up all inheritable **Backbone.Router** properties and methods.
	  _.extend(Router.prototype, Events, {
	
	    // Initialize is an empty function by default. Override it with your own
	    // initialization logic.
	    initialize: function(){},
	
	    // Manually bind a single named route to a callback. For example:
	    //
	    //     this.route('search/:query/p:num', 'search', function(query, num) {
	    //       ...
	    //     });
	    //
	    route: function(route, name, callback) {
	      if (!_.isRegExp(route)) route = this._routeToRegExp(route);
	      if (_.isFunction(name)) {
	        callback = name;
	        name = '';
	      }
	      if (!callback) callback = this[name];
	      var router = this;
	      Backbone.history.route(route, function(fragment) {
	        var args = router._extractParameters(route, fragment);
	        if (router.execute(callback, args, name) !== false) {
	          router.trigger.apply(router, ['route:' + name].concat(args));
	          router.trigger('route', name, args);
	          Backbone.history.trigger('route', router, name, args);
	        }
	      });
	      return this;
	    },
	
	    // Execute a route handler with the provided parameters.  This is an
	    // excellent place to do pre-route setup or post-route cleanup.
	    execute: function(callback, args, name) {
	      if (callback) callback.apply(this, args);
	    },
	
	    // Simple proxy to `Backbone.history` to save a fragment into the history.
	    navigate: function(fragment, options) {
	      Backbone.history.navigate(fragment, options);
	      return this;
	    },
	
	    // Bind all defined routes to `Backbone.history`. We have to reverse the
	    // order of the routes here to support behavior where the most general
	    // routes can be defined at the bottom of the route map.
	    _bindRoutes: function() {
	      if (!this.routes) return;
	      this.routes = _.result(this, 'routes');
	      var route, routes = _.keys(this.routes);
	      while ((route = routes.pop()) != null) {
	        this.route(route, this.routes[route]);
	      }
	    },
	
	    // Convert a route string into a regular expression, suitable for matching
	    // against the current location hash.
	    _routeToRegExp: function(route) {
	      route = route.replace(escapeRegExp, '\\$&')
	                   .replace(optionalParam, '(?:$1)?')
	                   .replace(namedParam, function(match, optional) {
	                     return optional ? match : '([^/?]+)';
	                   })
	                   .replace(splatParam, '([^?]*?)');
	      return new RegExp('^' + route + '(?:\\?([\\s\\S]*))?$');
	    },
	
	    // Given a route, and a URL fragment that it matches, return the array of
	    // extracted decoded parameters. Empty or unmatched parameters will be
	    // treated as `null` to normalize cross-browser behavior.
	    _extractParameters: function(route, fragment) {
	      var params = route.exec(fragment).slice(1);
	      return _.map(params, function(param, i) {
	        // Don't decode the search params.
	        if (i === params.length - 1) return param || null;
	        return param ? decodeURIComponent(param) : null;
	      });
	    }
	
	  });
	
	  // Backbone.History
	  // ----------------
	
	  // Handles cross-browser history management, based on either
	  // [pushState](http://diveintohtml5.info/history.html) and real URLs, or
	  // [onhashchange](https://developer.mozilla.org/en-US/docs/DOM/window.onhashchange)
	  // and URL fragments. If the browser supports neither (old IE, natch),
	  // falls back to polling.
	  var History = Backbone.History = function() {
	    this.handlers = [];
	    this.checkUrl = _.bind(this.checkUrl, this);
	
	    // Ensure that `History` can be used outside of the browser.
	    if (typeof window !== 'undefined') {
	      this.location = window.location;
	      this.history = window.history;
	    }
	  };
	
	  // Cached regex for stripping a leading hash/slash and trailing space.
	  var routeStripper = /^[#\/]|\s+$/g;
	
	  // Cached regex for stripping leading and trailing slashes.
	  var rootStripper = /^\/+|\/+$/g;
	
	  // Cached regex for stripping urls of hash.
	  var pathStripper = /#.*$/;
	
	  // Has the history handling already been started?
	  History.started = false;
	
	  // Set up all inheritable **Backbone.History** properties and methods.
	  _.extend(History.prototype, Events, {
	
	    // The default interval to poll for hash changes, if necessary, is
	    // twenty times a second.
	    interval: 50,
	
	    // Are we at the app root?
	    atRoot: function() {
	      var path = this.location.pathname.replace(/[^\/]$/, '$&/');
	      return path === this.root && !this.getSearch();
	    },
	
	    // Does the pathname match the root?
	    matchRoot: function() {
	      var path = this.decodeFragment(this.location.pathname);
	      var rootPath = path.slice(0, this.root.length - 1) + '/';
	      return rootPath === this.root;
	    },
	
	    // Unicode characters in `location.pathname` are percent encoded so they're
	    // decoded for comparison. `%25` should not be decoded since it may be part
	    // of an encoded parameter.
	    decodeFragment: function(fragment) {
	      return decodeURI(fragment.replace(/%25/g, '%2525'));
	    },
	
	    // In IE6, the hash fragment and search params are incorrect if the
	    // fragment contains `?`.
	    getSearch: function() {
	      var match = this.location.href.replace(/#.*/, '').match(/\?.+/);
	      return match ? match[0] : '';
	    },
	
	    // Gets the true hash value. Cannot use location.hash directly due to bug
	    // in Firefox where location.hash will always be decoded.
	    getHash: function(window) {
	      var match = (window || this).location.href.match(/#(.*)$/);
	      return match ? match[1] : '';
	    },
	
	    // Get the pathname and search params, without the root.
	    getPath: function() {
	      var path = this.decodeFragment(
	        this.location.pathname + this.getSearch()
	      ).slice(this.root.length - 1);
	      return path.charAt(0) === '/' ? path.slice(1) : path;
	    },
	
	    // Get the cross-browser normalized URL fragment from the path or hash.
	    getFragment: function(fragment) {
	      if (fragment == null) {
	        if (this._usePushState || !this._wantsHashChange) {
	          fragment = this.getPath();
	        } else {
	          fragment = this.getHash();
	        }
	      }
	      return fragment.replace(routeStripper, '');
	    },
	
	    // Start the hash change handling, returning `true` if the current URL matches
	    // an existing route, and `false` otherwise.
	    start: function(options) {
	      if (History.started) throw new Error('Backbone.history has already been started');
	      History.started = true;
	
	      // Figure out the initial configuration. Do we need an iframe?
	      // Is pushState desired ... is it available?
	      this.options          = _.extend({root: '/'}, this.options, options);
	      this.root             = this.options.root;
	      this._wantsHashChange = this.options.hashChange !== false;
	      this._hasHashChange   = 'onhashchange' in window && (document.documentMode === void 0 || document.documentMode > 7);
	      this._useHashChange   = this._wantsHashChange && this._hasHashChange;
	      this._wantsPushState  = !!this.options.pushState;
	      this._hasPushState    = !!(this.history && this.history.pushState);
	      this._usePushState    = this._wantsPushState && this._hasPushState;
	      this.fragment         = this.getFragment();
	
	      // Normalize root to always include a leading and trailing slash.
	      this.root = ('/' + this.root + '/').replace(rootStripper, '/');
	
	      // Transition from hashChange to pushState or vice versa if both are
	      // requested.
	      if (this._wantsHashChange && this._wantsPushState) {
	
	        // If we've started off with a route from a `pushState`-enabled
	        // browser, but we're currently in a browser that doesn't support it...
	        if (!this._hasPushState && !this.atRoot()) {
	          var rootPath = this.root.slice(0, -1) || '/';
	          this.location.replace(rootPath + '#' + this.getPath());
	          // Return immediately as browser will do redirect to new url
	          return true;
	
	        // Or if we've started out with a hash-based route, but we're currently
	        // in a browser where it could be `pushState`-based instead...
	        } else if (this._hasPushState && this.atRoot()) {
	          this.navigate(this.getHash(), {replace: true});
	        }
	
	      }
	
	      // Proxy an iframe to handle location events if the browser doesn't
	      // support the `hashchange` event, HTML5 history, or the user wants
	      // `hashChange` but not `pushState`.
	      if (!this._hasHashChange && this._wantsHashChange && !this._usePushState) {
	        this.iframe = document.createElement('iframe');
	        this.iframe.src = 'javascript:0';
	        this.iframe.style.display = 'none';
	        this.iframe.tabIndex = -1;
	        var body = document.body;
	        // Using `appendChild` will throw on IE < 9 if the document is not ready.
	        var iWindow = body.insertBefore(this.iframe, body.firstChild).contentWindow;
	        iWindow.document.open();
	        iWindow.document.close();
	        iWindow.location.hash = '#' + this.fragment;
	      }
	
	      // Add a cross-platform `addEventListener` shim for older browsers.
	      var addEventListener = window.addEventListener || function(eventName, listener) {
	        return attachEvent('on' + eventName, listener);
	      };
	
	      // Depending on whether we're using pushState or hashes, and whether
	      // 'onhashchange' is supported, determine how we check the URL state.
	      if (this._usePushState) {
	        addEventListener('popstate', this.checkUrl, false);
	      } else if (this._useHashChange && !this.iframe) {
	        addEventListener('hashchange', this.checkUrl, false);
	      } else if (this._wantsHashChange) {
	        this._checkUrlInterval = setInterval(this.checkUrl, this.interval);
	      }
	
	      if (!this.options.silent) return this.loadUrl();
	    },
	
	    // Disable Backbone.history, perhaps temporarily. Not useful in a real app,
	    // but possibly useful for unit testing Routers.
	    stop: function() {
	      // Add a cross-platform `removeEventListener` shim for older browsers.
	      var removeEventListener = window.removeEventListener || function(eventName, listener) {
	        return detachEvent('on' + eventName, listener);
	      };
	
	      // Remove window listeners.
	      if (this._usePushState) {
	        removeEventListener('popstate', this.checkUrl, false);
	      } else if (this._useHashChange && !this.iframe) {
	        removeEventListener('hashchange', this.checkUrl, false);
	      }
	
	      // Clean up the iframe if necessary.
	      if (this.iframe) {
	        document.body.removeChild(this.iframe);
	        this.iframe = null;
	      }
	
	      // Some environments will throw when clearing an undefined interval.
	      if (this._checkUrlInterval) clearInterval(this._checkUrlInterval);
	      History.started = false;
	    },
	
	    // Add a route to be tested when the fragment changes. Routes added later
	    // may override previous routes.
	    route: function(route, callback) {
	      this.handlers.unshift({route: route, callback: callback});
	    },
	
	    // Checks the current URL to see if it has changed, and if it has,
	    // calls `loadUrl`, normalizing across the hidden iframe.
	    checkUrl: function(e) {
	      var current = this.getFragment();
	
	      // If the user pressed the back button, the iframe's hash will have
	      // changed and we should use that for comparison.
	      if (current === this.fragment && this.iframe) {
	        current = this.getHash(this.iframe.contentWindow);
	      }
	
	      if (current === this.fragment) return false;
	      if (this.iframe) this.navigate(current);
	      this.loadUrl();
	    },
	
	    // Attempt to load the current URL fragment. If a route succeeds with a
	    // match, returns `true`. If no defined routes matches the fragment,
	    // returns `false`.
	    loadUrl: function(fragment) {
	      // If the root doesn't match, no routes can match either.
	      if (!this.matchRoot()) return false;
	      fragment = this.fragment = this.getFragment(fragment);
	      return _.some(this.handlers, function(handler) {
	        if (handler.route.test(fragment)) {
	          handler.callback(fragment);
	          return true;
	        }
	      });
	    },
	
	    // Save a fragment into the hash history, or replace the URL state if the
	    // 'replace' option is passed. You are responsible for properly URL-encoding
	    // the fragment in advance.
	    //
	    // The options object can contain `trigger: true` if you wish to have the
	    // route callback be fired (not usually desirable), or `replace: true`, if
	    // you wish to modify the current URL without adding an entry to the history.
	    navigate: function(fragment, options) {
	      if (!History.started) return false;
	      if (!options || options === true) options = {trigger: !!options};
	
	      // Normalize the fragment.
	      fragment = this.getFragment(fragment || '');
	
	      // Don't include a trailing slash on the root.
	      var rootPath = this.root;
	      if (fragment === '' || fragment.charAt(0) === '?') {
	        rootPath = rootPath.slice(0, -1) || '/';
	      }
	      var url = rootPath + fragment;
	
	      // Strip the hash and decode for matching.
	      fragment = this.decodeFragment(fragment.replace(pathStripper, ''));
	
	      if (this.fragment === fragment) return;
	      this.fragment = fragment;
	
	      // If pushState is available, we use it to set the fragment as a real URL.
	      if (this._usePushState) {
	        this.history[options.replace ? 'replaceState' : 'pushState']({}, document.title, url);
	
	      // If hash changes haven't been explicitly disabled, update the hash
	      // fragment to store history.
	      } else if (this._wantsHashChange) {
	        this._updateHash(this.location, fragment, options.replace);
	        if (this.iframe && fragment !== this.getHash(this.iframe.contentWindow)) {
	          var iWindow = this.iframe.contentWindow;
	
	          // Opening and closing the iframe tricks IE7 and earlier to push a
	          // history entry on hash-tag change.  When replace is true, we don't
	          // want this.
	          if (!options.replace) {
	            iWindow.document.open();
	            iWindow.document.close();
	          }
	
	          this._updateHash(iWindow.location, fragment, options.replace);
	        }
	
	      // If you've told us that you explicitly don't want fallback hashchange-
	      // based history, then `navigate` becomes a page refresh.
	      } else {
	        return this.location.assign(url);
	      }
	      if (options.trigger) return this.loadUrl(fragment);
	    },
	
	    // Update the hash location, either replacing the current entry, or adding
	    // a new one to the browser history.
	    _updateHash: function(location, fragment, replace) {
	      if (replace) {
	        var href = location.href.replace(/(javascript:|#).*$/, '');
	        location.replace(href + '#' + fragment);
	      } else {
	        // Some browsers require that `hash` contains a leading #.
	        location.hash = '#' + fragment;
	      }
	    }
	
	  });
	
	  // Create the default Backbone.history.
	  Backbone.history = new History;
	
	  // Helpers
	  // -------
	
	  // Helper function to correctly set up the prototype chain for subclasses.
	  // Similar to `goog.inherits`, but uses a hash of prototype properties and
	  // class properties to be extended.
	  var extend = function(protoProps, staticProps) {
	    var parent = this;
	    var child;
	
	    // The constructor function for the new subclass is either defined by you
	    // (the "constructor" property in your `extend` definition), or defaulted
	    // by us to simply call the parent constructor.
	    if (protoProps && _.has(protoProps, 'constructor')) {
	      child = protoProps.constructor;
	    } else {
	      child = function(){ return parent.apply(this, arguments); };
	    }
	
	    // Add static properties to the constructor function, if supplied.
	    _.extend(child, parent, staticProps);
	
	    // Set the prototype chain to inherit from `parent`, without calling
	    // `parent`'s constructor function and add the prototype properties.
	    child.prototype = _.create(parent.prototype, protoProps);
	    child.prototype.constructor = child;
	
	    // Set a convenience property in case the parent's prototype is needed
	    // later.
	    child.__super__ = parent.prototype;
	
	    return child;
	  };
	
	  // Set up inheritance for the model, collection, router, view and history.
	  Model.extend = Collection.extend = Router.extend = View.extend = History.extend = extend;
	
	  // Throw an error when a URL is needed, and none is supplied.
	  var urlError = function() {
	    throw new Error('A "url" property or function must be specified');
	  };
	
	  // Wrap an optional error callback with a fallback error event.
	  var wrapError = function(model, options) {
	    var error = options.error;
	    options.error = function(resp) {
	      if (error) error.call(options.context, model, resp, options);
	      model.trigger('error', model, resp, options);
	    };
	  };
	
	  return Backbone;
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Wrapper über die axios AJAX-Library für saubere Fehlerbehandlung
	 */
	
	'use strict';
	
	var _ = __webpack_require__(7);
	var $ = __webpack_require__(6);
	//var Promise = require('promise-polyfill');
	
	/**
	 * Erzeugt einen neuen AJAX-Request und gibt ein natives Promise zurück.
	 * Zusätzlich werden bekannte Fehler-Probleme (500er, API Error) direkt abgefangen und
	 * in saubere Fehler-Objekte umgewandelt.
	 *
	 * Folgende Argumente werden für den Request unterstützt:
	 * - url: Ziel-URL (String)
	 * - method: HTTP-Methode (Standard: GET)
	 * - params: URL-Parameter (Objekt)
	 * - data: HTML Body Data (Objekt)
	 * - headers: Zusätzliche HTTP-Header (Objekt)
	 * - responseType: text|json (Standard: json)
	 *
	 * Content-Type muss per headers = { "content-type": "application/json" } gesetzt werden.
	 *
	 * @param config {Object} Request-Argumente
	 * @return {Promise} Gibt das Request-Ergebnis zurück
	 */
	var call = function call(url, config) {
		/* This function can be called with 3 different signatures:
	    call("http://something")
	    call("http://something", {key: value})
	    call({url: "http://something", key: value})
	 */
		if (typeof config === "undefined") {
			config = {};
		}
		if (typeof url === "string") {
			config.url = url;
		} else if (typeof url === "object") {
			config = url;
		}
	
		if (!config.url) {
			throw new Error("ajax.call: Needs url or config object as first parameter");
		}
	
		config = _.extendOwn({
			url: null,
			method: "get",
			params: {},
			data: {},
			headers: {},
			responseType: "json",
			timeout: null
		}, config);
	
		_.extend(config.data, config.params);
		config.dataType = "json";
	
		/* Older versions of jQuery send null as "null" to the server, which is bad.
	    To be consistent with any backend, we manually delete null-values from the query */
		_.each(config.data, function (value, key) {
			if (value === null) {
				//console.log("[ajax] Removing null-key:", key);
				delete config.data[key];
			}
		});
	
		/* Error-Objekt erzeugen um Raven einen sauberen Stacktrace liefern zu können */
		var maybeError = new Error("AJAX call failed (unknown reason)");
	
		config.error = function (jqXHR, textStatus, errorThrown) {
			maybeError.message = "AJAX call to " + config.url + " failed with code " + jqXHR.status + " (" + jqXHR.statusText + ")";
			if (typeof window.Raven !== "undefined") {
				Raven.captureException(maybeError, {
					extra: {
						status: jqXHR.status,
						statusText: jqXHR.statusText,
						headers: jqXHR.getAllResponseHeaders(),
						url: config.url,
						method: config.method,
						data: config.data,
						params: config.params
					}
				});
			};
			throw maybeError;
		};
	
		return Promise.resolve($.ajax(config.url, config));
	};
	
	module.exports = call;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Stellt eine Mini-Benchmark-Funktion zur Verfügung.
	 *
	 * Exportiert eine Factory-Funktion, welche beim ersten Aufruf einen Timer stellt
	 * welcher beim Aufruf in die Konsole loggt und die benötigte Zeit zurück gibt.
	 */
	
	"use strict";
	
	var timefunc;
	
	if (false) {
	
		if (window.performance && typeof window.performance.now === "function") {
	
			timefunc = function (title) {
				var start = window.performance.now();
				return function (result_text) {
					var needed_time = window.performance.now() - start;
					result_text = result_text ? " -> " + result_text : "";
					result_text = (needed_time / 1000).toFixed(6) + " sec" + result_text;
	
					return needed_time / 1000;
				};
			};
		} else {
	
			timefunc = function (title) {
				var start = new Date();
				return function (result_text) {
					var needed_time = new Date() - start;
					result_text = result_text ? " -> " + result_text : "";
	
					return needed_time / 1000;
				};
			};
		}
	} else {
	
		timefunc = function (a) {
			return function (b) {
				return 0;
			};
		};
	}
	
	module.exports = timefunc;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Wrapper over Storage which works around some browser bugs.
	 *
	 * Provides an object with the following keys:
	 * - SafeStorage => Access to the class
	 * - local => SafeStorage singletone for localStorage
	 * - session => SafeStorage singletone for sessionStorage
	 */
	
	'use strict';
	
	var _ = __webpack_require__(7);
	var Backbone = __webpack_require__(20);
	var MemoryStorage = __webpack_require__(24);
	
	var fakeStorage = new MemoryStorage('oberstdorf');
	
	/* Our storage class */
	var SafeStorage = function SafeStorage(backend_ident) {
		_.extend(this, Backbone.Events);
		_.bindAll(this, "get", "set", "clear", "remove", "handleError", "storageEventHandler");
	
		this.looksLikePrivateMode = false;
		this.hasCookiesDisabled = false;
		this.eventGuard = 100;
		this.lastSetValue = null;
	
		this.backend = fakeStorage;
		this.usingFakeBackend = true;
	
		/**
	  * localStorage is a piece of shit that can fail even if you just look at it.
	  * So we need to wrap everything that touches it and catch any errors.
	  * Remember: It can fail at really any possible situation.
	  */
		try {
			var maybeBackend;
			switch (backend_ident) {
				case 'local':
					maybeBackend = window.localStorage;break;
				case 'session':
					maybeBackend = window.sessionStorage;break;
				default:
					maybeBackend = fakeStorage;
			}
	
			/* Test the backend */
			var key = "__StorageTest__";
			var value = new Date().getTime().toString();
			maybeBackend.setItem(key, value);
			if (value === maybeBackend.getItem(key)) {
				maybeBackend.removeItem(key);
			}
			this.backend = maybeBackend;
			this.usingFakeBackend = false;
		} catch (e) {
			this.handleError(e);
		}
	
		if (backend_ident === 'local' && !this.usingFakeBackend) {
			window.addEventListener('storage', this.storageEventHandler);
		}
	};
	
	SafeStorage.prototype.storageEventHandler = function (e) {
		/* e = e.key, e.oldValue */
	
		/* Nobody cares about that */
		if (e.key === "TraminoAnalyticsQueue" || e.key === "__StorageTest__") return;
	
		/* Guard against IE bug */
		if (this.eventGuard <= 0) return;
	
		/* IE triggers 'storage' event in the same tab */
		if (e.value == this.lastSetValue) {
			return;
		}
		this.eventGuard--;
		this.trigger('change:' + e.key, e.key, this.backend.getItem(e.key));
	};
	
	SafeStorage.prototype.handleError = function (e) {
		this.backend = fakeStorage;
		this.usingFakeBackend = true;
	
		var knownError = false;
	
		/* Most browsers sets the Quota to 0 when in private mode */
		if (e.toString().toLowerCase().indexOf('quota') !== -1) {
			this.looksLikePrivateMode = true;
			knownError = true;
		}
	
		/* German IE */
		if (e.toString().indexOf('Speicher') !== -1) {
			this.looksLikePrivateMode = true;
			knownError = true;
		}
	
		/* Firefox raises SecurityError when cookies are disabled */
		if (e.toString().indexOf('SecurityError') !== -1) {
			this.hasCookiesDisabled = true;
			knownError = true;
		}
	
		/*
	 if ( !knownError && typeof window.Raven !== "undefined" ) {
	 	Raven.captureException(e, {
	 		fingerprint: ['localStorageError'],
	 	});
	 }
	 */
	};
	
	SafeStorage.prototype.get = function (key) {
		try {
			var cached = this.backend.getItem(key);
			var ttl = this.backend.getItem(key + "__ttl__");
	
			if (!ttl || parseInt(ttl, 10) > new Date().getTime()) {
				return cached;
			}
			return null;
		} catch (e) {
			this.handleError(e);
			return;
		}
	};
	
	SafeStorage.prototype.set = function (key, value, expire) {
		try {
			if (this.sameTabWorkaround) {
				this.lastSetValue = value;
			}
			this.backend.setItem(key, value);
	
			if (typeof expire !== "undefined") {
				this.backend.setItem(key + '.__ttl__', new Date().getTime() + expire);
			}
		} catch (e) {
			this.handleError(e);
			return;
		}
	};
	
	SafeStorage.prototype.remove = function (key) {
		try {
			this.backend.removeItem(key);
		} catch (e) {
			this.handleError(e);
			return;
		}
	};
	
	SafeStorage.prototype.clear = function () {
		try {
			this.backend.clear();
		} catch (e) {
			this.handleError(e);
			return;
		}
	};
	
	module.exports = {
		SafeStorage: SafeStorage,
		local: new SafeStorage('local'),
		session: new SafeStorage('session')
	};

/***/ }),
/* 24 */
/***/ (function(module, exports) {

	/*! 
	 * memorystorage.js - A memory-backed implementation of the Web Storage API.
	 *
	 * @copyright Copyright 2015 by Stijn de Witt. Some rights reserved. 
	 * @license Licensed under [Creative Commons Attribution 4.0 International (CC BY 4.0)](https://creativecommons.org/licenses/by/4.0/).
	 */
	// API methods and properties will be cloaked
	'use strict';
	
	var API = { 'clear': 1, 'getItem': 1, 'id': 1, 'key': 1, 'length': 1, 'removeItem': 1, 'setItem': 1 },
	    API_LENGTH = Object.keys(API).length,
	    CLOAK = '__memorystorage_cloaked_items__';
	
	// Used to store all memorystorage objects
	var storage = {};
	
	/** @module memorystorage */
	
	/**
	 * Creates a new MemoryStorage object implementing the <a href="http://www.w3.org/TR/webstorage/">Web Storage API</a> using memory.
	 * 
	 * <p>If no arguments are given, the created memory storage object will read from and write to the
	 * <code>global</code> memory storage. If a string argument is given, the new storage object
	 * will read from and write to it's own segment of memory. Any data written to such a memory
	 * storage object will only show up in other memory storage objects that have been created with
	 * the same id. This data will not show up in the <code>global</code> memory space. As such it 
	 * is recommended to always construct a memory storage object with a unique string id as argument.</p> 
	 * 
	 * @param id Optional string argument used to isolate this memory storage object from others.
	 *
	 * @alias module:memorystorage.MemoryStorage
	 * @class 
	 */
	function MemoryStorage(id) {
		// jshint ignore:line
		// make sure id is assigned
		id = id || 'global';
		// try to get existing store
		var result = storage[id];
		// return it if found
		if (result) {
			return result;
		}
	
		// make sure there is no harm in leaving out new in invocations to MemoryStorage
		if (!(this instanceof MemoryStorage)) {
			return new MemoryStorage(id);
		}
	
		// create a new store and save a ref to it so we can get it back later
		result = storage[id] = this;
		// create a space to store 'cloaked' key/values: items that have a key
		// that collides with Web Storage API method names.
		var cloaked = {};
		Object.defineProperty(result, CLOAK, {
			enumerable: false,
			get: function get() {
				return cloaked;
			}
		});
		// Allow client code to read the id
		Object.defineProperty(result, 'id', {
			enumerable: true,
			get: function get() {
				return id;
			}
		});
		// Create the length property
		Object.defineProperty(result, 'length', {
			enumerable: true,
			get: function get() {
				return Object.keys(this).length + Object.keys(this[CLOAK]).length - API_LENGTH;
			}
		});
		// Create API methods
		result.getItem = function MemoryStorage_getItem(key) {
			return key in API ? this[CLOAK][key] : this[key];
		};
		result.setItem = function MemoryStorage_setItem(key, val) {
			if (key in API) {
				this[CLOAK][key] = val;
			} else {
				this[key] = val;
			}
		};
		result.removeItem = function MemoryStorage_removeItem(key) {
			if (key in API) {
				delete this[CLOAK][key];
			} else {
				delete this[key];
			}
		};
		result.key = function MemoryStorage_key(idx) {
			var keys = Object.keys(this).concat(Object.keys(this[CLOAK]));
			keys = keys.filter(function (x) {
				return !(x in API);
			});
			return idx >= 0 && idx < keys.length ? keys[idx] : null;
		};
		result.clear = function MemoryStorage_clear() {
			var keys = Object.keys(this).filter(function (x) {
				return !(x in API);
			});
			for (var i = 0, key; key = keys[i]; i++) {
				if (!(key in API)) {
					delete this[key];
				}
			}
			keys = Object.keys(this[CLOAK]);
			for (var i = 0, key; key = keys[i]; i++) {
				delete this[CLOAK][key];
			}
		};
		return result;
	}
	
	module.exports = MemoryStorage;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Bietet einen zentralen Cache für Underscore Templates + Helfer (globale Variablen/Funktionen).
	 */
	
	var _ = __webpack_require__(7);
	var Backbone = __webpack_require__(20);
	
	var TemplateCache = function TemplateCache() {
		_.extend(this, Backbone.Events);
	
		/* Globale Helferfunktionen */
		this.helpers = {};
	
		/* Kompilierte Templates */
		this.cache = {};
	
		/* Registrierte Funktionen zum Laden von Templates. { name: func(ident) } */
		this.loaders = {};
	
		/* Verwendungsreihenfolge der Loader. Nicht-definierte Loader werden ignoriert.*/
		this.loadersOrder = ['dom', 'jst', 'webpack'];
	
		/* Gesamtzeit die fürs Kompiling verwendet wurde (Sekunden) */
		this.compileTime = 0.0;
	
		/* Gesamtzeit die fürs Rendering verwendet wurde (Sekunden) */
		this.renderTime = 0.0;
	
		_.bindAll(this, "helper", "clear", "render", "errorFunc");
	};
	
	/**
	 * Eine Lade-Funktion registrieren. Ermöglicht das Laden von Templates von verschiedenen
	 * Quellen, etwa dem DOM oder vorkompilierten Templates.
	 *
	 * @param loader {Function} Erhält den Ident als ersten Parameter und muss einen String oder null zurückgeben.
	 */
	TemplateCache.prototype.registerLoader = function (name, loader) {
		this.loaders[name] = loader;
	};
	
	/**
	 * Ein Template laden und mit Daten rendern.
	 * Kompilierte Templates werden zwischengespeichert, bis clear() aufgerufen wird.
	 *
	 * @param ident {String} ID des Templates im DOM
	 * @param data {Object} Zu rendernde Daten
	 */
	TemplateCache.prototype.render = function (ident, data) {
		/* Templates können auch ohne Daten gerendet werden, etwa Loading-Indicators */
		var template = this._get(ident);
	
		var start = new Date();
		var result = typeof data === "undefined" ? template() : template(data);
	
		this.renderTime += (new Date() - start) / 1000;
		this.trigger("render", ident, data, result);
		this.trigger("render:" + ident, ident, data, result);
		return result;
	};
	
	TemplateCache.prototype._get = function (ident) {
		if (typeof this.cache[ident] === "undefined") {
			var template = null;
	
			for (var i = 0, loaderName = undefined; loaderName = this.loadersOrder[i]; ++i) {
				var loader = this.loaders[loaderName];
				if (!loader) continue;
	
				var loaded_template = loader(ident);
				//console.log("[TemplateCache] " + ident + ": " + loaderName + " => " + (typeof loaded_template));
				if (loaded_template) {
					template = loaded_template;
					break;
				}
			}
	
			if (template === null) {
				return this.errorFunc("No loader returned a template for " + ident);
			}
	
			try {
				this.cache[ident] = this._compile(ident, template);
			} catch (e) {
				return this.errorFunc("Failed to compile template " + ident, e);
			}
		}
		return this.cache[ident];
	};
	
	TemplateCache.prototype._compile = function (ident, template) {
		var timer = __webpack_require__(22)("Compile: " + ident);
	
		if (typeof template === "string") {
			template = _.template(template);
		}
	
		var wrappedTemplate = (function (data) {
			data = _.defaults({}, data, this.helpers);
			try {
				return template.call(this, data);
			} catch (e) {
				return this.errorFunc("Render Error in Template: " + ident, e)();
			}
		}).bind(this);
	
		this.compileTime += timer();
		return wrappedTemplate;
	};
	
	/**
	 * Gibt eine Funktion zurück, die eine Fehlermeldung als String zurück gibt.
	 * Wird verwendet, wenn es Probleme mit Templates gibt.
	 * Dies verhindert, dass Apps an zufälligen Stellen abstürzen.
	 */
	TemplateCache.prototype.errorFunc = function (message, e) {
		if (typeof e !== "undefined") {
			message += "<br>" + e.toString();
		}
		return function () {
			if (typeof Raven !== "undefined") Raven.captureMessage("TemplateCache: " + message.replace('<br>', ' '));
			return '<div class="template-error"><b>[TemplateCache ERROR]</b> ' + message + '</div>';
		};
	};
	
	/**
	 * Eine globale Helfer-Funktion für Templates registrieren
	 *
	 * @param name {String} Name des Helfers
	 * @param name {Function} Aufzurufende Funktion
	 */
	TemplateCache.prototype.helper = function (name, func) {
		this.helpers[name] = func;
	};
	
	/**
	 * Alle gecachten Templates entfernen.
	 */
	TemplateCache.prototype.clear = function () {
		this.cache = {};
	};
	
	/* Singleton erzeugen */
	var singleton = new TemplateCache();
	
	/**
	 * Loader um Templates aus dem DOM zu holen. Primär für die Entwicklung verwendet.
	 */
	singleton.registerLoader("dom", function (ident) {
		var node = document.getElementById(ident);
		if (node) return node.innerHTML;
	});
	
	/**
	 * Loader um Templates aus window.JST zu holen. Wird später für Template Resources gebraucht.
	 */
	singleton.registerLoader("jst", function (ident) {
		if (window.JST && typeof window.JST[ident] === "function") {
			return window.JST[ident];
		}
	});
	
	module.exports = singleton;

/***/ }),
/* 26 */
/***/ (function(module, exports) {

	/**
	 * Correct and clean decoupling is pretty hard in complex applications.
	 * So let's add a registry! When using global state, at least put it somewhere together.
	 */
	
	"use strict";
	
	var Registry = function Registry() {
		this._attributes = {};
	};
	
	Registry.prototype.get = function (key, default_value) {
		if (typeof this._attributes[key] === "undefined") {
			return default_value;
		}
		return this._attributes[key];
	};
	
	Registry.prototype.set = function (key, value) {
		this._attributes[key] = value;
	};
	
	Registry.prototype.setAll = function (attributes) {
		this._attributes = attributes;
	};
	
	module.exports = new Registry();

/***/ }),
/* 27 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Sammelt alle URL-Parameter und gibt diese als Objekt zurück.
	 */
	module.exports = function getQueryParameters() {
	    var urls = [
	    // Regular URL-Parameters
	    decodeURIComponent(window.location.search.substring(1)),
	    // #?foo=bar Syntax
	    decodeURIComponent(window.location.hash.substring(2))];
	
	    var parameters = {};
	
	    for (var i = 0; i < urls.length; i++) {
	        var variables = urls[i].split('&');
	        for (var j = 0, part = undefined; part = variables[j]; j++) {
	            var keyvalue = part.split('=');
	            parameters[keyvalue[0]] = keyvalue[1];
	        }
	    }
	
	    return parameters;
	};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Backbone = __webpack_require__(20);
	
	var Result = Backbone.Model.extend({});
	
	module.exports = Result;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(7);
	var Backbone = __webpack_require__(20);
	var Result = __webpack_require__(28);
	
	var ResultStore = Backbone.Collection.extend({
	    model: Result,
	
	    comparator: function comparator(result) {
	        return result.attributes.sort[0];
	    },
	
	    getVisible: function getVisible() {
	        return _(this.filter(function (result) {
	            return result.get("visible");
	        }));
	    }
	
	});
	
	module.exports = ResultStore;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $ = __webpack_require__(6);
	var Backbone = __webpack_require__(20);
	
	var TemplateCache = __webpack_require__(25);
	
	module.exports = Backbone.View.extend({
	
		events: {
			'click span.tag': 'handleClick',
			'click span.more': 'handleMore'
		},
	
		initialize: function initialize() {
			this.listenTo(this.model, "change:tags", this.render);
			this.listenTo(this.model, "change:selectedTags", this.render);
			this.listenTo(this.model, "change:tagsCount", this.render);
		},
	
		render: function render() {
			var selectedTags = this.model.get("selectedTags");
	
			var html = TemplateCache.render('SidebarTemplate', {
				groups: this.model.tagGroups,
				isSelected: function isSelected(tag_id) {
					tag_id = parseInt(tag_id, 10);
					return selectedTags.indexOf(tag_id) !== -1;
				}
			});
			// console.log("[SidebarView] HTML:", html);
			this.el.innerHTML = html;
	
			/* Fix the layout (list + maps) */
			$('.result-tabs').css('min-height', $('#engine-sidebar').outerHeight());
		},
	
		handleClick: function handleClick(e) {
			e.preventDefault();
			var link = $(e.currentTarget);
			if (link.hasClass('disabled')) return;
			this.model.toggleTag(link.data('id'));
		},
	
		handleMore: function handleMore(e) {
			e.preventDefault();
			var link = $(e.currentTarget);
			var group = link.data('group');
	
			$('.tag_group_' + group + ' .hidden').removeClass('hidden');
			link.hide();
		}
	
	});

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $ = __webpack_require__(6);
	var _ = __webpack_require__(7);
	var Backbone = __webpack_require__(20);
	
	var MiniTimer = __webpack_require__(22);
	var TemplateCache = __webpack_require__(25);
	
	module.exports = Backbone.View.extend({
	
		events: {
			'click span': 'handleClick'
		},
	
		initialize: function initialize() {
			this.listenTo(this.model, "change:sortBy", this.render);
			this.lastOrderBy = null;
		},
	
		render: function render() {
			var timer = MiniTimer("Render sortBy");
			var currentSortBy = this.model.get("sortBy");
			if (currentSortBy == this.lastOrderBy) return;
	
			this.el.innerHTML = TemplateCache.render('SortOrderTemplate', {
				active: currentSortBy
			});
			//timer();
		},
	
		handleClick: function handleClick(e) {
			e.preventDefault();
			var newSortBy = $(e.currentTarget).data('orderby');
	
			this.$el.find('.active').removeClass('active');
			$(e.currentTarget).addClass("active");
			this.currentSortBy = newSortBy;
			this.model.setSortOrder(newSortBy);
		}
	
	});

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $ = __webpack_require__(6);
	var Backbone = __webpack_require__(20);
	
	var TemplateCache = __webpack_require__(25);
	
	var ResultView = Backbone.View.extend({
	
		events: {
			'click .arrow.next': 'slideImageNext',
			'click .arrow.prev': 'slideImagePrev',
			'click a, .item': 'openItem',
			'click .alpentraum': 'openItem',
			'click .favable': 'handleFavorite',
			'click .backend-stack': 'handleStack'
		},
	
		initialize: function initialize() {
			this.rendered = false;
			this.dirty = false;
		},
	
		render: function render() {
			var favorites = typeof window.TraminoFavoriten !== "undefined" ? TraminoFavoriten.getItemsMap() : {};
			this.fav_key = 'clients-' + this.model.get("id");
	
			this.el.innerHTML = TemplateCache.render('result-template', {
				result: this.model.toJSON(),
				app: this.app,
				favorited: typeof favorites[this.fav_key] !== "undefined"
			});
			/* Da die Box gefloatet ist, funktionen Funktionen wie .offset() nicht auf dem Parent-Element von Backbone */
			this.$box = this.$el.find('.result-box');
			this.rendered = true;
			this.dirty = false;
			this.shown = false;
		},
	
		hide: function hide() {
			//if ( !this.shown ) return; // @todo Debug why this isn't working
			this.$el.detach();
			this.shown = false;
		},
	
		show: function show($list) {
			if (!this.rendered) {
				this.render();
			}
	
			this.$el.appendTo($list);
			//console.warn("Show", this.model.get("name"));
			this.shown = true;
		},
	
		slideImageNext: function slideImageNext() {
			var $slider = this.$el.find('.slider');
			$slider.children(':last').insertBefore($slider.children(':first'));
		},
	
		slideImagePrev: function slideImagePrev() {
			var $slider = this.$el.find('.slider');
			$slider.children(':first').insertAfter($slider.children(':last'));
		},
	
		openItem: function openItem(e) {
			e.preventDefault();
	
			/* Nicht bei den Arrows triggern */
			if (e.target.className.indexOf('arrow') !== -1) return;
			/* Auch nicht bei Favoriten */
			if (e.target.className.indexOf('favable') !== -1) return;
			/* Auch nicht im Backend */
			if (e.target.className.indexOf('important-tags') !== -1) return;
	
			var item_class = $(e.currentTarget).data('id');
			var item_id = $(e.currentTarget).data('item');
			var append = reservaApp.formModel.getForm();
			if (item_class) append['class'] = item_class;
			if (item_id) append.item = item_id;
	
			if (append.rooms == 0) append.rooms = 1;
	
			var tags = this.app.get("selectedTags");
			if (tags.length) {
				append.tags = tags.join(",");
			}
	
			TraminoAnalytics.send(this.model.get("id"), "click");
			window.open(this.$el.find('a').attr('href') + '#?' + $.param(append));
		},
	
		handleFavorite: function handleFavorite(e) {
			var items = TraminoFavoriten.getItemsMap();
			var promise;
			if (typeof items[this.fav_key] === "undefined") {
				promise = TraminoFavoriten.add({ id: this.fav_key });
				TraminoAnalytics.send(this.model.get("id"), "favorite");
			} else {
				promise = TraminoFavoriten.remove(this.fav_key);
			}
			promise.then((function () {
				/* Wir müssen den View neu erzeugen, da dieser gerade nicht im DOM sein könnte, wenn "Header Favoriten" das aktualisiert. */
				this.render();
			}).bind(this));
		},
	
		handleStack: function handleStack(e) {
			e.preventDefault();e.stopImmediatePropagation();
			var btn = $(e.currentTarget);
			var item = btn.data("item");
	
			if (!this.app.userStackExists(item)) {
				this.app.userStackAdd(item, { item: item });
				btn.addClass('active');
			} else {
				this.app.userStackRemove(item);
				btn.removeClass('active');
			}
		},
	
		/* Create a copy of this view (needed for Google Maps) */
		clone: function clone() {
			var view = new ResultView({
				model: this.model
			});
			view.app = this.app;
			return view;
		}
	
	});
	
	module.exports = ResultView;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $ = __webpack_require__(6);
	var Backbone = __webpack_require__(20);
	
	var TemplateCache = __webpack_require__(25);
	
	var FilterInfoView = Backbone.View.extend({
	
		events: {
			'click .tag': 'tagClick'
		},
	
		initialize: function initialize() {
			this.listenTo(this.model, "change:filterInfos", this.render);
		},
	
		render: function render() {
			/* We need to cache that for the tagClick handler */
			this.infos = this.model.get("filterInfos");
	
			if (this.infos.length > 0) {
				this.el.innerHTML = TemplateCache.render('filterinfo', {
					infos: this.infos
				});
				this.$el.show();
			} else {
				this.$el.hide().html('');
			}
		},
	
		tagClick: function tagClick(e) {
			var index = $(e.currentTarget).data('index');
			this.infos[index].onclick();
		}
	
	});
	
	module.exports = FilterInfoView;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__) {/**
	 * Enthält das Formular-Model für die Reserva Suche + Funktionen zum Validieren der Personen.
	 */
	
	'use strict';
	
	var $ = __webpack_require__(6);
	var _ = __webpack_require__(7);
	var moment = __webpack_require__(8);
	var Backbone = __webpack_require__(20);
	var SafeStorage = __webpack_require__(23);
	var Registry = __webpack_require__(26);
	var getQueryParameters = __webpack_require__(27);
	
	var getPeopleStructure = __webpack_require__(35);
	
	/**
	 * Einen Wert als Zahl parsen und diese zurück geben. Alle anderen ungültigen Eingaben geben 0 zurück.
	 */
	var parseIntOrZero = function parseIntOrZero(value) {
	    var result = value;
	    value = parseInt(value, 10);
	    if (value > 0) {
	        result = value;
	    } else {
	        result = 0;
	    }
	    return result;
	};
	
	var FormModel = Backbone.Model.extend({
	    defaults: function defaults() {
	        return {
	            "from": null,
	            "to": null,
	
	            /* Für die Vererbung in die Templates */
	            "isTouchDevice": false,
	
	            /* Anzahl Nächste */
	            "nights": null,
	
	            /* Kalender Auswahl-Modus (none, exact, flex) */
	            "select_mode": "exact",
	
	            "rooms": 1,
	            "rooms.1.type": "any",
	            "rooms.1.bedrooms": 0,
	            "rooms.1.adults": 2,
	            "rooms.1.children": 0,
	            "rooms.1.child1": 0,
	            "rooms.1.child2": 0,
	            "rooms.1.child3": 0,
	            "rooms.1.child4": 0,
	            "rooms.1.child5": 0,
	            "rooms.2.type": "any",
	            "rooms.2.bedrooms": 0,
	            "rooms.2.adults": 2,
	            "rooms.2.children": 0,
	            "rooms.2.child1": 0,
	            "rooms.2.child2": 0,
	            "rooms.2.child3": 0,
	            "rooms.2.child4": 0,
	            "rooms.2.child5": 0,
	            "rooms.3.type": "any",
	            "rooms.3.bedrooms": 0,
	            "rooms.3.adults": 2,
	            "rooms.3.children": 0,
	            "rooms.3.child1": 0,
	            "rooms.3.child2": 0,
	            "rooms.3.child3": 0,
	            "rooms.3.child4": 0,
	            "rooms.3.child5": 0
	        };
	    },
	
	    /* Variablen, die nicht mit dem Formular verschickt werden sollen */
	    form_blacklist: [
	    /* Interner App-State */
	    'isTouchDevice',
	    /* Schrott-Formularfelder */
	    'control-nights', 'control-from', 'control-to', 'action'],
	
	    /* Felder aus dem PeopleSelect */
	    peopleFields: ["rooms.1.adults", "rooms.1.children", "rooms.1.child1", "rooms.1.child2", "rooms.1.child3", "rooms.1.child4", "rooms.1.child5", "rooms.2.adults", "rooms.2.children", "rooms.2.child1", "rooms.2.child2", "rooms.2.child3", "rooms.2.child4", "rooms.2.child5", "rooms.3.adults", "rooms.3.children", "rooms.3.child1", "rooms.3.child2", "rooms.3.child3", "rooms.3.child4", "rooms.3.child5"],
	
	    /* Datenfelder die intern immer Integer (oder null) sein müssen */
	    numberFields: ["rooms", "rooms.1.bedrooms", "rooms.1.adults", "rooms.1.children", "rooms.1.child1", "rooms.1.child2", "rooms.1.child3", "rooms.1.child4", "rooms.1.child5", "rooms.2.bedrooms", "rooms.2.adults", "rooms.2.children", "rooms.2.child1", "rooms.2.child2", "rooms.2.child3", "rooms.2.child4", "rooms.2.child5", "rooms.3.bedrooms", "rooms.3.adults", "rooms.3.children", "rooms.3.child1", "rooms.3.child2", "rooms.3.child3", "rooms.3.child4", "rooms.3.child5"],
	
	    /**
	     * Model initialisieren
	     */
	    initialize: function initialize() {
	        this.form = null;
	        this.boundToSafeStorage = false;
	    },
	
	    /**
	     * URL-Parameter ins Model importieren
	     */
	    setFromQueryString: function setFromQueryString() {
	        var parameters = getQueryParameters();
	
	        this.setSafe(parameters);
	    },
	
	    /**
	     * Parameter aus Formular importieren
	     */
	    setFromForm: function setFromForm(form) {
	        if (typeof form === "undefined") {
	            form = this.form;
	        }
	        if (!this.form || !this.form.length) {
	            return;
	        }
	
	        var keys = _(this.attributes).keys();
	        var parameters = {};
	        for (var i = 0; i < keys.length; i++) {
	            var field = keys[i];
	
	            var value = $('[name="' + field + '"]', form).val();
	            if (value) {
	                parameters[field] = value;
	            }
	        }
	
	        this.setSafe(parameters);
	    },
	
	    /**
	     * Parameter setzen und dabei die Datentypen korrigieren falls notwendig.
	     */
	    setSafe: function setSafe(parameters) {
	        var keys = _(parameters).keys();
	
	        for (var i = 0; i < this.numberFields.length; i++) {
	            var field = this.numberFields[i];
	            if (parameters[field]) {
	                parameters[field] = parseInt(parameters[field], 10);
	            }
	        }
	        this.set(parameters);
	    },
	
	    /**
	     * Gibt alle Felder für das Formular zurück. Ignoriert dabei Felder, die momentan nicht sichtbar sind.
	     */
	    getForm: function getForm() {
	        var data = {};
	        var model = this;
	        var structure = getPeopleStructure(this, false);
	
	        /* Erstmal Formulardaten verwenden */
	        _.extend(data, this.getFormParameters());
	        /* Danach unsere Modeldaten */
	        _.extend(data, this.toJSON());
	
	        /* Unsichtbare Felder löschen */
	        _.each(structure, function (item) {
	            if (!item.condition(model)) {
	                delete data[item.key];
	            }
	        });
	
	        /* Auswahlmodus Kein Datum */
	        if (data.select_mode === "none") {
	            delete data.from;
	            delete data.to;
	        }
	
	        /* Werte filtern */
	        _.each(data, (function (value, key) {
	            /* Leere Werte */
	            if (value === null || value === "") {
	                delete data[key];
	            }
	            /* Leere Raum-Werte interessieren nicht (außer es ist "rooms" selbst, das kann 0 sein und muss geschickt werden) */
	            if (key.indexOf('rooms.') === 0 && (value === 0 || value === "0")) {
	                delete data[key];
	            }
	            /* Auf der Blacklist? */
	            if (this.form_blacklist.indexOf(key) !== -1 || key === "nights" && data.select_mode !== "flex") {
	                delete data[key];
	            }
	        }).bind(this));
	
	        /* Datumswerte serialisieren */
	        if (moment.isMoment(data.from)) {
	            data.from = data.from.format("YYYY-MM-DD");
	        }
	        if (moment.isMoment(data.to)) {
	            data.to = data.to.format("YYYY-MM-DD");
	        }
	
	        return data;
	    },
	
	    /**
	     * Reset the form to it's defaults. Also triggers change notifications
	     */
	    reset: function reset() {
	        this.set(this.defaults());
	    },
	
	    /**
	     * Zusammenfassung der Personen erzeugen. Gibt ein Objekt mit folgenden Keys zurück:
	     * 
	     * - rooms: Anzahl der ausgewählten Unterkünfte (Räume)
	     * - adults: Anzahl der ausgewählten Erwachsenen insgesamt
	     * - children: Anzahl der ausgewählten Kinder insgesamt (ohne Prüfung auf Gültigkeit)
	     * - kids_ages: Liste der ausgewählten Kinder-Alter (geprüft)
	     * - valid_children: Anzahl der ausgewählten Kinder insgesamt (mit ausgewähltem Alter)
	     * - missing_kids_age: Fehlen Altersangaben? (bool)
	     */
	    getPeople: function getPeople() {
	
	        var rooms = parseIntOrZero(this.get("rooms"));
	        var adults = 0;
	        var children = 0;
	        var children_ages = [];
	        var valid_children = 0;
	        var missing_kids_age = false;
	
	        for (var i = 1; i <= rooms; i++) {
	            var prefix = "rooms." + i + ".";
	            var room_kidscount = parseIntOrZero(this.get(prefix + "children"));
	
	            adults += parseIntOrZero(this.get(prefix + "adults"));
	            children += room_kidscount;
	
	            for (var j = 1; j <= 5; ++j) {
	                if (room_kidscount >= j) {
	                    var age = parseIntOrZero(this.get(prefix + "child" + j));
	                    if (age > 0) {
	                        valid_children++;
	                        children_ages.push(age);
	                    } else {
	                        missing_kids_age = true;
	                    }
	                }
	            }
	        }
	
	        children_ages.sort(function (a, b) {
	            return a - b;
	        });
	
	        return {
	            rooms: rooms,
	            adults: adults,
	            children: children,
	            children_ages: children_ages,
	            valid_children: valid_children,
	            missing_kids_age: missing_kids_age
	        };
	    },
	
	    /**
	     * Gibt einen String zurück, der die Personen in Textform beschreibt
	     */
	    getPeopleString: function getPeopleString(people) {
	        if (typeof people === "undefined") people = this.getPeople();
	        var text = "";
	        var short_text = Registry.get("PeopleSelect.ShortText");
	        var roomTitleMap = {
	            any: __("housing_any"),
	            room: __("housing_room"),
	            single: __("housing_single"),
	            double: __("housing_double"),
	            flat: __("housing_flat"),
	            house: __("housing_house"),
	            campsite: __("housing_campsite")
	        };
	
	        if (people.rooms === 0) {
	            return __("people_any_count");
	        }
	
	        if (people.rooms > 1) {
	            text += people.rooms + " " + __("housings") + ", "; // neutral wg. Zimmer/Fewo/Bett
	        }
	
	        if (people.valid_children) {
	            text += people.adults > 0 ? people.adults + " " + __("adults") + ", " : " " + __("no_adults") + ", ";
	            text += people.valid_children + " " + (people.valid_children > 1 ? __("children") : __("child"));
	        } else {
	            text += people.adults > 1 ? people.adults + " " + __("adults") + "" : " 1 " + __("adult");
	        }
	
	        if (people.rooms === 1 && Registry.get("PeopleStructure.ShowRoomTypes")) {
	            var roomTypeTitle = roomTitleMap[this.get("rooms.1.type")];
	            text += " in " + roomTypeTitle;
	        }
	
	        if (short_text) {
	            var parts = [];
	            if (people.rooms > 1) parts.push(people.rooms + "U");
	            if (people.adults > 0) parts.push(people.adults + "E");
	            if (people.valid_children > 0) parts.push(people.valid_children + "K");
	            text = parts.join(" + ");
	        }
	
	        return text;
	    },
	
	    /**
	     * Bindet das Model an ein HTML-Formular. Alle Änderungen werden entsprechend dem Formular zugewiesen.
	     * Nicht im Formular vorhandene Felder werden als hidden Felder erzeugt (praktisch für die Personen).
	     */
	    bindToForm: function bindToForm(form) {
	        this.form = form;
	
	        this.on('change', (function (e) {
	            _.each(e.changed, (function (value, key) {
	                if (_.indexOf(this.form_blacklist, key) >= 0) return;
	
	                var input = form.find("[name='" + key + "']");
	                if (input.length === 0) {
	                    input = $('<input/>').attr({
	                        'type': 'hidden',
	                        'name': key
	                    }).appendTo(form);
	                }
	                input.val(value);
	            }).bind(this));
	        }).bind(this));
	    },
	
	    /**
	     * Setzt alle Attribute vom FormModel zum verbundenen Formular.
	     * Praktisch für Such-Sonderfälle wie das Backend.
	     */
	    updateForm: function updateForm(form) {
	        var create_inputs = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
	        form = form || this.form;
	        if (!form) {
	            throw new Error("[FormModel] Tried to updateForm without a form");
	        }
	
	        _.each(this.attributes, (function (value, key) {
	            if (_.indexOf(this.form_blacklist, key) >= 0) return;
	
	            var input = form.find("[name='" + key + "']");
	            if (input.length === 0 && create_inputs) {
	                input = $('<input/>').attr({
	                    'type': 'hidden',
	                    'name': key
	                }).appendTo(form);
	            }
	            input.val(value);
	        }).bind(this));
	    },
	
	    /**
	     * Alle Parameter aus dem Formular ermitteln und in ein Objekt packen
	     */
	    getFormParameters: function getFormParameters() {
	        if (!this.form) return {};
	
	        var params = {};
	        this.form.find('[name]').each(function (i, item) {
	            var $item = $(item);
	            params[$item.attr('name')] = $item.val();
	        });
	        return params;
	    },
	
	    /**
	     * Bindet das Model an das localStorage. Alle Änderungen werden dort gespeichert.
	     */
	    bindToLocalStorage: function bindToLocalStorage() {
	        this.on('change', function (e) {
	            _.each(e.changed, function (value, key) {
	                SafeStorage.local.set("ReservaForm:" + key, value);
	            });
	        });
	        this.boundToSafeStorage = true;
	    },
	
	    /**
	     * URL-Parameter ins Model importieren
	     */
	    setFromLocalStorage: function setFromLocalStorage() {
	        if (this.boundToSafeStorage) {
	            throw new Error("Please call setFromLocalStorage before bindToLocalStorage");
	        }
	
	        var keys = _(this.attributes).keys();
	        var new_values = {};
	        for (var i = 0, key; key = keys[i]; ++i) {
	            var cached = SafeStorage.local.get("ReservaForm:" + key);
	            if (cached) {
	                if (this.numberFields.indexOf(key) !== -1) {
	                    cached = parseInt(cached, 10);
	                }
	                new_values[key] = cached;
	            }
	        }
	
	        this.set(new_values);
	    },
	
	    /**
	     * Formulardaten validieren
	     */
	    validate: function validate(data) {
	        var errors = [];
	
	        /* Dates */
	        if (data.select_mode !== "none") {
	            var date_from = moment(data.from, "YYYY-MM-DD");
	            var date_to = moment(data.to, "YYYY-MM-DD");
	
	            if (!date_from.isValid) {
	                errors.push("Das Ankunfsdatum ist nicht korrekt: " + data.from);
	            }
	            if (!date_to.isValid) {
	                errors.push("Das Ankunfsdatum ist nicht korrekt: " + data.to);
	            }
	
	            if (date_to.diff(date_from, "days") > 21) {
	                errors.push("Eine Suche ist für maximal 21 Tage möglich.");
	            }
	        }
	
	        /* Kinder */
	        for (var room_id = 1; room_id <= data.rooms; ++room_id) {
	            var children = data["rooms." + room_id + ".children"];
	            for (var i = 1; i <= children; ++i) {
	                if (!data["rooms." + room_id + ".child" + i]) {
	                    errors.push("Unterkunft " + room_id + " Kind " + i + ": Alter fehlt");
	                }
	            }
	        }
	
	        return errors;
	    },
	
	    /**
	     * Beim Suchagent gibt es folgendes Problem:
	     * - Wir haben select-Felder für die Personenauswahl
	     * - Der Server gibt im Formular die gleichen Felder nochmals
	     *   als <input type="hidden"> aus, daher sind die Felder nun doppelt
	     * - Der submit geht kaputt wegen der Backend-Behandlung von Mehrfachfeldern
	     *
	     * Diese Funktion findet doppelte Felder und löscht die hidden-Elemente raus.
	     */
	    fixSearchAgentForm: function fixSearchAgentForm(form) {
	        if (typeof form === "undefined") {
	            form = this.form;
	        }
	        if (!this.form || !this.form.length) {
	            return;
	        }
	
	        _.each(this.attributes, (function (value, key) {
	            if (_.indexOf(this.form_blacklist, key) >= 0) return;
	
	            var input = form.find("input[name='" + key + "']");
	            var select = form.find("select[name='" + key + "']");
	
	            if (input.length > 0 && select.length > 0) {
	                var input_value = input.val();
	                if (input_value) {
	                    select.val(input_value);
	                }
	
	                input.remove();
	            }
	        }).bind(this));
	    }
	
	});
	
	module.exports = FormModel;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__) {/*
	- Query Strings übernehmen ins Formular
	
	Personenauswahl
	
		Select: Anzahl Wohneinheiten 1-3
	
		AuswahlTyp:
		- Beliebige Art (default)
		- Zimmer
			Einzelzimmer (single)
			Doppelzimmer (double)
		- Ferienwohnung (flat)
			Falls ausgewählt: Zusätzliche Auswahl Anzahl Schlafzimmer [1-4]
		- Ferienhaus (house)
		- Stellplatz (campsite)
		- Betten (beds)
	
		SelectRow = [AuswahlTyp] [AnzahlSchlafzimmer:optional] [Erwachsense:1-15] [Kinder:1-5] [Kind1] [Kind2] [Kind3] [Kind4] [Kind5]
	
		A [SelectRow]
		B [SelectRow]
		C [SelectRow]
	
	{
		rooms: int,
		rooms.1.type: single|double|flat|house|campsite|beds,
		rooms.1.schlafzimmer: int,
		rooms.1.adults: int,
		rooms.1.children: int,
		rooms.1.child1: int,
		rooms.1.child2: int,
		rooms.1.child3: int,
		rooms.1.child4: int,
		rooms.1.child5: int,
	}
	
	*/
	
	'use strict';
	
	var _ = __webpack_require__(7);
	var Registry = __webpack_require__(26);
	
	/* General structure */
	
	var returnTrue = function returnTrue() {
		return true;
	};
	
	/**
	 * Erzeugt die Formular-Struktur für das Personen-Auswahl-Feld
	 *
	 * @param model {Backbone.Model} Model welches die Formular-Daten enthält
	 */
	module.exports = function (model, use_filter) {
		if (typeof use_filter === "undefined") {
			use_filter = true;
		}
	
		var structure = [];
	
		// Wenn wir 0 als Raum bekommen, müssen wir das auf 1 hochcasten.
		// Oh da das hier JS ist, kann es auch "0" sein, was true'ish ist.
		var rooms = parseInt(model.get("rooms"), 10) || 1;
	
		if (Registry.get("PeopleStructure.ShowMultiRooms") || !use_filter) {
			structure.push({
				key: "rooms",
				'class': "rooms",
				values: [[0, "Ohne Wohneinheit"], [1, "1 Wohneinheit"], [2, "2 Wohneinheiten"], [3, "3 Wohneinheiten"]]
			});
		}
	
		var makeChildSelect = function makeChildSelect(prefix, c, room_index) {
			return {
				key: prefix + "child" + c,
				values: [[0, __("age")], [1, "1 Jahr"], [2, "2 Jahre"], [3, "3 Jahre"], [4, "4 Jahre"], [5, "5 Jahre"], [6, "6 Jahre"], [7, "7 Jahre"], [8, "8 Jahre"], [9, "9 Jahre"], [10, "10 Jahre"], [11, "11 Jahre"], [12, "12 Jahre"], [13, "13 Jahre"], [14, "14 Jahre"], [15, "15 Jahre"], [16, "16 Jahre"], [17, "17 Jahre"]],
				condition: function condition(model) {
					if (rooms < room_index) return false;
					return model.get(prefix + "children") >= c;
				}
			};
		};
	
		/* Each location block */
		_.each(['A', 'B', 'C'], function (group, i) {
			var index = i + 1;
			var prefix = "rooms." + index + ".";
	
			structure.push({
				type: 'groupStart',
				group: group,
				condition: function condition(model) {
					return rooms >= index && rooms > 1;
				}
			});
	
			structure.push({
				key: prefix + "type",
				'class': "room-type",
				valuesFunc: function valuesFunc(model) {
					var defaults = [["any", __("housing_any")], ["room", __("housing_room")], ["single", "&nbsp; " + __("housing_single")], ["double", "&nbsp; " + __("housing_double")], ["flat", __("housing_flat")], ["house", __("housing_house")]];
	
					if (Registry.get("Customer").Bergwelt) {
						defaults = [["any", __("housing_any")], ["flat", __("housing_flat")], ["house", __("housing_house")]];
					}
	
					if (!Registry.get("Customer").Wertach && !Registry.get("Customer").Bergwelt && !Registry.get("Customer").Oberstdorf && !Registry.get("Customer").Scheidegg) {
						defaults.push(["campsite", __("housing_campsite")]);
					}
	
					return defaults;
				},
				condition: function condition(model) {
					if (!Registry.get("PeopleStructure.ShowRoomTypes", true)) return false;
					return rooms >= index;
				}
			});
	
			structure.push({
				key: prefix + "bedrooms",
				values: [[0, __("bedroom_count")], [1, "1 " + __("bedroom")], [2, "2 " + __("bedrooms")], [3, "3 " + __("bedrooms")]],
				condition: function condition(model) {
					if (!Registry.get("PeopleStructure.ShowRoomTypes", true)) return false;
					if (rooms < index) return false;
					return model.get(prefix + "type") == "flat";
				}
			});
	
			structure.push({
				key: prefix + "adults",
				'class': "room-adults",
				valuesFunc: function valuesFunc(model) {
					var type = model.get(prefix + "type");
					var selectable = ({
						"any": model.get("room_limit_any") || 18,
						"room": model.get("room_limit_room") || 9,
						"single": model.get("room_limit_single") || 2,
						"double": model.get("room_limit_double") || 3,
						"flat": model.get("room_limit_flat") || 15,
						"house": model.get("room_limit_house") || 18,
						"campsite": model.get("room_limit_campsite") || 9,
						"beds": model.get("room_limit_beds") || 18
					})[type];
	
					var values = [[1, "1 " + __("adult")]];
					for (var i = 1; i < selectable; i++) {
						values.push([i + 1, i + 1 + " " + __("adults")]);
					}
					return values;
				},
				condition: function condition(model) {
					return rooms >= index;
				}
			});
	
			structure.push({
				key: prefix + "children",
				'class': "room-childage",
				values: [[0, __("no_children")], [1, __("one_child")], [2, "2 " + __("children")], [3, "3 " + __("children")], [4, "4 " + __("children")], [5, "5 " + __("children")]],
				condition: function condition(model) {
					if (model.get("no_children")) return false;
					return rooms >= index;
				}
			});
	
			for (var c = 1; c <= 5; c++) {
				structure.push(makeChildSelect(prefix, c, i));
			}
	
			structure.push({
				type: 'groupEnd',
				group: group,
				condition: function condition(model) {
					return rooms >= index && rooms > 1;
				}
			});
		});
	
		/* Apply defaults to all items */
		_(structure).each(function (item) {
			if (!item.type) item.type = "select";
			if (!item['class']) item['class'] = "";
			if (!item.condition) item.condition = returnTrue;
	
			if (typeof item.valuesFunc === "function") {
				item.values = item.valuesFunc(model);
			}
		});
	
		if (use_filter) {
			structure = _.filter(structure, function (item) {
				return item.condition(model);
			});
		}
		return structure;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Dieses Modul stellt die Client-API für die Reserva Engine zur Verfügung.
	 */
	
	'use strict';
	
	var Promise = __webpack_require__(2);
	var ajax = __webpack_require__(21);
	
	/**
	 * Ergebnis einer Suchanfrage. Wird von der exportierten Funktion des Moduls erzeugt.
	 * 
	 * @param params {Object} Request-Parameter
	 * @param response {Object} Rückgabe vom Server
	 */
	var TraminoEngineResult = function TraminoEngineResult(params, response) {
		this.params = params;
		this.response = response;
	
		if (!response || !response.cache) {
			var e = new Error("Invalid response from engine API");
			Raven.captureException(e, {
				extra: {
					param: params,
					response: response
				}
			});
			throw e;
		}
	
		this.more_results = response.cache.count > 0;
		this.results_count = response.results.length;
		this.initial_results_count = response.results.length;
		this.start_time = new Date().getTime();
		this.more_count = 0;
	};
	
	/**
	 * Liste aller Suchergebnisse zurück geben + Liste leeren
	 */
	TraminoEngineResult.prototype.getInitialResults = function () {
		var results = this.response.results;
		this.response.results = null;
		return results;
	};
	
	/**
	 * Mehr Ergebnisse vom Server abfragen.
	 *
	 * @return {Promise} Gibt die Liste der NEUEN Ergebnisse zurück
	 */
	TraminoEngineResult.prototype.loadMore = function () {
		if (!this.more_results) return Promise.resolve([]);
	
		var url = this.response.refs.results + '&nocache=' + new Date().getTime();
		return ajax(url).then((function (response) {
			this.more_results = response.cache.count > 0;
			this.results_count += response.results.length;
			this.more_count++;
	
			if (!this.more_results && this.results_count != this.response.count) {
				Raven.captureMessage("ResultMismatch", {
					extra: {
						firstResponse: {
							cache: this.response.cache,
							resultsLength: this.initial_results_count,
							totalResults: this.response.count
						},
						lastResponse: {
							cache: response.cache,
							resultsLength: response.results.length
						},
						state: {
							resultsCount: this.results_count,
							moreCount: this.more_count
						},
						query: this.params,
						timeSinceStart: new Date().getTime() - this.start_time
					}
				});
			}
	
			return response.results;
		}).bind(this));
	};
	
	/**
	 * Suche ausführen
	 *
	 * @param params {Object} Suchparameter
	 * @return {Promise} Gibt ein TraminoEngineResult zurück
	 */
	module.exports = {
		TraminoEngineResult: TraminoEngineResult,
	
		search: function search(params) {
			params.cache = 0; // @todo Temporary until double render fix. 23.12.2016
			return ajax({
				method: 'GET',
				url: '/api/engine/',
				params: params
			}).then(function (response) {
				if (response.status && response.status === "error") {
					throw new Error("Fehler bei der Suche: " + response.message);
				}
	
				return new TraminoEngineResult(params, response);
			});
		}
	};

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Erzeugt eine Google Maps zur Anzeige von Betrieben
	 *
	 * Features:
	 * - Asynchrones Laden von Google Maps
	 * - Integration Mapcluster + Fixes für Sonderfälle
	 *
	 * Erforderliche Parameter:
	 * @param target {String}: ID des Karten-Elements
	 * @param onClick {Function}: Callback für Klicks auf Marker
	 *
	 * Optionale Parameter
	 * @param center {Objekt, null}: Mitte der Karte (Standard: Oberstdorf)
	 * @param zoom {Number, null}: Zoomlevel (Standard: 15)
	 *
	 * Referenz:
	 * https://googlemaps.github.io/js-marker-clusterer/docs/reference.html
	 */
	
	'use strict';
	
	var $ = __webpack_require__(6);
	var _ = __webpack_require__(7);
	var Promise = __webpack_require__(2);
	
	var defaultCoordinates = {
	    // Oberstdorf
	    100: {
	        lat: 47.40925187377930000,
	        lng: 10.27934982299804700
	    },
	
	    // Ammersee-Lech
	    620: {
	        lat: 48.0458172,
	        lng: 10.8659336
	    },
	
	    // Wertach
	    9350: {
	        lat: 47.602137,
	        lng: 10.411246
	    }
	};
	
	/**
	 * Returns the default coordinates for the current client, destination,
	 * or Oberstdorf if unknown.
	 */
	function getDefaultCoordinates() {
	    var client = parseInt(window.Tramino.client, 10);
	    var destination = parseInt(window.Tramino.destination, 10);
	
	    return defaultCoordinates[client] || defaultCoordinates[destination] || defaultCoordinates[100];
	}
	
	var TraminoClientsMap = function TraminoClientsMap(options) {
	    _.bindAll(this, "init", "loadMaps", "addMarkers", "clearMarkers");
	
	    this.options = options;
	    this.loadingPromise = null;
	    this.initialized = false;
	
	    if (!this.options.center) {
	        this.options.center = getDefaultCoordinates();
	    }
	    if (!this.options.zoom) {
	        this.options.zoom = 15;
	    }
	    if (!this.options.autofit) {
	        this.options.autofit = false;
	    }
	    if (!this.options.api_key) {
	        this.options.api_key = "AIzaSyDprYveDeS9YkRYuRNEG3i_hrfUa140JB4";
	    }
	
	    this.loadMaps();
	};
	
	/**
	 * Google Maps asyncron laden, falls notwendig.
	 *
	 * @return {Promise} Feuert wenn Google Maps bereit ist. Das gelieferte Ergebnis ist undefiniert.
	 */
	TraminoClientsMap.prototype.loadMaps = function () {
	    if (window.google && google.maps) {
	        return Promise.resolve(true);
	    }
	
	    if (this.loadingPromise === null) {
	        var maps_url = "https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry&callback=TraminoClientsMapReady&key=" + this.options.api_key;
	        var cluster_url = "/tramino/js/markerclusterer/markerclusterer_compiled.js";
	
	        this.loadingPromise = new Promise(function (resolve, reject) {
	            window.TraminoClientsMapReady = function () {
	                resolve();
	                delete window.TraminoClientsMapReady;
	            };
	
	            Promise.all([Promise.resolve($.getScript(maps_url)), Promise.resolve($.getScript(cluster_url))]).then(function () {});
	        });
	    }
	    return this.loadingPromise;
	};
	
	/**
	 * Karte initialisieren.
	 *
	 * @return {Promise}
	 */
	TraminoClientsMap.prototype.init = function () {
	    return this.loadMaps().then((function () {
	        this.map = new google.maps.Map(document.getElementById(this.options.target), {
	            zoom: this.options.zoom,
	            center: this.options.center,
	            scrollwheel: false
	        });
	
	        if (typeof window.MarkerClusterer !== "undefined") {
	            this.mc = new MarkerClusterer(this.map, [], {
	                gridSize: 25,
	                maxZoom: 15
	            });
	        }
	
	        this.infoWindow = new google.maps.InfoWindow({
	            content: "Kein Inhalt gefunden"
	        });
	        this.initialized = true;
	
	        if (this.options.data) {
	            this.addMarkers(this.options.data);
	        }
	    }).bind(this));
	};
	
	TraminoClientsMap.prototype.displayInfo = function (marker, content, options) {
	    if (!this.initialized) return;
	
	    if (options) {
	        this.infoWindow.setOptions(options);
	    }
	    this.infoWindow.setContent(content);
	    this.infoWindow.open(this.map, marker);
	};
	
	TraminoClientsMap.prototype.addMarkers = function (clients) {
	    if (!this.initialized) return;
	
	    var self = this;
	    var markers = [];
	
	    var addMarker = function addMarker(betrieb) {
	        var marker = new google.maps.Marker({
	            position: {
	                lat: parseFloat(betrieb.lat),
	                lng: parseFloat(betrieb.lng)
	            },
	            /*icon: '',*/
	            title: betrieb.name
	        });
	        marker.addListener('click', function (e) {
	            self.options.onClick(e, marker, betrieb);
	        });
	        markers.push(marker);
	    };
	
	    for (var i = 0; i < clients.length; ++i) {
	        var betrieb = clients[i];
	        addMarker(betrieb);
	    }
	
	    this.mc.addMarkers(markers);
	
	    if (this.options.autofit) {
	        /* Karte neu ausrichten */
	        var bounds = new google.maps.LatLngBounds();
	        _.each(clients, function (b) {
	            if (b.lat && b.lng) {
	                bounds.extend(new google.maps.LatLng(b.lat, b.lng));
	            }
	        });
	
	        /* Fake-Marker falls keine Marker gesetzt */
	        if (clients.length === 0) {
	            var coords = getDefaultCoordinates();
	            bounds.extend(new google.maps.LatLng(coords.lat, coords.lng));
	        }
	
	        /* Verhindern dass wir zu nah zoomen */
	        if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
	            var extendPoint1 = new google.maps.LatLng(bounds.getNorthEast().lat() + 0.01, bounds.getNorthEast().lng() + 0.01);
	            var extendPoint2 = new google.maps.LatLng(bounds.getNorthEast().lat() - 0.01, bounds.getNorthEast().lng() - 0.01);
	            bounds.extend(extendPoint1);
	            bounds.extend(extendPoint2);
	        }
	
	        this.map.setCenter(bounds.getCenter());
	        this.map.fitBounds(bounds);
	    }
	};
	
	TraminoClientsMap.prototype.clearMarkers = function () {
	    if (!this.initialized) return;
	
	    this.mc.clearMarkers();
	};
	
	module.exports = TraminoClientsMap;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Reserva DatePicker
	 *
	 * Generalisierte Version des IBE1 Datepickers zur Verwendung in beliebigen Webseiten.
	 */
	
	'use strict';
	
	var Backbone = __webpack_require__(20);
	
	/**
	 * ReservaDaysModel
	 */
	var ReservaDaysModel = Backbone.Model.extend({
		defaults: function defaults() {
			return {
				days: [],
				nights: [],
				name: ''
			};
		},
	
		reset: function reset() {
			this.set(this.defaults());
		}
	});
	
	module.exports = ReservaDaysModel;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__) {'use strict';
	
	var _ = __webpack_require__(7);
	
	var ajax = __webpack_require__(21);
	var DateTime = __webpack_require__(40);
	var ReservaDatePicker = __webpack_require__(41);
	
	var PeopleView = __webpack_require__(44);
	
	var mixin = {
	
	    /**
	     * Informationen über Paket-Tage von der API laden
	     */
	    loadItemDays: function loadItemDays() {
	        var item = this.get("item");
	        var client = this.get("client"); /* Client wird nur für die MiniEngine gebraucht */
	        if (item === null && client === null) {
	            this.daysModel.reset();
	            return Promise.resolve(true);
	        }
	
	        var query = {};
	        if (item) query.item = item;
	        if (client) query.client = client;
	        query.lang = window.Tramino.lang;
	
	        return ajax('/api/engine/days/', { params: query }).then((function (result) {
	            if (!result.success) {
	                Raven.captureMessage("loadItemDays failed (test 3)", {
	                    extra: {
	                        item: item,
	                        client: client,
	                        result: result
	                    }
	                });
	                return;
	            }
	
	            this.daysModel.set({
	                days: result.days,
	                name: result.name
	            });
	
	            /* Anders als bei der IBE wissen wir an diesem Punkt schon, dass der Kalender steht. */
	            if (!this.datepicker.initialized) {
	                throw new Error("State Error: Calendar is no ready yet");
	            }
	
	            if (result.days.length > 0) {
	                /*
	                var days = _.pluck(result.days, "date");
	                if ( days.indexOf(this.formModel.get("from")) === -1 ) {
	                    this.datepicker.setFrom(null);
	                    this.datepicker.setTo(null);
	                    this.formModel.set("select_mode", "none");
	                     if ( result.days.length > 0 ) {
	                        console.log("Setting first calendar day to", result.days[0].date);
	                        this.datepicker.datepicker.datepicker("setDate", result.days[0].date);
	                    }
	                }*/
	                this.datepicker.datepicker.datepicker("refresh");
	            }
	        }).bind(this))['catch'](this.promiseError);
	    },
	
	    /**
	     * DatePicker initialisieren. Kann auch unabhängig
	     * von einer vollen Reserva-Anwendung verwendet werden.
	     *
	     * Erstes Argument ist ein Dict von jQuery-Objekten:
	     * - form: Formular, an das der Datepicker gebunden wird
	     * - datepicker_display: Anzeige des gewählten Datums
	     * - datepicker_container: Container des jQuery UI Datepicker
	     * - datepicker_box: Kompletter Container des Datepickers, inklusive aller anderen Widgets
	     *                   wie die controls. Optional, verwendet sonst datepicker_container.
	     * - datepicker_unchain: Datepicker lösen und ans Ende vom Body packen
	     * - datepicker_fixto: An ein bestimmtes Element fixieren
	     * - fixto_direction: An ein bestimmtes Element fixieren
	     */
	    initializeDatepicker: function initializeDatepicker(nodes) {
	        var _this = this;
	
	        var defaultstartin = nodes.defaultstartin || this.get("defaultstartin");
	        var defaultdays = nodes.defaultdays || this.get("defaultdays") || 7;
	
	        // Datepicker anzeigen
	        var datepickerOptions = {
	            form: nodes.form,
	            container: nodes.datepicker_container,
	            isTouchDevice: this.get("isTouchDevice"),
	
	            defaultstartin: defaultstartin,
	            defaultdays: defaultdays,
	            app: this,
	            model: this.formModel,
	            daysmodel: this.daysModel
	        };
	        if (nodes.numberOfMonths) {
	            datepickerOptions.numberOfMonths = nodes.numberOfMonths;
	        }
	
	        this.datepicker = new ReservaDatePicker(datepickerOptions);
	        this.datepicker.init();
	
	        this.datepickerButton = nodes.datepicker_display;
	
	        this.on('change:isTouchDevice', function (e) {
	            _this.datepicker.isTouchDevice = e.attributes.isTouchDevice;
	        });
	
	        if (nodes.datepicker_fixto) {
	            /* Erstmal irgendwo hin packen dass die Länge ermittelt werden kann */
	            nodes.fixto_direction = nodes.fixto_direction || 'bottom';
	            nodes.fixto_origin = nodes.fixto_origin || 'left';
	
	            this.datepicker.container.css({
	                position: 'fixed',
	                top: -10000,
	                left: -1000,
	                "z-index": $('#menu').css('z-index') + 1
	            });
	        }
	
	        /* Unchain funktioniert nur mit der Fixierung */
	        if (nodes.datepicker_unchain) {
	            var unchain_target = $('#page');
	            if (unchain_target.length === 0) {
	                unchain_target = $('body');
	            }
	            this.datepicker.container.detach().appendTo(unchain_target);
	        }
	
	        this.formModel.on('change:from change:to change:nights change:select_mode', this.updateDatePickerDisplay);
	        this.updateDatePickerDisplay();
	
	        var calendarWidth = this.datepicker.container.outerWidth(true);
	
	        this.datepickerButton.on('click', (function (e) {
	            e.preventDefault();
	
	            if (this.get("autoHideWidgets")) {
	                this.hidePeopleSelect();
	            }
	
	            if (this.datepicker.isOpen) {
	                this.hideDatepicker();
	                return;
	            }
	
	            /* In manchen Templates muss der DatePicker auf der Seite fixiert werden, da er sonst
	               von zu kleinen Responsive-Boxen abgeschnitten wird. Was wir doof finden. */
	            if (nodes.datepicker_fixto) {
	                var offset = nodes.datepicker_fixto.offset();
	                var height = nodes.datepicker_fixto.outerHeight(true);
	                var width = nodes.datepicker_fixto.outerWidth();
	                var top;
	
	                if (nodes.fixto_direction === "top") {
	                    top = offset.top - this.datepicker.container.outerHeight(true);
	                }
	                if (nodes.fixto_direction === "bottom") {
	                    top = offset.top + height;
	                }
	
	                if (nodes.fixto_origin === "left") {
	                    /* Verhindern, dass der DatePicker zu weit rechts rutscht */
	                    var maxLeft = $(window).width() - calendarWidth - 20;
	                    if (offset.left > maxLeft) {
	                        offset.left = maxLeft;
	                    }
	                    /* Verhindern, dass der DatePicker zu weit links rutscht */
	                    if (offset.left < 20) {
	                        offset.left = 20;
	                    }
	                } else {
	                    /* Rechter Rand des Datepickers muss am rechten Rand vom Objekt sein */
	                    offset.left = offset.left + width - this.datepicker.container.outerWidth() + 1;
	                }
	
	                /* Und nun an die richtige Stelle packen */
	                this.datepicker.container.css({
	                    position: 'absolute',
	                    top: top,
	                    left: offset.left
	                });
	            }
	
	            this.showDatepicker();
	        }).bind(this));
	
	        this.datepicker_initialized = true;
	    },
	
	    /**
	     * DatePicker einblenden und aktivieren
	     */
	    showDatepicker: function showDatepicker() {
	        this.datepicker.container.show();
	        this.datepicker.opened();
	        this.datepickerButton.addClass('on');
	        this.updateDatePickerDisplay();
	        this.trigger("show:datepicker", this);
	
	        $('body').addClass('datepicker-open');
	    },
	
	    /**
	     * DatePicker ausblenden und aufräumen
	     */
	    hideDatepicker: function hideDatepicker() {
	        this.datepicker.container.hide();
	        this.datepicker.closed();
	        if (this.datepickerButton && this.datepickerButton.length) this.datepickerButton.removeClass('on');
	        this.updateDatePickerDisplay();
	
	        $('body').removeClass('datepicker-open');
	    },
	
	    /**
	     * Datepicker-Anzeige aktualisieren
	     */
	    updateDatePickerDisplay: function updateDatePickerDisplay() {
	        if (this.datepicker.isOpen) {
	            return;
	        }
	
	        var text;
	        var from = this.formModel.get("from");
	        var to = this.formModel.get("to");
	        var nights = this.formModel.get("nights");
	        var select_mode = this.formModel.get("select_mode");
	
	        if (select_mode === "none") {
	            text = __("dd_selected_none");
	            if (window.Tramino.client == 107) {
	                text = __("dd_select_date_short");
	            }
	        } else {
	            if (!from && !to) {
	                text = __("dd_select_date");
	            } else {
	                text = DateTime.textPeriod(from, to, nights, select_mode);
	            }
	        }
	
	        this.datepickerButton.text(text);
	    },
	
	    /**
	     * People initialisieren. Kann auch unabhängig
	     * von einer vollen Reserva-Anwendung verwendet werden.
	     *
	     * Erstes Argument ist ein Dict von jQuery-Objekten:
	     * - form: Formular, an das der Selector gebunden wird (optional)
	     * - people_display: Anzeige der gewählten Personen
	     * - people_container: Container der Auswahlfelder
	     * - people_fixto: An einem DOM-Element ausrichten
	     */
	    initializePeopleSelect: function initializePeopleSelect(nodes) {
	
	        // Personen-Auswahl
	        this.peopleView = new PeopleView({
	            model: this.formModel,
	            el: nodes.people_container
	        });
	        this.peopleView.render();
	
	        // Personen-Button
	        this.peopleButton = nodes.people_display;
	
	        var peopleSelectorWidth = this.peopleView.$el.outerWidth(true);
	
	        this.peopleButton.on('click', (function (e) {
	            e.preventDefault();
	
	            if (this.get("autoHideWidgets")) {
	                this.hideDatepicker();
	            }
	
	            /* In manchen Templates muss der PeopleSelect auf der Seite fixiert werden, da er sonst
	               von zu kleinen Responsive-Boxen abgeschnitten wird. Was wir doof finden. */
	            if (nodes.people_fixto) {
	                var offset = nodes.people_fixto.offset();
	                var height = nodes.people_fixto.outerHeight(true);
	
	                /* Verhindern, dass der PeopleSelect zu weit rechts rutscht */
	                var maxLeft = $(window).width() - peopleSelectorWidth - 20;
	                if (offset.left > maxLeft) {
	                    offset.left = maxLeft;
	                }
	                /* Verhindern, dass der PeopleSelect zu weit links rutscht */
	                if (offset.left < 20) {
	                    offset.left = 20;
	                }
	
	                /* Und nun an die richtige Stelle packen */
	                this.peopleView.$el.css({
	                    position: 'absolute',
	                    top: offset.top + height,
	                    left: offset.left
	                });
	
	                /* Unchain funktioniert nur mit der Fixierung */
	                if (nodes.people_unchain) {
	                    var unchain_target = $('#page');
	                    if (unchain_target.length === 0) {
	                        unchain_target = $('body');
	                    }
	                    this.peopleView.$el.detach().appendTo(unchain_target);
	                }
	            }
	
	            if (this.peopleButton.hasClass('on')) {
	                this.hidePeopleSelect();
	            } else {
	                this.showPeopleSelect();
	            }
	        }).bind(this));
	
	        if (nodes.form) {
	            this.formModel.bindToForm(nodes.form);
	        }
	
	        /*
	        this.formModel.on(this.formModel.peopleFields.map(f => `change:${f}`).join(" "), e => {
	            this.updatePeopleDisplay()
	        })
	        */
	
	        this.updatePeopleDisplay();
	        this.peopleselect_initialized = true;
	    },
	
	    /**
	     * Personen-Auswahl ausblenden
	     */
	    showPeopleSelect: function showPeopleSelect() {
	        if (!this.peopleView) return;
	
	        /* Thomas asked for it. */
	        if (this.formModel.get("rooms") === 0) {
	            this.formModel.set("rooms", 1);
	        }
	
	        this.peopleView.$el.show();
	        this.peopleButton.addClass('on');
	        this.trigger("show:peopleselect", this);
	
	        $('body').addClass('peopleselect-open');
	    },
	
	    /**
	     * Personen-Auswahl ausblenden
	     */
	    hidePeopleSelect: function hidePeopleSelect() {
	        if (!this.peopleView) return;
	        this.updatePeopleDisplay();
	        this.peopleView.$el.hide();
	        if (this.peopleButton && this.peopleButton.length) this.peopleButton.removeClass('on');
	
	        $('body').removeClass('peopleselect-open');
	    },
	
	    /**
	     * Personen-Auswahl-Feld aktualisieren
	     */
	    updatePeopleDisplay: function updatePeopleDisplay() {
	        if (!this.peopleButton) return;
	        var people = this.formModel.getPeople();
	        var text = this.formModel.getPeopleString(people);
	        this.peopleButton.text(text);
	    }
	
	};
	
	module.exports = function (app) {
	    _.extend(app, mixin);
	    _.bindAll(app, "hideDatepicker", "hidePeopleSelect", "loadItemDays", "showDatepicker", "showPeopleSelect", "updateDatePickerDisplay", "updatePeopleDisplay");
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__) {'use strict';
	
	var moment = __webpack_require__(8);
	var Registry = __webpack_require__(26);
	
	/**
	 * Ein Datum parsen und ein moment-Objekt zurückgeben
	 */
	var parseDate = function parseDate(d, reset) {
		if (window.Tramino.lang == "de") {
			moment.locale("de");
		}
		if (d === null) return null;
		var result = undefined;
	
		if (d instanceof Date) {
			result = moment(d);
		} else {
			result = moment(d, ['L', 'DD.MM.YY', 'DD.MM.YYYY', 'YYYY-MM-DD']);
		}
		return reset ? resetTimeFields(result) : result;
	};
	
	/**
	 * Render a string for the from - to period.
	 *  @todo t10n, i18n
	 */
	var textPeriod = function textPeriod(from, to, nights, select_mode) {
		var m_from = moment(from, 'YYYY-MM-DD');
		var m_to = moment(to, 'YYYY-MM-DD');
		var now = moment();
	
		if (window.Tramino.lang == "de") {
			moment.locale("de");
		}
	
		var shortmode = Registry.get("DateTime.ShortTextPeriod", false);
		select_mode = select_mode || "exact";
	
		if (!from || !m_from.isValid()) {
			return __("no_date");
		}
		if (!to || !m_to.isValid()) {
			return m_from.format("dd. DD.MM.YYYY") + " bis ...";
		}
	
		var date_to = " " + __("date_to") + " ";
	
		/* Standard */
		var result = m_from.format("DD.MM.YYYY") + date_to + m_to.format("DD.MM.YYYY");
		var weekdays = m_from.format("dd") + "-" + m_to.format("dd");
	
		/* Bei gleichem Jahr dieses ausblenden */
		if (m_from.year() === m_to.year() && m_from.year() === now.year()) {
			result = m_from.format("DD.MM.") + date_to + m_to.format("DD.MM.YYYY");
		}
	
		/* Gleicher Monat, aktuelles Jahr */
		if (m_from.month() === m_to.month() && m_from.year() === now.year()) {
			result = m_from.format("DD.") + date_to + m_to.format("DD. MMMM");
		}
	
		/* Gleicher Monat, anderes Jahr */
		if (m_from.month() === m_to.month() && m_from.year() !== now.year()) {
			result = m_from.format("DD. ") + date_to + m_to.format("DD. MMMM YYYY");
		}
	
		/* Nächte */
		nights = nights || m_to.diff(m_from, 'days');
		var nights_part;
		if (nights === 1) {
			nights_part = __("one_night");
		} else {
			nights_part = __("x_nights", { nights: nights });
		}
	
		if (select_mode === "flex") {
			result = nights_part + " im Zeitraum " + result;
		} else if (!shortmode) {
			result = result + ", " + nights_part + " (" + weekdays + ")";
		}
	
		var guard = 10;
		while (result.indexOf('  ') !== -1) {
			result = result.replace('  ', ' '); // Safari is the new IE
			guard--;
			if (guard <= 0) break;
		}
		return result;
	};
	
	/**
	 * Reset all time fields of a Date object to zero (hour, minute, second, msec)
	 */
	var resetTimeFields = function resetTimeFields(date) {
		if (moment.isMoment(date)) {
			date.hours(0);
			date.minutes(0);
			date.seconds(0);
			date.milliseconds(0);
		} else {
			date.setHours(0);
			date.setMinutes(0);
			date.setSeconds(0);
			date.setMilliseconds(0);
		}
		return date;
	};
	
	module.exports = {
		parse: parseDate,
		moment: moment,
		textPeriod: textPeriod,
		resetTimeFields: resetTimeFields
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Reserva DatePicker
	 *
	 * Generalisierte Version des IBE1 Datepickers zur Verwendung in beliebigen Webseiten.
	 */
	
	'use strict';
	
	var _ = __webpack_require__(7);
	var moment = __webpack_require__(8);
	var Backbone = __webpack_require__(20);
	
	var DateTime = __webpack_require__(40);
	var TemplateCache = __webpack_require__(25);
	
	var DatepickerControlsView = __webpack_require__(42);
	var Translator = __webpack_require__(18).singleton;
	
	var Tooltip = __webpack_require__(43);
	var Registry = __webpack_require__(26);
	
	var ReservaDatePicker = function ReservaDatePicker(options) {
		_.extend(this, Backbone.Events);
		_.extendOwn(this, {
			/* Required fields */
			form: null, /* Form to use */
			container: null, /* Where to put the datepicker */
	
			/* Dates */
			from: null,
			to: null,
	
			/* Date state */
			previousFrom: null,
			previousTo: null,
	
			/* Calendar configuration */
			from_field: 'from',
			to_field: 'to',
			item: null,
			numberOfMonths: $(window).width() > 600 ? 2 : 1,
			canGoBackInTime: false,
	
			/* Default date for calendar */
			defaultstartin: null,
			defaultdays: null,
	
			/* Mobile fixes */
			isTouchDevice: false,
	
			/* DOM nodes/Views */
			datepicker: null,
			controls: null,
			infotext: null,
	
			/* Remote models */
			app: null,
			model: null,
			daysmodel: null
		}, options);
	
		_.bindAll(this, "onSelect", "cellHoverHandler", "setFrom", "setTo", "disableTooltip", "boxCheck", "runAwayScreaming");
	
		/* Validation of parameters */
		if (!this.form || !this.form.length) throw new Error("[ReservaDatePicker] Missing form");
		if (!this.container || !this.container.length) throw new Error("[ReservaDatePicker] Missing container");
	
		/* DOM-Elemente sammeln */
		this.from_input = this.form.find('input[name=' + this.from_field + ']');
		this.to_input = this.form.find('input[name=' + this.to_field + ']');
	
		if (!this.from_input.length) {
			this.from_input = $('<input>').attr({
				name: 'from',
				type: 'hidden'
			}).appendTo(this.form);
		}
		if (!this.to_input.length) {
			this.to_input = $('<input>').attr({
				name: 'to',
				type: 'hidden'
			}).appendTo(this.form);
		}
	
		/* Tooltip erzeugen */
		this.tooltip = new Tooltip({
			box: this.container,
			className: "reserva-datepicker-tooltip"
		});
	
		/* Container vorbereiten (drei Elemente: Controls, Datepicker, Infotext) */
		this.container.html("");
		this.controls = new DatepickerControlsView({
			el: $('<div/>').addClass('reserva-datepicker-controls').appendTo(this.container)[0],
			model: this.model,
			datepicker: this
		});
		this.datepicker = $('<div/>').addClass('reserva-datepicker-container').appendTo(this.container);
		this.infotext = $('<div/>').appendTo(this.container);
	
		this.diffBeginDate = parseDate("2014-10-01");
	
		/* State Variables */
		this.isOpen = false;
		this.initialized = false;
	
		this.pointerX = -1000;
		this.pointerY = -1000;
	
		this.select_step = 0;
		this.currentlySelectedDaysCount = 0;
		this.last_to = null;
	
		this.last_tooltip = "";
		this.tooltipInitialText = "und jetzt das Abreisedatum...";
		this.update_days_count_timer = null; // int: Interval ID
		this.datepicker_box_bounds = null;
		this.unavailable_shown = false;
	
		this.invalid_nightscount = false; /* Amount of nights is too low/high */
		this.usedDefaultDate = false;
	
		if (!this.model) {
			this.model = new Backbone.Model();
			this.model.set(this.from_field, null);
			this.model.set(this.to_field, null);
		}
	
		/* Bei Änderungen an Model aktualisieren auch wir unsere Daten */
		this.modelChanging = false;
	
		this.model.on('change:' + this.from_field, (function (e) {
			if (this.modelChanging) return;
			this.setFrom(e.attributes[this.from_field]);
		}).bind(this));
	
		this.model.on('change:' + this.to_field, (function (e) {
			if (this.modelChanging) return;
			this.setTo(e.attributes[this.to_field]);
		}).bind(this));
	
		this.model.on('change:select_mode', (function (e) {
			this.datepicker.datepicker("refresh");
		}).bind(this));
	
		this.daysmodel.on('change', (function (e) {
			if (!e.attributes.days) return;
			//this.canGoBackInTime = e.attributes.days.length === 0;
			//console.log("[ReservaDatePicker] canGoBackInTime = ", this.canGoBackInTime);
	
			this.infotext.html(TemplateCache.render("datepicker-item-info", {
				item: this.daysmodel.toJSON()
			}));
		}).bind(this));
	};
	
	/**
	 * Datepicker initialisieren
	 */
	ReservaDatePicker.prototype.init = function () {
		var self = this;
		var from, to;
	
		/* Datum aus dem Model laden */
		var temp;
		if (temp = this.model.get(this.from_field)) {
			from = parseDate(temp);
		}
		if (temp = this.model.get(this.to_field)) {
			to = parseDate(temp);
		}
	
		/* There are horrible typed languages. And there is JavaScript */
		var isBroken = function isBroken(something) {
			if (typeof something === "string") {
				if (something.indexOf('NaN') !== -1) {
					return true;
				}
			}
			if (something.toString() === "Invalid Date") {
				return true;
			}
	
			return false;
		};
	
		// If any of the dates are in the past, ignore both
		var today = DateTime.resetTimeFields(new Date());
		if (+from < +today || +to < +today) {
			from = null;
			to = null;
		}
	
		/* If we didn't get a saved or otherwise valid result, just use the defaults */
		if (!from || !to || isBroken(from) || isBroken(to)) {
			var defaultstartin = this.defaultstartin || 0;
			var defaultdays = this.defaultdays || 1;
			from = addDays(new Date(), parseInt(defaultstartin, 10));
			to = addDays(from, parseInt(defaultdays, 10));
	
			this.usedDefaultDate = true;
		}
	
		this.controls.render();
	
		/* Datepicker konfigurieren */
		if (!this.datepicker.datepicker) {
			/* jQuery UI is not initialized properly :-( */
			var e = new Error("[ReservaDatePicker] jQuery UI Datepicker unavailable", this.datepicker.datepicker);
			if (window.Raven && Raven.isSetup()) {
				Raven.captureException(e);
			}
			throw e;
		}
	
		this.datepicker = this.datepicker.datepicker({
			dateFormat: 'yy-mm-dd',
			/* @todo Translation */
			altFormat: 'dd.mm.yy',
			dayNames: Translator.get("dayNames"),
			dayNamesMin: Translator.get("dayNamesMin"),
			dayNamesShort: Translator.get("dayNamesShort"),
			monthNames: Translator.get("monthNames"),
			monthNamesShort: Translator.get("monthNamesShort"),
			nextText: "&rarr;",
			prevText: "&larr;",
			weekHeader: "",
			showWeek: true,
			firstDay: 1,
			numberOfMonths: this.numberOfMonths,
			onSelect: this.onSelect,
			minDate: new Date(),
	
			beforeShowDay: (function (dd) {
				var c = [];
				var today = DateTime.resetTimeFields(new Date());
				var d = new Date(dd);
				var humandate = makeDate(dd);
				var selectable = true;
	
				var days = this.daysmodel ? this.daysmodel.get("days") : [];
				if (days.length > 0) {
					// Only show valid dates
					var seen = false;
					for (var i = 0, date; date = days[i]; ++i) {
						if (date.date != humandate) continue;
						seen = true;
						break;
					}
					if (seen) {
						c.push("available");
					} else {
						c.push("unavailable");
					}
				}
	
				if (+today > +d || !selectable) {
					c.push("day_past");
				}
	
				/* This is only needed for the first render,
	      after that the hover handler will take care of that */
				if (this.from && this.to && this.model.get("select_mode") !== "none") {
					if (+d === +this.from) c.push("selection-start");
					if (+d === +this.to) c.push("selection-end");
	
					if (+d >= +this.from && +d <= +this.to) {
						c.push("selected");
					}
					if (+d <= +this.from && +d >= +this.to && +d >= +today) {
						c.push("selected");
					}
				}
	
				if (d) {
					c.push("day_" + diffDate(this.diffBeginDate, d));
				};
				return [selectable, c.join(" "), ""];
			}).bind(this)
	
		});
	
		// Am Ende das ermittelte Datum überall übernehmen
		this.setFrom(DateTime.resetTimeFields(from));
		this.setTo(DateTime.resetTimeFields(to));
	
		logVars("InitialDate", { from: this.from, to: this.to });
	
		this.datepicker.datepicker("setDate", null); // unset default date
		this.datepicker.find('.ui-datepicker-current-day').removeClass('ui-datepicker-current-day');
		this.datepicker.find('.ui-state-active').removeClass('ui-state-active');
	
		this.datepicker.on("mouseenter", "td", function (e) {
			if (e.isTrigger) {
				/* Sometimes the jQuery UI DatePicker sends fake events. Ignore them. */
				return;
			}
			self.cellHoverHandler(e, this);
		});
	
		// Maus-Position fürs Tooltip tracken
		$(document).mousemove((function (e) {
			this.pointerX = e.pageX;
			this.pointerY = e.pageY;
		}).bind(this));
	
		/* Infotext einmal rendern */
		this.infotext.html(TemplateCache.render("datepicker-item-info", {
			item: this.daysmodel.toJSON()
		}));
	
		if (this.app) this.app.trigger("DatePicker.Initialized");
		this.initialized = true;
	};
	
	/**
	 * Click-Handler für Daten
	 */
	ReservaDatePicker.prototype.onSelect = function (dateText, inst) {
		logVars("[DatePicker.onSelect] state:", { from: this.from, to: this.to, currentlySelectedDaysCount: this.currentlySelectedDaysCount });
	
		/* Prevent selection if day is unavailable. And show a tooltip. */
		var dayslist = this.daysmodel.get("days");
		if (dayslist.length > 0) {
			var select_from_obj = _.find(dayslist, function (item) {
				return item.date == dateText;
			});
			if (!select_from_obj && this.currentlySelectedDaysCount === 0) {
				var tooltip = Translator.get("no_arrival");
				this.setTooltip(tooltip);
				setTimeout((function () {
					this.disableTooltip();
				}).bind(this), 2000);
				/* @todo Make this more clever */
				return false;
			}
		}
	
		this.disableTooltip();
	
		/* Falls der User einen Tag gegen Ende des letzten wählbaren Monats ausgewählt hat,
	       den Kalender eins weiter springen lassen um eine Auswahl für den nächsten Monat zu ermöglichen.
	 */
	
		// parseInt(parts[1], 10) === this.datepicker.datepicker("getDate").getMonth() + 1 &&
		/*
	 let parts = dateText.split('-');
	 if ( parts[2] > 14 ) {
	 	setTimeout(() => this.datepicker.find('.ui-datepicker-next').click(), 1000);
	 }
	 */
	
		var from, to;
	
		if (this.currentlySelectedDaysCount == 0) {
			/* Schritt 1: Start-Datum auswählen */
	
			this.previousFrom = this.from;
			this.previousTo = this.to;
	
			from = parseDate(dateText);
			this.setTo(null);
			this.currentlySelectedDaysCount = diffDate(this.diffBeginDate, parseDate(dateText));
			this.selectedDaysCount = diffDate(this.diffBeginDate, parseDate(dateText));
	
			this.setTooltip(this.tooltipInitialText);
			if (this.app && !this.app.get("isTouchDevice")) {
				var startX = this.pointerX;
				var startY = this.pointerY;
			}
	
			if (this.model.get("select_mode") === "none") {
				this.model.set("select_mode", "exact");
			}
	
			this.container.addClass('selecting');
		} else {
			/* Schritt 2: End-Datum auswählen */
			from = this.from;
			to = parseDate(dateText);
	
			/* Swap reverse selection */
			if (+from > +to) {
				to = this.from;
				from = parseDate(dateText);
			}
			this.currentlySelectedDaysCount = 0;
			this.container.removeClass('selecting');
		}
	
		if (from) DateTime.resetTimeFields(from);
		if (to) DateTime.resetTimeFields(to);
	
		if (+from === +to) {
			this.runAwayScreaming();
	
			// Start + End on the same day. Doesn't work for us.
			return;
		}
	
		if (from) {
			this.setFrom(from);
		}
	
		if (to) {
			this.setTo(to);
		}
	
		this.datepicker.datepicker("refresh");
		if (this.from && this.to) {
			if (this.app) {
				this.app.trigger("DatePicker.dateSelected", this);
			}
		}
	
		logVars("[DatePicker.onSelect] state2:", { from: this.from, to: this.to, currentlySelectedDaysCount: this.currentlySelectedDaysCount });
	};
	
	ReservaDatePicker.prototype.setFrom = function (from) {
		if (typeof from === "string") {
			/* We expecent internally a Date object, but our model gets only a string for form processing */
			from = parseDate(from);
		}
	
		if (this.from === from) return;
		this.from = from;
	
		var from_date = from === null ? "" : makeDate(this.from);
	
		this.from_input.val(from_date);
	
		var new_values = {};
		new_values[this.from_field] = from ? from_date : null;
		if (this.to && this.model.get("select_mode") !== "flex") {
			new_values.nights = DateTime.moment(this.to).diff(DateTime.moment(this.from), 'days');
		}
		this.modelChanging = true;
		this.model.set(new_values);
		this.modelChanging = false;
	};
	
	ReservaDatePicker.prototype.setTo = function (to, find_a_name_for_me) {
		if (typeof to === "string") {
			/* We expecent internally a Date object, but our model gets only a string for form processing */
			to = parseDate(to);
		}
	
		if (this.to === to) return;
		this.to = to;
	
		var to_date = to === null ? "" : makeDate(this.to);
	
		this.to_input.val(to_date);
	
		var new_values = {};
		new_values[this.to_field] = to ? to_date : null;
	
		if (this.model.get("select_mode") !== "flex") {
			new_values.nights = Math.abs(DateTime.moment(this.to).diff(DateTime.moment(this.from), 'days'));
		}
	
		this.modelChanging = true;
		this.model.set(new_values);
		this.modelChanging = false;
	
		if (this.to && !find_a_name_for_me) {
			this.datepicker.datepicker("setDate", this.from);
		}
	};
	
	ReservaDatePicker.prototype.setTooltip = function (text) {
		if (this.isTouchDevice) return;
		this.last_tooltip = text;
		this.tooltip.set(text);
	};
	
	ReservaDatePicker.prototype.disableTooltip = function () {
		if (this.update_days_count_timer) {
			window.clearInterval(this.update_days_count_timer);
			this.update_days_count_timer = null;
		}
		this.last_tooltip = null;
		this.tooltip.hide();
	};
	
	/**
	 * Callback for mouseenter
	 *
	 * Because "this" is a special snowflake in JS, we do this dance to get the 'td' without using a self variable.
	 */
	ReservaDatePicker.prototype.cellHoverHandler = function (e, node) {
		if (this.app && this.app.get('isTouchDevice')) return;
		var day = getDayClass(node);
		var dayslist = this.daysmodel ? this.daysmodel.get("days") : [];
		var product_name = this.daysmodel ? this.daysmodel.get("name") : "";
		var min_nights = null;
		var max_nights = null;
		var valid_nights = [];
		var nights;
		var tooltip = null;
	
		/* Produktname in eigene Zeile, falls definiert */
		if (product_name) product_name += "<br>";
	
		if ($(e.currentTarget).hasClass('hasDatePicker')) return;
		if (!this.currentlySelectedDaysCount || !this.from) return;
	
		var from_m = moment(this.from);
		var new_to = addDays(this.from, day - this.currentlySelectedDaysCount);
	
		if (+new_to === +this.from) {
			nights = 1;
		} else if (+new_to > +this.from) {
			nights = diffDate(this.from, new_to);
		} else {
			if (this.canGoBackInTime) {
				nights = diffDate(new_to, this.from);
			} else {
				return;
			}
		}
	
		this.setTo(new_to, true);
	
		var select_from_date = makeDate(this.from);
		if (dayslist.length > 0) {
			var select_from_date = _.find(dayslist, function (item) {
				return item.date == select_from_date;
			});
			if (select_from_date) {
				if (typeof select_from_date.nights !== "undefined") {
					valid_nights = select_from_date.nights;
				} else {
					min_nights = select_from_date.min;
					max_nights = select_from_date.max;
				}
			} else {
				tooltip = Translator.get("no_arrival");
				return;
			}
		}
	
		// Limit date ranges
		if (valid_nights.length > 0 && nights > 0 && _.indexOf(valid_nights, nights) === -1) {
			this.invalid_nightscount = true;
		} else {
			this.invalid_nightscount = false;
		}
	
		var max_nightscount = this.model.get("select_mode") === "flex" ? 100 : 21;
	
		if (nights > max_nightscount) {
			this.invalid_nightscount = true;
		}
	
		if (nights > 0) {
			var nightstext = nights + " " + (nights > 1 ? Translator.get("nights") : Translator.get("night"));
			if (this.invalid_nightscount) {
				if (nights > max_nightscount) {
					//tooltip = `Eine Online-Buchung ist für maximal ${max_nightscount} Nächte möglich.`;
					tooltip = "DISABLE";
				} else {
	
					var valid_text;
					if (valid_nights.length > 1) {
						var valid_nights_copy = valid_nights.slice();
						var last_night = valid_nights_copy.pop();
						valid_text = valid_nights_copy.join(" ,") + " " + Translator.get("or") + " " + last_night;
					} else {
						valid_text = valid_nights[0].toString();
					}
	
					tooltip = product_name + Translator.get("available") + " " + valid_text + " " + Translator.get("overnight") + "<br>" + Translator.get("upon_arrival") + " " + from_m.format("LL");
				}
			} else {
				tooltip = nightstext;
			}
	
			/* Mindestaufenthalt an diesem Tag */
			if (!this.invalid_nightscount && min_nights !== null && nights < min_nights) {
				tooltip = product_name + Translator.get("min_stay") + " " + min_nights + " " + Translator.get("nights") + "<br>" + Translator.get("upon_arrival") + " " + from_m.format('LL');
				this.invalid_nightscount = true;
			}
	
			/* Maximale Anzahl Nächste */
			if (!this.invalid_nightscount && max_nights !== null && nights > max_nights) {
				tooltip = product_name + Translator.get("max") + " " + max_nights + " " + Translator.get("nights_available") + "<br>" + Translator.get("upon_arrival") + " " + from_m.format('LL');
				this.invalid_nightscount = true;
			}
		} else {
			// Tooltip deaktivieren, außer es ist der initiale Text (Hack)
			if (this.last_tooltip !== this.tooltipInitialText) {
				if (this.canGoBackInTime) {
					tooltip = "DISABLE";
				} else {
					tooltip = Translator.get("departure_date");
				}
			}
		}
	
		if (this.last_to != makeDate(this.to)) {
			// Refresh classes
			var start_index = diffDate(this.diffBeginDate, this.from);
			var end_index = diffDate(this.diffBeginDate, this.to);
	
			var cellclass = this.invalid_nightscount ? "invalid_nightscount" : "selected";
	
			this.datepicker.find('.invalid_nightscount').removeClass("invalid_nightscount");
			this.datepicker.find('.selected').removeClass("selected");
	
			/* Start/End classes */
			if (start_index !== end_index) {
				this.datepicker.find('.day_' + start_index).addClass("selection-start");
				this.datepicker.find('.day_' + end_index).addClass("selection-end");
			}
	
			/* Anything before the start */
			for (var i = 2; i <= start_index; ++i) {
				this.datepicker.find('.day_' + i).addClass('unavailable');
			}
	
			/* Selected classes */
			if (end_index === start_index) {
				this.datepicker.find('.day_' + start_index).addClass(cellclass);
			} else if (end_index > start_index) {
				for (var i = start_index; i <= end_index; ++i) {
					this.datepicker.find('.day_' + i).addClass(cellclass);
				}
			} else {
				if (this.canGoBackInTime) {
					for (var i = start_index; i > end_index - 1; --i) {
						this.datepicker.find('.day_' + i).addClass(cellclass);
					}
				}
			}
	
			this.last_to = makeDate(this.to);
		}
	
		if (tooltip) {
			if (tooltip === "DISABLE") {
				this.disableTooltip();
			} else {
				this.setTooltip(tooltip);
			}
		}
	};
	
	ReservaDatePicker.prototype.boxCheck = function () {
	
		// Calculate the datepicker box to prevent strange tooltip positions
		if (!this.container_box_bounds) {
			var container = this.container;
	
			var offset = container.offset();
			this.container_box_bounds = {
				x1: offset.left,
				y1: offset.top,
				x2: offset.left + container.outerWidth(),
				y2: offset.top + container.outerHeight()
			};
		}
	
		/* Check if the mouse pointer is inside the datepicker box
	 	  x1,y1
	 	+--------+
	 	| Px,Py  |
	 	|   +    |
	 	+--------+
	 			x2,y2
	 */
		var box = this.container_box_bounds;
		this.inside_container = this.pointerX >= box.x1 && this.pointerY >= box.y1 && this.pointerX <= box.x2 && this.pointerY <= box.y2;
	
		if (!this.inside_container && this.currentlySelectedDaysCount) {
			if (!this.firstSeenOutside) {
				this.firstSeenOutside = new Date().getTime();
			}
			var now = new Date().getTime();
			if (now - this.firstSeenOutside > 1500) {
				this.runAwayScreaming();
	
				// User has left the DatePicker for 1.5 seconds, request it's close through the app
				this.firstSeenOutside = null;
			}
		} else {
			this.firstSeenOutside = null;
		}
	};
	
	ReservaDatePicker.prototype.runAwayScreaming = function () {
		if (this.isTouchDevice) {
			return;
		}
	
		this.disableTooltip();
		this.currentlySelectedDaysCount = 0;
		this.setFrom(this.previousFrom);
		this.setTo(this.previousTo);
	
		if (this.previousFrom) {
			this.datepicker.datepicker("setDate", null);
		}
	
		this.datepicker.datepicker("refresh");
		this.container.removeClass('selecting');
	};
	
	/**
	 * Aufrufen, wenn der DatePicker geöffnet wurde. Registriert Timer.
	 */
	ReservaDatePicker.prototype.opened = function () {
		this.boxCheckInterval = window.setInterval(this.boxCheck, 100);
		this.isOpen = true;
	};
	
	/**
	 * Aufrufen, wenn der DatePicker wieder geschlossen wurde.
	 * Deaktiviert alle Timer und deaktiviert den Tooltip.
	 */
	ReservaDatePicker.prototype.closed = function () {
		if (!this.isOpen) return;
		this.isOpen = false;
	
		window.clearInterval(this.boxCheckInterval);
		this.boxCheckInterval = null;
	
		this.disableTooltip();
		this.container.removeClass('selecting');
	};
	
	/**
	 * Wird aufgerufen, wenn die Controls Fokus bekommen.
	 * Falls wir gerade in einer Auswahl sind, wird diese beendet.
	 */
	ReservaDatePicker.prototype.handleControlInputFocus = function () {
		if (this.isTouchDevice) {
			return;
		}
	
		if (this.currentlySelectedDaysCount !== 0) {
	
			this.disableTooltip();
			this.currentlySelectedDaysCount = 0;
	
			this.container.removeClass('selecting');
		}
	};
	
	/* Example:
	var DatePicker = new ReservaDatePicker();
	DatePicker.init();
	
	*/
	
	/**
	 * Helper functions
	 */
	
	function getDayClass(o) {
		return $.grep(o.className.split(" "), function (v, i) {
			return v.indexOf('day_') === 0;
		}).join().replace("day_", "");
	}
	
	/* @todo Replace with DateTime.parse */
	function parseDate(d) {
		var parts = d.split("-");
		return new Date(parts[0], parts[1] - 1, parts[2]);
	}
	
	/* @todo Replace with moment(to).diff(from, 'days') */
	function diffDate(from, to) {
		return Math.round((to - from) / (1000 * 60 * 60 * 24));
	}
	
	/* @todo Replace with moment(date).add(days, 'days') */
	function addDays(date, days) {
		var result = new Date(date);
		result.setDate(date.getDate() + days);
		return result;
	}
	
	/* @todo Replace with moment(d).format('YYYY-MM-DD') */
	function makeDate(d) {
		if (!d) {
			return;
		};
		return d.getFullYear() + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2);
	}
	
	/**
	 * Debug helper: Print a prefix + a bunch of variables
	 */
	var logVars = function logVars(prefix, variables) {};
	
	module.exports = ReservaDatePicker;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	Todo: Submit Handler bei dateSelect raus (ist in den Templates meistens)
	
	Modes:
	
	    Ohne:
	        - from = null, to = null
	        - Keine Auswahl im Kalender anzeigen
	        - Bei Auswahl im Kalender auf "Exakt" springen
	
	    Range:
	        - Klassischer Datepicker mit Auswahl
	
	    Flexibel:
	        - Auswahl der Nächte in einem Zeitraum, der Datepicker ignoriert dann die maximalen buchbaren Tage bei der Auswahl
	*/
	
	'use strict';
	
	var $ = __webpack_require__(6);
	var Backbone = __webpack_require__(20);
	
	var DateTime = __webpack_require__(40);
	var TemplateCache = __webpack_require__(25);
	var Registry = __webpack_require__(26);
	
	var DatepickerControlsView = Backbone.View.extend({
	    /* model = ReservaDatePicker */
	
	    events: {
	        'click .modes span': 'handleChangeMode',
	        'change select[name="control-nights"]': 'handleChangeNights',
	        'change input[name="control-from"]': 'handleChangeFrom',
	        'change input[name="control-to"]': 'handleChangeTo',
	        'focus input[name="control-from"]': 'handleFocus',
	        'focus input[name="control-to"]': 'handleFocus',
	        'keydown input[name="control-from"]': 'preventSubmitFrom',
	        'keydown input[name="control-to"]': 'preventSubmitTo',
	        'click .datepicker-close': 'closeDatepicker'
	    },
	
	    constructor: function constructor(options) {
	        this.datepicker = options.datepicker;
	        Backbone.View.apply(this, arguments);
	    },
	
	    initialize: function initialize() {
	        this.listenTo(this.model, "change:select_mode change:nights change:from change:to", this.render);
	        this.nextFocus = null;
	    },
	
	    render: function render() {
	        var data = this.model.toJSON();
	
	        /* Bei nativen HTML Datepickern brauchen wir wieder das US-Format ... */
	        var format = this.model.get("isTouchDevice") ? "YYYY-MM-DD" : "L";
	
	        data.from_human = data.from ? DateTime.parse(data.from).format(format) : "";
	        data.to_human = data.to ? DateTime.parse(data.to).format(format) : "";
	
	        this.$el.html(TemplateCache.render("datepicker-controls", data));
	
	        if (this.nextFocus) {
	            this.$el.find(this.nextFocus).focus();
	        }
	    },
	
	    /*
	     DOM handlers
	    */
	    handleChangeMode: function handleChangeMode(e) {
	        e.preventDefault();
	        var target = $(e.currentTarget);
	        var new_mode = target.data('mode');
	
	        this.model.set("select_mode", new_mode);
	    },
	
	    handleChangeNights: function handleChangeNights(e) {
	        var new_nights = e.currentTarget.value;
	        var diff = new_nights - this.model.get("nights");
	        var to = DateTime.parse(this.model.get("to"));
	
	        if (!to) to = DateTime.parse(this.model.get("from"));
	        if (!to) return;
	
	        if (this.model.get("select_mode") === "flex") {
	            this.model.set("nights", new_nights);
	            return;
	        }
	
	        if (diff > 0) {
	            to.add(diff, 'days');
	        } else {
	            to.subtract(diff * -1, 'days');
	        }
	
	        /* "nights" wird vom DatePicker neu berechnet und gesetzt */
	        this.datepicker.setTo(to._d);
	        this.datepicker.datepicker.datepicker("refresh");
	    },
	
	    handleChangeFrom: function handleChangeFrom(e) {
	        if (this.model.get("select_mode") === "flex") return;
	
	        var now = DateTime.resetTimeFields(DateTime.moment());
	        var new_from = DateTime.parse(e.currentTarget.value, true);
	        var new_to = null;
	
	        if (new_from.isValid()) {
	            if (new_from.isBefore(now)) {
	                new_from = now;
	            }
	
	            this.nextFocus = "input[name=control-to]";
	
	            var new_to = new_from.clone();
	            new_to.add(this.model.get("nights"), "days");
	
	            if (+new_from._d === +new_to._d) {
	                new_to.add(1, "days");
	            }
	
	            this.datepicker.setFrom(new_from._d);
	            this.datepicker.setTo(new_to._d);
	            this.datepicker.datepicker.datepicker("refresh");
	
	            this.nextFocus = null;
	        } else {
	            this.nextFocus = "input[name=control-from]";
	            this.render();
	        }
	    },
	
	    handleChangeTo: function handleChangeTo(e) {
	        if (this.model.get("select_mode") === "flex") return;
	
	        var now = DateTime.resetTimeFields(DateTime.moment());
	        var new_to = DateTime.parse(e.currentTarget.value, true);
	        var current_from = DateTime.parse(this.model.get("from"), true);
	
	        if (new_to && new_to.isValid() && current_from && current_from.isValid()) {
	            this.nextFocus = "input[name=control-from]";
	
	            if (+current_from._d === +new_to._d) {
	                new_to.add(1, "days");
	            }
	
	            if (new_to.isBefore(now)) {
	                /* Are you kidding me? */
	                new_to = now.clone();
	                new_to.add(this.model.get("nights"), "days");
	
	                this.datepicker.setFrom(now._d);
	                this.datepicker.setTo(new_to._d);
	            } else if (new_to.isBefore(current_from)) {
	                /* Users are insane */
	                this.datepicker.setFrom(new_to._d);
	                this.datepicker.setTo(current_from._d);
	            } else {
	                this.datepicker.setTo(new_to._d);
	            }
	
	            this.datepicker.datepicker.datepicker("refresh");
	            this.nextFocus = null;
	        } else {
	            this.nextFocus = "input[name=control-to]";
	            this.render();
	        }
	    },
	
	    handleFocus: function handleFocus(e) {
	        this.datepicker.handleControlInputFocus();
	    },
	
	    preventSubmitFrom: function preventSubmitFrom(e) {
	        if (e.keyCode == 13) {
	            e.preventDefault();
	            this.$el.find('input[name=control-to]').focus();
	        }
	    },
	
	    preventSubmitTo: function preventSubmitTo(e) {
	        var _this = this;
	
	        if (e.keyCode == 13) {
	            e.preventDefault();
	            this.$el.find('input[name=control-to]').blur();
	            setTimeout(function () {
	                _this.datepicker.app.trigger("DatePicker.dateSelected", _this.datepicker);
	            }, 0);
	        }
	    },
	
	    closeDatepicker: function closeDatepicker() {
	        this.datepicker.app.hideDatepicker();
	    }
	
	});
	
	module.exports = DatepickerControlsView;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Tooltip
	 */
	
	"use strict";
	
	var _ = __webpack_require__(7);
	
	/**
	 * Create a new tooltip instance.
	 *
	 * Options:
	 * - box: Element for boundary check
	 * - tooltip: Tooltip element (optional). Will be created on demand.
	 * - className: Class for styling (only for auto-generated tooltips)
	 */
	var Tooltip = function Tooltip(options) {
		_.bindAll(this, "updatePosition", "set", "hide", "boxHasChanged");
	
		this.box = null;
		this.tooltip = null;
		this.className = "";
		this.boxTransform = function (box) {
			return box;
		};
		_.extendOwn(this, options);
	
		if (!this.tooltip) {
			this.tooltip = $('<div>').addClass(this.className).css({
				"position": "absolute",
				"z-index": 9999
			});
			this.tooltip.appendTo('body');
		}
	
		/* Mapping of {x1, x2, y1, y2} of this.box */
		this.box_rect = null;
		/* Bool: Is the mouse inside box_rect? */
		this.inside_box = false;
		/* Last tooltip text */
		this.last_tooltip = null;
		/* Timeout for calling updatePosition */
		this.update_timer = null;
		/* Timeout for boxCheck */
		this.box_timer = null;
	
		/* Tracking of mouse position. */
		this.pointerX = -1000;
		this.pointerY = -1000;
		this.previousPointerX = -1000;
		this.previousPointerY = -1000;
	
		$(document).mousemove((function (e) {
			this.pointerX = e.pageX;
			this.pointerY = e.pageY;
		}).bind(this));
	};
	
	/**
	 * Set or override the tooltip content. Also shows and updates the position.
	 *
	 * @param text {String} Tooltip content. Can be any HTML.
	 */
	Tooltip.prototype.set = function (text) {
		this.last_tooltip = text;
		this.tooltip.html(text);
		this.updatePosition();
	};
	
	/**
	 * Hide the tooltip and reset display timers.
	 */
	Tooltip.prototype.hide = function () {
		if (this.update_timer) {
			window.clearInterval(this.update_timer);
			this.update_timer = null;
		}
		this.last_tooltip = null;
		this.tooltip.hide();
	};
	
	/**
	 * Notifies the tooltip if the size of the box has changed. Needed for a correct box check.
	 */
	Tooltip.prototype.boxHasChanged = function () {
		this.box_rect = null;
	};
	
	/**
	 * Internal: Check if the pointer is currently inside the bounding box.
	 * Sets the attributes inside_box.
	 */
	Tooltip.prototype.boxCheck = function () {
		if (!this.box.length || !this.box.offset) {
			this.inside_box = false;
			return;
		}
	
		// Calculate the box rectangle to prevent strange tooltip positions
		if (!this.box_rect) {
			var box = this.box;
			var offset = box.offset();
			this.box_rect = this.boxTransform({
				x1: offset.left,
				y1: offset.top,
				x2: offset.left + box.outerWidth(),
				y2: offset.top + box.outerHeight()
			});
		}
	
		/* Check if the mouse pointer is inside the box
	 	  x1,y1
	 	+--------+
	 	| Px,Py  |
	 	|   +    |
	 	+--------+
	 			x2,y2
	 */
		var box = this.box_rect;
		/* Wir haben einen "Puffer" von 10 Pixel außerhalb der Box da Browser manchmal zu langsam sind
	    die Maus-Position schnell genug zu aktualisieren und wir dann beim Boxcheck einen alten
	    Wert haben, der noch außerhalb der Box ist. */
		this.inside_box = this.pointerX >= box.x1 - 10 && this.pointerY >= box.y1 - 10 && this.pointerX <= box.x2 + 10 && this.pointerY <= box.y2 + 10;
	};
	
	/**
	 * Internal: Update the position of the tooltip and show/hide it depending on position.
	 */
	Tooltip.prototype.updatePosition = function () {
		if (this.last_tooltip === null) {
			return;
		}
	
		this.boxCheck();
		if (this.inside_box) {
			if (this.previousPointerY !== this.pointerY || this.previousPointerX !== this.pointerX) {
				//console.log(`[Tooltip] position -> (${this.pointerX + 15}, ${this.pointerY + 15})`);
				this.tooltip.show().css({
					top: this.pointerY + 15,
					left: this.pointerX + 15
				});
	
				this.previousPointerY = this.pointerY;
				this.previousPointerX = this.pointerX;
			}
		} else {
			this.last_tooltip = null; // @todo configurable?
			this.tooltip.hide();
		}
	
		this.update_timer = setTimeout(this.updatePosition, 1000 / 30);
	};
	
	module.exports = Tooltip;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $ = __webpack_require__(6);
	var Backbone = __webpack_require__(20);
	
	var TemplateCache = __webpack_require__(25);
	
	var getPeopleStructure = __webpack_require__(35);
	
	module.exports = Backbone.View.extend({
	
		events: {
			'click .dropdown span': 'handleClick',
			'change select': 'handleChange'
		},
	
		initialize: function initialize() {
			this.listenTo(this.model, "change", this.render);
			this.focusNextRender = null;
		},
	
		render: function render() {
			var model = this.model;
	
			this.lastRenderStructure = getPeopleStructure(this.model);
			this.el.innerHTML = TemplateCache.render('reserva-people-template', {
				items: this.lastRenderStructure,
				model: model
			});
	
			if (this.focusNextRender) {
				this.$el.find('select[name="' + this.focusNextRender + '"]').focus();
				this.focusNextRender = null;
			}
		},
	
		handleClick: function handleClick(e) {
			e.preventDefault();
			var link = $(e.currentTarget);
			var parent = link.parents('.dropdown');
	
			this.model.set(parent.data('key'), link.data('value'));
		},
	
		handleChange: function handleChange(e) {
			var select = e.currentTarget;
			var key = select.name;
			var oldValue = this.model.get(key);
			var newValue = select.options[select.selectedIndex].value;
	
			/* This hack is needed for a race condition when new options appear after changing the values */
			this.model.attributes[key] = newValue;
	
			var takeNext = false;
			for (var i = 0, item; item = this.lastRenderStructure[i]; ++i) {
				if (takeNext && item.type === "select" && item.condition(this.model)) {
					this.focusNextRender = item.key;
					break;
				}
				if (item.key == select.name) {
					takeNext = true;
				}
			};
	
			this.model.attributes[key] = oldValue;
			this.model.set(select.name, select.options[select.selectedIndex].value);
		}
	
	});

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Tramino API Benchmark
	 */
	
	'use strict';
	
	var template = __webpack_require__(46);
	var StyleTemplate = __webpack_require__(47);
	
	var Backbone = __webpack_require__(20);
	var BenchmarkModel = Backbone.Model.extend({});
	
	var BenchmarkView = Backbone.View.extend({
	
		id: 'api-benchmark',
		className: 'timebar hidden',
	
		events: {
			'click h1': 'toggle',
			'mouseenter h1': 'show',
			'mouseleave': 'hide',
			'mouseenter div[data-index]': 'hover',
			'mouseleave div[data-index]': 'unhover'
		},
	
		render: function render() {
			this.el.innerHTML = template(this.model.attributes);
		},
	
		show: function show(e) {
			this.$el.removeClass('hidden');
		},
	
		hide: function hide(e) {
			this.$el.addClass('hidden');
		},
	
		toggle: function toggle(e) {
			this.$el.toggleClass('fixed');
		},
	
		hover: function hover(e) {
			var index = $(e.currentTarget).data('index');
			this.$el.find('div[data-index=' + index + ']').addClass('hovered');
		},
	
		unhover: function unhover(e) {
			this.$el.find('.hovered').removeClass('hovered');
		}
	});
	
	var process = function process(benchmark) {
		var results = benchmark.results;
	
		var data = {
			min: 0.0,
			max: 0.0,
			total: 0.0,
			results: [],
			extra: benchmark.extra
		};
	
		for (var i = 0, result; result = results[i]; ++i) {
			if (data.min > result.start) data.min = result.start;
			if (data.max < result.end) data.max = result.end;
			result.duration = result.end - result.start;
		}
		data.total = data.max - data.min;
	
		for (var i = 0, result; result = results[i]; ++i) {
			result.startPercent = result.start / data.total * 100;
			result.endPercent = result.end / data.total * 100;
			result.left = result.startPercent + '%';
			result.width = result.endPercent - result.startPercent + '%';
			result.color = i % 20 + 1;
	
			data.results.push(result);
		}
	
		return new BenchmarkModel(data);
	};
	
	var view;
	var initialized = false;
	
	module.exports = {
		init: function init() {
			if (initialized) return;
			$('body').append(StyleTemplate());
	
			view = new BenchmarkView({
				model: new BenchmarkModel()
			});
	
			$('body').append(view.el);
			initialized = true;
		},
		render: function render(benchmark) {
			if (!initialized) throw new Error("ApiBench is not initialized");
	
			view.model = process(benchmark);
			view.render();
		},
		process: process
	};

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<h1 class="hideable">API-Analyse</h1>\n\n<div class="blocks hideable">\n	';
	 _.each(results, function(r, index) { 
	__p+='\n		<div style="left: '+
	((__t=( r.left ))==null?'':__t)+
	'; width: '+
	((__t=( r.width ))==null?'':__t)+
	'; z-index: '+
	((__t=( r.depth * 1000 ))==null?'':__t)+
	'"\n			 class="block depth-'+
	((__t=( r.depth ))==null?'':__t)+
	' color-'+
	((__t=( r.color ))==null?'':__t)+
	'" data-index="'+
	((__t=( index ))==null?'':__t)+
	'"\n			 title="'+
	((__t=( r.title ))==null?'':__t)+
	' ('+
	((__t=( r.start ))==null?'':__t)+
	' - '+
	((__t=( r.end ))==null?'':__t)+
	'; '+
	((__t=( r.duration ))==null?'':__t)+
	' ms)"\n		></div>\n	';
	 }); 
	__p+='\n\n	<div class="min">\n		'+
	((__t=( min ))==null?'':__t)+
	'\n	</div>\n	<div class="max">\n		'+
	((__t=( max ))==null?'':__t)+
	'\n	</div>\n</div>\n\n<div class="details hideable">\n	';
	 _.each(results, function(r, index) { 
	__p+='\n	<div style="margin-left: '+
	((__t=( (r.depth - 1) * 20 ))==null?'':__t)+
	'px"\n		 class="color-'+
	((__t=( r.color ))==null?'':__t)+
	'" data-index="'+
	((__t=( index ))==null?'':__t)+
	'"\n		 ';
	 if ( r.detail ) { 
	__p+='data-detail="'+
	((__t=( r.detail ))==null?'':__t)+
	'"';
	 } 
	__p+='\n	>\n		<b>'+
	((__t=( r.title ))==null?'':__t)+
	'</b>\n		<span>'+
	((__t=( Math.round(r.duration) ))==null?'':__t)+
	' ms</span>\n	</div>\n	';
	 }); 
	__p+='\n\n	<hr>\n\n	<div class="color-20">\n		<b>Response Time</b>\n		<span>'+
	((__t=( total ))==null?'':__t)+
	' ms</span>\n	</div>\n\n	<hr>\n\n</div>\n\n<h1>API-Analyse</h1>\n\n';
	}
	return __p;
	};

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<style>\n.timebar {\n	position: fixed;\n	bottom: 0;\n	right: 0;\n	width: 400px;\n	z-index: 9999;\n}\n\n.timebar .hovered {\n	background: red !important;\n}\n\n.timebar.hidden:not(.fixed) {\n	width: auto;\n}\n.timebar.hidden:not(.fixed) .hideable {\n	display: none;\n}\n.timebar.fixed h1 {\n	background: #6A7677;\n}\n\n.timebar h1 {\n	background: #95A5A6;\n	padding: 4px 14px;\n	margin: 0;\n	color: white;\n	font-size: 14px;\n	line-height: 16px;\n	cursor: pointer;\n	text-align: right;\n}\n\n.timebar .blocks { position: relative; height: 70px; }\n.timebar .block {\n	position: absolute;\n	border-left: 1px solid rgb(20, 20, 20);\n	border-bottom: 1px solid rgb(20, 20, 20);\n}\n\n.timebar .block.depth-1 { height: 100%; }\n.timebar .block.depth-2 { height: 80%; }\n.timebar .block.depth-3 { height: 60%; }\n.timebar .block.depth-4 { height: 40%; }\n.timebar .block.depth-5 { height: 20%; }\n.timebar .color-1 { background: #1ABC9C; }\n.timebar .color-2 { background: #16A085; }\n.timebar .color-3 { background: #2ECC71; }\n.timebar .color-4 { background: #27AE60; }\n.timebar .color-5 { background: #3498DB; }\n.timebar .color-6 { background: #2980B9; }\n.timebar .color-7 { background: #9B59B6; }\n.timebar .color-8 { background: #8E44AD; }\n.timebar .color-9 { background: #34495E; }\n.timebar .color-10 { background: #2C3E50; }\n.timebar .color-11 { background: #F1C40F; }\n.timebar .color-12 { background: #F39C12; }\n.timebar .color-13 { background: #E67E22; }\n.timebar .color-14 { background: #D35400; }\n.timebar .color-15 { background: #E74C3C; }\n.timebar .color-16 { background: #C0392B; }\n.timebar .color-17 { background: #ECF0F1; }\n.timebar .color-18 { background: #BDC3C7; }\n.timebar .color-19 { background: #95A5A6; }\n.timebar .color-20 { background: #7F8C8D; }\n.timebar .min { position: absolute; top: 2px; left: 4px; z-index: 999999; color: white; font-size: 8pt; }\n.timebar .max { position: absolute; top: 2px; right: 4px; z-index: 999999; color: white; font-size: 8pt;  }\n.timebar .clear { clear: both; margin-bottom: 1em; }\n.timebar hr { border: 0; border-top: 5px solid black; margin: 0; }\n.timebar .details div { \n	color: white;\n	padding: 2px 4px;\n}\n.timebar .details div[data-detail] { cursor: pointer; }\n\n.timebar .details div span { float: right };\n\n</style>\n';
	}
	return __p;
	};

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	// General modules
	var $ = __webpack_require__(6);
	var _ = __webpack_require__(7);
	var Backbone = __webpack_require__(20);
	var Promise = __webpack_require__(2);
	var ajax = __webpack_require__(21);
	
	var SafeStorage = __webpack_require__(23);
	var MiniTimer = __webpack_require__(22);
	var TemplateCache = __webpack_require__(25);
	
	// App modules
	var SidebarView = __webpack_require__(49);
	var ResultView = __webpack_require__(50);
	var SortOrderView = __webpack_require__(51);
	
	var TraminoClientsMap = __webpack_require__(37);
	
	var Result = Backbone.Model.extend({});
	
	var ResultStore = Backbone.Collection.extend({
	    model: Result,
	
	    getVisible: function getVisible() {
	        return this.filter(function (result) {
	            return result.visible;
	        });
	    }
	
	});
	
	var BrowserApp = Backbone.Model.extend({
	
	    defaults: function defaults() {
	        return {
	            /* Parameters */
	            group: null, /* Partnergruppe (client_group) */
	            tagGroupFilter: [], /* Auf bestimmte Tag-Gruppen filtern */
	
	            /* State */
	            selectedTags: [],
	            searchQuery: "", /* Aktuelle Suchanfrage */
	            sortBy: 'auto', /* auto, stars, ratings, price */
	            tagsCount: {}, /* Mapping of tag_id => Count */
	            tab: "list", /* list, map */
	            isTouchDevice: false, /* Sind wir auf Mobile? */
	            favoritesOnly: false };
	    },
	
	    /* Nur Favoriten anzeigen? */
	    //
	    // Lifecycle Methods
	    //
	
	    /**
	     * Grundsätzlichen Zustand der Anwendung intialisieren.
	     */
	    initialize: function initialize() {
	        if (typeof window.Raven !== "undefined") {
	            Raven.setTagsContext({ app: "browser" });
	        }
	
	        if (!this.get("group")) {
	            throw new Error("Missing group for BrowserApp");
	        }
	
	        // Collection of all retrieved results
	        this.resultStore = new ResultStore();
	
	        // Mapping of client_id => ResultView
	        this.resultViews = {};
	
	        // List of tag groups and their tags (sidebar data source)
	        // [ { name: "", items: [ { id, tag, count }, ... ] }, .. ]
	        this.tagGroups = [];
	
	        // Mapping of { tag_id => [ clients ] }
	        this.tagMapping = {};
	
	        // Mapping of { class => [ tag_id, ...] }
	        this.clientTagMapping = {};
	
	        // Mapping of { tag_id => Results count }
	        this.tagCounts = {};
	
	        // TraminoClientsMap object, only initialized when the map tab was opened
	        this.map = null;
	
	        // How many items are rendered in a batch
	        this.renderBatchSize = 8;
	
	        _.bindAll(this, "processResults", "promiseError", "renderResults", "scrollHandler", "updateFavButton", "updateMapMarkers", "loadResults");
	
	        /* If it looks like a duck, assume it's one */
	        var isSomethingMobile = navigator.userAgent.match(/iPad|iPhone|Android|Windows Phone/i) !== null;
	        if (isSomethingMobile) {
	            this.set("isTouchDevice", true);
	        } else {
	            /* Touch device detection */
	            var handler = function handler() {
	                this.set("isTouchDevice", true);
	                $(document).off('touchstart', handler);
	            };
	            $(document).on('touchstart', handler);
	        }
	
	        /* Dem Template-Loader einen Hinweis geben, dass wir der Browser sind */
	        __webpack_require__(52).setPrefix('browser/');
	    },
	
	    run: function run() {
	        /* Validierung */
	        if (typeof window.TraminoFavoriten === "undefined") {
	            throw new Error("Reserva: window.TraminoFavoriten ist nicht definiert.");
	        }
	
	        /* Bei Änderung der Tags oder Suche die Ergebnisse filtern und neu rendern */
	        this.on('change:selectedTags', function (e) {
	            this.filterResults();
	            this.renderResults();
	            this.updateMapMarkers();
	            this.scrollUp();
	        });
	
	        /* Suche */
	        this.on('change:searchQuery', (function (e) {
	            // Stichwortsuche
	            var query = this.get("searchQuery").toLowerCase();
	            if (query.length > 2) {
	                this.renderResultsSearch(query);
	            } else {
	                this.$search_list.html("");
	                this.renderResults();
	            }
	        }).bind(this));
	
	        /* Namens-Filter */
	        var searchQueryInput = $('input[name="searchQuery"]');
	        searchQueryInput.on('keyup', _.debounce((function () {
	            this.set("searchQuery", searchQueryInput.val());
	        }).bind(this), 300));
	
	        /* Views vorbereiten */
	        this.sidebarView = new SidebarView({
	            el: document.getElementById('browser-sidebar'),
	            model: this
	        });
	        this.sortOrderView = new SortOrderView({
	            el: document.getElementById('sort_order'),
	            model: this
	        });
	        this.$list = $('#results-list');
	        this.$search_list = $('#results-search-list');
	        if (!this.$list.length) {
	            throw new Error("Result container not found: #results-list");
	        }
	
	        /* Rest der UI rendern */
	        this.sortOrderView.render();
	
	        /* Button für die Favoriten */
	        TraminoFavoriten.on('change:items', this.updateFavButton);
	        this.updateFavButton();
	
	        /* Sobald alles bereit ist die Clients laden */
	        this.loadTags().then(this.loadResults)['catch'](this.promiseError);
	
	        /* Scroll-Handler fürs Nach-Rendern von Ergebnissen */
	        $(window).on('scroll', _.throttle(this.scrollHandler, 200));
	
	        /* Tabs für Liste und Karte initialisieren */
	        var buttons = $('.result-tabs-buttons span');
	        var tabs = $('.result-tabs .tab');
	        var self = this;
	        buttons.on('click', function (e) {
	            var $this = $(this);
	            var tab = $this.data('href');
	            var $target = $('#tab-' + tab);
	            self.set("tab", tab);
	
	            buttons.removeClass('active');
	            tabs.removeClass('active');
	            $target.addClass('active');
	            $this.addClass('active');
	
	            // Wir sparen Zeit, wenn wir Google Maps nur einmal initialisieren und dann wiederverwerten
	            if (tab === "geo" && !self.map) {
	
	                // Karte erzeugen, aber noch keine Marker definieren. Diese laden wir danach erst per AJAX.
	                self.map = new TraminoClientsMap({
	                    target: 'partner-map',
	                    data: [], // Filled out later
	                    onClick: function onClick(e, marker, betrieb) {
	                        var view = self.resultViews[betrieb.id].clone();
	                        view.render();
	                        self.map.displayInfo(marker, view.el);
	                    }
	                });
	                self.map.init().then(function () {
	                    self.updateMapMarkers();
	                });
	            }
	
	            /* Sortierung bei der Karte ausblenden */
	            if (tab === "geo") {
	                $('.tabs .right').hide();
	            } else {
	                $('.tabs .right').show();
	            }
	        });
	
	        /* Drucken Button */
	        $('.print-group').on('click', (function () {
	            var resultIDs = this.resultStore.getVisible().map(function (result) {
	                return result.id;
	            });
	            location.search = "?mode=print&results=" + resultIDs.join(",");
	        }).bind(this));
	
	        /* Favoriten Filter */
	        var fav_btns = $('.fav-group span');
	        fav_btns.on('click', function (e) {
	            var current = $(this);
	            var href = current.data().href;
	
	            fav_btns.removeClass("active");
	            current.addClass("active");
	
	            if (href === "all") {
	                self.set("favoritesOnly", false);
	            }
	            if (href === "favs") {
	                self.set("favoritesOnly", true);
	            }
	
	            self.filterResults();
	            self.renderResults();
	            self.updateMapMarkers();
	        });
	    },
	
	    /**
	     * Favoriten-Button aktualisieren
	     */
	    updateFavButton: function updateFavButton(e) {
	        var count = 0;
	        var favs = TraminoFavoriten.getItemsMap();
	        this.resultStore.each(function (result) {
	            // n = 0 - 100
	            if (!result.visible) return;
	            if (typeof favs["clients-" + result.get("id")] !== "undefined") {
	                count++;
	            }
	        });
	        $('.fav-group span[data-href="favs"]').text(count === 0 ? "FAVORITEN" : count === 1 ? "1 FAVORIT" : count + " FAVORITEN");
	    },
	
	    /**
	     * Marker auf der Karte aktualisieren
	     */
	    updateMapMarkers: function updateMapMarkers() {
	        if (!this.map) return;
	        this.map.clearMarkers();
	        var clients = this.resultStore.getVisible().map(function (result) {
	            return {
	                id: result.id,
	                name: result.get("geo_name"),
	                lat: result.get("lat"),
	                lng: result.get("lng")
	            };
	        });
	        this.map.addMarkers(clients);
	
	        /* Karte neu ausrichten */
	        var bounds = new google.maps.LatLngBounds();
	        _.each(clients, function (b) {
	            if (b.lat && b.lng) {
	                bounds.extend(new google.maps.LatLng(b.lat, b.lng));
	            }
	        });
	
	        /* Verhindern dass wir zu nah zoomen */
	        if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
	            var extendPoint1 = new google.maps.LatLng(bounds.getNorthEast().lat() + 0.01, bounds.getNorthEast().lng() + 0.01);
	            var extendPoint2 = new google.maps.LatLng(bounds.getNorthEast().lat() - 0.01, bounds.getNorthEast().lng() - 0.01);
	            bounds.extend(extendPoint1);
	            bounds.extend(extendPoint2);
	        }
	
	        this.map.map.setCenter(bounds.getCenter());
	        this.map.map.fitBounds(bounds);
	    },
	
	    /**
	     * Nicht anderweitig abgefangene Promise-Fehler behandeln
	     */
	    promiseError: function promiseError(e) {
	        if (typeof window.Raven !== "undefined") {
	            Raven.captureException(e);
	        }
	    },
	
	    /**
	     * Sammelt alle URL-Parameter und gibt diese als Objekt zurück.
	     */
	    getQueryParameters: function getQueryParameters() {
	        var url = decodeURIComponent(window.location.search.substring(1));
	        var variables = url.split('&');
	        var parameters = {};
	
	        for (var i = 0, part; part = variables[i]; i++) {
	            var keyvalue = part.split('=');
	            parameters[keyvalue[0]] = keyvalue[1];
	        }
	        return parameters;
	    },
	
	    //
	    // Model methods
	    //
	
	    loadTags: function loadTags() {
	        var timer = MiniTimer("Load Tags");
	
	        var handler = (function (response) {
	            timer();timer = MiniTimer("Parse Tags");
	
	            this.tagGroups = [];
	            this.tagMapping = {};
	            this.clientTagMapping = {};
	
	            var currentGroupName = null;
	            var currentGroupId = null;
	            var currentTags = [];
	
	            for (var i = 0, result; result = response.tags_info[i]; ++i) {
	                // result = { order, group, id, tag, [clients] }
	                if (!currentGroupName) currentGroupName = result.group;
	                if (!currentGroupId) currentGroupId = result.group_id;
	                if (currentGroupName != result.group) {
	                    this.tagGroups.push({
	                        id: currentGroupId,
	                        name: currentGroupName,
	                        tags: currentTags
	                    });
	                    currentGroupName = result.group;
	                    currentGroupId = result.group_id;
	                    currentTags = [];
	                }
	
	                currentTags.push({
	                    id: result.id,
	                    tag: result.tag,
	                    count: null });
	
	                /* null = Unknown count */
	                var clients = result.clients.split(',');
	
	                /* Wir erzeugen hier ein Mapping von tag_id => Array von Clients.
	                   Dies ermöglicht es uns später, schnell anhand der ausgewählten Tags die Ergebnisse zu filtern */
	                for (var j = 0, client_id; client_id = clients[j]; ++j) {
	                    if (typeof this.tagMapping[result.id] === "undefined") {
	                        this.tagMapping[result.id] = [];
	                    }
	                    this.tagMapping[result.id].push(parseInt(client_id, 10)); // result.id = tag.id
	
	                    if (typeof this.clientTagMapping[client_id] === "undefined") {
	                        this.clientTagMapping[client_id] = [];
	                    }
	                    this.clientTagMapping[client_id].push(parseInt(result.id, 10)); // result.id = tag.id
	
	                    this.tagCounts[client_id] = 0;
	                }
	            }
	
	            this.tagGroups.push({
	                id: currentGroupId,
	                name: currentGroupName,
	                tags: currentTags
	            });
	            this.resetTagCounts();
	
	            /* Gruppen filtern, die wir nicht brauchen */
	            var tagGroupFilter = this.get("tagGroupFilter");
	            if (tagGroupFilter.length > 0) {
	                this.tagGroups = this.tagGroups.filter(function (group) {
	                    return tagGroupFilter.indexOf(group.id) !== -1;
	                });
	            }
	
	            this.trigger("change:tags");
	
	            timer();
	        }).bind(this);
	
	        var lang = window.Tramino.lang;
	        var cache_key = "browser.tags." + lang;
	        var cache = SafeStorage.session.get(cache_key);
	
	        if (cache) {
	            return Promise.resolve(JSON.parse(cache)).then(handler)['catch'](this.promiseError);
	        } else {
	            return ajax('/api/partner/tags/', { params: { lang: lang } }).then(function (result) {
	                SafeStorage.session.set(cache_key, JSON.stringify(result), 3600 * 1000);
	                return result;
	            }).then(handler)['catch'](this.promiseError);
	        }
	    },
	
	    resetTagCounts: function resetTagCounts() {
	        this.tagCounts = {};
	        var tagCounts = this.tagCounts;
	        _.each(this.tagGroups, function (group) {
	            // n = ~4
	            _.each(group.tags, function (tag) {
	                // n = ~8
	                tagCounts[tag.id] = [];
	            });
	        });
	    },
	
	    loadResults: function loadResults() {
	        var timer = MiniTimer("Load results");
	        this.$list.html(TemplateCache.render("LoadingIndicator"));
	
	        ajax('/api/partner/?group=' + this.get('group')).then((function (result) {
	            timer();
	
	            // Ergebnisse hinzufügen und rendern
	            this.processResults(result.results);
	
	            /* Falls wir Tags aus der URL erhalten haben, diese anwenden */
	            var requestedTags = this.getQueryParameters().tags;
	            if (requestedTags) {
	                this.set("selectedTags", _.map(requestedTags.split(','), function (x) {
	                    return parseInt(x, 10);
	                }));
	            }
	
	            this.filterResults();
	            this.renderResults();
	        }).bind(this))['catch']((function (e) {
	            // e = jqXHR object
	            this.$list.html(TemplateCache.render("ResultError", {
	                error: e.statusText || e.message || e.toString()
	            }));
	            this.promiseError(e);
	        }).bind(this));
	    },
	
	    /**
	     * Einkommende Ergebnisse verarbeiten:
	     * - In den resultStore packen
	     * - Views erzeugen
	     * - Tags filtern (visible status)
	     * - Anzeigen
	     */
	    processResults: function processResults(results) {
	        var timer = MiniTimer("processResults");
	        for (var i = 0, result; result = results[i]; ++i) {
	            // n = 1-20
	            // Sortierparameter auftrennen
	            var sort = result.sort ? result.sort : [0, 0, 0];
	            result.sort_auto = parseFloat(sort[0]);
	            result.sort_name = parseFloat(sort[1]);
	            result.sort_ratings = parseFloat(sort[2]);
	
	            var model = new Result(result);
	            // Standard-Sichtbarkeit setzen
	            model.visible = true;
	
	            var view = new ResultView({
	                model: model
	            });
	
	            this.resultStore.add(model);
	            this.resultViews[result.id] = view;
	        }
	
	        timer("added " + results.length + " results");
	    },
	
	    filterResults: function filterResults() {
	        var selectedTags = this.get("selectedTags");
	        var clientTagMapping = this.clientTagMapping;
	        var tagMapping = this.tagMapping;
	        var timer = MiniTimer("filterResults");
	        var count = 0;
	
	        if (selectedTags.length > 0) {
	            // Sichtbarkeit berechnen
	            this.resultStore.each((function (result) {
	                // n = 0 - 100
	                // result = Backbone.Model
	                var resultId = parseInt(result.id, 10);
	
	                result.visible = true;
	                for (var i = 0, tag_id; tag_id = selectedTags[i]; ++i) {
	                    // n = 0 - 4
	                    var clients_with_this_tag = tagMapping[tag_id];
	                    if (typeof clients_with_this_tag === "undefined") {
	                        throw new Error("tagMapping is missing tag #" + tag_id);
	                    }
	                    if (clients_with_this_tag.length === 0) {
	                        throw new Error("clients_with_this_tag is 0, which shouldn't happen #" + tag_id);
	                    }
	                    if (clients_with_this_tag.indexOf(resultId) === -1) {
	                        result.visible = false;
	                    }
	                }
	
	                if (result.visible) count++;
	            }).bind(this)); // Ende Berechnung Sichtbarkeit
	
	            if (count === 0) {
	                Raven.captureMessage("TagfilterNoResults", {
	                    extra: { selectedTags: selectedTags }
	                });
	            }
	        } else {
	
	            // Es werden alle Ergebnisse angezeigt
	            this.resultStore.each(function (result) {
	                // n = 0 - 100
	                result.visible = true;
	            });
	        }
	
	        /* @todo Sollen wir bei einer Suchanfrage die Tags vergessen?
	                 "Es wurden keine Partner mit diesem Namen in dieser Kategorie gefunden.
	                  Sie könnten [alle Filter deaktiveren](resetFilter)."
	        */
	        var query = this.get("searchQuery");
	        if (query.length > 2) {
	            query = query.toLowerCase();
	
	            this.resultStore.each(function (result) {
	                // n = 0 - 100
	                var name = result.get("name").toLowerCase();
	                result.visible = name.indexOf(query) !== -1;
	            });
	        }
	
	        // Filterung nach Favoriten
	        if (this.get("favoritesOnly")) {
	            var favs = TraminoFavoriten.getItemsMap();
	            this.resultStore.each(function (result) {
	                // n = 0 - 100
	                if (typeof favs["clients-" + result.get("id")] === "undefined") {
	                    result.visible = false;
	                }
	            });
	        }
	        this.updateFavButton();
	
	        // Tags zählen
	        this.resetTagCounts();
	
	        // Berechnen, welcher Tag wie viele sichtbaren Ergebnisse hat
	        var tagCounts = this.tagCounts;
	        this.resultStore.each(function (result) {
	            // n = 0 - 100
	            if (!result.visible) return;
	
	            var tags_with_this_clients = clientTagMapping[result.id];
	
	            _.each(tags_with_this_clients, function (tag_id) {
	                // Nur Tags zählen, die wir auch in der Sidebar anzeigen
	                if (tagCounts.hasOwnProperty(tag_id)) {
	                    tagCounts[tag_id].push(result.id);
	                }
	            });
	        });
	
	        // Der Menüliste die Zähler zuweisen
	        _.each(this.tagGroups, function (group) {
	            // n = ~4
	            _.each(group.tags, function (tag) {
	                // n = ~8
	                if (tagCounts[tag.id]) {
	                    tag.count = _.unique(tagCounts[tag.id]).length;
	                } else {
	                    tag.count = 0;
	                }
	            });
	            group.tags = _(group.tags).sortBy(function (tag) {
	                return -tag.count;
	            });
	        });
	
	        // Dem View mitteilen, dass die Seite neu gerendet werden kann
	        this.trigger("change:tags");
	        timer(count + " results are visible");
	    },
	
	    renderResults: function renderResults() {
	        var timer = MiniTimer("renderResults");
	
	        /* For performance reasons, we keep all result nodes around
	           and just detach and re-attach them to the DOM when necesssary */
	        _.each(this.resultViews, function (view, result_id) {
	            view.hide();
	        });
	        this.lastRenderIndex = 0;
	        this.renderMoreResults();
	        timer();
	    },
	
	    /**
	     * Zusätzliche Ergebnisse rendern
	     */
	    renderMoreResults: function renderMoreResults() {
	        var models = this.resultStore.getVisible();
	        models = models.slice(this.lastRenderIndex, this.lastRenderIndex + this.renderBatchSize);
	
	        if (models.length === 0 && this.lastRenderIndex === 0) {
	            if (this.get("favoritesOnly")) {
	                this.$list.html("<div class='results-404'>Sie haben keine Favoriten, die den aktuellen Suchbedingungen entsprechen.</div>");
	            } else {
	                this.$list.html("<div class='results-404'>Keine Ergebnisse gefunden. Bitte versuchen Sie es mit einer anderen Abfrage.</div>");
	            }
	        }
	
	        if (models.length > 0) {
	
	            // Sicherstellen, dass die Box leer ist falls keine Ergebnisse gerendert wurden
	            if (this.$list.find('.result-box').length === 0) this.$list.html("");
	
	            var views = this.resultViews;
	            _.each(models, (function (result, i) {
	                if (!result.visible) return;
	                var view = views[result.id];
	                if (typeof view === "undefined") {
	                    throw new Error("BUGCHECK: Missing resultView of result #" + result.id);
	                }
	
	                if (!view.rendered) {
	                    // Wir erzeugen erst die Elemente, wenn wir sie wirklich brauchen.
	                    // Spart RAM und verhindert, dass Bilder zu früh geladen werden.
	                    view.render();
	                }
	
	                view.show(this.$list);
	                this.lastRenderIndex++;
	            }).bind(this));
	        }
	    },
	
	    /**
	     * Rendering von Suchergebnissen
	     */
	    renderResultsSearch: function renderResultsSearch(query) {
	        var timer = MiniTimer("renderResultsSearch");
	
	        var models = this.resultStore.filter(function (result) {
	            var name = result.get("name").toLowerCase();
	            return name.indexOf(query) !== -1;
	        });
	
	        this.$search_list.html("");
	        this.$search_list.append("<div class='results-divider'>Suchergebnisse</div>");
	
	        if (models.length === 0) {
	            this.$search_list.append("<div class='results-404'>Keine Anbieter mit diesem Namen gefunden.</div>");
	        } else {
	
	            var views = this.resultViews;
	            _.each(models, (function (result, i) {
	                var view = views[result.id];
	                if (typeof view === "undefined") {
	                    throw new Error("BUGCHECK: Missing resultView of result #" + result.id);
	                }
	
	                if (!view.rendered) {
	                    // Wir erzeugen erst die Elemente, wenn wir sie wirklich brauchen.
	                    // Spart RAM und verhindert, dass Bilder zu früh geladen werden.
	                    view.render();
	                }
	                view.hide();
	                view.show(this.$search_list);
	            }).bind(this));
	        }
	
	        this.$search_list.append("<div class='clear'></div>");
	        this.$search_list.append("<div class='results-divider'>Weitere Anbieter</div>");
	
	        timer();
	    },
	
	    //
	    // User actions
	    //
	
	    setSortOrder: function setSortOrder(order) {
	        var timer = MiniTimer("SortResults: " + order);
	        var previous = this.get("sortBy");
	        if (order == previous) return;
	        var sortArrayIndex = ({
	            'auto': 0,
	            'name': 1,
	            'ratings': 2
	        })[order];
	
	        this.set("sortBy", order);
	        this.resultStore.comparator = function (result) {
	            return result.attributes.sort[sortArrayIndex];
	        };
	        this.resultStore.sort();
	
	        timer();
	        this.renderResults();
	    },
	
	    toggleTag: function toggleTag(tag_id) {
	        var tags = this.get("selectedTags");
	        tag_id = parseInt(tag_id, 10);
	        if (_.contains(tags, tag_id)) {
	            tags.splice(tags.indexOf(tag_id), 1);
	        } else {
	            tags.push(tag_id);
	        }
	
	        this.set("selectedTags", tags);
	        // Backbone wont trigger on set cause the array is still the same array object
	        this.trigger("change:selectedTags");
	    },
	
	    //
	    // View Methods
	    //
	
	    scrollHandler: function scrollHandler() {
	        var scrollTop = $(window).scrollTop();
	        var boxes = this.$list.find('.result-box');
	        if (!boxes.length) {
	            // Nothing has been rendered yet
	            return;
	        }
	        if (this.get("tab") !== "list") return;
	
	        var lastBoxOffset = boxes.last().offset().top;
	        var viewportBottom = scrollTop + $(window).height() + 100;
	        if (viewportBottom > lastBoxOffset) {
	            // Mehr Ergebnisse rendern
	            this.renderMoreResults();
	        }
	    },
	
	    scrollUp: function scrollUp() {
	        var currentScrollTop = $('html').scrollTop();
	        if (currentScrollTop === 0) return; /* Nicht scrollen wenn ganz oben */
	
	        $('html, body').animate({
	            scrollTop: $('.tabs').offset().top - 20
	        }, 400);
	    }
	
	});
	
	module.exports = BrowserApp;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $ = __webpack_require__(6);
	var Backbone = __webpack_require__(20);
	
	var TemplateCache = __webpack_require__(25);
	
	module.exports = Backbone.View.extend({
	
		events: {
			'click span.tag': 'handleClick',
			'click span.more': 'handleMore'
		},
	
		initialize: function initialize() {
			this.listenTo(this.model, "change:tags", this.render);
			this.listenTo(this.model, "change:selectedTags", this.render);
			this.listenTo(this.model, "change:tagsCount", this.render);
		},
	
		render: function render() {
			var selectedTags = this.model.get("selectedTags");
			this.el.innerHTML = TemplateCache.render('SidebarTemplate', {
				groups: this.model.tagGroups,
				isSelected: function isSelected(tag_id) {
					tag_id = parseInt(tag_id, 10);
					return selectedTags.indexOf(tag_id) !== -1;
				}
			});
	
			/* Fix the layout (list + maps) */
			$('.result-tabs').css('min-height', $('#engine-sidebar').outerHeight());
		},
	
		handleClick: function handleClick(e) {
			e.preventDefault();
			var link = $(e.currentTarget);
			if (link.hasClass('disabled')) return;
			this.model.toggleTag(link.data('id'));
		},
	
		handleMore: function handleMore(e) {
			e.preventDefault();
			var link = $(e.currentTarget);
			var group = link.data('group');
	
			$('.tag_group_' + group + ' .hidden').removeClass('hidden');
			link.hide();
		}
	
	});

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $ = __webpack_require__(6);
	var Backbone = __webpack_require__(20);
	
	var TemplateCache = __webpack_require__(25);
	
	var ResultView = Backbone.View.extend({
	
		events: {
			'click .favable': 'handleFavorite',
			'click .result-box .image': 'openItem',
			'click .result-box .info': 'openItem'
		},
	
		initialize: function initialize() {
			this.rendered = false;
		},
	
		render: function render() {
			var favorites = TraminoFavoriten.getItemsMap();
			this.fav_key = 'clients-' + this.model.get("id");
	
			this.el.innerHTML = TemplateCache.render('ResultTemplate', {
				result: this.model.toJSON(),
				favorited: typeof favorites[this.fav_key] !== "undefined"
			});
	
			this.rendered = true;
		},
	
		hide: function hide() {
			this.$el.detach();
		},
	
		show: function show($list) {
			this.$el.appendTo($list);
		},
	
		openItem: function openItem(e) {
			/* Nicht bei den Arrows triggern */
			if (e.target.className.indexOf('favable') !== -1) return;
			e.preventDefault();
			window.open(this.$el.find('h2 a').attr('href'));
		},
	
		handleFavorite: function handleFavorite(e) {
			var items = TraminoFavoriten.getItemsMap();
			if (typeof items[this.fav_key] === "undefined") {
				TraminoFavoriten.add({ id: this.fav_key });
			} else {
				TraminoFavoriten.remove(this.fav_key);
			}
		},
	
		/* Create a copy of this view (needed for Google Maps) */
		clone: function clone() {
			var view = new ResultView({
				model: this.model
			});
			return view;
		}
	
	});
	
	module.exports = ResultView;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $ = __webpack_require__(6);
	var Backbone = __webpack_require__(20);
	
	var TemplateCache = __webpack_require__(25);
	
	module.exports = Backbone.View.extend({
	
		events: {
			'click span': 'handleClick'
		},
	
		initialize: function initialize() {
			this.listenTo(this.model, "change:sortBy", this.render);
			this.lastOrderBy = null;
		},
	
		render: function render() {
			var currentSortBy = this.model.get("sortBy");
			if (currentSortBy == this.lastOrderBy) return;
	
			this.el.innerHTML = TemplateCache.render('SortOrderTemplate', {
				active: currentSortBy
			});
		},
	
		handleClick: function handleClick(e) {
			e.preventDefault();
			var newSortBy = $(e.currentTarget).data('orderby');
	
			this.$el.find('.active').removeClass('active');
			$(e.currentTarget).addClass("active");
			this.currentSortBy = newSortBy;
			this.model.setSortOrder(newSortBy);
		}
	
	});

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Diese Datei enthält Referenzen auf alle prekompilierten Templates
	 * und registriert den notwendigen Loader für den TemplateCache.
	 */
	
	'use strict';
	
	var TemplateCache = __webpack_require__(25);
	var Registry = __webpack_require__(26);
	
	var PREFIX = '';
	
	var TEMPLATES = {
		/* Header */
		'cart-items-template': __webpack_require__(53),
		'favorites-template': __webpack_require__(54),
		'sitesearch-template': __webpack_require__(55),
	
		/* Engine */
		'datepicker-controls': __webpack_require__(56),
		'datepicker-item-info': __webpack_require__(57),
		'SortOrderTemplate': __webpack_require__(58),
		'reserva-people-template': __webpack_require__(59),
		'loader-results': __webpack_require__(60),
		'no-results': __webpack_require__(61),
		'result-template': __webpack_require__(62),
		'SidebarTemplate': __webpack_require__(63),
		'result-error': __webpack_require__(64),
		'result-error-validate': __webpack_require__(65),
		'filterinfo': __webpack_require__(66),
	
		/* Browser */
		'browser/SidebarTemplate': __webpack_require__(67),
		'browser/SortOrderTemplate': __webpack_require__(68),
		'browser/LoadingIndicator': __webpack_require__(69),
		'browser/ResultError': __webpack_require__(70),
		'browser/ResultTemplate': __webpack_require__(71),
	
		/* Miniengine */
		'timetable-template': __webpack_require__(72),
		'pricetable-template': __webpack_require__(73),
		'classes-template': __webpack_require__(74),
		'products-template': __webpack_require__(75),
		'ratings-template': __webpack_require__(76),
		'reserva-yeartable': __webpack_require__(77),
	
		/* Interest Filter */
		'interest-filter': __webpack_require__(78)
	};
	
	if (Registry.get("Customer").Alpentraum) {
		TEMPLATES['result-template'] = __webpack_require__(79);
	}
	
	if (Registry.get("Customer").Montana) {
		TEMPLATES['result-template'] = __webpack_require__(80);
	}
	
	module.exports = {
		/**
	  * Registriert den webpack-Loader im TemplateCache
	  */
		register: function register() {
			TemplateCache.registerLoader("webpack", function (ident) {
				if (PREFIX && TEMPLATES[PREFIX + ident]) {
					return TEMPLATES[PREFIX + ident];
				}
				return TEMPLATES[ident];
			});
		},
	
		/**
	  * Definiert einen Prefix der beim Lookup zuerst geprüft wird.
	  * Hack um doppelte Template-Namen bei Engine/Browser aufzulösen.
	  */
		setPrefix: function setPrefix(prefix) {
			PREFIX = prefix;
		}
	};

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n<div class="cart-items">\n\n	';
	 if ( itemsCount ) { 
	__p+='\n		<h3 class="count">'+
	((__t=( paginationInfo ))==null?'':__t)+
	'</h3>\n	';
	 } 
	__p+='\n\n\n	<div class="cart-list">\n	';
	 if ( itemsCount ) { 
	__p+='\n		';
	 _.each(items, function(item) { 
	__p+='\n\n			<div class="cart-item">\n				<div class="image">\n					';
	 if ( item.image ) { 
	__p+='<img src="https://tramino.s3.amazonaws.com'+
	((__t=( item.image ))==null?'':__t)+
	'" width="100" height="60"/>';
	 } 
	__p+='\n				</div>\n				<div class="info">\n					<h5>'+
	((__t=( item.item_client_name ))==null?'':__t)+
	'</h5>\n					<h4>'+
	((__t=( item.name ))==null?'':__t)+
	'</h4>\n					';
	 if ( item.von ) { 
	__p+='\n						';
	 if ( item.von == item.bis || item.bis == "" ) { 
	__p+='\n							<div class="period">'+
	((__t=( moment( item.von, "YYYY-MM-DD").format("L") ))==null?'':__t)+
	'</div>\n						';
	 } else { 
	__p+='\n							<div class="period">'+
	((__t=( moment( item.von, "YYYY-MM-DD").format("L") ))==null?'':__t)+
	' - '+
	((__t=( moment( item.bis, "YYYY-MM-DD").format("L") ))==null?'':__t)+
	'</div>\n						';
	 }
	__p+='\n					';
	 }
	__p+='\n					';
	 if ( item.facts ) { 
	__p+='<span class="facts">'+
	((__t=( item.facts ))==null?'':__t)+
	'</span>';
	 } 
	__p+='\n					';
	 if ( item.inclusive ) { 
	__p+=' <span class="inkl">'+
	((__t=( Translator.get('inkl') ))==null?'':__t)+
	' '+
	((__t=( item.inclusive ))==null?'':__t)+
	'</span>';
	 } 
	__p+='\n					\n				</div>\n				<div class="price">\n					<div data-id="'+
	((__t=( item.id ))==null?'':__t)+
	'" class="items-remove">'+
	((__t=( __('remove') ))==null?'':__t)+
	'</div>\n					<div class="amount">'+
	((__t=( Translator.currency(  item.preis_gesamt, "EUR" ) ))==null?'':__t)+
	'</div>\n					';
	 if ( item.zzgl ) { 
	__p+='<div class="exkl">'+
	((__t=( Translator.get('zzgl') ))==null?'':__t)+
	' '+
	((__t=( item.zzgl ))==null?'':__t)+
	'</div>';
	 } 
	__p+='\n				</div>\n				<div class="clear"></div>\n			</div>\n\n		';
	 }); 
	__p+='\n	';
	 } else { 
	__p+='\n		<div class="notification">'+
	((__t=( __('cart_empty') ))==null?'':__t)+
	'</div>\n	';
	 } 
	__p+='\n	</div>\n\n	<div class="paginator">\n		';
	 if ( hasNext ) { 
	__p+='<a href="" class="items-next">'+
	((__t=( __('next') ))==null?'':__t)+
	' &rarr;</a>';
	 } 
	__p+='\n		';
	 if ( hasPrev ) { 
	__p+='<a href="" class="items-prev">&larr; '+
	((__t=( __('prev') ))==null?'':__t)+
	'</a>';
	 } 
	__p+='\n	</div>\n\n</div>\n\n';
	}
	return __p;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='';
	 if ( itemsCount ) { 
	__p+='\n	<h3 class="count">'+
	((__t=( paginationInfo ))==null?'':__t)+
	'</h3>\n';
	 } 
	__p+='\n\n<div class="favorites-list">\n\n	';
	 if ( itemsCount ) { 
	__p+='\n		';
	 _.each(items, function(item) { 
	__p+='\n			<div class="favorites-item">\n				<div class="image" onclick="location.href=\''+
	((__t=( item.url ))==null?'':__t)+
	'\'">\n					';
	 if ( item.image ) { 
	__p+='<img src="//tramino.s3.amazonaws.com'+
	((__t=( item.image ))==null?'':__t)+
	'" width="100" height="60"/>';
	 } 
	__p+='\n				</div>\n				<div class="info">\n					<h5><a href="'+
	((__t=( item.url ))==null?'':__t)+
	'">'+
	((__t=( item.name ))==null?'':__t)+
	'</a></h5>\n				</div>\n				<div data-id="'+
	((__t=( item.id ))==null?'':__t)+
	'" class="items-remove" title="'+
	((__t=( __('remove') ))==null?'':__t)+
	'">&times;</div>\n			</div>\n		';
	 }); 
	__p+='\n	';
	 } else { 
	__p+='\n		<div class="notification">'+
	((__t=( text_not_found ))==null?'':__t)+
	'</div>\n	';
	 } 
	__p+='\n	\n	<div class="clear"></div>\n\n</div>\n\n<div class="paginator">\n	';
	 if ( hasNext ) { 
	__p+='<a href="#" class="items-next">'+
	((__t=( __('next') ))==null?'':__t)+
	' &rarr;</a>';
	 } 
	__p+='\n	';
	 if ( hasPrev ) { 
	__p+='<a href="#" class="items-prev">&larr; '+
	((__t=( __('prev') ))==null?'':__t)+
	'</a>';
	 } 
	__p+='	\n</div>\n';
	}
	return __p;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='';
	 if ( isLoading ) { 
	__p+='\n\n	<h3 class="count">Suchergebnisse</h3>\n\n	<div class="matches-list">\n		<ul>\n			<li>Einen Moment bitte...</li>\n		</ul>\n	</div>\n\n';
	 } else { 
	__p+='\n\n	<h3 class="count">'+
	((__t=( paginationInfo ))==null?'':__t)+
	'</h3>\n\n	';
	 if ( results.length ) { 
	__p+='\n		<div class="matches-list">\n			<ul>\n			';
	 _.each(results, function(result) { 
	__p+='\n				<li>\n					<a class="main" href="'+
	((__t=( result.uri ))==null?'':__t)+
	'">'+
	((__t=( result.name ))==null?'':__t)+
	'</a> ('+
	((__t=( result.kategorie ))==null?'':__t)+
	')<br>\n				</li>\n			';
	 }); 
	__p+='\n			</ul>\n		</div>\n	';
	 } else { 
	__p+='\n		<div class="notify">Für diesen Begriff wurde leider nichts gefunden.</div>\n	';
	 } 
	__p+='\n\n	<div class="paginator">\n		';
	 if ( hasPrev ) { 
	__p+='<a href="#" class="search-prev">&larr; '+
	((__t=( __('prev') ))==null?'':__t)+
	'</a>';
	 } 
	__p+='	\n		';
	 if ( hasNext ) { 
	__p+='<a href="#" class="search-next">'+
	((__t=( __('next') ))==null?'':__t)+
	' &rarr;</a>';
	 } 
	__p+='\n	</div>\n';
	 } 
	__p+='\n';
	}
	return __p;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="datepicker-controls">\n\n	<span class="modes">\n		<span class="mode '+
	((__t=( select_mode == 'none'  ? 'on' : '' ))==null?'':__t)+
	'" data-mode="none">\n			'+
	((__t=( __('dp_controls_mode_none') ))==null?'':__t)+
	'\n		</span>\n		<span class="mode '+
	((__t=( select_mode == 'exact' ? 'on' : '' ))==null?'':__t)+
	'" data-mode="exact">\n			'+
	((__t=( __('dp_controls_mode_exact') ))==null?'':__t)+
	'\n		</span>\n		';
	 if ( registry('DatePicker.EnableFlexible') ) { 
	__p+='\n		<span class="mode '+
	((__t=( select_mode == 'flex'  ? 'on' : '' ))==null?'':__t)+
	'" data-mode="flex">\n			'+
	((__t=( __('dp_controls_mode_range') ))==null?'':__t)+
	'\n		</span>\n		';
	 } 
	__p+='\n	</span>\n\n	<span class="wrapper">\n		<select name="control-nights" class="nights">\n			';
	 for ( n=1; n <= 21; n++) { 
	__p+='\n			<option value="'+
	((__t=( n ))==null?'':__t)+
	'" '+
	((__t=( ( n == nights ? 'selected' : '' ) ))==null?'':__t)+
	'>'+
	((__t=( n ))==null?'':__t)+
	' '+
	((__t=( ( n == 1 ? __('night') : __('nights') ) ))==null?'':__t)+
	'</option>\n			';
	 } 
	__p+='\n		</select>\n		<span class="date_wrapper">\n			<span class="word">'+
	((__t=( __('dp_controls_from') ))==null?'':__t)+
	'</span> \n			<input type="'+
	((__t=( isTouchDevice ? 'date' : 'text' ))==null?'':__t)+
	'" value="'+
	((__t=( from_human ))==null?'':__t)+
	'" class="from" name="control-from" size="10">\n		</span>\n		<span class="date_wrapper">\n			<span class="word">'+
	((__t=( __('dp_controls_to') ))==null?'':__t)+
	'</span> \n			<input type="'+
	((__t=( isTouchDevice ? 'date' : 'text' ))==null?'':__t)+
	'" value="'+
	((__t=( to_human ))==null?'':__t)+
	'"   class="to"   name="control-to"   size="10">\n		</span>\n	</span>\n\n	<span class="datepicker-close">&times;</span>\n</div>\n';
	}
	return __p;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="datepicker-item-info">\n		'+
	((__t=( __('datepicker_item_tip') ))==null?'':__t)+
	'<br/>\n	';
	 if ( item.name ) { 
	__p+='\n		'+
	((__t=( __('datepicker_item_selected', {name: item.name}) ))==null?'':__t)+
	'\n	';
	 } 
	__p+='\n</div>\n';
	}
	return __p;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<span data-orderby="auto" '+
	((__t=( active == "auto" ? 'class="active"' : '' ))==null?'':__t)+
	'>\n	'+
	((__t=( __("sort_auto") ))==null?'':__t)+
	'\n</span>\n<span data-orderby="booking" '+
	((__t=( active == "booking" ? 'class="active"' : '' ))==null?'':__t)+
	'>\n	'+
	((__t=( __("sort_booking") ))==null?'':__t)+
	'\n</span>\n<span data-orderby="stars" '+
	((__t=( active == "stars" ? 'class="active"' : '' ))==null?'':__t)+
	'>\n	'+
	((__t=( __("sort_stars") ))==null?'':__t)+
	'\n</span>\n<span data-orderby="ratings" '+
	((__t=( active == "ratings" ? 'class="active"' : '' ))==null?'':__t)+
	'>\n	'+
	((__t=( __("sort_ratings") ))==null?'':__t)+
	'\n</span>\n<span data-orderby="price" '+
	((__t=( active == "price" ? 'class="active"' : '' ))==null?'':__t)+
	'>\n	'+
	((__t=( __("sort_price") ))==null?'':__t)+
	'\n</span>\n';
	}
	return __p;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 59 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="people-panel">\n	';
	 _.each(items, function(element) { 
	__p+='\n		';
	 if ( element.type === "groupStart" ) { 
	__p+='\n			\n			<div class="people-group">\n\n		';
	 } else if ( element.type === "select" ) { 
	__p+='\n\n			<select name="'+
	((__t=( element.key ))==null?'':__t)+
	'" class="'+
	((__t=( element.class ))==null?'':__t)+
	'">\n				';
	 _.each(element.values, function(value) { 
	__p+='\n				<option value="'+
	((__t=( value[0] ))==null?'':__t)+
	'" '+
	((__t=( model.get(element.key) == value[0] ? 'selected' : '' ))==null?'':__t)+
	'>'+
	((__t=( value[1] ))==null?'':__t)+
	'</option>\n				';
	 }); 
	__p+='\n			</select>\n\n		';
	 } else if ( element.type === "groupEnd" ) { 
	__p+='\n\n			</div>\n\n		';
	 } else if ( element.type === "break" ) { 
	__p+='\n\n			<br>\n\n		';
	 }; /* end if element.type */ 
	__p+='\n	';
	 }); 
	__p+='\n</div>\n';
	}
	return __p;
	};

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="notify loader-results">\n	<h3>'+
	((__t=( __('loading_text') ))==null?'':__t)+
	'</h3>\n	<img src="/tramino/gfx/loading_anim.gif">\n</div>\n';
	}
	return __p;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="notify no-results">\n	';
	 if ( searchQuery ) { 
	__p+='\n\n		<h3>'+
	((__t=( __('searchquery_no_result_title', {searchQuery: searchQuery}) ))==null?'':__t)+
	'</h3>\n		'+
	((__t=( __('searchquery_no_result_match') ))==null?'':__t)+
	'\n\n	';
	 } else { 
	__p+='\n\n		';
	 if ( favoritesOnly ) { 
	__p+='\n\n			<h3>'+
	((__t=( __('favsonly_empty_title') ))==null?'':__t)+
	'</h3>\n			'+
	((__t=( __('favsonly_empty_text') ))==null?'':__t)+
	'\n\n		';
	 } else { 
	__p+='\n\n			<h3>'+
	((__t=( registry("Engine.NoResultTitle") ))==null?'':__t)+
	'</h3>\n			<p>'+
	((__t=( registry("Engine.NoResultMessage") ))==null?'':__t)+
	'</p>\n\n		';
	 }  
	__p+='\n\n\n	';
	 }  
	__p+='\n</div>\n';
	}
	return __p;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='';
	
		var min_ratings = 1;
		if ( registry("Customer").Oberstdorf ) {
			min_ratings = 10;
		}
	
	__p+='\n\n<section class="result-box hidden" data-id="'+
	((__t=( result.id ))==null?'':__t)+
	'">\n	\n	<div class="inner">\n		\n		';
	 if ( result.rating > 0 && result.rating_count >= min_ratings ) { 
	__p+='<div class="result-box-overlay-right">\n			<span class="digit">'+
	((__t=( Math.round( result.rating ) ))==null?'':__t)+
	'%</span> '+
	((__t=( __('recommentation') ))==null?'':__t)+
	'</div>';
	 } 
	__p+='\n\n		';
	 var visibleResults = result.classes.filter(function(r) { return r.visible }) 
	__p+='\n\n		<div class="slider ';
	 if ( visibleResults.length <= 1 ) print('single') 
	__p+='">\n\n			';
	 _.each( visibleResults.reverse(), function(item) { 
	__p+=' \n\n 				<div class="item" data-id="'+
	((__t=( item.id ))==null?'':__t)+
	'" data-item="'+
	((__t=( item.item ))==null?'':__t)+
	'">\n\n					<div class="image">\n						';
	 if ( item.image && item.image != "0" ) { 
	__p+='\n						<div class="inner" style="background-image: url(https://'+
	((__t=( window.Tramino.cdn || 'tramino.s3.amazonaws.com' ))==null?'':__t)+
	''+
	((__t=( item.image ))==null?'':__t)+
	')"></div>\n						';
	 } 
	__p+='\n					</div>\n\n 					';
	 if ( item.stars ) { 
	__p+='\n					<div class="stars">'+
	((__t=( __("result_validated") ))==null?'':__t)+
	'<br/>'+
	((__t=( item.stars ))==null?'':__t)+
	'</div>\n					';
	 } 
	__p+='\n\n					<div class="info">\n					\n						<div class="arrow prev"><div class="arrow-inner"></div></div>\n\n							';
	 if ( item.price ) {  
	__p+='\n								<div class="price" title="Gesamtpreis für alle Personen">\n									<span class="digits">'+
	((__t=( Math.round( parseFloat(item.price) )  ))==null?'':__t)+
	'</span><span class="currency">€</span>\n									';
	 if ( result.booking == 1 ) { 
	__p+='<div class="online-booking">'+
	((__t=( __("result_book_online") ))==null?'':__t)+
	'</div>';
	 } 
	__p+='\n								</div>\n							';
	 } else { 
	__p+='\n								<div class="price">\n								</div>\n							';
	 } 
	__p+='\n						<div class="text">\n							<div class="inner">\n								<b>'+
	((__t=( item.name ))==null?'':__t)+
	'</b>\n								<br/>\n								';
	 if ( item.price ) {  
	__p+='\n									';
	 if ( item.inkl ) print(__('item_includes', { item: item.inkl }) ) 
	__p+=' \n									';
	 if ( Tramino.client != 620 ) { 
	__p+='\n										';
	 if ( item.inkl ) print(", ") 
	__p+='\n										'+
	((__t=( __('zzgl') ))==null?'':__t)+
	'\n										';
	 if ( tagSelected(1522) && ( ! ( item.inkl && item.inkl.match(/Frühstück|breakfast|Halbpension|¾|half|Vollpension|full/i  ) ) || ! item.inkl ) ) print(__('breakfast_charge')) 
	__p+='\n										';
	 if ( tagSelected(4598) && ( ! ( item.inkl && item.inkl.match(/Halbpension|¾|half/i ) ) || ! item.inkl ) ) print(__('halfboard_charge')) 
	__p+='\n										';
	 if ( tagSelected(8134) && ( ! ( item.inkl && item.inkl.match(/Vollpension|full/i ) ) || ! item.inkl ) ) print(__('fullboard_charge')) 
	__p+='\n										'+
	((__t=( __('spatax') ))==null?'':__t)+
	'\n									';
	 } 
	__p+='\n									<br/>\n								';
	 } 
	__p+='\n							</div>\n						</div>\n\n						<div class="arrow next"><div class="arrow-inner"></div></div>\n\n					</div>\n\n				</div>\n\n			';
	 }); 
	__p+='\n\n		</div>\n\n		<div class="info bottom">\n\n			<div class="logo" >\n				<div class="inner">\n				';
	 if ( result.logo && result.logo != 0 ) { 
	__p+='\n				<img src="https://'+
	((__t=( window.Tramino.cdn || 'tramino.s3.amazonaws.com' ))==null?'':__t)+
	''+
	((__t=( result.logo ))==null?'':__t)+
	'" width="200" height="150">\n				';
	 } 
	__p+='\n				</div>\n			</div>\n\n			<div class="text">\n				<h2 '+
	((__t=( ( result.name.length > 25 ) ? 'class="longname"' : '' ))==null?'':__t)+
	' ><a href="'+
	((__t=( registry('PartnerBase') ))==null?'':__t)+
	''+
	((__t=( result.shortcut ))==null?'':__t)+
	'.html">'+
	((__t=( result.name ))==null?'':__t)+
	'</a></h2>\n				<h3 class="color">'+
	((__t=( result.slogan ))==null?'':__t)+
	'</h3>\n				<div class="foot">\n					<div class="address">'+
	((__t=( result.street ))==null?'':__t)+
	'';
	 if (result.district) print( "<span class='district'>, " + result.district + "</span>") 
	__p+='</div>\n					<div class="phone">\n						'+
	((__t=( __('Tel.') ))==null?'':__t)+
	' '+
	((__t=( result.phone ))==null?'':__t)+
	'\n					</div>\n				</div>\n			</div>\n\n			';
	 if ( favorited ) { 
	__p+='\n			<div class="favable on" data-item="clients-'+
	((__t=( result.id ))==null?'':__t)+
	'" title="'+
	((__t=( __('unlike') ))==null?'':__t)+
	'"></div>\n			';
	 } else { 
	__p+='\n			<div class="favable" data-item="clients-'+
	((__t=( result.id ))==null?'':__t)+
	'" title="'+
	((__t=( __('like') ))==null?'':__t)+
	'"></div>\n			';
	 } 
	__p+='\n\n			<div class="clear"></div>\n\n		</div>\n	</div>\n\n</section>\n\n';
	}
	return __p;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='';
	 _.each(groups, function(group) { 
	__p+='\n	';
	
			var visible_count = 0;
			for(var i = 0, tag; tag = group.tags[i]; ++i) {
				if ( !tag.count ) { continue; }
				visible_count++;
			}
			if ( visible_count === 0 ) return; // Aus der each groups Loop ausbrechen
		
	__p+='\n\n<div class="group tag_group_'+
	((__t=( group.index ))==null?'':__t)+
	'">\n	<h4>'+
	((__t=( group.name ))==null?'':__t)+
	'</h4>\n	';
	
			var visible_count = 0;
			var treshhold = registry("CollapseTagGroupsTreshhold");
			if ( group.index == 51 ) treshhold = 50; // Ortsteile in Oberstdorf
	
			var visible_tags = _.filter(group.tags, function(tag) { return tag.count > 0 });
			/* Falls es nur ein Item als "Mehr" gibt, setzen wir das Limit für die Gruppe einfach hoch */
			if ( visible_tags.length === treshhold + 1 ) { treshhold++; }
		
	__p+='\n	';
	 _.each(visible_tags, function(tag, i) { 
	__p+='\n		';
	 i = i + 1 
	__p+='\n		';
	 visible_count++; 
	__p+='\n\n			<span data-id="'+
	((__t=( tag.id ))==null?'':__t)+
	'"\n				  data-group="'+
	((__t=( group.name ))==null?'':__t)+
	'"\n				  title="'+
	((__t=( tag.info ))==null?'':__t)+
	'"\n				  class="tag '+
	((__t=( isSelected(tag.id) ? 'checked' : '' ))==null?'':__t)+
	' '+
	((__t=( tag.count === 0 ? 'disabled' : '' ))==null?'':__t)+
	' '+
	((__t=( i > treshhold ? 'hidden' : '' ))==null?'':__t)+
	'">\n				<label for="tag_'+
	((__t=( tag.id ))==null?'':__t)+
	'">\n					'+
	((__t=( tag.tag ))==null?'':__t)+
	'\n					';
	 if ( tag.count !== null ) { 
	__p+='\n						';
	 if ( tag.count > 0 ) { 
	__p+='\n						<span class="count">'+
	((__t=( tag.count ))==null?'':__t)+
	'</span>\n						';
	 } 
	__p+='\n					';
	 } 
	__p+='\n				</label>\n				<br/>\n			</span>\n\n	';
	 }) 
	__p+='\n\n	';
	 if ( visible_count > treshhold ) { 
	__p+='\n	<span class="more" data-group="'+
	((__t=( group.index ))==null?'':__t)+
	'">\n		'+
	((__t=( __("sidebar_more") ))==null?'':__t)+
	'\n	</span>\n	';
	 } 
	__p+='\n\n</div>\n';
	 }) 
	__p+='\n';
	}
	return __p;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="notify result-error-info">\n\n	<h3>'+
	((__t=( __('result_error_title') ))==null?'':__t)+
	'</h3>\n	<p>'+
	((__t=( registry("Engine.NoResultMessage") ))==null?'':__t)+
	'</p>\n\n	';
	 if ( showError ) { 
	__p+='\n		<br>\n		[Nur für eingeloggte Nutzer sichtbar:]<br>\n		Fehlergrund: '+
	((__t=( error ))==null?'':__t)+
	'<br>\n		Bitte melden Sie dieses Problem dem Tramino-Support.\n	';
	 } 
	__p+='\n\n</div>\n';
	}
	return __p;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="notify result-error-info">\n\n	<h3>'+
	((__t=( __('result_error_title') ))==null?'':__t)+
	'</h3>\n\n	<p>'+
	((__t=( __('result_error_subtitle') ))==null?'':__t)+
	'</p>\n	<ul>\n		';
	 _.each(errors, function(e) { 
	__p+='\n		<li>'+
	((__t=( e ))==null?'':__t)+
	'</li>\n		';
	 }) 
	__p+='\n	</ul>\n\n	<p>'+
	((__t=( registry("Engine.NoResultMessage") ))==null?'':__t)+
	'</p>\n\n	<button class="btn-reset">'+
	((__t=( __('reset_search') ))==null?'':__t)+
	'</button>\n\n</div>\n';
	}
	return __p;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 66 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='';
	 _.each(infos, function(info, i) { 
	__p+='\n<span class="tag ';
	 if ( info.closeable !== false ) print('clickable') 
	__p+='" data-index="'+
	((__t=( i ))==null?'':__t)+
	'">\n	'+
	((__t=( info.text ))==null?'':__t)+
	'\n	';
	 if ( info.closeable !== false ) { 
	__p+='\n		<span>x</span>\n	';
	 } 
	__p+='\n</span>\n';
	 }) 
	__p+='\n';
	}
	return __p;
	};

/***/ }),
/* 67 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='';
	 _.each(groups, function(group) { 
	__p+='\n	<div class="group tag_group_'+
	((__t=( group.id ))==null?'':__t)+
	'">\n		<h4>'+
	((__t=( group.name ))==null?'':__t)+
	'</h4>\n		';
	 var visible_count = 0; 
	__p+='\n		';
	 _.each(group.tags, function(tag, i) { 
	__p+='\n			';
	 i = i + 1 
	__p+='\n			';
	 visible_count++; 
	__p+='\n\n			<span data-id="'+
	((__t=( tag.id ))==null?'':__t)+
	'"\n				data-group="'+
	((__t=( group.name ))==null?'':__t)+
	'"\n				class="tag '+
	((__t=( tag.count === 0 ? 'disabled' : '' ))==null?'':__t)+
	' '+
	((__t=( i > 99 ? 'hidden' : '' ))==null?'':__t)+
	'">\n				<input type="checkbox" name="tags" value="'+
	((__t=( tag.id ))==null?'':__t)+
	'" id="tag_'+
	((__t=( tag.id ))==null?'':__t)+
	'" class="checkbox" '+
	((__t=( isSelected(tag.id) ? 'checked' : '' ))==null?'':__t)+
	' />\n				<label for="tag_'+
	((__t=( tag.id ))==null?'':__t)+
	'">\n					'+
	((__t=( tag.tag ))==null?'':__t)+
	'\n					';
	 if ( tag.count !== null ) { 
	__p+='\n						';
	 if ( tag.count > 0 ) { 
	__p+='\n							<span class="count">'+
	((__t=( tag.count ))==null?'':__t)+
	'</span>\n							';
	 } 
	__p+='\n							';
	 } 
	__p+='\n						</label>\n						<br/>\n					</span>\n\n					';
	 }) 
	__p+='\n\n		';
	 if ( visible_count > 20 ) { 
	__p+='\n			<span class="more" data-group="'+
	((__t=( group.id ))==null?'':__t)+
	'">\n				Mehr\n			</span>\n			';
	 } 
	__p+='\n\n	</div>\n';
	 }) 
	__p+='\n';
	}
	return __p;
	};

/***/ }),
/* 68 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<span data-orderby="auto" '+
	((__t=( active == "auto" ? 'class="active"' : '' ))==null?'':__t)+
	'>Aktualität</span>\n<span data-orderby="name" '+
	((__t=( active == "name" ? 'class="active"' : '' ))==null?'':__t)+
	'>Name</span>\n';
	}
	return __p;
	};

/***/ }),
/* 69 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="loader-results">\n	<img src="/tramino/gfx/loading_anim.gif">\n	Einen Augenblick bitte\n</div>\n';
	}
	return __p;
	};

/***/ }),
/* 70 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='ResultError\n'+
	((__t=( error ))==null?'':__t)+
	'\n';
	}
	return __p;
	};

/***/ }),
/* 71 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<section class="result-box hidden ';
	 if ( result.paid ) print('paid') 
	__p+='" data-id="'+
	((__t=( result.id ))==null?'':__t)+
	'">\n	\n	<div class="inner">\n		\n		';
	 if ( result.rating > 0 ) { 
	__p+='\n			<div class="result-box-overlay-right">\n				<span class="digit">'+
	((__t=( Math.round( result.rating ) ))==null?'':__t)+
	'%</span> Empfehlung\n			</div>\n		';
	 } 
	__p+='\n		\n		<div class="image">\n			';
	 if ( result.image && result.paid ) { 
	__p+='\n				<div class="inner" style="background-image: url(//tramino.s3.amazonaws.com'+
	((__t=( result.image ))==null?'':__t)+
	')"></div>\n			';
	 } 
	__p+='\n			<div class="tags_badges">\n				';
	 if ( result.oeffnungszeiten0 ) { 
	__p+='<span class="tag">Heute '+
	((__t=( result.oeffnungszeiten0 ))==null?'':__t)+
	'</span>';
	 } 
	__p+='\n				';
	 if ( result.oeffnungszeiten1 ) { 
	__p+='<span class="tag">Morgen '+
	((__t=( result.oeffnungszeiten1 ))==null?'':__t)+
	'</span>';
	 } 
	__p+='\n\n				';
	 
						if ( $('.result-tabs').data("tags_badges") !== undefined ) {
							var tags_badges = $('.result-tabs').data("tags_badges").split(",");
							for (var i = 0; i < tags_badges.length; i++) {
								if ( result.tags[tags_badges[i]] ) { 
	__p+='\n							<span class="tag tag'+
	((__t=( tags_badges[i]))==null?'':__t)+
	'">'+
	((__t=( result.tags[tags_badges[i]] ))==null?'':__t)+
	'</span>\n							';
	}
							}
						}
					
	__p+='\n			</div>\n		</div>\n\n		<div class="info">\n\n			<div class="logo" >\n				<div class="inner">\n				';
	 if ( result.logo && result.paid ) { 
	__p+='\n					<img src="https://'+
	((__t=( window.Tramino.cdn || 'tramino.s3.amazonaws.com' ))==null?'':__t)+
	''+
	((__t=( result.logo ))==null?'':__t)+
	'" width="200" height="150" loading="lazy">\n					';
	 } 
	__p+='\n				</div>\n			</div>\n\n\n				<div class="text">\n					<h2 '+
	((__t=( ( result.name.length > 25 ) ? 'class="longname"' : '' ))==null?'':__t)+
	'><a href="/partner/'+
	((__t=( result.shortcut ))==null?'':__t)+
	'.html" target="blank">'+
	((__t=( result.name ))==null?'':__t)+
	'</a></h2>\n					<h3 class="color">'+
	((__t=( result.slogan ))==null?'':__t)+
	'</h3>\n					<div class="foot">\n						<div class="address">'+
	((__t=( result.street ))==null?'':__t)+
	'';
	 if ( result.district ) print( "<span class='district'>, " + result.district + "</span>" ) 
	__p+='</div>\n						<div class="phone">Tel. '+
	((__t=( result.phone ))==null?'':__t)+
	'</div>\n					</div>\n				</div>\n\n				';
	 if ( favorited ) { 
	__p+='\n					<div class="favable on" data-item="clients-'+
	((__t=( result.id ))==null?'':__t)+
	'" title="gefällt mir nicht mehr"></div>\n				';
	 } else { 
	__p+='\n					<div class="favable" data-item="clients-'+
	((__t=( result.id ))==null?'':__t)+
	'" title="gefällt mir"></div>\n				';
	 } 
	__p+='\n\n				<div class="clear"></div>\n\n			</div>\n	</div>\n\n</section>\n';
	}
	return __p;
	};

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<div class="timetable-controls">\n\n	<div class="timetable-buttons">\n		<button class="offset-down" data-days="14" '+
	((__t=( renderOffset === 0 ? 'disabled' : '' ))==null?'':__t)+
	'>&lt;&lt;</button>\n		<button class="offset-down" data-days="7" '+
	((__t=( renderOffset === 0 ? 'disabled' : '' ))==null?'':__t)+
	'>&lt;</button>\n		';
	 if ( developer ) { 
	__p+='<button class="offset-down" data-days="1" '+
	((__t=( renderOffset === 0 ? 'disabled' : '' ))==null?'':__t)+
	'>-1d</button>';
	 } 
	__p+='\n		<button class="btn-reset">'+
	((__t=( __('today') ))==null?'':__t)+
	'</button>\n		';
	 if ( developer ) { 
	__p+='<button class="offset-up" data-days="1" ';
	 if ( !canGoFurther ) print('disabled') 
	__p+='>+1d</button>';
	 } 
	__p+='\n		<button class="offset-up" data-days="7" ';
	 if ( !canGoFurther ) print('disabled') 
	__p+='>&gt;</button>\n		<button class="offset-up" data-days="14" ';
	 if ( !canGoFurther ) print('disabled') 
	__p+='>&gt;&gt;</button>\n	</div>\n\n</div>\n\n<table class="reserva-table" cellspacing="0" cellpadding="0">\n	<thead>\n		<tr class="months">\n			<th>&nbsp;</th>\n			';
	 _.each(months, function(month) { 
	__p+='\n				<th colspan="'+
	((__t=( monthCounters[month] ))==null?'':__t)+
	'"><div>'+
	((__t=( month ))==null?'':__t)+
	'</div></th>\n			';
	 }) 
	__p+='\n		</tr>\n		<tr class="days">\n			<th>&nbsp;</th>\n			';
	 _.each(days, function(day) { 
	__p+='\n				<th class="day_'+
	((__t=( day.index ))==null?'':__t)+
	' ';
	 if ( selectedNightsIndexes && selectedNightsIndexes.indexOf(day.index) !== -1 ) print('selected') 
	__p+=' ';
	 if ( day.weekend ) print('weekend') 
	__p+='">'+
	((__t=( day.day ))==null?'':__t)+
	'</th>\n			';
	 }) 
	__p+='\n		</tr>\n	</thead>\n\n	<tbody>\n		';
	 _.each(classes, function(klass, class_i) { 
	__p+='\n		<tr>\n			<th>\n				<div class="class-name">'+
	((__t=( klass.name ))==null?'':__t)+
	'</div>\n				<div class="class-info">'+
	((__t=( klass.info ))==null?'':__t)+
	'</div>\n			</th>\n			';
	
					_.each(klass.days, function(day) {
				
	__p+='\n			<td class="'+
	((__t=( day.className ))==null?'':__t)+
	' '+
	((__t=( day.helperClasses ))==null?'':__t)+
	' day_'+
	((__t=( day.index ))==null?'':__t)+
	' cell_'+
	((__t=( class_i ))==null?'':__t)+
	'_'+
	((__t=( day.index ))==null?'':__t)+
	'" data-class-offset="'+
	((__t=( class_i ))==null?'':__t)+
	'" data-day-offset="'+
	((__t=( day.index ))==null?'':__t)+
	'">\n				<div></div>\n				<span></span>\n			</td>\n			';
	 }) 
	__p+='\n		</tr>\n		';
	 }) 
	__p+='\n	</tbody>\n\n	';
	 if ( classes.length >= 10 ) { 
	__p+='\n	<tfoot>\n		<tr class="days">\n			<th>&nbsp;</th>\n			';
	 _.each(days, function(day) { 
	__p+='\n				<th class="day_'+
	((__t=( day.index ))==null?'':__t)+
	' ';
	 if ( selectedNightsIndexes.indexOf(day.index) !== -1 ) print('selected') 
	__p+=' ';
	 if ( day.weekend ) print('weekend') 
	__p+='">'+
	((__t=( day.day ))==null?'':__t)+
	'</th>\n			';
	 }) 
	__p+='\n		</tr>\n		<tr class="months">\n			<th>&nbsp;</th>\n			';
	 _.each(months, function(month) { 
	__p+='\n				<th colspan="'+
	((__t=( monthCounters[month] ))==null?'':__t)+
	'"><div>'+
	((__t=( month ))==null?'':__t)+
	'</div></th>\n			';
	 }) 
	__p+='\n		</tr>\n	</tfoot>\n	';
	 } 
	__p+='\n\n</table>\n\n';
	}
	return __p;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='';
	 if ( typeof days === "undefined" ) { 
	__p+='\n\n	Bitte wählen Sie einen Zeitraum aus, um Preise zu erhalten.\n\n';
	 } else { 
	__p+='\n\n<div class="controls">\n	<span class="pricetable-info">'+
	((__t=( info ))==null?'':__t)+
	'</span>\n\n	<div class="right button offset-up" data-days="7" ';
	 if ( !canGoFurther ) print('disabled') 
	__p+='>&gt;&gt;</div>\n	<div class="right button offset-up" data-days="1" ';
	 if ( !canGoFurther ) print('disabled') 
	__p+='>&gt;</div>\n	';
	 if ( developer ) { 
	__p+='<div class="right button offset-up" data-days="1" ';
	 if ( !canGoFurther ) print('disabled') 
	__p+='>+1d</div>';
	 } 
	__p+='\n\n\n	<div class="right button btn-reset">'+
	((__t=( __('today') ))==null?'':__t)+
	'</div>\n\n	';
	 if ( developer ) { 
	__p+='<div class="right button offset-down" data-days="1" '+
	((__t=( renderOffset === 0 ? 'disabled' : '' ))==null?'':__t)+
	'>-1d</div>';
	 } 
	__p+='\n	<div class="right button offset-down" data-days="1" '+
	((__t=( renderOffset === 0 ? 'disabled' : '' ))==null?'':__t)+
	'>&lt;</div>\n	<div class="right button offset-down" data-days="7" '+
	((__t=( renderOffset === 0 ? 'disabled' : '' ))==null?'':__t)+
	'>&lt;&lt;</div>\n\n	<div class="clear"></div>\n</div>\n\n<table>\n	<thead>\n		<tr>\n			<th>&nbsp;</th>\n			';
	 _.each(days, function(day) { 
	__p+='\n				<th class="day_'+
	((__t=( day.index ))==null?'':__t)+
	' ';
	 if ( selectedNightString == day.date ) print('highlight') 
	__p+=' ';
	 if ( day.weekend ) print('weekend') 
	__p+='">\n					'+
	((__t=( day.line1 ))==null?'':__t)+
	'<br>\n					<b>'+
	((__t=( day.line2 ))==null?'':__t)+
	'</b>\n				</th>\n			';
	 }) 
	__p+='\n		</tr>\n	</thead>\n\n	<tbody>\n		';
	 _.each(groups, function (group) { 
	__p+='\n		<tr>\n			<td class="divider" colspan="'+
	((__t=( renderDaysCount + 1 ))==null?'':__t)+
	'">'+
	((__t=( group.title ))==null?'':__t)+
	'</td>\n		</tr>\n\n			';
	 _.each(group.offers, function (offer) { 
	__p+='\n				<tr>\n					<td class="kat">\n						<b>'+
	((__t=( offer.title ))==null?'':__t)+
	'</b>\n						<br/>'+
	((__t=( offer.subtitle ))==null?'':__t)+
	'\n					</td>\n					';
	 _.each(days, function(day, i) { 
	__p+='\n						';
	 var value = offer.values[i] 
	__p+='\n						';
	 var display_value = offer.values_display[i] 
	__p+='\n						';
	 if ( display_value === "" ) { 
	__p+='\n						<td class="na ';
	 if ( day.weekend ) print('weekend') 
	__p+=' ';
	 if ( day.selected ) print('highlight') 
	__p+='">&times;</a></td>\n						';
	 } else { 
	__p+='\n						<td class="ok ';
	 if ( day.weekend ) print('weekend') 
	__p+=' ';
	 if ( day.selected ) print('highlight') 
	__p+='">\n							<a href="#"\n							  class="price"\n							  data-class="'+
	((__t=( offer.class ))==null?'':__t)+
	'"\n							  data-client="'+
	((__t=( offer.client ))==null?'':__t)+
	'"\n							  data-item="'+
	((__t=( offer.item ))==null?'':__t)+
	'"\n							  data-url="'+
	((__t=( offer.url ))==null?'':__t)+
	'"\n							  data-from="'+
	((__t=( day.date ))==null?'':__t)+
	'"\n							>\n								';
	 if ( value < 0 ) { 
	__p+='ab<br>';
	 } 
	__p+='\n								'+
	((__t=( display_value ))==null?'':__t)+
	'\n							</a>\n						</td>\n						';
	 } 
	__p+='\n					';
	 }) 
	__p+='\n				</tr>\n\n			';
	 }) 
	__p+='\n		';
	 }) 
	__p+='\n	</tbody>\n\n</table>\n\n';
	 } 
	__p+='\n';
	}
	return __p;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<style type="text/css" media="screen">\na.button.button-prod-more {\n	min-width: 75px;\n	text-align: center;\n	display: inline-block;\n	text-transform: uppercase;\n	font-weight: bold;\n	font-size: 14px;\n	padding: 5px 30px;\n	color: #fff !important;\n	background-color: #444;\n	cursor: pointer;\n	text-decoration: none;\n	margin-bottom: 10px;\n}\n</style>\n\n';
	 if ( results && results.length > 0 ) { 
	__p+='\n\n	';
	 _.each( results, function(result) { 
	__p+='\n\n	';
	 if ( results.length > 1 ) { 
	__p+='\n	<div class="class focus">\n		<h3>'+
	((__t=( result.name ))==null?'':__t)+
	'</h3>\n	</div>\n	';
	 } 
	__p+='\n\n\n	';
	 if ( item && result.item_name  ) { 
	__p+='\n\n		<div class="class focus">\n	\n			<div class="col images">\n				';
	 if ( result.item_image ) { 
	__p+='\n					<div class="image">\n						<div class="inner" style="background-image: url(//tramino.s3.amazonaws.com'+
	((__t=( result.item_image ))==null?'':__t)+
	')"></div>\n					</div>\n				';
	 } else { 
	__p+='\n					&nbsp;\n				';
	 }  
	__p+='\n			</div>\n\n			<div class="col info">\n\n				<h4>'+
	((__t=( __('item_focused') ))==null?'':__t)+
	'</h4>\n				<h2>'+
	((__t=( result.item_name ))==null?'':__t)+
	'</h2>\n				';
	 if ( result.item_subheadline ) { 
	__p+='<h6>'+
	((__t=( result.item_subheadline ))==null?'':__t)+
	'</h6>';
	 } 
	__p+='\n\n				';
	 if ( result.item_info ) { 
	__p+='\n					<div class="line">'+
	((__t=( result.item_info.substr(0, 250) ))==null?'':__t)+
	'</div>\n				';
	 } 
	__p+='\n\n				';
	 if ( result.item_text ) { 
	__p+='\n					<div class="line details details-1">'+
	((__t=( result.item_text.substr(0, 1000).replace("\n","<br>") ))==null?'':__t)+
	'</div>\n				';
	 } 
	__p+='\n\n				';
	 console.log("---focus", result) 
	__p+='\n\n				';
	 if ( result.item_link ) { 
	__p+='\n					<a class="button button-prod-more" href="'+
	((__t=( item.link ))==null?'':__t)+
	'" target="_blank" rel="noopener">\n						'+
	((__t=( __('more_info') ))==null?'':__t)+
	'\n					</a>\n\n				';
	 } 
	__p+='\n\n			</div>\n\n			<div class="col book">\n				<div class="inner">\n					<a href="" class="reset-item">&times;</a>\n				</div>\n			</div>\n\n			<div class="clear"></div>\n\n		</div>\n\n	';
	 } 
	__p+='\n\n	';
	
			var occupiedCount = 0;
			_.each(result.classes, function(item) {
				if ( item.occupied ) occupiedCount++
			});
			if ( result.classes.length == occupiedCount ) occupiedCount = 0; // wenn alles belegt
			if ( result.classes.length < 8 ) occupiedCount = 0; // kleinere Betriebe ausschliessen
		
	__p+='\n\n	';
	 _.each(result.classes, function(item) { 
	__p+='\n\n	<div id="class_'+
	((__t=( item.id ))==null?'':__t)+
	'" class="class C'+
	((__t=( result.client_id ))==null?'':__t)+
	' '+
	((__t=( item.occupied && occupiedCount > 3 ? 'item-occupied' : '' ))==null?'':__t)+
	'" data-class="'+
	((__t=( item.id ))==null?'':__t)+
	'" '+
	((__t=( item.occupied && occupiedCount > 3 ? 'style="display: none"' : '' ))==null?'':__t)+
	'>\n\n		<div class="col images">\n			';
	 if ( item.images ) { 
	__p+='\n				<div class="slider">\n\n					';
	 _.each( item.images.reverse(), function(img) { 
	__p+='\n						<div class="slider_inner">\n							';
	 var imgbig = img.replace("600x400", "1200") 
	__p+='\n							<a href="//tramino.s3.amazonaws.com'+
	((__t=( imgbig ))==null?'':__t)+
	'" class=" fancybox image" title="'+
	((__t=( item.name ))==null?'':__t)+
	'" rel="r'+
	((__t=( item.id ))==null?'':__t)+
	'">\n								<div class="inner" style="background-image: url(//tramino.s3.amazonaws.com'+
	((__t=( img ))==null?'':__t)+
	')"></div>\n							</a>\n							';
	 if ( item.images.length > 1 ) { 
	__p+='\n								<div class="arrow prev"><div class="arrow-inner"></div></div>\n								<div class="arrow next"><div class="arrow-inner"></div></div>\n							';
	 } 
	__p+='\n						</div>				\n					';
	 }) 
	__p+='\n					\n				</div>\n			';
	 } else if ( item.image ) { 
	__p+='\n				<div class="image">\n					<div class="inner" style="background-image: url(//tramino.s3.amazonaws.com'+
	((__t=( item.image ))==null?'':__t)+
	')"></div>\n				</div>\n			';
	 } else { 
	__p+='\n				&nbsp;\n			';
	 } 
	__p+='\n			';
	 if ( item.stars ) { 
	__p+='\n			 	<div class="stars">'+
	((__t=( __('result_validated') ))==null?'':__t)+
	'<br/>'+
	((__t=( item.stars ))==null?'':__t)+
	'</div>\n			';
	 } 
	__p+='\n		</div>\n\n		<div class="col info">\n\n			';
	 if ( item.subheadline ) { 
	__p+='<h4>'+
	((__t=( item.subheadline ))==null?'':__t)+
	'</h4>';
	 } 
	__p+='\n			\n			<h2>'+
	((__t=( item.name ))==null?'':__t)+
	'</h2>\n			\n			<div class="line">\n\n				<div class="col text">\n					<div class="inner">\n						';
	 if ( item.info ) { var s=item.info.substr( 0, 250); print(s); }
	__p+='\n					</div>\n				</div>\n\n				<div class="col facts item-facts">\n					<div class="inner">'+
	((__t=( item.facts ))==null?'':__t)+
	'</div>\n				</div>\n\n				<div class="clear"></div>\n			</div>\n\n			<div class="line tags">\n				';
	 _.each( item.tags, function( tag ) { 
	__p+='\n					';
	 if ( typeof tag == "string" ) { 
	__p+='\n						<div class="tag">&#10003;&nbsp;&nbsp;&nbsp;'+
	((__t=( tag ))==null?'':__t)+
	'</div>\n					';
	 } else { 
	__p+='\n						<div class="tag">\n							&#10003;&nbsp;&nbsp;&nbsp;\n							<b>'+
	((__t=( tag.name ))==null?'':__t)+
	':</b>\n							'+
	((__t=( tag.tags.join(", ") ))==null?'':__t)+
	'\n						</div>\n					';
	 } 
	__p+='\n				';
	 }) 
	__p+='\n			</div>\n\n			';
	 if ( item.text ) { 
	__p+='\n				<div class="line details details-2">';
	 var s=item.text.substr( 0, 1000); print(s); 
	__p+='</div>\n			';
	 } 
	__p+='\n\n\n\n			';
	 if ( item.packages ) { 
	__p+='\n			<div class="subclasses" id="subclasses'+
	((__t=( item.id ))==null?'':__t)+
	'" style="display: block">\n				';
	 _.each( item.packages, function(c) { 
	__p+='			 \n					';
	 if ( c.price ) { 
	__p+='\n						<div class="subclass">\n							<div class="name">\n								'+
	((__t=( c.name ))==null?'':__t)+
	'\n								<div class="subclass-info">\n									'+
	((__t=( c.subheadline ? c.subheadline.substr( 0, 140) : "" ))==null?'':__t)+
	'\n\n									<a href="#reserva-package-'+
	((__t=( c.id ))==null?'':__t)+
	'" class="package-links">\n										&middot;&middot;&middot;\n									</a>\n								</div>\n							</div>\n							\n							<div class="subclass-price">\n								\n								';
	 if ( c.discount_id ) { 
	__p+='\n									<div class="subclass-discount">\n										<div class="subclass-discount-name">'+
	((__t=( c.discount_name ))==null?'':__t)+
	'</div>\n										<del>'+
	((__t=( currencyHTML( c.discount_base, "EUR" ) ))==null?'':__t)+
	'</del>\n										<div class="discount_popup"></div>\n										<div class="discount_details" style="display: none;">\n											'+
	((__t=( c.discount_details ))==null?'':__t)+
	'\n										</div>\n									</div>\n								';
	 } 
	__p+='\n\n								<div class="subclass-amount">'+
	((__t=( currencyHTML( c.price, "EUR" ) ))==null?'':__t)+
	'</div>\n\n								';
	 if ( c.inkl ) { 
	__p+='\n									<div class="subclass-facts">\n										';
	 if ( c.inkl ) print("inkl. " + c.inkl) 
	__p+='\n										';
	 if ( item.show_spa_tax ) print( ", " + __('add_spa_tax') ) 
	__p+=' \n									</div>\n								';
	 } 
	__p+='\n							</div>\n							<div class="subclass-action">\n								<div class="button-subclass button-booking button-booking-1"\n									 data-discount="'+
	((__t=( c.discount_id ))==null?'':__t)+
	'"\n									 data-item="'+
	((__t=( c.id ))==null?'':__t)+
	'"\n									 data-class="'+
	((__t=( item.id ))==null?'':__t)+
	'">\n									'+
	((__t=( __('order') ))==null?'':__t)+
	'\n								</div>\n							</div>\n							<div class="clear"></div>\n						</div>\n					';
	 } 
	__p+='\n				';
	 }) 
	__p+='\n\n				';
	 if ( item.packages && item.packages.length > 0 ) { 
	__p+='\n					<a href="#reserva-packages" class="button-more">'+
	((__t=( __('more_offers') ))==null?'':__t)+
	'</a>';
	 } 
	__p+='\n			</div><!-- /.subclasses -->\n			';
	 } 
	__p+=' \n\n\n		</div>\n\n		<div class="col book">\n			<div class="inner">\n	\n				';
	 if ( item.price ) { 
	__p+='\n\n					';
	 if ( item.price_info ) { 
	__p+='<div class="text">'+
	((__t=( item.price_info  ))==null?'':__t)+
	'</div>';
	 } 
	__p+='\n\n					<div class="price">\n							';
	 if ( item.discount_id ) { 
	__p+='\n								<div class="discount">\n									<div class="discount-name">'+
	((__t=( item.discount_name ))==null?'':__t)+
	'</div>\n									<del>'+
	((__t=( currencyHTML( item.discount_base, "EUR" ) ))==null?'':__t)+
	'</del>\n									';
	 if ( item.discount_details ) { 
	__p+='\n										<div class="discount_popup"></div>\n										<div class="discount_details" style="display: none;">\n											'+
	((__t=( item.discount_details ))==null?'':__t)+
	'\n										</div>\n									';
	 } 
	__p+='\n								</div>\n								\n							';
	 } 
	__p+='\n							'+
	((__t=( currencyHTML( item.price, "EUR" ) ))==null?'':__t)+
	'\n					</div>\n\n\n					';
	 if ( result.booking ) { 
	__p+='\n						';
	 if ( registry('ResultView.ShowRequestButton') ) { 
	__p+='\n						<div class="button button-request button-inquiry"\n							 data-discount="'+
	((__t=( item.discount_id ))==null?'':__t)+
	'"\n							 data-item="'+
	((__t=( item.item ))==null?'':__t)+
	'"\n							 data-class="'+
	((__t=( item.id ))==null?'':__t)+
	'">\n							'+
	((__t=( __('inquiry') ))==null?'':__t)+
	'\n						</div>\n						';
	 } 
	__p+='\n\n						<div class="button button-booking button-booking-2"\n							 data-discount="'+
	((__t=( item.discount_id ))==null?'':__t)+
	'"\n							 data-item="'+
	((__t=( item.item ))==null?'':__t)+
	'"\n							 data-class="'+
	((__t=( item.id ))==null?'':__t)+
	'">\n							 	'+
	((__t=( __('order') ))==null?'':__t)+
	'\n						</div>\n					';
	 } else { 
	__p+='\n						<div class="button button-request">'+
	((__t=( __('inquiry') ))==null?'':__t)+
	'</div>\n					';
	 } 
	__p+='\n\n					<div class="text">\n						';
	 if ( item.item_name ) { 
	__p+='<b>'+
	((__t=( item.item_name ))==null?'':__t)+
	'</b><br/>';
	 } 
	__p+='\n						'+
	((__t=( __('total_price') ))==null?'':__t)+
	' \n						';
	 if ( item.inkl ) print( __('item_includes', { item: item.inkl} ) ) 
	__p+=' \n						';
	 if ( item.inkl && item.show_spa_tax ) print( __('add_spa_tax') ) 
	__p+=' \n					</div>\n					\n					';
	 if ( item.options ) { 
	__p+='\n						<div class="booking-options">\n						';
	 _.each( item.options, function( option ) { 
	__p+='\n							<div class="booking-option">\n								'+
	((__t=( option.name ))==null?'':__t)+
	'\n								<select name="option_'+
	((__t=( option.id ))==null?'':__t)+
	'">\n								';
	 _.each( option.classes, function( o ) { 
	__p+='\n									<option value="'+
	((__t=( o.id ))==null?'':__t)+
	'">'+
	((__t=( o.name ))==null?'':__t)+
	' \n										';
	 if ( o.inclusive ) { 
	__p+='(inkl.)';
	 } else { 
	__p+='\n											'+
	((__t=( o.price > 0 ? "+" : "" ))==null?'':__t)+
	''+
	((__t=( currencyHTML( o.price, "EUR" ) ))==null?'':__t)+
	'\n									';
	 } 
	__p+='</option>\n								';
	 }) 
	__p+='\n								</select>\n							</div>\n						';
	 }) 
	__p+='\n						</div>\n					';
	 } 
	__p+='\n					\n\n				';
	 } else { 
	__p+='\n					<div class="price">\n						';
	 if ( item.occupied ) { 
	__p+='\n							<div class="missing">'+
	((__t=( item.occupied ))==null?'':__t)+
	'</div>\n						';
	 } else { 
	__p+='\n							<div class="missing">'+
	((__t=( __('price_no_query') ))==null?'':__t)+
	'</div>\n						';
	 } 
	__p+='\n					</div>\n					';
	 if ( !item.occupied ) { 
	__p+='\n						<div class="button button-more" onclick="miniEngine.setItem(\'\').then(miniEngine.app.showDatepicker); $(\'html, body\').animate({ scrollTop: $(\'#detail-booking\').offset().top}, 300);">\n							'+
	((__t=( __('search') ))==null?'':__t)+
	'\n						</div>\n					';
	 } else { 
	__p+='\n						<div class="button button-request">'+
	((__t=( __('inquiry') ))==null?'':__t)+
	'</div>\n					';
	 } 
	__p+='		\n				';
	 } 
	__p+='\n			</div>\n		</div>\n\n		<div class="clear"></div>\n\n\n		<button class="show-result-timetable" data-klass="'+
	((__t=( item.id ))==null?'':__t)+
	'" data-client="'+
	((__t=( result.client_id ))==null?'':__t)+
	'" data-for="#result-timetable-'+
	((__t=( item.id ))==null?'':__t)+
	'">'+
	((__t=( __('occupancy_plan') ))==null?'':__t)+
	'</button>\n		<div id="result-timetable-'+
	((__t=( item.id ))==null?'':__t)+
	'" class="class-timetable"></div>\n\n	</div>\n\n\n	';
	 }) 
	__p+='\n	\n\n	';
	 if ( occupiedCount > 3 ) { 
	__p+='\n\n		<div class="item-occupied-show-button" onclick="$(\'.item-occupied.C'+
	((__t=( result.client_id ))==null?'':__t)+
	'\').show(); $(this).hide();">\n			'+
	((__t=( __("showUnavailableClasses", {occupiedCount: occupiedCount}) ))==null?'':__t)+
	'\n		</div>\n\n	';
	 } 
	__p+='\n\n\n\n	';
	 if ( result.packages && result.packages.length > 0 ) { 
	__p+=' <h5 class="normal packages-title">'+
	((__t=( __('packages') ))==null?'':__t)+
	'</h5>';
	 } 
	__p+='\n	<div class="anker" id="reserva-packages"></div>\n\n	';
	 _.each(result.packages, function(item) { 
	__p+='\n\n	<div class="class package">\n		<div class="anker" id="reserva-package-'+
	((__t=( item.id ))==null?'':__t)+
	'"></div>\n		<div class="col images">\n			';
	 if ( item.image ) { 
	__p+='\n				<div class="image">\n					<div class="inner" style="background-image: url(//tramino.s3.amazonaws.com'+
	((__t=( item.image ))==null?'':__t)+
	')"></div>\n				</div>\n			';
	 } else { 
	__p+='\n				&nbsp;\n			';
	 }  
	__p+='\n		</div>\n\n		<div class="col info">\n\n			<h4>'+
	((__t=( __('package') ))==null?'':__t)+
	'</h4>\n			<h2>'+
	((__t=( item.name ))==null?'':__t)+
	'</h2>\n			';
	 if ( item.subheadline ) { 
	__p+='<h6>'+
	((__t=( item.subheadline ))==null?'':__t)+
	'</h6>';
	 } 
	__p+='\n\n			<div class="line">\n				<div class="col text">\n					<div class="inner">';
	 if ( item.info ) { var s = item.info.substr( 0, 250 ); print(s); } 
	__p+='</div>\n				</div>\n				<div class="col facts package-item-facts">\n					<div class="inner">'+
	((__t=( item.facts.split(",").join("<br>") ))==null?'':__t)+
	'</div>\n				</div>\n				<div class="clear"></div>\n			</div>\n\n			\n\n			<div class="subclasses" id="subclasses'+
	((__t=( item.id ))==null?'':__t)+
	'">\n				';
	 _.each(item.classes, function(c) { 
	__p+='\n					';
	 if ( c.price ) { 
	__p+='\n						<div class="subclass">\n							<div class="name">'+
	((__t=( c.name ))==null?'':__t)+
	'</div>\n							<div class="subclass-price">\n								<div class="subclass-amount">'+
	((__t=( currencyHTML( c.price, "EUR" ) ))==null?'':__t)+
	'</div>\n								';
	 if ( c.facts ) { 
	__p+='<div class="subclass-facts">'+
	((__t=( c.facts ))==null?'':__t)+
	'</div>';
	 } 
	__p+='\n							</div>\n							<div class="subclass-action">\n								<div class="button-subclass button-booking button-booking-3"\n									 data-item="'+
	((__t=( item.id ))==null?'':__t)+
	'"\n									 data-class="'+
	((__t=( c.id ))==null?'':__t)+
	'">\n									 	'+
	((__t=( __('order') ))==null?'':__t)+
	'\n								</div>\n							</div>\n							<div class="clear"></div>\n						</div>\n					';
	 } 
	__p+='\n				';
	 }) 
	__p+='\n			</div>\n\n			';
	 if ( item.text ) { 
	__p+='\n				<div class="line details details-3">';
	 var s=item.text.substr( 0, 1000); print(s); 
	__p+='</div>\n			';
	 } 
	__p+='\n\n			';
	 if ( item.link ) { 
	__p+='\n				<a class="button button-prod-more" href="'+
	((__t=( item.link ))==null?'':__t)+
	'" target="_blank" rel="noopener">\n					'+
	((__t=( __('more_info') ))==null?'':__t)+
	'\n				</a>\n			';
	 } 
	__p+='\n	\n		</div>\n\n		<div class="col book">\n			<div class="inner">\n				';
	 if ( item.price_min ) { 
	__p+='\n					<div class="price">\n						<span class="preis-ab">'+
	((__t=( __('price_from') ))==null?'':__t)+
	'</span>\n						'+
	((__t=( currencyHTML( item.price_min, "EUR" ) ))==null?'':__t)+
	'\n					</div>\n					<div class="button button-more" onclick="$(\'#subclasses'+
	((__t=( item.id ))==null?'':__t)+
	'\').slideDown(); $(this).fadeOut();">Mehr</div>\n					<div class="text">\n						'+
	((__t=( __('total_price') ))==null?'':__t)+
	' \n						';
	 if ( item.inkl ) print( __('item_includes', { item: item.inkl} ) ) 
	__p+=' \n						';
	 if ( item.inkl && Tramino.client != 620 ) print( __('add_spa_tax') ) 
	__p+=' \n					</div>\n				';
	 } else { 
	__p+='\n					<div class="price"><div class="missing">'+
	((__t=( __('price_no_query') ))==null?'':__t)+
	'</div></div>\n					<div class="button button-more" \n						onclick="miniEngine.setItem(\''+
	((__t=( item.id ))==null?'':__t)+
	'\').then(miniEngine.app.showDatepicker); miniEngine.search(); $(\'html,body\').animate({\'scrollTop\': 0})">'+
	((__t=( __('search') ))==null?'':__t)+
	'</div>\n				';
	 } 
	__p+='\n			</div>\n		</div>\n\n		<div class="clear"></div>\n	</div>\n\n\n	';
	 }) /* end result.packages */ 
	__p+='\n\n\n	';
	 }) /* end results */ 
	__p+='\n\n';
	 } else if ( error ) { 
	__p+='\n\n	<div class="notify results-404">\n		<h3>'+
	((__t=( __('result_error_subtitle') ))==null?'':__t)+
	'</h3>\n		'+
	((__t=( error ))==null?'':__t)+
	'\n	</div>\n\n';
	 } else if ( isLoading ) { 
	__p+='\n\n	<div class="notify results-loading">\n		<h3>'+
	((__t=( __('loading_text') ))==null?'':__t)+
	'</h3>\n	</div>\n\n';
	 } else { 
	__p+='\n\n	<div class="notify results-404">\n		<h3>'+
	((__t=( __('results_404_title') ))==null?'':__t)+
	'</h3>\n		'+
	((__t=( __('results_404_prefix') ))==null?'':__t)+
	'\n		 <a href="#" \n			onclick="miniEngine.app.formModel.set({ rooms: 0, select_mode: \'none\' })">'+
	((__t=( __('results_404_link') ))==null?'':__t)+
	'</a>\n	</div>\n\n';
	 } 
	__p+='\n';
	}
	return __p;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='';
	 if ( products && products.length ) { 
	__p+='\n\n	<h5 class="normal">'+
	((__t=( __('products_and_services') ))==null?'':__t)+
	'</h5>\n\n	';
	 _.each( products, function(item) { 
	__p+='\n\n		<div class="class">\n\n			<div class="col images">\n				';
	 if ( item.image ) { 
	__p+='\n					<div class="image">\n						<div class="inner" style="background-image: url(//tramino.s3.amazonaws.com'+
	((__t=( item.image ))==null?'':__t)+
	')"></div>\n					</div>\n				';
	 } else { 
	__p+='\n					&nbsp;\n				';
	 } 
	__p+='\n			</div>\n\n			<div class="col info">\n\n				<h4>'+
	((__t=( __('product') ))==null?'':__t)+
	'</h4>\n				<h2>'+
	((__t=( item.name ))==null?'':__t)+
	'</h2>\n\n				<div class="line">\n					<div class="col text">\n						<div class="inner">\n							';
	 if ( item.info ) { 
	__p+='\n								';
	 var s=item.info.substr( 0, 250); print(s); 
	__p+='\n							';
	 } 
	__p+='\n						</div>\n					</div>\n					<div class="col facts">\n						<div class="inner">'+
	((__t=( item.facts ))==null?'':__t)+
	'</div>\n					</div>\n					<div class="clear"></div>\n				</div>\n\n				';
	 if ( item.classes.length >= 2 ) { 
	__p+='\n				<div class="subclasses" id="subclasses'+
	((__t=( item.id ))==null?'':__t)+
	'">\n					';
	 _.each( item.classes, function(c) { 
	__p+='\n					\n						<div class="subclass">\n\n							<div class="name">'+
	((__t=( c.name ))==null?'':__t)+
	'</div>\n							<div class="subclass-price">\n								<div class="subclass-amount">'+
	((__t=( currencyHTML(  c.price, "EUR" ) ))==null?'':__t)+
	'</div>\n								';
	 if ( c.facts ) { 
	__p+='<div class="subclass-facts">'+
	((__t=( c.facts ))==null?'':__t)+
	'</div>';
	 } 
	__p+='\n							</div>\n							<div class="subclass-action">\n								';
	 if ( c.price && c.booking ) { 
	__p+='\n								<div class="button-subclass button-booking" data-item="'+
	((__t=( item.id ))==null?'':__t)+
	'" data-class="'+
	((__t=( c.id ))==null?'':__t)+
	'">'+
	((__t=( __('order') ))==null?'':__t)+
	'</div>\n								';
	 } 
	__p+='\n							</div>\n							<div class="clear"></div>\n						</div>\n						\n					';
	 }) 
	__p+='\n				</div>\n				';
	 } 
	__p+='\n\n				';
	 if ( item.text ) { 
	__p+='\n					<div class="line details details-4">'+
	((__t=( item.text.substr(0, 1000).replace("\n","<br>") ))==null?'':__t)+
	'</div>\n				';
	 } 
	__p+='\n\n\n				';
	 if ( item.link ) { 
	__p+='\n					<a class="button button-prod-more" href="'+
	((__t=( item.link ))==null?'':__t)+
	'" target="_blank" rel="noopener">\n						'+
	((__t=( __('more_info') ))==null?'':__t)+
	'\n					</a>\n\n					<style type="text/css" media="screen">\n					a.button.button-prod-more {\n						min-width: 75px;\n						text-align: center;\n						display: inline-block;\n						text-transform: uppercase;\n						font-weight: bold;\n						font-size: 14px;\n						padding: 5px 30px;\n						color: #fff !important;\n						background-color: #444;\n						cursor: pointer;\n					}\n					a.button.button-prod-more:active {\n						text-decoration: none;\n					}\n					</style>\n				';
	 } 
	__p+='\n\n			</div>\n\n			<div class="col book">\n				<div class="inner">\n					';
	 if ( item.price_min ) { 
	__p+='\n						';
	 if ( item.classes.length == 1 ) { 
	__p+='\n							<div class="price">\n								'+
	((__t=( currencyHTML( item.classes[0].price, "EUR" ) ))==null?'':__t)+
	'\n							</div>\n							';
	 if ( parseInt(item.booking, 10) > 0 ) { 
	__p+='\n							<div class="button button-booking" data-item="'+
	((__t=( item.id ))==null?'':__t)+
	'" data-class="'+
	((__t=( item.classes[0].id ))==null?'':__t)+
	'">'+
	((__t=( __('order') ))==null?'':__t)+
	'</div>\n							';
	 } 
	__p+='\n						';
	 } else { 
	__p+='\n							<div class="price">\n								<span class="preis-ab">'+
	((__t=( __('price_from') ))==null?'':__t)+
	'</span>\n								'+
	((__t=( currencyHTML( item.price_min, "EUR" ) ))==null?'':__t)+
	'\n							</div>\n							<div class="button button-more" onclick="$(\'#subclasses'+
	((__t=( item.id ))==null?'':__t)+
	'\').slideDown(); $(this).fadeOut();">Mehr</div>\n						';
	 } 
	__p+='\n						';
	 if ( item.classes[0].facts ) { 
	__p+='\n							<div class="facts">\n								'+
	((__t=( item.classes[0].facts ))==null?'':__t)+
	'\n							</div>\n						';
	 } 
	__p+='\n					';
	 } 
	__p+='\n				</div>\n			</div>\n\n			<div class="clear"></div>\n		</div>\n\n	';
	 }) 
	__p+='\n\n';
	 } else if ( error ) { 
	__p+='\n\n	<div class="notify results-404">\n		<h3>Ein Fehler ist aufgetreten</h3>\n		'+
	((__t=( error ))==null?'':__t)+
	'\n	</div>\n\n';
	 } else if ( false ) { 
	__p+='\n\n	<div class="notify results-loading">\n		<h3>Produkte werden geladen ...</h3>\n	</div>\n\n';
	 } else if ( 0 ) { 
	__p+='\n\n	<div class="notify results-404">\n		<h3>Keine Produkte gefunden</h3>\n	</div>\n\n';
	 } 
	__p+='\n';
	}
	return __p;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='';
	 if ( itemsCount ) { 
	__p+='\n	<h5 class="count">'+
	((__t=( paginationInfo ))==null?'':__t)+
	'</h5>\n';
	 } 
	__p+='\n\n<div class="paginator">\n	<a href="" class="paginator-button ratings-prev ';
	 if ( hasPrev ) print('show') 
	__p+='">&larr;</a>\n	<a href="" class="paginator-button ratings-next ';
	 if ( hasNext ) print('show') 
	__p+='">&rarr;</a>\n</div>\n\n<div class="rating-list">\n\n	';
	 if ( itemsCount ) { 
	__p+='\n		';
	 _.each(items, function(item) { 
	__p+='\n\n			<div class="rating">\n\n				<div class="content">\n					\n					<h3>'+
	((__t=( item.titel ))==null?'':__t)+
	'</h3>\n					<div class="text">'+
	((__t=( item.text ))==null?'':__t)+
	'</div>\n\n					';
	 if ( item.response.length > 0 ) { 
	__p+='\n						<div class="response_group">\n							';
	 _.each(item.response, function(response) { 
	__p+='\n								<div class="response">\n									<div class="info">\n										<span class="username">'+
	((__t=( response.username ))==null?'':__t)+
	'</span>\n										<span class="datum"> am '+
	((__t=( response.datum ))==null?'':__t)+
	'</span>\n									</div>\n									'+
	((__t=( response.text ))==null?'':__t)+
	'\n								</div>\n							';
	 }); 
	__p+='\n						</div>\n					';
	 } 
	__p+='\n\n				</div>\n\n				<div class="context">\n					\n					'+
	((__t=( __('rated_on') ))==null?'':__t)+
	' '+
	((__t=( moment( item.created, "YYYY-MM-DD").format("L") ))==null?'':__t)+
	'<br>\n					<br>\n\n					<div class="stars">\n						';
	 if ( item.rating_1 == 1 ) print("<span>&#10029;</span>") 
	__p+='\n						';
	 if ( item.rating_1 == 2 ) print("<span>&#10029;&#10029;</span>") 
	__p+='\n						';
	 if ( item.rating_1 == 3 ) print("<span>&#10029;&#10029;&#10029;</span>") 
	__p+='\n						';
	 if ( item.rating_1 == 4 ) print("<span>&#10029;&#10029;&#10029;&#10029;</span>") 
	__p+='\n						';
	 if ( item.rating_1 == 5 ) print("<span>&#10029;&#10029;&#10029;&#10029;&#10029;</span>") 
	__p+='&nbsp;&nbsp;'+
	((__t=( __('rating_1') ))==null?'':__t)+
	'<br>\n						\n						';
	 if ( item.rating_2 == 1 ) print("<span>&#10029;</span>") 
	__p+='\n						';
	 if ( item.rating_2 == 2 ) print("<span>&#10029;&#10029;</span>") 
	__p+='\n						';
	 if ( item.rating_2 == 3 ) print("<span>&#10029;&#10029;&#10029;</span>") 
	__p+='\n						';
	 if ( item.rating_2 == 4 ) print("<span>&#10029;&#10029;&#10029;&#10029;</span>") 
	__p+='\n						';
	 if ( item.rating_2 == 5 ) print("<span>&#10029;&#10029;&#10029;&#10029;&#10029;</span>") 
	__p+='&nbsp;&nbsp;'+
	((__t=( __('rating_2') ))==null?'':__t)+
	'<br>\n					\n						';
	 if ( item.rating_3 == 1 ) print("<span>&#10029;</span>") 
	__p+='\n						';
	 if ( item.rating_3 == 2 ) print("<span>&#10029;&#10029;</span>") 
	__p+='\n						';
	 if ( item.rating_3 == 3 ) print("<span>&#10029;&#10029;&#10029;</span>") 
	__p+='\n						';
	 if ( item.rating_3 == 4 ) print("<span>&#10029;&#10029;&#10029;&#10029;</span>") 
	__p+='\n						';
	 if ( item.rating_3 == 5 ) print("<span>&#10029;&#10029;&#10029;&#10029;&#10029;</span>") 
	__p+='&nbsp;&nbsp;'+
	((__t=( __('rating_3') ))==null?'':__t)+
	'<br>\n					\n						';
	 if ( item.rating_4 == 1 ) print("<span>&#10029;</span>") 
	__p+='\n						';
	 if ( item.rating_4 == 2 ) print("<span>&#10029;&#10029;</span>") 
	__p+='\n						';
	 if ( item.rating_4 == 3 ) print("<span>&#10029;&#10029;&#10029;</span>") 
	__p+='\n						';
	 if ( item.rating_4 == 4 ) print("<span>&#10029;&#10029;&#10029;&#10029;</span>") 
	__p+='\n						';
	 if ( item.rating_4 == 5 ) print("<span>&#10029;&#10029;&#10029;&#10029;&#10029;</span>") 
	__p+='&nbsp;&nbsp;'+
	((__t=( __('rating_4') ))==null?'':__t)+
	'<br>\n					</div>\n					<br>\n	\n					\n					'+
	((__t=( __('age') ))==null?'':__t)+
	': '+
	((__t=( __('age_range', { from: parseInt( item.extra_alter ), to: parseInt( item.extra_alter ) + 9} ) ))==null?'':__t)+
	'\n					<br>\n		\n					'+
	((__t=( __('traveled_as_' + item.extra_typ) ))==null?'':__t)+
	'\n					<br>\n\n					';
	 if ( item.extra_dauer == 1 ) { 
	__p+=' 1-3 Tage\n					';
	 } else if ( item.extra_dauer == 4 ) { 
	__p+=' 4-6 Tage\n					';
	 } else if ( item.extra_dauer == 7 ) { 
	__p+=' '+
	((__t=( __('for_one_week') ))==null?'':__t)+
	'\n					';
	 } else if ( item.extra_dauer == 14 ) { 
	__p+=' '+
	((__t=( __('for_two_weeks') ))==null?'':__t)+
	'\n					';
	 } 
	__p+='\n					<br>\n\n					';
	 if ( item.jahr_tag >= 335 || item.jahr_tag < 79 ) print(__("in_winter")) 
	__p+=' \n					';
	 if ( item.jahr_tag >= 79 && item.jahr_tag < 172 ) print(__("in_spring")) 
	__p+=' \n					';
	 if ( item.jahr_tag >= 172 && item.jahr_tag < 266 ) print(__("in_summer")) 
	__p+=' \n					';
	 if ( item.jahr_tag >= 266 && item.jahr_tag < 335 ) print(__("in_autumn")) 
	__p+=' '+
	((__t=( item.jahr ))==null?'':__t)+
	'\n\n			       \n				';
	 if ( window.Tramino.client !== 100 ) { 
	__p+='\n					<div class="rating-button"><a href="?rate_client='+
	((__t=( client ))==null?'':__t)+
	'#detail-rating-tramino">'+
	((__t=( __('add_rating') ))==null?'':__t)+
	'</a></div>\n				';
	 } else { 
	__p+='\n					<div class="rating-button"><a href="/urlaubszuhause/bewertung.html?client='+
	((__t=( client ))==null?'':__t)+
	'">'+
	((__t=( __('add_rating') ))==null?'':__t)+
	'</a></div>\n				';
	 } 
	__p+='			        \n					\n\n\n				</div>\n		     	\n		     	<div class="clear"></div>\n\n	        </div>\n\n		';
	 }); 
	__p+='\n	';
	 } else { 
	__p+='\n		<div class="notification">'+
	((__t=( __('no_ratings') ))==null?'':__t)+
	'</div>\n	';
	 } 
	__p+='\n	\n	<div class="clear"></div>\n\n</div>\n';
	}
	return __p;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 77 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='\n';
	 _.each(classes, function(klass, class_i) { 
	__p+='\n	';
	 if ( filterClass && klass.name !== filterClass ) return; 
	__p+='\n\n	<h2>'+
	((__t=( klass.name ))==null?'':__t)+
	'</h2>\n\n	<table class="reserva-table-year" cellspacing="0" cellpadding="0">\n		<thead>\n			<tr>\n				<th>&nbsp;</th>\n				';
	 for(var j = 1; j <= 31; ++j) { 
	__p+='\n				<th>'+
	((__t=( j ))==null?'':__t)+
	'</th>\n				';
	 } 
	__p+='\n			</tr>\n		</thead>\n		<tbody>\n			';
	 var daysOffset = 0 
	__p+='\n			';
	 var end = false 
	__p+='\n			';
	 var year = (new Date()).getFullYear(); 
	__p+='\n\n			<!-- Cycle through each possible month, up to 4 years -->\n			';
	 for(var monthIndex = start.month(); monthIndex < 48; ++monthIndex) { if ( end ) break; 
	__p+='\n				\n				<!-- Break on next year -->\n				';
	 if ( monthIndex % 12 == 0 && monthIndex != 0 ) { 
	__p+='\n					';
	 year++ 
	__p+='\n					<tr class="break"><td colspan="32"></td></tr>\n				';
	 } 
	__p+='\n\n				<tr>\n					<!-- Left header -->\n					<th>\n						'+
	((__t=( monthNames[monthIndex % 12] ))==null?'':__t)+
	'\n						'+
	((__t=( (year + "").substring(2) ))==null?'':__t)+
	'\n					</th>\n\n					<!-- Fill every day of each month -->\n					';
	 for(var monthDayIndex = 0; monthDayIndex < monthDays[monthIndex]; ++monthDayIndex) { 
	__p+='\n						';
	 var day = klass.days[daysOffset]; 
	__p+='\n\n						<!-- Offset at the first month -->\n						';
	 if ( daysOffset === 0 && monthDayIndex === 0 && start.date() !== 1 ) { 
	__p+='\n							<td colspan="'+
	((__t=( start.date() - 1 ))==null?'':__t)+
	'" class="month-start"></td>\n							';
	 monthDayIndex += start.date() - 1 
	__p+='\n						';
	 } 
	__p+='\n\n						';
	 if ( day ) { 
	__p+='\n\n							<td class="day '+
	((__t=( day.className ))==null?'':__t)+
	' '+
	((__t=( day.helperClasses ))==null?'':__t)+
	' cell_'+
	((__t=( class_i ))==null?'':__t)+
	'_'+
	((__t=( day.index ))==null?'':__t)+
	'" data-class-offset="'+
	((__t=( class_i ))==null?'':__t)+
	'" data-day-offset="'+
	((__t=( day.index ))==null?'':__t)+
	'" data-day="'+
	((__t=( day.date.format('LL') ))==null?'':__t)+
	'" data-daysOffset="'+
	((__t=( daysOffset ))==null?'':__t)+
	'">\n								<div></div>\n								';
	 if ( day.helperClasses.indexOf("weekend") !== -1 ) { 
	__p+='\n									<b></b>\n								';
	 } 
	__p+='\n								<span></span>\n							</td>\n\n							';
	 daysOffset++; 
	__p+='\n\n						';
	 } else { 
	__p+='\n\n							';
	 end = true; 
	__p+='\n\n							<td class="day rest">\n								<div></div>\n							</td>\n\n						';
	 } 
	__p+='\n\n					';
	 } 
	__p+='\n\n					';
	 if ( monthDays[monthIndex] < 31 ) { 
	__p+='\n						<td colspan="'+
	((__t=( 31 - monthDays[monthIndex] ))==null?'':__t)+
	'" class="month-rest"></td>\n					';
	 } 
	__p+='\n\n				</tr>\n			';
	 } 
	__p+='\n		</tbody>\n	</table>\n\n';
	 }) 
	__p+='\n';
	}
	return __p;
	};

/***/ }),
/* 78 */
/***/ (function(module, exports) {

	module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='';
	 if ( error ) { 
	__p+='\n\n	<p class="interest-filter-error">\n		'+
	((__t=( error ))==null?'':__t)+
	'\n	</p>\n\n';
	 } else { 
	__p+='\n\n	';
	 if ( loading ) { 
	__p+='\n\n		<p class="interest-filter-loading">\n			Interessen werden geladen, einen Moment bitte...\n		</p>\n\n	';
	 } else { 
	__p+='\n\n		';
	 if ( local ) { 
	__p+='\n\n			<p>Ergebnisse '+
	((__t=( totalCount ))==null?'':__t)+
	'</p>\n			<p>\n				Tags '+
	((__t=( selectedTags.join(", ") ))==null?'':__t)+
	'\n				<button class="tags-reset">Reset selectedTags</button>\n				<button class="tags-submit">Submit</button>\n			</p>\n\n		';
	 } 
	__p+='\n\n		<div class="interest-filter">\n\n			';
	 _.each(tagGroups, function(group) { 
	__p+='\n				<div class="grid-box">\n					<h2>'+
	((__t=( group.name ))==null?'':__t)+
	'</h2>\n\n					<div class="grid-box-tags">\n						';
	 _.each(group.tags, function(tag) { 
	__p+='\n						<div class="tag-box '+
	((__t=( selectedTags.indexOf(tag.id) !== -1 ? "tag-selected" : "" ))==null?'':__t)+
	' '+
	((__t=( tag.count === 0 ? "tag-empty" : "" ))==null?'':__t)+
	'" title="Tag '+
	((__t=( tag.id ))==null?'':__t)+
	'" data-tag="'+
	((__t=( tag.id ))==null?'':__t)+
	'">\n							<div class="tag-count">'+
	((__t=( tag.count ))==null?'':__t)+
	'</div>\n							<div class="tag-name">'+
	((__t=( tag.tag ))==null?'':__t)+
	'</div>\n							<div class="tag-info">'+
	((__t=( tag.info ))==null?'':__t)+
	'</div>\n							<img class="tag-image" src="'+
	((__t=( tag.image ))==null?'':__t)+
	'">\n							';
	 if ( selectedTags.indexOf(tag.id) !== -1 ) { 
	__p+='\n								<div class="tag-selected-overlay"></div>\n							';
	 } 
	__p+='\n						</div>\n						';
	 }) 
	__p+='\n					</div>\n\n				</div>\n			';
	 }) 
	__p+='\n		</div>\n\n	';
	 } 
	__p+='\n\n';
	 } 
	__p+='\n\n\n';
	 if ( local ) { 
	__p+='\n<style type="text/css" media="screen">\n.interest-filter {\n	display: flex;\n	width: 100%;\n	justify-content: center;\n}\n.interest-filter .grid-box {\n	padding: 20px;\n	width: calc(100% / 3);\n	border-right: 1px solid #b1b4a4;\n}\n.interest-filter .grid-box:last-child {\n	border-right: 0;\n}\n\n.interest-filter .grid-box h2 {\n	text-transform: uppercase;\n	color: #b1b4a4;\n	font-weight: 200;\n	font-size: 14pt;\n	padding-left: 10px;\n}\n.interest-filter .grid-box-tags {\n	display: flex;\n	flex-flow: row wrap;\n}\n\n.tag-box {\n	display: flex;\n	width: 150px;\n	cursor: pointer;\n	padding: 5px;\n	flex-flow: row wrap;\n	margin: 5px;\n	position: relative;\n}\n.tag-box.tag-empty {\n	opacity: 0.5;\n	cursor: default;\n}\n.tag-box.tag-selected {\n	background: #ddd;\n}\n\n\n.tag-box .tag-image {\n	width: 100%; height: 80px; border: 3px solid #ccc; border-radius: 8px;\n}\n.tag-box.tag-selected .tag-image {\n	border: 3px solid white;\n}\n.tag-box .tag-selected-overlay {\n	position: absolute;\n	top: 5px;\n	left: 10px;\n	width: 30px;\n	height: 30px;\n	background: url(demo-img/checked.png) no-repeat;\n}\n\n.tag-box .tag-name { width: 85%; font-style: italic; }\n.tag-box .tag-count { width: 15%; text-align: right; color: #aaa; font-size: 90% }\n\n.interest-filter-error {\n	text-align: center;\n	color: #9C3300;\n	font-size: 14pt;\n}\n\n.interest-filter-loading {\n	text-align: center;\n	color: #0C5B03;\n	font-size: 14pt;\n}\n\n</style>\n\n';
	 } 
	__p+='';
	}
	return __p;
	};

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<section class="result-box alpentraum hidden" data-id="'+
	((__t=( result.id ))==null?'':__t)+
	'">\n	<div class="inner">\n		\n		';
	 var item = result.classes[0] 
	__p+='\n\n		<div class="row1">\n\n			<div class="image" style="background-image: url(https://'+
	((__t=( window.Tramino.cdn || 'tramino.s3.amazonaws.com' ))==null?'':__t)+
	''+
	((__t=( item.image ))==null?'':__t)+
	')"></div>\n		\n			';
	 if ( item.price ) {  
	__p+='\n			<div class="price" title="';
	 if ( item.inkl ) print("inkl. " + item.inkl + ", ") 
	__p+=' '+
	((__t=( __('add_spa_tax') ))==null?'':__t)+
	'">\n				';
	 if ( result.booking == 1 ) { 
	__p+='<span class="booking">'+
	((__t=( __("result_book_online") ))==null?'':__t)+
	'</span>';
	 } 
	__p+='\n				<span class="digits">'+
	((__t=( Math.round( parseFloat(item.price) )  ))==null?'':__t)+
	'</span>\n				<span class="currency">€</span>\n			</div>\n			';
	 } 
	__p+='\n\n		</div>\n\n		<div class="row2">\n\n			';
	 if ( favorited ) { 
	__p+='\n			<div class="favable on" data-item="clients-'+
	((__t=( result.id ))==null?'':__t)+
	'" title="'+
	((__t=( __('unlike') ))==null?'':__t)+
	'"></div>\n			';
	 } else { 
	__p+='\n			<div class="favable" data-item="clients-'+
	((__t=( result.id ))==null?'':__t)+
	'" title="'+
	((__t=( __('like') ))==null?'':__t)+
	'"></div>\n			';
	 } 
	__p+='\n\n			<div class="col col1">\n				<div class="haus">'+
	((__t=( result.name ))==null?'':__t)+
	'</div>\n				<h2 class="name"><a href="'+
	((__t=( registry('PartnerBase') ))==null?'':__t)+
	''+
	((__t=( result.shortcut ))==null?'':__t)+
	'.html">'+
	((__t=( item.name ))==null?'':__t)+
	'</a></h2>\n				<div class="info">'+
	((__t=( item.facts ))==null?'':__t)+
	'</div>\n			</div>\n\n			<div class="col col2">	\n				\n				<div class="location">\n					'+
	((__t=( result.street ))==null?'':__t)+
	' <br />\n					'+
	((__t=( result.plz ))==null?'':__t)+
	' '+
	((__t=( result.ort ))==null?'':__t)+
	' ';
	 if ( result.district ) { 
	__p+=' / ';
	 } 
	__p+=' '+
	((__t=( result.district ))==null?'':__t)+
	'\n				</div>\n\n				';
	 if ( hasTag(result, 1990) ) { 
	__p+='<div class="fact">'+
	((__t=( tagName(1990) ))==null?'':__t)+
	'</div>';
	 } // Bergbahnen inklusive 
	__p+='\n				';
	 if ( hasTag(result, 37603) ) { 
	__p+='<div class="fact">'+
	((__t=( tagName(37603) ))==null?'':__t)+
	'</div>';
	 } // Hörnerbahnen inklusive 
	__p+='\n				';
	 if ( hasTag(result, 24268) ) { 
	__p+='<div class="fact">'+
	((__t=( tagName(24268) ))==null?'':__t)+
	'</div>';
	 } // Skipass SKI OK 
	__p+='\n				';
	 if ( hasTag(result, 37601) ) { 
	__p+='<div class="fact">'+
	((__t=( tagName(37601) ))==null?'':__t)+
	'</div>';
	 } // Heiß auf Weiß 
	__p+='\n\n\n				';
	 if ( result.rating > 0 ) { 
	__p+='<div class="fact">'+
	((__t=( Math.round( result.rating ) ))==null?'':__t)+
	'%&nbsp;'+
	((__t=( __('result_recommentation') ))==null?'':__t)+
	'</div>';
	 } 
	__p+='\n				';
	 if ( item.stars ) { 
	__p+='<div class="fact">'+
	((__t=( __("result_validated") ))==null?'':__t)+
	'&nbsp; '+
	((__t=( item.stars.replace(" ","&nbsp;") ))==null?'':__t)+
	'</div>';
	 } 
	__p+='\n\n			</div>\n			<div class="clear"></div>\n		</div>\n	</div>\n</section>\n\n';
	}
	return __p;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__) {module.exports = function(obj){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	with(obj||{}){
	__p+='<section class="result-box montana hidden" data-id="'+
	((__t=( result.id ))==null?'':__t)+
	'">\n	\n	';
	 var item = result.classes[0] 
	__p+='\n	\n	<div class="inner item" data-id="'+
	((__t=( item.id ))==null?'':__t)+
	'" data-item="'+
	((__t=( item.item ))==null?'':__t)+
	'">\n\n		<div class="row1">\n\n			<div class="image" style="background-image: url(https://'+
	((__t=( window.Tramino.cdn || 'tramino.s3.amazonaws.com' ))==null?'':__t)+
	''+
	((__t=( item.image ))==null?'':__t)+
	')"></div>\n		\n			';
	 if ( item.price ) {  
	__p+='\n			<div class="price" title="';
	 if ( item.inkl ) print("inkl. " + item.inkl + ", ") 
	__p+=' '+
	((__t=( __('add_spa_tax') ))==null?'':__t)+
	'">\n				';
	 if ( result.booking == 1 ) { 
	__p+='<span class="booking">'+
	((__t=( __("result_book_online") ))==null?'':__t)+
	'</span>';
	 } 
	__p+='\n				<span class="digits">'+
	((__t=( Math.round( parseFloat(item.price) )  ))==null?'':__t)+
	'</span>\n				<span class="currency">€</span>\n			</div>\n			';
	 } 
	__p+='\n\n		</div>\n\n		<div class="row2">\n\n			<div class="col col1">\n				\n				<h2 class="name">\n					'+
	((__t=( item.name ))==null?'':__t)+
	'\n				</h2>\n				\n				';
	 if ( hasTag(result, 62004) ) { 
	__p+='<div class="fact">'+
	((__t=( tagName(62004) ))==null?'':__t)+
	'</div>';
	 } // Bergbahnen Unlimited 
	__p+='\n				';
	 if ( hasTag(result, 49243) ) { 
	__p+='<div class="fact">'+
	((__t=( tagName(49243) ))==null?'':__t)+
	'</div>';
	 } // Sauna/Hallenbad 
	__p+='\n				';
	 if ( hasTag(result, 7166) ) { 
	__p+='<div class="fact">'+
	((__t=( tagName(7166) ))==null?'':__t)+
	'</div>';
	 } // WLAN 
	__p+='\n\n\n			</div>\n\n			<div class="col col2">	\n\n				<div class="haus"></div>\n				<div class="location">\n					<a href="'+
	((__t=( registry('PartnerBase') ))==null?'':__t)+
	''+
	((__t=( result.shortcut ))==null?'':__t)+
	'.html">\n					';
	 if ( result.name.match('Huth') ) { 
	__p+='\n						Montana Ferienwohnungen<br>\n					';
	 } else if ( result.street == 'Trettachstraße 17' ) { 
	__p+='\n						Montana Haus<br>\n					';
	 } else { 
	__p+='\n						'+
	((__t=( result.name ))==null?'':__t)+
	'<br>\n					';
	 } 
	__p+='\n					</a>\n					';
	 if ( ! result.name.match('Huth') ) { 
	__p+='\n						'+
	((__t=( result.street ))==null?'':__t)+
	' <br>\n						'+
	((__t=( result.plz ))==null?'':__t)+
	' '+
	((__t=( result.ort ))==null?'':__t)+
	' ';
	 if ( result.district ) { 
	__p+=' / ';
	 } 
	__p+=' '+
	((__t=( result.district ))==null?'':__t)+
	'\n					';
	 } 
	__p+='\n				</div>\n\n				';
	 
						var facts = new Array();
						if ( hasTag(result, 13915) ) { facts.push(tagName(13915)) } // Garage/Tiefgarage
						if ( hasTag(result, 1692) ) { facts.push(tagName(1692)) } // Balkon
						if ( hasTag(result, 2849) ) { facts.push(tagName(2849)) } // Terrasse
					
	__p+='\n\n				<div class="info">\n					'+
	((__t=( item.facts ))==null?'':__t)+
	'';
	 if ( facts.length > 0 ) { 
	__p+=', '+
	((__t=( facts.join(", ") ))==null?'':__t)+
	'';
	 } 
	__p+='\n					';
	 console.log(item.tags) 
	__p+='\n				</div>\n\n			\n\n			</div>\n			<div class="clear"></div>\n		</div>\n	</div>\n</section>\n\n';
	}
	return __p;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Stellt ein generisches System für "Kollektionen" bereit, also eine Sammlung von Objekten.
	 * Dazu gehören momentan der Warenkorb und die Favoriten.
	 */
	
	'use strict';
	
	var $ = __webpack_require__(6);
	var _ = __webpack_require__(7);
	var Backbone = __webpack_require__(20);
	var Promise = __webpack_require__(2);
	var ajax = __webpack_require__(21);
	
	var Translator = __webpack_require__(18).singleton;
	var __ = Translator.get;
	
	var TemplateCache = __webpack_require__(25);
	var SafeStorage = __webpack_require__(23);
	
	var TraminoCollectibleView = Backbone.View.extend({
	
		events: {
			'click .items-next': 'handleNext',
			'click .items-prev': 'handlePrev',
			'click .items-remove': 'handleRemove',
			'click .items-reload': 'handleReload'
		},
	
		initialize: function initialize() {
			this.listenTo(this.model, "change:items change:startIndex change:isLoading", this.render);
		},
	
		render: function render() {
			var startIndex = this.model.get("startIndex");
			var items = this.model.get("items");
			var itemsCount = items ? items.length : 0;
			var perPage = this.model.get("perPage");
	
			if (items) {
				items = items.slice(startIndex, startIndex + this.model.get('perPage'));
			} else {
				items = [];
			}
	
			var nextPageIndex = startIndex + perPage;
			var paginationInfo = [__("collectible.results"), startIndex + 1, "-", nextPageIndex < itemsCount ? nextPageIndex : itemsCount];
			if (nextPageIndex <= itemsCount) {
				paginationInfo.push(__("collectible.of"));
				paginationInfo.push(itemsCount);
			}
	
			this.el.innerHTML = TemplateCache.render(this.model.get("template_id"), {
				isLoading: this.model.get("isLoading"),
				items: items,
				session: this.model.get("session"),
				itemsCount: itemsCount,
				startIndex: startIndex,
				perPage: perPage,
				hasPrev: startIndex > 0,
				hasNext: startIndex + perPage < itemsCount,
				paginationInfo: paginationInfo.join(" "),
				text_not_found: this.model.get("text_not_found")
			});
		},
	
		handleNext: function handleNext(e) {
			e.preventDefault();
			this.model.set("startIndex", this.model.get("startIndex") + this.model.get('perPage'));
		},
	
		handlePrev: function handlePrev(e) {
			e.preventDefault();
			this.model.set("startIndex", this.model.get("startIndex") - this.model.get('perPage'));
		},
	
		handleRemove: function handleRemove(e) {
			e.preventDefault();
			var item_id = $(e.currentTarget).data().id;
	
			if (item_id) {
				this.model.remove(item_id);
			}
		},
	
		handleReload: function handleReload(e) {
			e.preventDefault();
			this.model.reload();
		}
	
	});
	
	var TraminoCollectible = Backbone.Model.extend({
	
		defaults: function defaults() {
			return {
				/* Parameters */
				namespace: null,
				api: null,
				template_id: null,
				render_to: null,
				text_not_found: "Schade, keine Favoriten gefunden...",
	
				/* Pagination */
				startIndex: 0,
				perPage: 10,
	
				/* State */
				items: null,
				session: null, /* Created by server */
				isLoading: false
			};
		},
	
		initialize: function initialize() {
			_.bindAll(this, 'add', 'remove', 'reload', '_resolve');
	
			if (!this.get("namespace")) throw new Error("TraminoCollectible: A namespace is required");
			if (!this.get("api")) throw new Error("TraminoCollectible: A api endpoint is required");
			if (!this.get("template_id")) throw new Error("TraminoCollectible: A template_id is required");
			if (!this.get("render_to")) throw new Error("TraminoCollectible: A render_to is required");
	
			var renderTarget = document.getElementById(this.get("render_to"));
			if (!renderTarget) {
				renderTarget = $('<div>').hide()[0];
			}
	
			this.view = new TraminoCollectibleView({
				model: this,
				el: renderTarget
			});
	
			this.cache_key = "collectible-" + this.get("namespace");
		},
	
		/**
	  * Initiale Daten laden (entweder aus dem Cache oder von der API)
	  *
	  * @return {Promise} Triggert wenn der initiale Sync erledigt wurde.
	  *                   Das Ergebnis ist undefiniert und bedeutungslos.
	  */
		init: function init() {
			/**
	   * Sometimes when the moon is in the right position and a cruel user is on his desk,
	   * he changes it's cart or favorites in multiple tabs and expects them to be in sync
	   * all the time. So be it.
	   */
			SafeStorage.session.on('change:' + this.cache_key, (function (key, value) {
				this._resolve(Promise.resolve(JSON.parse(value)));
			}).bind(this));
	
			var cached;
			if (cached = SafeStorage.session.get(this.cache_key)) {
				return this._resolve(Promise.resolve(JSON.parse(cached)));
			} else {
				return this.reload();
			}
		},
	
		/**
	  * Behandelt die Rückgabe vom Server.
	  *
	  * @param request {Promise} Muss die aktuellen Daten vom Server zurückgeben
	  */
		_resolve: function _resolve(request) {
			this.set("isLoading", true);
			return request.then((function (data) {
				if (!data) return;
				if (data.status && data.status === "error") {
					throw new Error(data.message);
				}
				/* Setzt item, session, und was sonst noch vom Server kommt */
				this.set(data);
	
				/* We're done (from the user's point of view) */
				this.set("isLoading", false);
	
				/* Add to cache. This emits a window storage event */
				SafeStorage.session.set(this.cache_key, JSON.stringify(data), 300);
			}).bind(this))['catch']((function (e) {
				this.set("isLoading", false);
	
				throw e; // Send to next catch handler
			}).bind(this));
		},
	
		/**
	  * Fügt eine Seite der Collection hinzu.
	  *
	  * @return {Promise} Promise mit der Liste der aktuellen Favoriten zurück.
	  */
		add: function add(item) {
			return this._resolve(ajax({
				url: this.get("api"),
				method: 'post',
				data: {
					action: "add",
					item: JSON.stringify(item),
					session: this.get("session")
				}
			}));
		},
	
		/**
	  * Entfernt eine Seite aus der Collection.
	  *
	  * @return {Promise} Promise mit der Liste der aktuellen Favoriten zurück.
	  */
		remove: function remove(item_id) {
			return this._resolve(ajax({
				url: this.get("api"),
				method: 'post',
				data: {
					action: "remove",
					id: item_id,
					session: this.get("session")
				}
			}));
		},
	
		/**
	  * Gibt die Liste aller Items in der Collection aktuellen Benutzer zurück
	  *
	  * @return {Promise} Promise mit der Liste der aktuellen Favoriten zurück.
	  */
		reload: function reload() {
			return this._resolve(ajax({
				url: this.get("api"),
				method: 'get',
				params: {
					session: this.get("session")
				}
			}));
		},
	
		/**
	  * Gibt die aktuelle Anzahl der Items zurück
	  *
	  * @return {Number} Anzahl items
	  */
		count: function count() {
			/* items kann null sein (Noch nicht geladen), wir gehen dann davon aus dass wir 0 haben */
			var items = this.get("items");
			return items ? items.length : 0;
		},
	
		/**
	  * Gibt die Liste der Items zurück
	  */
		getItems: function getItems() {
			return this.attributes.items;
		},
	
		/**
	  * Gibt alle Items als Objekt für den schnell Zugriff zurück
	  */
		getItemsMap: function getItemsMap() {
			var result = {};
			if (this.attributes.items && this.attributes.items.length) {
				for (var i = 0, item; item = this.attributes.items[i]; ++i) {
					result[item.id] = item;
				}
			}
			return result;
		}
	
	});
	
	module.exports = TraminoCollectible;
	
	/* API example */
	/*
	if ( 0 ) {
		var warenkorb = new TraminoCollectible({
			namespace: "cart",
			api: '/api/cart/items/',
			template_id: 'cart-items-template',
			render_to: 'cart-items-template',
		});
		warenkorb.on('change:items', function() {
			$('..').text(warenkorb.count(), " Favoriten");
		});

		warenkorb.add(150);
		warenkorb.remove(150);
		warenkorb.reload().then(function(results) {

		})
	}
	*/

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(7);
	var Backbone = __webpack_require__(20);
	var ajax = __webpack_require__(21);
	
	var Translator = __webpack_require__(18).singleton;
	var __ = Translator.get;
	
	var TemplateCache = __webpack_require__(25);
	
	var SiteSearchResultView = Backbone.View.extend({
	
		events: {
			'click .search-next': 'handleNext',
			'click .search-prev': 'handlePrev'
		},
	
		initialize: function initialize() {
			this.listenTo(this.model, "change:results change:startIndex change:isLoading", this.render);
		},
	
		render: function render() {
			if (this.model.get("isLoading")) {
				this.el.innerHTML = TemplateCache.render(this.model.get("template_id"), {
					isLoading: true
				});
				return;
			}
	
			var startIndex = this.model.get("startIndex");
			var resultsCount = this.model.get("resultsCount");
			var perPage = this.model.get("perPage");
			var results = this.model.get('results').slice(startIndex, startIndex + this.model.get('perPage'));
	
			var nextPageIndex = startIndex + perPage;
			var paginationInfo = [__("collectible.results"), startIndex + 1, "-", nextPageIndex < resultsCount ? nextPageIndex : resultsCount];
			if (nextPageIndex <= resultsCount) {
				paginationInfo.push(__("collectible.of"));
				paginationInfo.push(resultsCount);
			}
	
			this.el.innerHTML = TemplateCache.render(this.model.get("template_id"), {
				isLoading: false,
				results: results,
				startIndex: startIndex,
				resultsCount: resultsCount,
				perPage: perPage,
				hasPrev: startIndex > 0,
				hasNext: startIndex + perPage < resultsCount,
				paginationInfo: paginationInfo.join(" ")
			});
		},
	
		handleNext: function handleNext(e) {
			e.preventDefault();
			this.model.set("startIndex", this.model.get("startIndex") + this.model.get('perPage'));
		},
	
		handlePrev: function handlePrev(e) {
			e.preventDefault();
			this.model.set("startIndex", this.model.get("startIndex") - this.model.get('perPage'));
		}
	
	});
	
	var TraminoSiteSearch = Backbone.Model.extend({
	
		defaults: function defaults() {
			return {
				/* Parameters */
				api: null,
				template_id: null,
				render_to: null,
				perPage: 10,
	
				/* State */
				isLoading: false,
				results: null,
				startIndex: 0,
				resultsCount: 0
			};
		},
	
		initialize: function initialize() {
			_.bindAll(this, 'search');
	
			if (!this.get("api")) throw new Error("TraminoSiteSearch: A api endpoint is required");
			if (!this.get("template_id")) throw new Error("TraminoSiteSearch: A template_id is required");
			if (!this.get("render_to")) throw new Error("TraminoSiteSearch: A render_to is required");
	
			this.view = new SiteSearchResultView({
				model: this,
				el: document.getElementById(this.get("render_to"))
			});
		},
	
		/**
	  * Suchfunktion
	  */
		search: function search(query) {
			if (typeof query === "string") {
				query = { 'query': query };
			}
			this.set("isLoading", true);
	
			return ajax(this.get('api'), { params: query }).then((function (response) {
				if (response.status && response.status === "error") {
					throw new Error("API call failed: " + response.message);
				}
				this.set({
					"isLoading": false,
					"startIndex": 0,
					"resultsCount": response.items.length,
					"results": response.items
				});
				return response.results;
			}).bind(this))['catch'](function (e) {
				Raven.captureException(e);
			});
		}
	
	});
	
	module.exports = TraminoSiteSearch;
	
	/* API example */
	/*
	if ( 0 ) {
		window.SiteSearch = new TraminoSiteSearch({
			api: '/api/search/',
			template_id: 'sitesearch-template',
			render_to: 'sitesearch-result',
		});
		
		$('#search_input').on('keyup', function(e) {
			var query = $(this).val();
			if ( query.length >= 3 ) {
				SiteSearch.search(query);
			}
		});

	}
	*/

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Der ScrollSpy ermöglicht es, Menüpunkt anhand der aktuellen Scrollpositionen
	 * als "aktiv" oder "inaktiv" zu markieren.
	 *
	 * Voraussetzungen:
	 * - Das Menü muss data-scrollspy="1" als Attribut enthalten
	 * - Alle Menüelemente müssen <a> sein mit einem href auf eine DOM-ID (href="#irgendwas")
	 */
	
	'use strict';
	
	var $ = __webpack_require__(6);
	var _ = __webpack_require__(7);
	
	var ScrollSpy = function ScrollSpy() {
		_.bindAll(this, "check");
	
		this.headings = [];
	
		this.scrollCheck = _.throttle(this.check, 1000 / 3); /* Muss höher als die Dauer der Scroll-Animation sein */
		this.isScrollingSelf = false;
		this.documentHeight = null;
	};
	
	/**
	 * ScrollSpy für die aktuelle Seite initialisieren.
	 */
	ScrollSpy.prototype.init = function () {
		/* Alle ScrollSpy Gruppen finden */
		var headings = this.headings;
		var self = this;
		this.documentHeight = $(document).height();
	
		$('[data-scrollspy]').each(function () {
			/* Alle Links und die jeweiligen Überschriften finden und merken */
			var links = $(this).find('a');
			links.each(function () {
				var link = $(this);
				var target_id = link.attr('href');
				if (target_id.substring(0, 1) !== "#") {
					/* Kein interner Link, ignorieren wir */
					return;
				}
				var target = $(target_id);
				if (target.length === 0) {
					return;
				}
	
				/* Klick animieren */
				link.on('click', function (e) {
					e.preventDefault();
	
					self.isScrollingSelf = true;
					$('html, body').animate({ scrollTop: target.offset().top - 35 }, 300, function () {
						self.isScrollingSelf = false;
					});
					if (typeof history.pushState !== "undefined") {
						history.pushState(null, null, target_id);
					}
	
					self.activate(link);
				});
	
				var top = target.offset().top;
				headings.push({
					title: link.text(),
					link: link,
					target: target,
					top: top,
					bottom: top + target.outerHeight(true)
				});
			});
		});
	
		$(window).on('scroll', this.scrollCheck);
		this.check();
	};
	
	/**
	 * Einen Menüpunkt aktivieren und dabei alle anderen deaktivieren.
	 */
	ScrollSpy.prototype.activate = function (link) {
		_.each(this.headings, function (item) {
			item.link.removeClass('active');
		});
		link.addClass('active');
	};
	
	/**
	 * Positionen aller Menüpunkte aktualisieren. 
	 * Notwendig wenn etwa durch AJAX/Templates der Inhalt der Seite verändert wurde.
	 */
	ScrollSpy.prototype.refresh = function (link) {
		_.each(this.headings, function (item) {
			var top = item.target.offset().top;
			item.top = top;
			item.bottom = top + item.target.outerHeight(true);
		});
	};
	
	/**
	 * Stoppt die Funktionalität des ScrollSpy und entfernt alle Referenzen zu DOM-Elementen.
	 */
	ScrollSpy.prototype.stop = function () {
		this.headings = [];
		this.documentHeight = null;
		$(window).off('scroll', this.scrollCheck);
	};
	
	/**
	 * Prüfung ob sich das Dokument verändert hat und andere Menüpunkte aktiviert werden müssen.
	 */
	ScrollSpy.prototype.check = function () {
		if (self.isScrollingSelf) return;
		if (this.headings.length === 0) return;
	
		var scrollTop = $(window).scrollTop();
		if ($(document).height() != this.documentHeight) {
			this.refresh();
			this.documentHeight = $(document).height();
		}
	
		if (scrollTop < 100) {
			this.activate(this.headings[0].link);
			return;
		}
	
		/* Alle Headings durchlaufen und schauen, welches am besten passt */
		var bestMatch = null;
		_.each(this.headings, function (item) {
			if (scrollTop + 100 > item.top) {
				bestMatch = item;
			};
		});
	
		if (bestMatch) {
			this.activate(bestMatch.link);
		}
	};
	
	module.exports = new ScrollSpy();

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Mini-Engine für die Partner-Seite
	 */
	
	var _ = __webpack_require__(7);
	var moment = __webpack_require__(8);
	var Backbone = __webpack_require__(20);
	var ajax = __webpack_require__(21);
	
	var MiniTimer = __webpack_require__(22);
	var getQueryParameters = __webpack_require__(27);
	var Registry = __webpack_require__(26);
	
	var ResultView = __webpack_require__(85);
	var ProductsView = __webpack_require__(86);
	var ReservaTimeTable = __webpack_require__(87);
	var ReservaTimeTableYear = __webpack_require__(90);
	var ReservaPriceTable = __webpack_require__(92);
	var getQueryParameters = __webpack_require__(27);
	
	var MiniEngineSingletone = null;
	
	var MiniEngine = function MiniEngine(options) {
	    var _this = this;
	
	    _.bindAll(this, "search", "searchProducts", "updatePriceTable");
	
	    if (MiniEngineSingletone !== null) {
	        return MiniEngineSingletone;
	    }
	    MiniEngineSingletone = this;
	
	    var query = getQueryParameters();
	
	    /* Allgemein Parameter */
	    this.form = null;
	    this.item = query.item || null;
	    this.item_class = query['class'] || null;
	    this.client = null;
	    this.single_view = options.single_view || null;
	
	    /* API Endpoint */
	    this.api_engine = '/api/engine/';
	    this.api_products = '/api/products/';
	
	    /* Widgets */
	    this.datepicker_container = null;
	    this.datepicker_display = null;
	    this.datepicker_fixto = null;
	    this.people_container = null;
	    this.people_display = null;
	    this.people_fixto = null;
	    this.timetable_container = null;
	    this.pricetable_container = null;
	
	    /* Did we jump to a item defined by the URL? */
	    this.jumped = false;
	
	    /* Ergebnis DOM-Node */
	    this.result = null;
	    this.result_products = null;
	
	    this.dateDisplay = {};
	    this.dateDisplayInitialized = false;
	
	    _.extendOwn(this, options);
	
	    if (typeof window.Raven !== "undefined") {
	        Raven.setTagsContext({ app: "miniengine" });
	    }
	
	    /* Parameter Validation */
	    if (!this.single_view || this.single_view === "booking") {
	        var checks = ['form', 'result', 'datepicker_container', 'datepicker_display', 'people_container', 'people_display'];
	        for (var i = 0, field; field = checks[i]; ++i) {
	            if (!this[field]) {
	                throw new Error("[MiniEngine] Argument " + field + " is null but required");
	            }
	            if (!this[field].length) {
	                throw new Error("[MiniEngine] Argument " + field + " is empty (missing DOM element?)");
	            }
	        }
	    }
	
	    /* Initialize app */
	    this.app = new ReservaApp({
	        item: this.item,
	        client: this.client,
	        config: options.config || {},
	
	        defaultstartin: options.defaultstartin || 14,
	        defaultdays: options.defaultdays || 7,
	        select_mode: options.default_select_mode || "exact"
	    });
	
	    if (query.from || query.select_mode) {
	        this.app.formModel.setFromQueryString();
	    } else {
	        this.app.formModel.setFromLocalStorage();
	        this.app.formModel.bindToLocalStorage();
	    }
	
	    /* Initialize widgets */
	    if (!this.single_view || this.single_view === "booking") {
	        (function () {
	            _this.app.initializeDatepicker(_this);
	            _this.app.initializePeopleSelect(_this);
	
	            _this.initializeModelsAndViews();
	            _this.app.updatePeopleDisplay();
	
	            /* Submit form on select_mode == none */
	            _this.app.formModel.on('change:select_mode', (function (e) {
	                if (e.attributes.select_mode === "none") {
	                    this.app.hideDatepicker();
	                    this.search()['catch'](this.app.promiseError);
	                }
	            }).bind(_this));
	
	            /* Submit form on any date selection */
	            _this.app.on('DatePicker.dateSelected', (function () {
	                if (this.app.formModel.get("rooms") === 0) {
	                    this.app.formModel.set("rooms", 1);
	                }
	                this.search()['catch'](this.app.promiseError);
	                this.searchProducts()['catch'](this.app.promiseError);
	            }).bind(_this));
	
	            /* Integration Partnerseite */
	            var input_termin = $("input[name=termin]");
	            var input_von = $("input[name=von],input[name=from]");
	            var input_bis = $("input[name=bis],input[name=to]");
	
	            if (input_termin.length && input_von.length && input_bis.length) {
	                (function () {
	                    var input_personen = $("input[name=personen]");
	                    var input_erwachsene = $("select[name=erwachsene]");
	                    var input_kinder = $("select[name=kinder]");
	
	                    _this.app.formModel.on('change', (function () {
	                        var model = this.app.formModel;
	
	                        $("input[name=termin][value=1]").prop("checked", true);
	
	                        if (model.get("select_mode") === "none") {
	                            input_von.val("");
	                            input_bis.val("");
	                        } else {
	                            input_von.val(moment(model.get("from")).format("DD.MM.YYYY"));
	                            input_bis.val(moment(model.get("to")).format("DD.MM.YYYY"));
	                        }
	
	                        $("input[name=personen][value=1]").prop("checked", true);
	                        input_erwachsene.val(model.get("rooms.1.adults") + "");
	                        input_kinder.val(model.get("rooms.1.children") + "");
	
	                        var children = model.get("rooms.1.children");
	
	                        if (children >= 1) {
	                            $('#kindfeld1').show();
	                            $("#kind1").val(model.get("rooms.1.child1"));
	                        } else {
	                            $('#kindfeld1').hide();
	                        }
	
	                        if (children >= 2) {
	                            $('#kindfeld2').show();
	                            $("#kind2").val(model.get("rooms.1.child2"));
	                        } else {
	                            $('#kindfeld2').hide();
	                        }
	
	                        if (children >= 3) {
	                            $('#kindfeld3').show();
	                            $("#kind3").val(model.get("rooms.1.child3"));
	                        } else {
	                            $('#kindfeld3').hide();
	                        }
	
	                        if (children >= 4) {
	                            $('#kindfeld4').show();
	                            $("#kind4").val(model.get("rooms.1.child4"));
	                        } else {
	                            $('#kindfeld4').hide();
	                        }
	
	                        if (children >= 5) {
	                            $('#kindfeld5').show();
	                            $("#kind5").val(model.get("rooms.1.child5"));
	                        } else {
	                            $('#kindfeld5').hide();
	                        }
	                    }).bind(_this));
	                })();
	            }
	
	            /* Redirect DOM submit events to our search */
	            _this.form.on('submit', (function (e) {
	                e.preventDefault();
	                this.search()['catch'](this.app.promiseError);
	                this.searchProducts()['catch'](this.app.promiseError);
	            }).bind(_this));
	
	            /* If we got an item, load the valid days first (possible race condition). */
	            if (_this.item || _this.client) {
	                _this.app.loadItemDays();
	                _this.search()['catch'](_this.app.promiseError);
	                _this.searchProducts()['catch'](_this.app.promiseError);
	            } else {
	                _this.search()['catch'](_this.app.promiseError);
	                _this.searchProducts()['catch'](_this.app.promiseError);
	            }
	        })();
	    }
	
	    if (!this.single_view || this.single_view === "timetable") {
	        if (this.timetable_container) {
	            this.initializeTimeTable();
	        }
	    }
	};
	
	MiniEngine.prototype.initializeModelsAndViews = function () {
	    /* Results: Model + View */
	    this.resultsModel = new Backbone.Model({
	        results: null,
	        item: this.item,
	        error: null,
	        isLoading: true
	    });
	    this.resultsView = new ResultView({
	        model: this.resultsModel,
	        el: this.result
	    });
	    this.resultsView.render();
	
	    this.resultsModel.on("resetItem", (function (e) {
	        this.item = null;
	        this.resultsModel.set("item", null);
	        this.productsModel.set("item", null);
	
	        this.search()['catch'](this.app.promiseError);
	        this.searchProducts()['catch'](this.app.promiseError);
	    }).bind(this));
	
	    /* Products: Model + View */
	    this.productsModel = new Backbone.Model({
	        products: null,
	        item: null,
	        error: null,
	        isLoading: true
	    });
	
	    if (this.result_products) {
	        this.productsView = new ProductsView({
	            model: this.productsModel,
	            el: this.result_products
	        });
	        this.productsView.render();
	    }
	};
	
	/*************
	 * Timetable *
	 *************/
	
	MiniEngine.prototype.initializeTimeTable = function () {
	    var _this2 = this;
	
	    if (!this.timetable_container || this.timetable_container.length === 0) {
	        return;
	    }
	    if (this.dateDisplayInitialized) {
	        return;
	    }
	    this.dateDisplayInitialized = true;
	
	    ajax({
	        url: '/api/engine/timetable/',
	        params: _.extend(this.app.formModel.getForm(), {
	            client: this.client,
	            lang: window.Tramino && window.Tramino.lang || "de"
	        })
	    }). //item: this.item,
	    then(function (response) {
	
	        if (response.classes.length === 1 && Registry.get("MiniEngine.UseTimeTableYear")) {
	
	            _this2.dateDisplay = new ReservaTimeTableYear({
	                container: _this2.timetable_container,
	                model: _this2.app.formModel
	            });
	        } else {
	
	            _this2.dateDisplay = new ReservaTimeTable({
	                container: _this2.timetable_container,
	                model: _this2.app.formModel
	            });
	        }
	
	        if (!_this2.single_view || _this2.single_view === "booking") {
	            _this2.dateDisplay.on("dateSelected", function (from, to) {
	
	                _this2.app.formModel.set("select_mode", "exact");
	
	                _this2.app.datepicker.setFrom(from.format("YYYY-MM-DD"));
	                _this2.app.datepicker.setTo(to.format("YYYY-MM-DD"));
	
	                $('html, body').animate({
	                    scrollTop: _this2.datepicker_display.offset().top - 80
	                }, 600, function () {
	                    _this2.search()['catch'](_this2.app.promiseError);
	                    _this2.searchProducts()['catch'](_this2.app.promiseError);
	                });
	            });
	        }
	
	        var dateDisplay = _this2.dateDisplay;
	        var params = _this2.app.queryParameters;
	        if (params.renderDaysCount) dateDisplay.set("renderDaysCount", parseInt(params.renderDaysCount, 10));
	        if (params.renderOffset) dateDisplay.set("renderOffset", parseInt(params.renderOffset, 10));
	
	        dateDisplay.init();
	        dateDisplay.handleResponse(response);
	    })['catch'](this.app.promiseError);
	};
	
	MiniEngine.prototype.showResultTimeTable = function (options) {
	    var _this3 = this;
	
	    var klass = options.klass;
	    var item = options.item;
	    var container = options.container;
	    var client = options.client;
	
	    container.html("Einen Moment bitte...");
	
	    if (!client) {
	        client = this.client;
	    }
	    ajax({
	        url: '/api/engine/timetable/',
	        params: {
	            client: client,
	            item: item,
	            lang: window.Tramino && window.Tramino.lang || "de"
	        }
	    }).then(function (response) {
	
	        // Server responds always with all classes
	        response.classes = response.classes.filter(function (c) {
	            return c.id == klass;
	        });
	
	        var dateDisplay = _this3.dateDisplay[klass] = new ReservaTimeTableYear({
	            container: container,
	            model: _this3.app.formModel
	        });
	
	        if (!_this3.single_view || _this3.single_view === "booking") {
	            dateDisplay.on("dateSelected", function (from, to) {
	
	                _this3.app.formModel.set("select_mode", "exact");
	
	                _this3.app.datepicker.setFrom(from.format("YYYY-MM-DD"));
	                _this3.app.datepicker.setTo(to.format("YYYY-MM-DD"));
	
	                $('html, body').animate({
	                    scrollTop: _this3.datepicker_display.offset().top - 80
	                }, 600, function () {
	                    _this3.search()['catch'](_this3.app.promiseError);
	                    _this3.searchProducts()['catch'](_this3.app.promiseError);
	                });
	            });
	        }
	
	        dateDisplay.init();
	        dateDisplay.handleResponse(response);
	    })['catch'](this.app.promiseError);
	};
	
	/**************
	 * Pricetable *
	 **************/
	
	MiniEngine.prototype.initializePriceTable = function () {
	    if (!this.pricetable_container || this.pricetable_container.length === 0) {
	        return;
	    }
	
	    if (this.pricetable) {
	        this.pricetable_container.show();
	        this.updatePriceTable();
	        return;
	    }
	
	    this.pricetable = new ReservaPriceTable({
	        container: this.pricetable_container,
	        model: this.app.formModel
	    });
	    this.pricetable.run();
	
	    this.app.formModel.on('pricetableClick', (function (data) {
	        this.app.formModel.set({
	            from: data.from,
	            to: data.to
	        });
	
	        $('html, body').animate({
	            scrollTop: this.datepicker_display.offset().top - 80
	        }, 600, (function () {
	            this.search()['catch'](this.app.promiseError);
	            this.searchProducts()['catch'](this.app.promiseError);
	        }).bind(this));
	    }).bind(this));
	
	    this.updatePriceTable();
	};
	
	MiniEngine.prototype.updatePriceTable = function () {
	    this.pricetable_container.show();
	
	    /* Legacy IBE API @todo */
	    var payload = {
	        client: this.client,
	        notfound: 1,
	        item: this.item,
	        from: this.app.formModel.get("from"),
	        to: this.app.formModel.get("to"),
	        erwachsene: this.app.formModel.get("rooms.1.adults"),
	        kinder: this.app.formModel.get("rooms.1.children"),
	        kind1: this.app.formModel.get("rooms.1.child1"),
	        kind2: this.app.formModel.get("rooms.1.child2"),
	        kind3: this.app.formModel.get("rooms.1.child3"),
	        lang: window.Tramino && window.Tramino.lang || "de"
	    };
	
	    ajax({
	        url: "/api/engine/pricetable/",
	
	        /*
	        params: _.extend(this.app.formModel.getForm(), {
	            client: this.client,
	            item: this.item,
	        }),
	        */
	
	        params: payload }). /* @todo */
	    then((function (response) {
	        if (response.groups.length > 0) {
	            this.pricetable.handleResponse(response);
	        }
	    }).bind(this));
	};
	
	/***********
	 * Classes *
	 ***********/
	
	MiniEngine.prototype.search = function () {
	    this.app.hideDatepicker();
	    this.app.hidePeopleSelect();
	
	    var params = this.app.formModel.getForm();
	    params.item = this.item;
	    params['class'] = this.item_class;
	    params.lang = window.Tramino.lang;
	
	    this.resultsModel.set({
	        results: null,
	        error: null,
	        isLoading: true
	    });
	
	    return ajax({
	        url: this.api_engine,
	        params: params
	    }).then((function (response) {
	
	        if (response.status && response.status === "error") {
	
	            this.resultsModel.set({
	                error: response.message,
	                isLoading: false
	            });
	        } else {
	
	            if (this.pricetable_container) {
	                this.pricetable_container.hide();
	            }
	            if (this.pricetable_container && this.pricetable_container.length > 0) {
	                this.initializePriceTable();
	            }
	
	            var results = response.results || null;
	            var first_timetable = null;
	            if (results.length > 0) {
	                if (results[0].classes.length === 1) {
	                    // Spezialmodus für nur eine Wohnung:
	                    // - Ersten Belegungsplan direkt ausklappen
	                    // - Globalen Belegungsplan nicht anzeigen
	
	                    first_timetable = {
	                        klass: results[0].classes.id,
	                        container: $($('.show-result-timetable').data('for'))
	                    };
	
	                    this.timetable_container.hide();
	                    $('#detail-belegung').hide(); // ReservaPartner template
	                } else {
	                        this.timetable_container.show();
	                        $('#detail-belegung').show(); // ReservaPartner template
	                    }
	            }
	
	            this.resultsModel.set({
	                results: results,
	                error: null,
	                isLoading: false
	            });
	
	            if (first_timetable) {
	                // @todo This is horrible
	                $('.show-result-timetable').click();
	            }
	
	            if (this.item_class && !this.jumped) {
	                setTimeout((function () {
	                    var offset = $('.class[data-class="' + this.item_class + '"]').offset();
	                    if (offset && offset.top) {
	                        $('html,body').animate({
	                            scrollTop: offset.top - 150
	                        });
	                    }
	                }).bind(this), 100);
	                this.jumped = true;
	            }
	
	            // Discout Detail Popup
	            $('.classes-result .discount_popup, .classes-result .discount_details').click(function (e) {
	                $(this).siblings('.discount_details').toggle();
	            });
	
	            // html Anchor handling
	            if ($(location).attr('hash')) {
	                var anchor = $($(location).attr('hash'));
	                if (anchor.length) {
	                    if (anchor.hasClass('item-occupied')) {
	                        $('.item-occupied').show();
	                        $('.item-occupied-show-button').hide();
	                    }
	                    $('html,body').animate({ scrollTop: anchor.offset().top - 130 });
	                }
	            }
	        }
	    }).bind(this))['catch']((function (e) {
	        this.resultsModel.set({
	            error: e.statusText || e.message || e.error || e.toString(),
	            isLoading: false
	        });
	    }).bind(this))['catch'](this.app.promiseError);
	};
	
	/***********
	 * Products *
	 ***********/
	
	MiniEngine.prototype.searchProducts = function () {
	    var params = this.app.formModel.getForm();
	    params.item = this.item;
	    params['class'] = this.item_class;
	    params.lang = window.Tramino.lang;
	
	    this.productsModel.set({
	        products: null,
	        error: null,
	        isLoading: true
	    });
	
	    return ajax({
	        url: this.api_products,
	        params: params
	    }).then((function (response) {
	
	        if (response.status && response.status === "error") {
	            this.productsModel.set({
	                error: response.message,
	                isLoading: false
	            });
	        } else {
	            this.productsModel.set({
	                products: response.items || null,
	                error: null,
	                isLoading: false
	            });
	        }
	    }).bind(this))['catch']((function (e) {
	        this.productsModel.set({
	            error: e.statusText || e.message || e.error || e.toString(),
	            isLoading: false
	        });
	    }).bind(this))['catch'](this.app.promiseError);
	};
	
	MiniEngine.prototype.setItem = function (item) {
	    this.resultsModel.set("item", item);
	    this.productsModel.set("item", item);
	    this.app.set("item", item);
	    return this.app.loadItemDays();
	};
	
	module.exports = MiniEngine;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $ = __webpack_require__(6);
	var Backbone = __webpack_require__(20);
	
	var TemplateCache = __webpack_require__(25);
	
	var ResultView = Backbone.View.extend({
	
		events: {
			'click .arrow.next': 'slideImageNext',
			'click .arrow.prev': 'slideImagePrev',
			'click .reset-item': 'handleResetItem',
			'click .show-result-timetable': 'showTimeTable',
			'click .button-request': 'inquiryClicked'
		},
	
		initialize: function initialize() {
			this.listenTo(this.model, "change", this.render);
		},
	
		render: function render() {
			this.el.innerHTML = TemplateCache.render('classes-template', this.model.toJSON());
	
			// Sometimes the server does not return all packages
			// This hack removes them
			var hackRemoved = 0;
			$('.package-links').each(function (i, link) {
				var id = link.getAttribute("href").substring(1);
				if (!document.getElementById(id)) {
					$(link).remove();
					hackRemoved++;
				}
			});
			if (hackRemoved > 0 && window.Tramino.root) {}
		},
	
		slideImageNext: function slideImageNext(e) {
			var $slider = $(e.target).parents('.slider');
			$slider.children(':last').insertBefore($slider.children(':first'));
		},
	
		slideImagePrev: function slideImagePrev(e) {
			var $slider = $(e.target).parents('.slider');
			$slider.children(':first').insertAfter($slider.children(':last'));
		},
	
		handleBooking: function handleBooking(e) {
			e.preventDefault();
	
			var data = window.miniEngine.app.formModel.getForm();
			data['class'] = $(e.target).data('class');
	
			TraminoWarenkorb.add(data).then(function () {
				// Irgendwo hin scrollen, irgendwas anzeigen...
	
			});
		},
	
		handleResetItem: function handleResetItem(e) {
			e.preventDefault();
			this.model.trigger("resetItem");
		},
	
		showTimeTable: function showTimeTable(e) {
			e.preventDefault();
			var data = $(e.currentTarget).hide().data();
	
			miniEngine.showResultTimeTable({
				klass: parseInt(data.klass, 10),
				container: this.$el.find(data['for']),
				client: parseInt(data.client, 10)
			});
		},
	
		inquiryClicked: function inquiryClicked(e) {
			e.preventDefault();
	
			/* Show inquiry form */
			$('.show-anfrage-button').hide();
			$('#detail-request-inner').show();
	
			/* Preselect class in form */
			var class_id = $(e.currentTarget).parents('.class').data('class');
			$('select[name=anfrage_class]').val(class_id);
	
			/* Scroll to form */
			var scrollTargets = [$('#detail-request'), $('#detail-kontakt')].filter(function (t) {
				return t.length > 0;
			});
	
			$('html, body').animate({ scrollTop: scrollTargets[0].offset().top }, 1000);
		}
	
	});
	
	module.exports = ResultView;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $ = __webpack_require__(6);
	var Backbone = __webpack_require__(20);
	
	var TemplateCache = __webpack_require__(25);
	
	var ProductView = Backbone.View.extend({
	
		events: {},
	
		initialize: function initialize() {
			this.listenTo(this.model, "change", this.render);
		},
	
		render: function render() {
			this.el.innerHTML = TemplateCache.render('products-template', this.model.toJSON());
	
			var detail_request = $("#detail-request");
			if (!detail_request.length) {
				$('.button-inquiry').remove();
			}
		}
	});
	
	module.exports = ProductView;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Reserva Belegungsplan
	 */
	
	'use strict';
	
	var $ = __webpack_require__(6);
	var _ = __webpack_require__(7);
	var Backbone = __webpack_require__(20);
	var moment = __webpack_require__(8);
	
	var DateTime = __webpack_require__(40);
	var Tooltip = __webpack_require__(43);
	var TemplateCache = __webpack_require__(25);
	
	var NightsCompressor = __webpack_require__(88);
	var ReservaTimeTableView = __webpack_require__(89);
	
	var ReservaTimeTable = Backbone.Model.extend({
	
		defaults: function defaults() {
			return {
				classes: [],
				from: null,
				to: null,
				model: null,
				container: null,
				viewData: null,
				renderOffset: 0,
				renderDaysCount: 31,
				cellWidth: null,
				canGoFurther: true,
				titleWidth: 0,
				selectionData: null,
				selectedNightsIndexes: [],
	
				/* Dev feature: Auto scrolling */
				autoGo: false
			};
		},
	
		daysEncoding: {
			'.': -1, /* Empty display (not free) */
			'_': 0, /* Frei, aber kein Anreisetag */
			'1': 1,
			'2': 2,
			'3': 3,
			'4': 4,
			'5': 5,
			'6': 6,
			'7': 7,
			'8': 8,
			'9': 9,
			'A': 10,
			'B': 11,
			'C': 12,
			'D': 13,
			'E': 14,
			'F': 15,
			'G': 16,
			'H': 17,
			'I': 18,
			'J': 19,
			'K': 20,
			'L': 21
		},
	
		initialize: function initialize() {
			_.bindAll(this, "updateCellWidth");
	
			this.container = this.get("container");
			this.model = this.get("model");
	
			if (!this.container) {
				throw new Error('ReservaTimeTable: Invalid container specified: ' + this.container);
			}
			if (this.container.length === 0) {
				throw new Error('ReservaTimeTable: Container does not exist in DOM');
			}
	
			this.startDay = DateTime.resetTimeFields(moment());
	
			this.tooltip = new Tooltip({
				className: 'reserva-timetable-tooltip',
				boxTransform: (function (box) {
					/* Wir müssen die ersten 200px für die linken thead abschneiden */
					box.x1 += this.get("titleWidth");
					return box;
				}).bind(this)
			});
	
			this.view = new ReservaTimeTableView({
				el: this.container,
				model: this
			});
			this.view.tooltip = this.tooltip;
	
			this.on('change:autoGo', (function (e) {
				if (e.attributes.autoGo) {
					this.goInterval = window.setInterval((function () {
						if (!e.attributes.autoGo) return;
	
						var current = this.get("renderOffset");
						if (current > 521) current = 0;
						this.setRenderOffset(current + 1);
					}).bind(this), 400);
				} else {
					window.clearInterval(this.goInterval);
				}
			}).bind(this));
	
			this.dateCache = {};
			for (var i = 0; i <= 521; i++) {
				this.dateCache[i] = this.startDay.clone().add(i, 'days');
			}
	
			this.on('rendered', function () {
				this.tooltip.box = this.view.$el.find('tbody');
				this.tooltip.boxHasChanged();
			});
	
			/* The tooltip box is a static area relative to the page. On static elements like
	     the DatePicker this is fine, but on highly dynamic pages like partner the box
	     is always moving around. So we need to listen on all render events of the miniengine */
			TemplateCache.on('render:classes-template render:products-template render:ratings-template', this.tooltip.boxHasChanged);
		},
	
		init: function init() {
			var _this = this;
	
			/* Los geht's! */
			this.updateDate();
	
			/* Fake the data once to determine cell sizes */
			this.set("viewData", {
				months: [''],
				monthCounters: [1],
				days: ['01'],
				classes: [{ name: '', info: '', days: [{ day: 1, nextDay: 1, prevDay: 1, className: 'begin' }] }],
				selectedNightsIndexes: [],
				renderDaysCount: 1,
				renderOffset: 0,
				canGoFurther: false,
				developer: false
			});
			this.tooltip.box = this.view.$el.find('tbody');
			this.updateCellWidth();
	
			/* Handler registrieren (am Schluss) */
			$(window).on('resize', _.debounce(this.updateCellWidth, 500));
	
			this.on('change:renderOffset change:renderDaysCount', function () {
				_this.updateViewState();
			});
	
			/* Bei Änderungen am Model die Auswahl aktualisieren */
			this.model.on('change:to change:select_mode', function (e) {
				/* Leichte Verzögerung um die UI nicht so stark zu blockieren */
				setTimeout((function () {
					this.updateDate();
					this.precalculateClasses();
					this.updateViewState();
				}).bind(_this), 100);
			});
		},
	
		updateCellWidth: function updateCellWidth() {
			var container = this.view.$el;
	
			var cellWidth = container.find('td div').parent().width();
			this.set("cellWidth", cellWidth);
	
			var titleWidth = container.find('tbody th').width();
	
			var containerMaxWidth = container.width();
	
			var ww = $(window).width();
			var titleWidth = 200;
			if (ww < 1024) titleWidth = 80;
			if (ww < 768) titleWidth = 80;
			if (ww < 568) titleWidth = 80;
	
			var cellsToDisplay = Math.floor((containerMaxWidth - titleWidth) / cellWidth) - 1;
			this.set({
				"renderDaysCount": cellsToDisplay,
				"titleWidth": titleWidth
			});
		},
	
		updateDate: function updateDate() {
			var from = this.model.get("from");
			var to = this.model.get("to");
			var select_mode = this.model.get("select_mode");
	
			/* Entweder gibt es Start UND Ende, oder gar keine Auswahl */
			if (from && to && select_mode === "exact") {
				from = DateTime.resetTimeFields(DateTime.parse(from));
				to = DateTime.resetTimeFields(DateTime.parse(to));
			} else {
				from = null;
				to = null;
			}
	
			this.set({
				from: from,
				to: to,
				renderOffset: from ? Math.max(0, from.diff(this.startDay, 'days') - 3) : 0
			});
		},
	
		handleResponse: function handleResponse(response) {
			var mapping = this.daysEncoding;
			_.each(response.classes, function (klass) {
				klass.days_list = _.map(klass.days.split(''), function (c) {
					return mapping[c];
				});
			});
			this.set("response", response);
			this.precalculateClasses();
		},
	
		precalculateClasses: function precalculateClasses() {
			var _this2 = this;
	
			/* Highlight currently selected timerange */
			var from = this.get("from");
			var to = this.get("to");
			var selectedNightsIndexes = [];
			if (from && to) {
				var fromIndex = Math.abs(this.startDay.diff(from, 'days'));
				var selected_nights = Math.abs(to.diff(from, 'days'));
				for (var i = 0; i < selected_nights; ++i) {
					selectedNightsIndexes.push(fromIndex + i);
				}
			}
	
			/* viewData vorberechnen */
			var response = this.get("response");
	
			var classes = [];
	
			if (!response) return;
			_.each(response.classes, (function (klass) {
				var days_list = klass.days_list;
				var days = [];
	
				var maybePrevClass = '';
				var realPrevClass = '';
	
				var open = false; /* Sind wir in einem Gebiet mit freien Tagen? */
				var open2 = false; /* Sind wir in einem Gebiet mit freien Tagen, aber mit nicht-verfügbaren Anreisetagen? */
				var open3 = false; /* Sind wir in einem nicht-verfügbaren Gebiet, wo es kurz verfügbare Tage gibt? */
				_.each(days_list, (function (day, i) {
					if (i >= this.renderDaysCount) return; /* Eins drüber */
					var date = this.dateCache[i];
					if (!date) {
						// In rare occasions we get more than 500 days from the API.
						date = this.startDay.clone().add(i, 'days');
						this.dateCache[i] = date;
					}
	
					var prevDay = i > 0 ? days_list[i - 1] : -1;
					var nextDay = i < days_list.length ? days_list[i + 1] : -1;
	
					var validArrival = day > 0;
					var isFree = day >= 0;
	
					var mainClass = '';
	
					/**
	     * Übersicht über die Klassen:
	     * [<] begin 	   Hellgrüner Start 
	     * [ ] free-avail  Hellgrün, kein Pfeil
	     * [ ] part2       Dunkelgrün, kein Pfeil
	     * [>] close2      Ende von hellgrünen Bereich in dunkelgrünen Bereich
	     * [<] begin2      Start in einem dunkelgrünem Bereich 
	     * [>] end         Ende in hellgrünem Bereich 
	     * [>] end2        Ende von dunkelgrünem Bereich 
	     * [o] begin3      Start von hellgrün und sofort dunkelgrün nächster Tag
	     * [o] begin4      Start von dunkelgrün und sofort dunkelgrün nächster Tag
	     */
	
					if (open) {
						/* Einfacher Fall: Tag ist verfügbar -> grün */
						if (validArrival) {
							mainClass = 'free-avail';
						}
	
						/* Falls wir offen sind, aber ab heute nicht mehr verfügbar sind: Farbe wechseln */
						if (open3 && nextDay === 0) {
							mainClass = 'close2';
							open3 = false;
						} else if (open2) {
							if (validArrival) {
								/* Anreisetag in sonst nicht-freier Zone */
								mainClass = 'begin2';
								open3 = true;
							} else {
								mainClass = 'part2';
							}
						}
	
						/* Wenn der nächste Tag kein gültiger Anreisetag - aber frei ist, wechseln wir die Farbe */
						if (nextDay === 0 && !open2) {
							open2 = true;
							mainClass = 'close2';
						}
	
						/* Falls der Tag belegt ist, beenden wir diesen Block */
						if (day === -1) {
							mainClass = open2 ? 'end2' : 'end2';
							open = false;
							open2 = false;
							open3 = false;
						}
					} else {
						if (isFree && validArrival) {
							/* Einzelner Anreisetag */
							if (nextDay === 0) {
								mainClass = 'begin3';
								open = true;
								open2 = true;
							} else {
								/* Start einer Gruppe */
								mainClass = 'begin';
								open = true;
							}
						}
					}
	
					var helperClasses = [];
					if (selectedNightsIndexes.indexOf(i) !== -1) helperClasses.push('selected');
					if (open) helperClasses.push('open');
					if (open2) helperClasses.push('open2');
					if (open3) helperClasses.push('open3');
					if (validArrival) helperClasses.push('validArrival');
	
					/* Overrides to fix corner cases */
					var mainClassCopy = mainClass;
	
					// wenn [ ][ < ][ ] Zelle sollte [o] sein
					// hellgrüne Zelle zwischen dunkelgrün
					if (realPrevClass === "begin2" && mainClass === "part2") {
						days[i - 1].className = "begin4";
					}
	
					if (maybePrevClass === "begin2" && mainClass === "begin2") {
						mainClass = "free-avail";
					}
	
					if (realPrevClass === "begin2" && mainClass === "close2" && day === 0) {
						mainClass = "part2";
						days[i - 1].className = "begin4";
					}
	
					if (mainClassCopy === "end2" && days[i - 2] && days[i - 2].className != "begin3") {
	
						if (realPrevClass === "free-avail") {
							days[i - 1].className = "close2";
						} else {
							if (open2 || prevDay === 1) {
	
								days[i - 1].className = days[i - 2].className === ("part2" || "begin3") ? "begin4" : "begin3";
							} else {
								days[i - 1].className = "part2";
							}
						}
					}
	
					maybePrevClass = mainClassCopy;
					realPrevClass = mainClass;
	
					if (date.day() === 0 || date.day() === 6) {
						helperClasses.push("weekend");
					}
	
					if (mainClass == "") {
						mainClass = "occupied";
					}
	
					days.push({
						index: i,
						day: day,
						prevDay: prevDay,
						nextDay: nextDay,
						className: mainClass,
						maybeClass: mainClassCopy,
						helperClasses: helperClasses.join(" ")
					});
				}).bind(_this2));
	
				classes.push({
					name: klass.name,
					info: klass.info,
					/* + 1, da wir im Template einen Tag in die Zukunft sehen */
					days: days
				});
			}).bind(this));
	
			this.set({
				"classes": classes,
				"selectedNightsIndexes": selectedNightsIndexes
			});
	
			this.updateViewState();
		},
	
		setRenderOffset: function setRenderOffset(new_offset) {
			var classes = this.get("classes");
			if (new_offset < 0) {
				new_offset = 0;
			}
	
			if (classes && classes[0]) {
				var maxOffset = classes[0].days.length - this.get("renderDaysCount");
				new_offset = Math.min(new_offset, maxOffset);
	
				this.set({
					"renderOffset": new_offset,
					"canGoFurther": new_offset < maxOffset
				});
			} else {
				this.set({
					"renderOffset": 0,
					"canGoFurther": false
				});
			}
		},
	
		updateViewState: function updateViewState(e) {
			var renderOffset = this.get("renderOffset");
			var renderDaysCount = this.get("renderDaysCount");
	
			var months = [];
			var monthCounters = {};
			var days = [];
	
			if (this.get("classes").length === 0) {
				this.set("viewData", {
					months: [],
					monthCounters: {},
					days: [],
					classes: [],
					renderDaysCount: 0,
					renderOffset: 0,
					selectedNightsIndexes: [],
					canGoFurther: false,
					developer: false
				});
				return;
			}
	
			/* Make list of all days we're going to render, and group them by month */
			var makeMonths = (function (short_map) {
				short_map = short_map || {};
				months = [];
				days = [];
				monthCounters = {};
	
				for (var i = 0; i < renderDaysCount; ++i) {
					var day = this.startDay.clone().add(i + renderOffset, 'days');
					var monthname = day.format('MMMM YYYY');
					if (typeof short_map[monthname] !== "undefined") {
						monthname = day.format(short_map[monthname]);
					}
	
					if (months.indexOf(monthname) === -1) {
						months.push(monthname);
						monthCounters[monthname] = 0;
					}
					monthCounters[monthname]++;
					days.push({
						index: i + renderOffset,
						day: day.format('DD'),
						weekend: day.day() === 0 || day.day() === 6
					});
				}
			}).bind(this);
			makeMonths();
	
			/* Schauen ob wir die Monatsnamen kürzen müssen */
			_.each(monthCounters, function (count, month) {
				/* Wenn wir nur einen Monat haben, ist selbst "Nov." zu lang */
				if (count === 1) {
					var mapping = {};
					mapping[month] = ' '; /* Achtung: Empty string führt zu YYYY-MM-DD */
					makeMonths(mapping);
				}
				/* Bei weniger als 4 Tagen kürzen wir auf z. B. "Nov." statt "November 2015" */
				else if (count < 4) {
						var mapping = {};
						mapping[month] = 'MMM';
						makeMonths(mapping);
					}
			});
	
			/* Klassen erzeugen */
			var classes = [];
			_.each(this.get("classes"), function (klass) {
				classes.push({
					name: klass.name,
					info: klass.info,
					days: klass.days.slice(renderOffset, renderOffset + renderDaysCount)
				});
			});
	
			/* Alles zusammen packen und dann rendern */
			this.set("viewData", {
				months: months,
				monthCounters: monthCounters,
				days: days,
				classes: classes,
				renderDaysCount: renderDaysCount,
				renderOffset: renderOffset,
				selectedNightsIndexes: this.get("selectedNightsIndexes"),
				canGoFurther: this.get("canGoFurther"),
				developer: location.host.indexOf("localhost") !== -1
			});
		},
	
		/**
	  * Handler für Events auf einzelne Zellen
	  *
	  * @param data {Object} Daten von der Zelle (classOffset, dayOffset)
	  * @param $e {jQuery} Ausgewählte Zelle
	  * @param action {String} Aktion (click, hover)
	  */
		cellAction: function cellAction(data, $e, action) {
			var days = this.get("classes")[data.classOffset].days;
			var day_data = days[data.dayOffset];
			var day = day_data.day;
			var text = "";
	
			var dayOffset = data.dayOffset;
			var hoverDate = this.startDay.clone().add(dayOffset, 'days');
	
			var validArrival = day > 0;
			var isFree = day >= 0;
	
			var lines = [];
	
			var lookAhead = (function (dayOffset, day) {
				var nextOffset = dayOffset + day;
				var lookAhead = undefined;
				var nextValidNights = [];
				while (lookAhead = days[nextOffset]) {
	
					nextValidNights.push(nextOffset - dayOffset);
					nextOffset++;
					if (nextOffset - dayOffset > 21) break;
					if (lookAhead.day === -1) break;
				}
				if (nextValidNights.length === 0 && day > 0) return [day];
				return nextValidNights;
			}).bind(this);
	
			if (!isFree) {
				// Kein tooltip
			} else if (!validArrival) {
					lines.push(hoverDate.format("dddd, DD. MMMM YYYY"));
					lines.push("Keine Anreise möglich");
					/*
	    // Nach hinten schauen und prüfen, an welchen Tagen wir hätten anreisen könnten
	    let nextOffset = dayOffset;
	    let lookBehind;
	    let prevValidDays = [];
	    while ( lookBehind = days[nextOffset] ) {
	    	if ( lookBehind.day > 0 ) {
	    		let date = hoverDate.clone().subtract(dayOffset - nextOffset, 'days');
	    		prevValidDays.push("- " + date.format("LL"));
	    	}
	    	nextOffset--;
	    }
	    if ( prevValidDays.length > 0 ) {
	    	lines.push("Frühere Anreise möglich am:<br>" + prevValidDays.join("<br>"));
	    }
	    */
				} else {
						lines.push(hoverDate.format("dddd, DD. MMMM YYYY"));
	
						/* Nach vorne schauen und prüfen, an welchen Tagen wir noch anreisen könnten */
						var nextValidNights = lookAhead(dayOffset, day);
						var _text = "Anreise möglich für " + NightsCompressor.humanString(nextValidNights);
						lines.push(_text);
					}
	
			// Erstmal alle Selection-Klassen löschen
			this.view.$el.find('.selection').removeClass('selection select-start select-part select-end selection-valid selection-invalid');
	
			if (action === "click") {
	
				var _selectionData = this.get("selectionData");
				var select_start = true;
	
				if (_selectionData) {
					/* Der User hat bereits geklickt und will seine Auswahl vollenden */
					select_start = false;
	
					/* Falls es die gleiche Klasse ist, nehmen wir die Auswahl an. Ansonsten wird eine neue gestartet. */
					if (_selectionData.classOffset === data.classOffset) {
						var from = this.startDay.clone().add(_selectionData.dayOffset, 'days');
						var to = this.startDay.clone().add(data.dayOffset, 'days');
	
						var nightsCount = data.dayOffset - _selectionData.dayOffset;
						var valid = _selectionData.lookAhead.indexOf(nightsCount) !== -1;
						if (valid) {
							this.trigger("dateSelected", from, to);
						}
					} else {
						select_start = true;
					}
					this.set("selectionData", null);
				}
	
				if (select_start) {
					if (day > 0) {
						data.lookAhead = lookAhead(dayOffset, day);
						data.tooltip = "Anreise möglich für " + NightsCompressor.humanString(data.lookAhead);
						data.startDay = hoverDate;
						this.set("selectionData", data);
					} else if (day === -1) {
						lines = ["Unterkunft ist an diesem Tag bereits belegt."];
					}
				}
			}
	
			text = lines.join("<br>");
	
			var selectionData = this.get("selectionData");
			if (selectionData && selectionData.classOffset === data.classOffset) {
				var nightsCount = data.dayOffset - selectionData.dayOffset;
				nightsCount = Math.max(nightsCount, 0);
	
				var valid = selectionData.lookAhead.indexOf(nightsCount) !== -1;
				var validClass = 'selection-' + (valid ? 'valid' : 'invalid') + ' ';
	
				lines = [];
				lines.push('<span class="selection-info ' + validClass + '">');
				lines.push(DateTime.textPeriod(selectionData.startDay, hoverDate));
				lines.push('<br>');
	
				if (nightsCount > 21) {
					lines.push("Mehr als 21 Nächte ausgewählt");
				} else if (nightsCount === 0) {
					lines.push("Bitte Abreisetag auswählen");
				} else if (!valid) {
					lines.push(selectionData.tooltip);
				}
				lines.push('</span>');
	
				if (selectionData.dayOffset === data.dayOffset) {
					$e.addClass('selection ' + validClass + 'select-start');
				} else {
					for (var i = selectionData.dayOffset; i <= data.dayOffset; i++) {
						var klass = 'select-part';
						if (i === selectionData.dayOffset) klass = 'select-start';
						if (i === data.dayOffset) klass = 'select-end';
	
						this.view.$el.find('.cell_' + data.classOffset + '_' + i).addClass('selection ' + validClass + klass);
					}
				}
	
				text = lines.join("");
			}
	
			if (lines.length > 0) {
				if (location.hostname === "localhost") {
					text += "<br><i>index(" + day_data.index + ") prev(" + day_data.prevDay + ") day(" + day_data.day + ") next(" + day_data.nextDay + ") mainClass(" + day_data.className + ") maybeClass(" + day_data.maybeClass + ") helperClasses(" + day_data.helperClasses + ")</i>";
				}
	
				this.tooltip.set(text);
			} else {
				this.tooltip.hide();
			}
		}
	
	});
	
	module.exports = ReservaTimeTable;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__) {"use strict";
	
	var _ = __webpack_require__(7);
	
	/**
	 * "Komprimiert" eine Liste von Nächten. Für Beispiele siehe die Funktion test().
	 *
	 * Beispiele:
	 * [1, 2, 3, 5] => ["1-3", "5"]
	 *
	 * @param nights {Array} Liste der Nächte (muss sortiert sein)
	 */
	var compressNights = function compressNights(nights) {
	    var lastSeen = null;
	    var parts = [];
	    var currentStack = [];
	
	    for (var i = 0, night = undefined; night = nights[i]; ++i) {
	        if (lastSeen === null) {
	            currentStack.push(night);
	            lastSeen = night;
	            continue;
	        }
	
	        if (night != lastSeen + 1) {
	            var min = currentStack[0];
	            var max = currentStack.pop();
	            if (min === max) {
	                parts.push(min);
	            } else {
	                parts.push(min + "-" + max);
	            }
	            currentStack = [];
	        }
	        currentStack.push(night);
	        lastSeen = night;
	    }
	
	    if (currentStack.length > 0) {
	        var min = currentStack[0];
	        var max = currentStack.pop();
	        if (min === max) {
	            parts.push(min + "");
	        } else {
	            parts.push(min + "-" + max);
	        }
	    }
	
	    return parts;
	};
	
	/**
	 * Erzeugt aus einer Liste von gültigen Nächten einen "menschlichen" String.
	 * Beispiele:
	 *   [3] = "3"
	 *   [3, 4, 5] = "3-5"
	 *   [3, 5, 7] = "3, 5 und 7"
	 *
	 * @param nights {Array} Liste der Nächte (muss sortiert sein)
	 */
	var humanString = function humanString(nights) {
	    var parts = compressNights(nights);
	    switch (parts.length) {
	        case 0:
	            return "";
	        case 1:
	            var nights = parts[0].indexOf('-21') !== -1 ? __('at_least') + ' ' + parts[0].split('-')[0] : parts[0];
	            var label = parts[0] === "1" ? __("night") : __("nights");
	            return nights + " " + label;
	        default:
	            var last_item = parts.pop();
	            return __("nights_list", {
	                nights: parts.join(", "),
	                last_item: last_item
	            });
	    }
	};
	
	if (false) {
	
	    var test = function test() {
	        /* http://stackoverflow.com/a/14853974 */
	        Array.prototype.equals = function (array) {
	            // if the other array is a falsy value, return
	            if (!array) return false;
	
	            // compare lengths - can save a lot of time
	            if (this.length != array.length) return false;
	
	            for (var i = 0, l = this.length; i < l; i++) {
	                // Check if we have nested arrays
	                if (this[i] instanceof Array && array[i] instanceof Array) {
	                    // recurse into the nested arrays
	                    if (!this[i].equals(array[i])) return false;
	                } else if (this[i] != array[i]) {
	                    // Warning - two different object instances will never be equal: {x:20} != {x:20}
	                    return false;
	                }
	            }
	            return true;
	        };
	
	        var test_cases = [{ nights: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21],
	            expected: ["1-21"] }, { nights: [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21],
	            expected: ["3-21"] }, { nights: [5, 7, 9],
	            expected: [5, 7, 9] }, { nights: [5, 7, 9, 10, 11],
	            expected: [5, 7, "9-11"] }, { nights: [5, 7, 9, 10, 11, 13],
	            expected: [5, 7, "9-11", 13] }, { nights: [5, 6, 7, 9, 10, 11, 14, 21],
	            expected: ["5-7", "9-11", 14, 21] }, { nights: [],
	            expected: [] }];
	
	        var failed = 0;
	        _.each(test_cases, function (testcase) {
	            var result = compressNights(testcase.nights);
	            if (!result.equals(testcase.expected)) {
	                failed++;
	            }
	        });
	
	        if (!failed) {}
	    };
	}
	
	module.exports = {
	    compressNights: compressNights,
	    humanString: humanString
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $ = __webpack_require__(6);
	var Backbone = __webpack_require__(20);
	
	var ReservaTimeTableView = Backbone.View.extend({
	
		events: {
			'click .offset-down': 'offsetDown',
			'click .offset-up': 'offsetUp',
			'click .btn-reset': 'reset',
			'click .count-up': 'countUp',
			'click .count-down': 'countDown',
			'click tbody td': 'onClick',
			'mouseenter tbody td': 'onHover',
			'mousemove tbody td': 'onHover',
			'click .btn-start': 'start',
			'click .btn-stop': 'stop',
			'mouseleave tbody': 'resetStateClasses'
		},
	
		initialize: function initialize() {
			this.listenTo(this.model, "change:viewData", this.render);
		},
	
		render: function render() {
			this.el.innerHTML = TemplateCache.render('timetable-template', this.model.get("viewData"));
			this.model.trigger("rendered");
		},
	
		/*
	  Event Handler
	 */
	
		offsetDown: function offsetDown(e) {
			var days = $(e.currentTarget).data('days') | 0;
			this.model.setRenderOffset(this.model.get("renderOffset") - days);
		},
	
		offsetUp: function offsetUp(e) {
			var days = $(e.currentTarget).data('days') | 0;
			this.model.setRenderOffset(this.model.get("renderOffset") + days);
		},
	
		reset: function reset(e) {
			this.model.setRenderOffset(0);
		},
	
		countDown: function countDown(e) {
			this.model.set("renderDaysCount", Math.max(10, this.model.get("renderDaysCount") - 5));
		},
	
		countUp: function countUp(e) {
			this.model.set("renderDaysCount", this.model.get("renderDaysCount") + 5);
		},
	
		onHover: function onHover(e) {
			var $e = $(e.currentTarget);
			var data = $(e.currentTarget).data();
			if (typeof data.classOffset !== "undefined" && typeof data.dayOffset !== "undefined") {
				this.model.cellAction(data, $e, "hover");
	
				/* Hover for the current day */
				this.highlightDay(data.dayOffset);
			}
		},
	
		onClick: function onClick(e) {
			var $e = $(e.currentTarget);
			var data = $(e.currentTarget).data();
			if (typeof data.classOffset !== "undefined" && typeof data.dayOffset !== "undefined") {
				this.model.cellAction(data, $e, "click");
			}
		},
	
		start: function start(e) {
			this.model.set("autoGo", true);
		},
	
		stop: function stop(e) {
			this.model.set("autoGo", false);
		},
	
		resetStateClasses: function resetStateClasses(e) {
			this.$el.find('.day-hover').removeClass('day-hover');
		},
	
		/*
	  API
	 */
	
		highlightDay: function highlightDay(dayOffset) {
			this.$el.find('.day-hover').removeClass('day-hover');
			this.$el.find('.day_' + dayOffset).addClass('day-hover');
		}
	
	});
	
	module.exports = ReservaTimeTableView;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__) {/**
	 * Reserva Belegungsplan
	 */
	
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var $ = __webpack_require__(6);
	var _ = __webpack_require__(7);
	var Backbone = __webpack_require__(20);
	var moment = __webpack_require__(8);
	
	var DateTime = __webpack_require__(40);
	var Tooltip = __webpack_require__(43);
	var TemplateCache = __webpack_require__(25);
	
	var NightsCompressor = __webpack_require__(88);
	var ReservaTimeTableYearView = __webpack_require__(91);
	
	var ReservaTimeTableYear = Backbone.Model.extend({
	
		defaults: function defaults() {
			return {
				classes: [],
				start: null,
				container: null,
				viewData: null,
				cellWidth: null,
				titleWidth: 0,
				selectionData: null,
				filterClass: null
			};
		},
	
		daysEncoding: {
			'.': -1, /* Empty display (not free) */
			'_': 0, /* Frei, aber kein Anreisetag */
			'1': 1,
			'2': 2,
			'3': 3,
			'4': 4,
			'5': 5,
			'6': 6,
			'7': 7,
			'8': 8,
			'9': 9,
			'A': 10,
			'B': 11,
			'C': 12,
			'D': 13,
			'E': 14,
			'F': 15,
			'G': 16,
			'H': 17,
			'I': 18,
			'J': 19,
			'K': 20,
			'L': 21
		},
	
		initialize: function initialize() {
			var _this = this;
	
			this.container = this.get("container");
			this.startDay = DateTime.resetTimeFields(moment(new Date().getFullYear() + "-01-01"));
			this.previousHoverData = { classOffset: null, dayOffset: null };
	
			this.tooltip = new Tooltip({
				className: 'reserva-timetable-tooltip',
				boxTransform: (function (box) {
					/* Wir müssen die ersten 200px für die linken thead abschneiden */
					box.x1 += this.get("titleWidth");
					return box;
				}).bind(this)
			});
	
			this.view = new ReservaTimeTableYearView({
				el: this.container,
				model: this
			});
			this.view.tooltip = this.tooltip;
	
			this.on('rendered', function () {
				_this.tooltip.box = _this.view.$el.find('tbody');
				_this.tooltip.boxHasChanged();
			});
	
			this.on('change:filterClass', function () {
				_this.set("viewData", _extends({}, _this.get("viewData"), {
					filterClass: _this.get("filterClass")
				}));
				_this.view.render();
			});
		},
	
		init: function init() {
			this.tooltip.box = this.view.$el.find('tbody');
		},
	
		handleResponse: function handleResponse(response) {
			var _this2 = this;
	
			this.startDay = DateTime.parse(response.start);
	
			this.dateCache = {};
			for (var i = 0; i <= 521; i++) {
				this.dateCache[i] = this.startDay.clone().add(i, 'days');
			}
	
			var mapping = this.daysEncoding;
			_.each(response.classes, function (klass) {
				klass.days_list = _.map(klass.days.split(''), function (c) {
					return mapping[c];
				});
			});
	
			var classes = [];
			var start = DateTime.parse(response.start);
	
			_.each(response.classes, (function (klass) {
				var days_list = klass.days_list;
				var days = [];
	
				var maybePrevClass = '';
				var realPrevClass = '';
	
				var open = false; /* Sind wir in einem Gebiet mit freien Tagen? */
				var open2 = false; /* Sind wir in einem Gebiet mit freien Tagen, aber mit nicht-verfügbaren Anreisetagen? */
				var open3 = false; /* Sind wir in einem nicht-verfügbaren Gebiet, wo es kurz verfügbare Tage gibt? */
				_.each(days_list, (function (day, i) {
					var date = this.dateCache[i];
					if (!date) {
						// In rare occasions we get more than 500 days from the API.
						date = this.startDay.clone().add(i, 'days');
						this.dateCache[i] = date;
					}
	
					var prevDay = i > 0 ? days_list[i - 1] : -1;
					var nextDay = i < days_list.length ? days_list[i + 1] : -1;
	
					var validArrival = day > 0;
					var isFree = day >= 0;
	
					var mainClass = '';
	
					/**
	     * Übersicht über die Klassen:
	     * [<] begin 	   Hellgrüner Start 
	     * [ ] free-avail  Hellgrün, kein Pfeil
	     * [ ] part2       Dunkelgrün, kein Pfeil
	     * [>] close2      Ende von hellgrünen Bereich in dunkelgrünen Bereich
	     * [<] begin2      Start in einem dunkelgrünem Bereich 
	     * [>] end         Ende in hellgrünem Bereich 
	     * [>] end2        Ende von dunkelgrünem Bereich 
	     * [o] begin3      Start von hellgrün und sofort dunkelgrün nächster Tag
	     * [o] begin4      Start von dunkelgrün und sofort dunkelgrün nächster Tag
	     */
	
					if (open) {
						/* Einfacher Fall: Tag ist verfügbar -> grün */
						if (validArrival) {
							mainClass = 'free-avail';
						}
	
						/* Falls wir offen sind, aber ab heute nicht mehr verfügbar sind: Farbe wechseln */
						if (open3 && nextDay === 0) {
							mainClass = 'close2';
							open3 = false;
						} else if (open2) {
							if (validArrival) {
								/* Anreisetag in sonst nicht-freier Zone */
								mainClass = 'begin2';
								open3 = true;
							} else {
								mainClass = 'part2';
							}
						}
	
						/* Wenn der nächste Tag kein gültiger Anreisetag - aber frei ist, wechseln wir die Farbe */
						if (nextDay === 0 && !open2) {
							open2 = true;
							mainClass = 'close2';
						}
	
						/* Falls der Tag belegt ist, beenden wir diesen Block */
						if (day === -1) {
							mainClass = open2 ? 'end2' : 'end2';
							open = false;
							open2 = false;
							open3 = false;
						}
					} else {
						if (isFree && validArrival) {
							/* Einzelner Anreisetag */
							if (nextDay === 0) {
								mainClass = 'begin3';
								open = true;
								open2 = true;
							} else {
								/* Start einer Gruppe */
								mainClass = 'begin';
								open = true;
							}
						}
					}
	
					var helperClasses = [];
					if (open) helperClasses.push('open');
					if (open2) helperClasses.push('open2');
					if (open3) helperClasses.push('open3');
					if (validArrival) helperClasses.push('validArrival');
	
					/* Overrides to fix corner cases */
					var mainClassCopy = mainClass;
	
					// wenn [ ][ < ][ ] Zelle sollte [o] sein
					// hellgrüne Zelle zwischen dunkelgrün
					if (realPrevClass === "begin2" && mainClass === "part2") {
						days[i - 1].className = "begin4";
					}
	
					if (maybePrevClass === "begin2" && mainClass === "begin2") {
						mainClass = "free-avail";
					}
	
					if (realPrevClass === "begin2" && mainClass === "close2" && day === 0) {
						mainClass = "part2";
						days[i - 1].className = "begin4";
					}
	
					if (mainClassCopy === "end2" && days[i - 2] && days[i - 2].className != "begin3") {
	
						if (realPrevClass === "free-avail") {
							days[i - 1].className = "close2";
						} else {
							if (open2 || prevDay === 1) {
	
								days[i - 1].className = days[i - 2].className === ("part2" || "begin3") ? "begin4" : "begin3";
							} else {
								days[i - 1].className = "part2";
							}
						}
					}
	
					maybePrevClass = mainClassCopy;
					realPrevClass = mainClass;
	
					if (date.day() === 0 || date.day() === 6) {
						helperClasses.push("weekend");
					}
	
					var dayName = "";
					helperClasses.push("dayt_" + date.day());
					if (date.day() === 0) {
						dayName = "Su";
						helperClasses.push("sunday");
					}
					if (date.day() === 6) {
						dayName = "Sa";
						helperClasses.push("saturday");
					}
	
					if (mainClass === "") {
						mainClass = "occupied";
					}
	
					days.push({
						index: i,
						day: day,
						date: date,
						prevDay: prevDay,
						nextDay: nextDay,
						className: mainClass,
						dayName: dayName,
						maybeClass: mainClassCopy,
						helperClasses: helperClasses.join(" ")
					});
				}).bind(_this2));
	
				classes.push({
					name: klass.name,
					info: klass.info,
					/* + 1, da wir im Template einen Tag in die Zukunft sehen */
					days: days
				});
			}).bind(this));
	
			this.set({
				classes: classes,
				response: response,
				start: start,
				filterClass: classes[0].name
			});
	
			this.set("viewData", {
				filterClass: this.get("filterClass"),
				monthNames: __('monthNamesShort') || ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
				monthDays: [31, new Date().getFullYear() % 4 == 0 ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31, 31, (new Date().getFullYear() + 1) % 4 == 0 ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31, 31, (new Date().getFullYear() + 2) % 4 == 0 ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31, 31, (new Date().getFullYear() + 3) % 4 == 0 ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
				classes: classes,
				start: start
			});
		},
	
		/**
	  * Handler für Events auf einzelne Zellen
	  *
	  * @param data {Object} Daten von der Zelle (classOffset, dayOffset)
	  * @param $e {jQuery} Ausgewählte Zelle
	  * @param action {String} Aktion (click, hover)
	  */
		cellAction: function cellAction(data, $e, action) {
			var _this3 = this;
	
			var days = this.get("classes")[data.classOffset].days;
			var day_data = days[data.dayOffset];
			var day = day_data.day;
			var text = "";
	
			if (this.previousHoverData.classOffset === data.classOffset && this.previousHoverData.dayOffset === data.dayOffset && this.previousHoverAction == action) {
				return;
			}
	
			this.previousHoverData = data;
			this.previousHoverAction = action;
	
			var dayOffset = data.dayOffset;
			var hoverDate = this.startDay.clone().add(dayOffset, 'days');
	
			var validArrival = day > 0;
			var isFree = day >= 0;
	
			var lines = [];
	
			var lookAhead = (function (dayOffset, day) {
				var nextOffset = dayOffset + day;
				var lookAhead = undefined;
				var nextValidNights = [];
				while (lookAhead = days[nextOffset]) {
	
					nextValidNights.push(nextOffset - dayOffset);
					nextOffset++;
					if (nextOffset - dayOffset > 21) break;
					if (lookAhead.day === -1) break;
				}
				if (nextValidNights.length === 0 && day > 0) return [day];
				return nextValidNights;
			}).bind(this);
	
			if (!isFree) {
				// Kein tooltip
			} else if (!validArrival) {
					lines.push(hoverDate.format("dddd, DD. MMMM YYYY"));
					lines.push("Keine Anreise möglich");
				} else {
					lines.push(hoverDate.format("dddd, DD. MMMM YYYY"));
	
					/* Nach vorne schauen und prüfen, an welchen Tagen wir noch anreisen könnten */
					var nextValidNights = lookAhead(dayOffset, day);
					var _text = "Anreise möglich für " + NightsCompressor.humanString(nextValidNights);
					lines.push(_text);
				}
	
			// Erstmal alle Selection-Klassen löschen
			this.view.$el.find('.selection').removeClass('selection select-start select-part select-end selection-valid selection-invalid');
	
			if (action === "click") {
	
				var _selectionData = this.get("selectionData");
				var select_start = true;
	
				if (_selectionData) {
					/* Der User hat bereits geklickt und will seine Auswahl vollenden */
					select_start = false;
	
					/* Falls es die gleiche Klasse ist, nehmen wir die Auswahl an. Ansonsten wird eine neue gestartet. */
					if (_selectionData.classOffset === data.classOffset) {
						var from = this.startDay.clone().add(_selectionData.dayOffset, 'days');
						var to = this.startDay.clone().add(data.dayOffset, 'days');
	
						var nightsCount = data.dayOffset - _selectionData.dayOffset;
						var valid = _selectionData.lookAhead.indexOf(nightsCount) !== -1;
						if (valid) {
	
							this.trigger("dateSelected", from, to);
	
							setTimeout(function () {
								_this3.tooltip.boxHasChanged();
							}, 3000);
							setTimeout(function () {
								_this3.tooltip.boxHasChanged();
							}, 9000);
						}
					} else {
						select_start = true;
					}
					this.set("selectionData", null);
				}
	
				if (select_start) {
					if (day > 0) {
						data.lookAhead = lookAhead(dayOffset, day);
						data.tooltip = "Anreise möglich für " + NightsCompressor.humanString(data.lookAhead);
						data.startDay = hoverDate;
						this.set("selectionData", data);
					} else if (day === -1) {
						lines = ["Unterkunft ist an diesem Tag bereits belegt."];
					}
				}
			}
	
			text = lines.join("<br>");
	
			var selectionData = this.get("selectionData");
			if (selectionData && selectionData.classOffset === data.classOffset) {
				var nightsCount = data.dayOffset - selectionData.dayOffset;
				nightsCount = Math.max(nightsCount, 0);
	
				var valid = selectionData.lookAhead.indexOf(nightsCount) !== -1;
				var validClass = 'selection-' + (valid ? 'valid' : 'invalid') + ' ';
	
				lines = [];
				lines.push('<span class="selection-info ' + validClass + '">');
				lines.push(DateTime.textPeriod(selectionData.startDay, hoverDate));
				lines.push('<br>');
	
				if (nightsCount > 21) {
					lines.push("Mehr als 21 Nächte ausgewählt");
				} else if (nightsCount === 0) {
					lines.push("Bitte Abreisetag auswählen");
				} else if (!valid) {
					lines.push(selectionData.tooltip);
				}
				lines.push('</span>');
	
				if (selectionData.dayOffset === data.dayOffset) {
					$e.addClass('selection ' + validClass + 'select-start');
				} else {
					for (var i = selectionData.dayOffset; i <= data.dayOffset; i++) {
						var klass = 'select-part';
						if (i === selectionData.dayOffset) klass = 'select-start';
						if (i === data.dayOffset) klass = 'select-end';
	
						this.view.$el.find('.cell_' + data.classOffset + '_' + i).addClass('selection ' + validClass + klass);
					}
				}
	
				text = lines.join("");
			}
	
			if (lines.length === 0) {
				lines = ["Unterkunft ist an diesem Tag bereits belegt."];
				text = lines.join("");
			}
	
			if (lines.length > 0) {
				if (location.hostname === "localhost" || window.Tramino.user == 10) {
					text += "<br><i>index(" + day_data.index + ") prev(" + day_data.prevDay + ") day(" + day_data.day + ") next(" + day_data.nextDay + ") mainClass(" + day_data.className + ")<br>maybeClass(" + day_data.maybeClass + ") helperClasses(" + day_data.helperClasses + ")</i>";
				}
	
				this.tooltip.set(text);
			} else {
				this.tooltip.hide();
			}
		}
	
	});
	
	module.exports = ReservaTimeTableYear;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $ = __webpack_require__(6);
	var Backbone = __webpack_require__(20);
	
	var ReservaTimeTableYearView = Backbone.View.extend({
	
		events: {
			'click tbody td': 'onClick',
			'click .filter-class-select a': 'changeFilterClass',
			'mouseenter tbody td': 'onHover',
			'mousemove tbody td': 'onHover'
		},
	
		initialize: function initialize() {
			this.listenTo(this.model, "change:viewData", this.render);
		},
	
		render: function render() {
			var viewData = this.model.get("viewData");
			if (!viewData) return;
	
			if (!viewData.classes) {
				viewData.classes = [];
			}
	
			this.el.innerHTML = TemplateCache.render('reserva-yeartable', viewData);
			this.model.trigger("rendered");
		},
	
		/*
	  Event Handler
	 */
	
		onHover: function onHover(e) {
			var $e = $(e.currentTarget);
			var data = $(e.currentTarget).data();
			if (typeof data.classOffset !== "undefined" && typeof data.dayOffset !== "undefined") {
				this.model.cellAction(data, $e, "hover");
	
				/* Hover for the current day */
				this.highlightDay(data.dayOffset);
			}
		},
	
		onClick: function onClick(e) {
			var $e = $(e.currentTarget);
			var data = $(e.currentTarget).data();
			if (typeof data.classOffset !== "undefined" && typeof data.dayOffset !== "undefined") {
				this.model.cellAction(data, $e, "click");
			}
		},
	
		changeFilterClass: function changeFilterClass(e) {
			e.preventDefault();
			var data = $(e.currentTarget).data();
	
			this.model.set({
				filterClass: data['class']
			});
		},
	
		/*
	  API
	 */
	
		highlightDay: function highlightDay(dayOffset) {
			this.$el.find('.day-hover').removeClass('day-hover');
			this.$el.find('.day_' + dayOffset).addClass('day-hover');
		}
	
	});
	
	module.exports = ReservaTimeTableYearView;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Reserva Preismatrix
	 */
	
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var $ = __webpack_require__(6);
	var _ = __webpack_require__(7);
	var Backbone = __webpack_require__(20);
	var moment = __webpack_require__(8);
	
	var DateTime = __webpack_require__(40);
	var FormModel = __webpack_require__(34);
	var MiniTimer = __webpack_require__(22);
	
	var ReservaPriceTableView = __webpack_require__(93);
	
	var ReservaPriceTable = Backbone.Model.extend({
	
		defaults: function defaults() {
			return {
				groups: [],
				info: "",
				from: null,
				to: null,
				nights: 0,
				model: null,
				container: null,
				viewData: null,
	
				renderOffset: 0,
				renderDaysCount: 7,
				canGoFurther: true,
				overrideWidth: null
			};
		},
	
		initialize: function initialize() {
			_.bindAll(this, "updateViewState");
	
			this.container = this.get("container");
			this.model = this.get("model") || new FormModel();
	
			this.startDay = DateTime.resetTimeFields(moment());
	
			this.view = new ReservaPriceTableView({
				el: this.container,
				model: this
			});
	
			/* Bubble the event up */
			this.on("pricetableClick", (function (data) {
				this.get("model").trigger("pricetableClick", data);
			}).bind(this));
	
			this.dateCache = {};
			for (var i = 0; i <= 521; i++) {
				this.dateCache[i] = this.startDay.clone().add(i + 1, 'days');
			}
		},
	
		/**
	  * Die TimeTable initialisieren und rendern
	  */
		run: function run() {
			var _this = this;
	
			this.updateDate();
	
			this.on('change:renderOffset change:renderDaysCount', function () {
				_this.updateViewState();
			});
	
			/* Responsive Width Test */
			var timer = MiniTimer("Test rendering for column width");
			timer();
	
			$(window).on('resize', _.debounce(this.updateViewState, 300));
	
			/* Bei Änderungen am Model die Auswahl aktualisieren */
			this.model.on('change:to change:select_mode', function (e) {
				/* Leichte Verzögerung um die UI nicht so stark zu blockieren */
				setTimeout((function () {
					this.updateDate();
					this.updateViewState();
				}).bind(_this), 100);
			});
		},
	
		updateDate: function updateDate() {
			var from = this.model.get("from");
			var to = this.model.get("to");
			var select_mode = this.model.get("select_mode") || "exact";
	
			/* Entweder gibt es Start UND Ende, oder gar keine Auswahl */
			if (from && to && select_mode === "exact") {
				from = DateTime.resetTimeFields(DateTime.parse(from));
				to = DateTime.resetTimeFields(DateTime.parse(to));
			} else {
				from = null;
				to = null;
			}
	
			this.set({
				from: from,
				to: to,
				nights: to ? to.diff(from, 'days') : 0,
				renderOffset: from ? Math.max(0, from.diff(this.startDay, 'days') - 1) : 0
			});
		},
	
		/**
	  * Server-Rückgabe verarbeiten:
	  * - groups[*].offers[*].values 		=> in floats casten
	  * - groups[*].offers[*].values_display => erzeugen (Werte für die Ausgabe)
	  *
	  * @param response {Object} Server-Rückgabe
	  */
		handleResponse: function handleResponse(response) {
			_.each(response.groups, function (group) {
				_.each(group.offers, function (offer) {
					offer.values = _.map(offer.values, function (v) {
						return parseFloat(v);
					});
					offer.values_display = _.map(offer.values, function (v) {
						if (v === 0 || v > 9999) return "";
						return Math.abs(v).toFixed(2).replace('.', ',');
					});
				});
			});
			this.startDay = DateTime.resetTimeFields(moment(response.start));
			this.set({
				groups: response.groups,
				info: response.info
			});
			this.updateViewState();
		},
	
		setRenderOffset: function setRenderOffset(new_offset) {
			var groups = this.get("groups");
			if (new_offset < 0) {
				new_offset = 0;
			}
	
			if (groups && groups[0]) {
				var maxOffset = groups[0].offers[0].values.length - this.get("renderDaysCount");
				new_offset = Math.min(new_offset, maxOffset);
	
				this.set({
					"renderOffset": new_offset,
					"canGoFurther": new_offset < maxOffset
				});
			} else {
				this.set({
					"renderOffset": 0,
					"canGoFurther": false
				});
			}
		},
	
		updateViewState: function updateViewState(e) {
			var timer = MiniTimer("ReservaPriceTable.updateViewState");
	
			if (!this.get("to")) {
				this.set("viewData", {});
				return;
			}
	
			var container = this.view.$el;
	
			var cellWidth = 65;
			var titleWidth = container.find('tbody .kat').width();
	
			var containerMaxWidth = this.get("overrideWidth") || container.width();
			var cellsToDisplay = Math.floor((containerMaxWidth - 200) / cellWidth) - 1;
			cellsToDisplay = Math.max(cellsToDisplay, 3);
	
			this.set({
				"renderDaysCount": cellsToDisplay,
				"titleWidth": titleWidth
			}, { silent: true });
	
			var renderOffset = this.get("renderOffset");
			var renderDaysCount = this.get("renderDaysCount");
	
			var months = [];
			var monthCounters = {};
			var days = [];
	
			/* Highlight currently selected timerange */
	
			/* Make list of all days we're going to render, and group them by month */
			var makeMonths = (function (short_map) {
				short_map = short_map || {};
				months = [];
				days = [];
				monthCounters = {};
	
				for (var i = 0; i < renderDaysCount; ++i) {
					var day = this.startDay.clone().add(i + renderOffset, 'days');
					var monthname = day.format('MMMM YYYY');
					if (typeof short_map[monthname] !== "undefined") {
						monthname = day.format(short_map[monthname]);
					}
	
					if (months.indexOf(monthname) === -1) {
						months.push(monthname);
						monthCounters[monthname] = 0;
					}
					monthCounters[monthname]++;
	
					days.push({
						index: i + renderOffset,
						line1: day.format('dddd'),
						line2: day.format('D. MMM').replace(' ', '&nbsp;').replace('Febr.', 'Feb.').replace('Mrz.', 'März').replace('Jun.', 'Juni').replace('Jul.', 'Juli'),
						date: day.format('YYYY-MM-DD'),
						weekend: day.day() === 0 || day.day() === 6,
						selected: this.get("from") && this.get("from").format("YYYY-MM-DD") == day.format('YYYY-MM-DD')
					});
				}
			}).bind(this);
			makeMonths();
	
			/* Schauen ob wir die Monatsnamen kürzen müssen */
			_.each(monthCounters, function (count, month) {
				/* Wenn wir nur einen Monat haben, ist selbst "Nov." zu lang */
				if (count === 1) {
					var mapping = {};
					mapping[month] = ' '; /* Achtung: Empty string führt zu YYYY-MM-DD */
					makeMonths(mapping);
				}
				/* Bei weniger als 4 Tagen kürzen wir auf z. B. "Nov." statt "November 2015" */
				else if (count < 4) {
						var mapping = {};
						mapping[month] = 'MMM';
						makeMonths(mapping);
					}
			});
	
			/* Klassen erzeugen */
			var groups = [];
			_.each(this.get("groups"), function (group) {
				var offers = [];
				_.each(group.offers, function (offer) {
					offers.push(_extends({}, offer, {
						values: offer.values.slice(renderOffset, renderOffset + renderDaysCount),
						values_display: offer.values_display.slice(renderOffset, renderOffset + renderDaysCount)
					}));
				});
	
				groups.push(_extends({}, group, {
					offers: offers
				}));
			});
	
			timer();
	
			/* Alles zusammen packen und dann rendern */
			this.set("viewData", {
				months: months,
				monthCounters: monthCounters,
				days: days,
				groups: groups,
				info: this.get("info"),
				renderDaysCount: renderDaysCount,
				renderOffset: renderOffset,
				canGoFurther: this.get("canGoFurther"),
				developer: location.host.indexOf("localhost") !== -1,
				selectedNightString: this.get("from") ? this.get("from").format("YYYY-MM-DD") : ""
			});
		}
	
	});
	
	module.exports = ReservaPriceTable;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $ = __webpack_require__(6);
	var Backbone = __webpack_require__(20);
	var DateTime = __webpack_require__(40);
	
	var ReservaPriceTableView = Backbone.View.extend({
	
		events: {
			'click .offset-down': 'offsetDown',
			'click .offset-up': 'offsetUp',
			'click .btn-reset': 'reset',
			'click .count-up': 'countUp',
			'click .count-down': 'countDown',
			'mouseover a.price': 'priceHover',
			'click a.price': 'clickPrice'
		},
	
		initialize: function initialize() {
			this.listenTo(this.model, "change:viewData", this.render);
		},
	
		render: function render() {
			this.el.innerHTML = TemplateCache.render('pricetable-template', this.model.get("viewData"));
		},
	
		/*
	  Event Handler
	 */
	
		offsetDown: function offsetDown(e) {
			var days = $(e.currentTarget).data('days') | 0;
			this.model.setRenderOffset(this.model.get("renderOffset") - days);
		},
	
		offsetUp: function offsetUp(e) {
			var days = $(e.currentTarget).data('days') | 0;
			this.model.setRenderOffset(this.model.get("renderOffset") + days);
		},
	
		reset: function reset(e) {
			this.model.setRenderOffset(0);
		},
	
		countDown: function countDown(e) {
			this.model.set("renderDaysCount", Math.max(10, this.model.get("renderDaysCount") - 5));
		},
	
		countUp: function countUp(e) {
			this.model.set("renderDaysCount", this.model.get("renderDaysCount") + 5);
		},
	
		priceHover: function priceHover(e) {
			var data = $(e.currentTarget).data();
			data.to = DateTime.parse(data.from).add(this.model.get("nights"), "days").format("YYYY-MM-DD");
	
			var args = {
				from: data.from,
				to: data.to
			};
	
			/* A gorgeous hack to integrate the crappy old IBE. Should be neither hard-coded nor in this view. */
			if (typeof window.ReservaForm !== "undefined") {
				args.rooms = ReservaForm.get("rooms");
				args.erwachsene_1 = ReservaForm.get("erwachsene_1");
				args.kinder_1 = ReservaForm.get("kinder_1");
				args.kind1_1 = ReservaForm.get("kind1_1");
				args.kind2_1 = ReservaForm.get("kind2_1");
				args.kind3_1 = ReservaForm.get("kind3_1");
				args.erwachsene_2 = ReservaForm.get("erwachsene_2");
				args.kinder_2 = ReservaForm.get("kinder_2");
				args.kind1_2 = ReservaForm.get("kind1_2");
				args.kind2_2 = ReservaForm.get("kind2_2");
				args.kind3_2 = ReservaForm.get("kind3_2");
				args.erwachsene_3 = ReservaForm.get("erwachsene_3");
				args.kinder_3 = ReservaForm.get("kinder_3");
				args.kind1_3 = ReservaForm.get("kind1_3");
				args.kind2_3 = ReservaForm.get("kind2_3");
				args.kind3_3 = ReservaForm.get("kind3_3");
				args.item = ReservaForm.get("item");
				args.currency = ReservaForm.get("currency");
				args.lang = ReservaForm.get("lang");
			}
	
			e.currentTarget.href = data.url + '?' + $.param(args);
		},
	
		clickPrice: function clickPrice(e) {
			/* If we're inside the old IBE, do nothing and let the browser handle the link */
			if (window.ReservaForm) return;
			e.preventDefault();
	
			var data = $(e.currentTarget).data();
			data.to = DateTime.parse(data.from).add(this.model.get("nights"), "days").format("YYYY-MM-DD");
	
			this.model.trigger("pricetableClick", {
				href: e.currentTarget.href,
				from: data.from,
				to: data.to
			});
		}
	
	});
	
	module.exports = ReservaPriceTableView;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Partner-Seite: Bewertungs-Block
	 */
	
	var _ = __webpack_require__(7);
	
	var RatingsModel = __webpack_require__(95);
	var RatingsView = __webpack_require__(96);
	
	var ClientRatings = function ClientRatings(options) {
	    _.extendOwn(this, {
	        api: '/api/rating/',
	        client: null,
	        container: null
	    }, options);
	
	    this.ratingsModel = new RatingsModel({
	        client: this.client,
	        api: this.api
	    });
	    this.ratingsView = new RatingsView({
	        model: this.ratingsModel,
	        el: this.container
	    });
	};
	
	ClientRatings.prototype.run = function () {
	    this.ratingsModel.loadMore();
	    this.ratingsView.render();
	};
	
	module.exports = ClientRatings;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ = __webpack_require__(7);
	var Backbone = __webpack_require__(20);
	var ajax = __webpack_require__(21);
	
	var RatingsModel = Backbone.Model.extend({
	
		defaults: function defaults() {
			return {
				/* Parameters */
				client: null,
				api: null,
	
				/* State */
				startIndex: 0,
				perPage: 1,
				items: [],
				hasMore: true,
				total: null
			};
		},
	
		loadMore: function loadMore() {
			if (!this.attributes.hasMore) return;
			if (!this.attributes.client || !this.attributes.api) {
				throw new Error("RatingsModel: Missing client or api parameter");
			}
	
			ajax(this.attributes.api, {
				params: {
					client: this.attributes.client,
					start: this.attributes.items.length,
					lang: window.Tramino.lang
				}
			}).then((function (response) {
				if (response.status && response.status === "error") {
					throw new Error("API call failed: " + response.message);
				}
	
				if (!response.total) return; /* Empty response */
	
				this.set({
					items: _.union(this.attributes.items, response.items),
					total: response.total,
					hasMore: response.total > this.attributes.items.length
				});
			}).bind(this))['catch'](function (e) {});
		}
	
	});
	
	module.exports = RatingsModel;

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__) {"use strict";
	
	var Backbone = __webpack_require__(20);
	
	var TemplateCache = __webpack_require__(25);
	
	var RatingsView = Backbone.View.extend({
	
		events: {
			'click .ratings-next': 'nextItem',
			'click .ratings-prev': 'prevItem'
		},
	
		initialize: function initialize() {
			this.listenTo(this.model, "change:items change:startIndex", this.render);
		},
	
		render: function render() {
			var startIndex = this.model.get("startIndex");
			var itemsCount = this.model.get("items").length;
			var perPage = this.model.get("perPage");
			var items = this.model.get('items').slice(startIndex, startIndex + this.model.get('perPage'));
	
			var nextPageIndex = startIndex + perPage;
			var paginationInfo = [startIndex + 1];
			if (perPage > 1) {
				paginationInfo.push("-");
				paginationInfo.push(nextPageIndex < itemsCount ? nextPageIndex : itemsCount);
			};
			if (nextPageIndex <= itemsCount) {
				paginationInfo.push(__("collectible.of"));
				paginationInfo.push(this.model.get("total"));
			}
	
			this.el.innerHTML = TemplateCache.render('ratings-template', {
				client: this.model.get("client"),
				items: items,
				startIndex: startIndex,
				itemsCount: itemsCount,
				perPage: perPage,
				hasPrev: startIndex > 0,
				hasNext: startIndex + perPage < itemsCount,
				paginationInfo: paginationInfo.join(" ")
			});
		},
	
		nextItem: function nextItem(e) {
			e.preventDefault();
			if (this.startIndex >= this.model.length - 1) {
				return;
			}
			this.model.set("startIndex", this.model.get("startIndex") + 1);
	
			// Müssen wir mehr laden?
			if (this.model.get("startIndex") > this.model.get("items").length - 2) {
				this.model.loadMore();
			}
		},
	
		prevItem: function prevItem(e) {
			e.preventDefault();
			if (this.model.get("startIndex") === 0) {
				return;
			}
			this.model.set("startIndex", this.model.get("startIndex") - 1);
		}
	
	});
	
	module.exports = RatingsView;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _underscore = __webpack_require__(7);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _backbone = __webpack_require__(20);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	var _TemplateCache = __webpack_require__(25);
	
	var _TemplateCache2 = _interopRequireDefault(_TemplateCache);
	
	var FilterView = _backbone2['default'].View.extend({
	
	    events: {
	        'click .tag-box': 'toggleTag',
	        'click .tags-reset': 'resetSelectedTags',
	        'click .tags-submit': 'submitSelectedTags'
	    },
	
	    initialize: function initialize() {
	        this.listenTo(this.model, "change:error change:loading change:groups", this.render);
	    },
	
	    render: function render() {
	        this.el.innerHTML = _TemplateCache2['default'].render("interest-filter", this.model.toJSON());
	    },
	
	    toggleTag: function toggleTag(e) {
	        e.preventDefault();
	        this.model.toggleTag($(e.currentTarget).data('tag'));
	    },
	
	    resetSelectedTags: function resetSelectedTags(e) {
	        e.preventDefault();
	        this.model.set("selectedTags", []);
	    },
	
	    submitSelectedTags: function submitSelectedTags(e) {
	        e.preventDefault();
	        this.model.trigger("submit", this.model);
	    }
	});
	
	var ReservaInterestFilter = _backbone2['default'].Model.extend({
	
	    defaults: function defaults() {
	        return {
	            /* Params */
	            groups: [],
	            api: "/api/engine/tags/",
	            container: null,
	
	            /* State */
	            local: location.hostname === "localhost",
	            loading: true,
	            error: null,
	            selectedTags: [],
	            totalCount: 0,
	            resultsCount: 0,
	
	            tagGroups: []
	        };
	    },
	
	    initialize: function initialize() {
	        var _this = this;
	
	        _underscore2['default'].bindAll(this, "run", "reset");
	
	        var groups = this.get("groups");
	        if (typeof groups === "string") {
	            this.set("groups", (0, _underscore2['default'])(groups.split(',')).map(function (i) {
	                return parseInt(i, 10);
	            }));
	        }
	
	        this.tagMapping = {};
	        this.clientTagMapping = {};
	
	        this.on("change:selectedTags", function () {
	            _this.recountTags(_this.get("tagGroups"));
	            _this.view.render();
	        });
	    },
	
	    run: function run() {
	        var _this2 = this;
	
	        var groups = this.get("groups").join(",");
	        var container = this.get("container");
	
	        if (!container || !container.length) {
	            throw new Error("ReservaInterestFilter: Invalid container provided: " + container);
	        }
	
	        var url = this.get("api") + '?' + $.param({
	            groups: groups,
	            force_cors: 1,
	            clients: 1,
	            lang: window.Tramino && window.Tramino.lang || "de"
	        });
	
	        this.view = new FilterView({
	            el: container,
	            model: this
	        });
	        this.view.render();
	
	        var promise = undefined;
	
	        if (this.get("local")) {
	            var cached = sessionStorage.getItem("interest-filter-cache-2");
	            if (cached) {
	                promise = Promise.resolve(JSON.parse(cached));
	            }
	        }
	
	        if (!promise) {
	            promise = Promise.resolve($.getJSON(url));
	        }
	
	        promise.then(function (result) {
	            return _this2.onResult(result);
	        }, function (error) {
	            _this2.set({
	                loading: false,
	                error: "Konnte Interessen nicht laden. Bitte versuchen Sie es später nochmal."
	            });
	        });
	    },
	
	    onResult: function onResult(response) {
	        if (this.get("local")) {
	            sessionStorage.setItem("interest-filter-cache-2", JSON.stringify(response));
	        }
	
	        /**
	         * Tag-Gruppen bauen
	         */
	
	        var tagGroups = [];
	
	        var currentGroupName = null;
	        var currentTags = [];
	
	        for (var i = 0, result; result = response.tags_info[i]; ++i) {
	            // result = { order, group, id, tag, [clients] }
	            if (!currentGroupName) currentGroupName = result.group;
	            if (currentGroupName != result.group) {
	                tagGroups.push({
	                    index: i,
	                    name: currentGroupName,
	                    tags: currentTags
	                });
	                currentGroupName = result.group;
	                currentTags = [];
	            }
	
	            if (!result.image) {
	                result.image = "/tramino/gfx/icon_default.jpg";
	            }
	
	            if (result.image.substr(0, 3) === "/s/") {
	                result.image = "https://tramino.s3.amazonaws.com" + result.image;
	            }
	
	            if (location.hostname === "localhost" && result.image) {
	                if (result.image.substr(0, 1) === "/") {
	                    result.image = "http://oberstdorf.tramino.dev" + result.image;
	                }
	            }
	
	            var clients = result.clients.split(',');
	
	            currentTags.push({
	                id: result.id,
	                tag: result.tag,
	                info: result.info,
	                count: null, /* null = Unknown count */
	                image: result.image,
	                clients: clients
	            });
	
	            /* Wir erzeugen hier ein Mapping von tag_id => Array von Klassen.
	               Dies ermöglicht es uns später, schnell anhand der ausgewählten Tags die Ergebnisse zu filtern */
	            for (var j = 0, client_id; client_id = clients[j]; ++j) {
	                if (typeof this.tagMapping[result.id] === "undefined") {
	                    this.tagMapping[result.id] = [];
	                }
	                this.tagMapping[result.id].push(parseInt(client_id, 10)); // result.id = tag.id
	
	                if (typeof this.clientTagMapping[client_id] === "undefined") {
	                    this.clientTagMapping[client_id] = [];
	                }
	                this.clientTagMapping[client_id].push(parseInt(result.id, 10)); // result.id = tag.id
	            }
	        }
	
	        tagGroups.push({
	            name: currentGroupName,
	            tags: currentTags
	        });
	
	        this.recountTags(tagGroups);
	
	        this.set({
	            loading: false,
	            totalCount: _underscore2['default'].keys(this.clientTagMapping).length,
	            tagGroups: tagGroups
	        });
	    },
	
	    recountTags: function recountTags(tagGroups) {
	        var _this3 = this;
	
	        var selectedTags = this.get("selectedTags");
	        var matching_clients = [];
	
	        if (selectedTags.length > 0) {
	            (function () {
	                // Für jeden Tag alle Clients ermitteln, die den Tag haben
	
	                var clients_stack = [];
	
	                _underscore2['default'].each(selectedTags, function (tag_id) {
	                    clients_stack.push(_this3.tagMapping[tag_id]);
	                });
	
	                /*
	                clients_stack = [
	                    [1, 2, 3],
	                    [2, 3, 4, 5],
	                    [1, 2, 3, 5]
	                ]
	                 => matching_clients = [2, 3]
	                */
	
	                // Nun die gemeinsame Menge finden
	                matching_clients = _underscore2['default'].intersection.apply(_underscore2['default'], clients_stack);
	                _this3.matching_clients = matching_clients;
	            })();
	        }
	
	        // Tags zählen
	        var tagCounts = {};
	        var resultsCount = 9999;
	        _underscore2['default'].each(tagGroups, function (group) {
	            // n = ~3
	            _underscore2['default'].each(group.tags, function (tag) {
	                // n = ~10
	
	                if (selectedTags.length === 0) {
	                    tagCounts[tag.id] = _this3.tagMapping[tag.id].length;
	                } else {
	                    /* For this tag, check which other tags also have the same clients */
	                    tagCounts[tag.id] = _underscore2['default'].filter(_this3.tagMapping[tag.id], function (client) {
	                        return matching_clients.indexOf(client) !== -1;
	                    }).length;
	                }
	
	                if (selectedTags.indexOf(tag.id) !== -1) {
	                    //console.log(`Math.min(${resultsCount}, ${tagCounts[tag.id]}) = ${Math.min(resultsCount, tagCounts[tag.id])}`);
	                    resultsCount = Math.min(resultsCount, tagCounts[tag.id]);
	                }
	            });
	        });
	
	        if (resultsCount === 9999) {
	            resultsCount = 0;
	        }
	
	        _underscore2['default'].each(tagGroups, (function (group) {
	            // n = ~4
	            _underscore2['default'].each(group.tags, function (tag) {
	                // n = ~8
	                if (tagCounts[tag.id]) {
	                    tag.count = tagCounts[tag.id];
	                } else {
	                    tag.count = 0;
	                }
	            });
	            //group.tags = _(group.tags).sortBy(tag => -tag.count);
	            group.tags = (0, _underscore2['default'])(group.tags).sortBy(function (tag) {
	                return tag.name;
	            });
	        }).bind(this));
	
	        this.set({
	            resultsCount: resultsCount
	        });
	    },
	
	    toggleTag: function toggleTag(tag_id) {
	        var tags = this.get("selectedTags");
	        tag_id = parseInt(tag_id, 10);
	        if (_underscore2['default'].contains(tags, tag_id)) {
	            tags.splice(tags.indexOf(tag_id), 1);
	        } else {
	            tags.push(tag_id);
	        }
	
	        this.set("selectedTags", tags);
	        // Backbone wont trigger on set cause the array is still the same array object
	        this.trigger("change:selectedTags", this);
	    },
	
	    reset: function reset() {
	        this.set({
	            selectedTags: []
	        });
	    }
	
	});
	
	exports['default'] = ReservaInterestFilter;
	module.exports = exports['default'];

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(99);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(101)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./style.less", function() {
				var newContent = require("!!../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./style.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(100)();
	// imports
	
	
	// module
	exports.push([module.id, ".reserva-table-container{overflow:auto}.reserva-table-year{border:0 solid #000}.reserva-table-year thead th{font-size:14px;padding:0 0 3px;color:#666}.reserva-table-year tbody th{font-size:14px;text-align:right;padding:0 15px;color:#333;min-width:75px}.reserva-table-year *{box-sizing:border-box}.reserva-table-year td div{min-width:28px;min-height:28px}.reserva-table-year td.selected{background:#ffa}.reserva-table-year tbody td.begin div{border-left:14px solid #363;border-right:14px solid #363;border-radius:14px 0 0 14px}.reserva-table-year td{filter:none;position:relative}.reserva-table-year td.weekend b{display:block;position:absolute;top:0;left:0;padding-top:8px;width:100%;height:100%;color:hsla(0,0%,100%,.3);font-size:8pt;text-align:center;font-weight:400;background:hsla(0,0%,100%,.07)}.reserva-table-year td.sunday b{border-right:1px solid hsla(0,0%,100%,.2)}.reserva-table-year tr.break td{height:15px;border-left:0;border-right:0!important}.reserva-table-year tbody td.begin3{background:#fff;background:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/Pgo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDEgMSIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSI+CiAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkLXVjZ2ctZ2VuZXJhdGVkIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMCUiPgogICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3RvcC1jb2xvcj0iI2ZmZmZmZiIgc3RvcC1vcGFjaXR5PSIxIi8+CiAgICA8c3RvcCBvZmZzZXQ9IjUwJSIgc3RvcC1jb2xvcj0iI2ZmZmZmZiIgc3RvcC1vcGFjaXR5PSIxIi8+CiAgICA8c3RvcCBvZmZzZXQ9IjUwJSIgc3RvcC1jb2xvcj0iIzExNDQxMSIgc3RvcC1vcGFjaXR5PSIxIi8+CiAgICA8c3RvcCBvZmZzZXQ9Ijk5JSIgc3RvcC1jb2xvcj0iIzExNDQxMSIgc3RvcC1vcGFjaXR5PSIxIi8+CiAgPC9saW5lYXJHcmFkaWVudD4KICA8cmVjdCB4PSIwIiB5PSIwIiB3aWR0aD0iMSIgaGVpZ2h0PSIxIiBmaWxsPSJ1cmwoI2dyYWQtdWNnZy1nZW5lcmF0ZWQpIiAvPgo8L3N2Zz4=);background:linear-gradient(90deg,#c4c4c4 0,#c4c4c4 50%,#141 0,#141 99%);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#ffffff\",endColorstr=\"#114411\",GradientType=1)}.reserva-table-year tbody td.begin3 div{border-left:14px solid #363;border-right:14px solid #363;border-radius:14px 14px 14px 14px}.reserva-table-year tbody td.begin3.selected{background:#ffa;background:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/Pgo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDEgMSIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSI+CiAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkLXVjZ2ctZ2VuZXJhdGVkIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMCUiPgogICAgPHN0b3Agb2Zmc2V0PSIwJSIgc3RvcC1jb2xvcj0iI2ZmZmZhYSIgc3RvcC1vcGFjaXR5PSIxIi8+CiAgICA8c3RvcCBvZmZzZXQ9IjUwJSIgc3RvcC1jb2xvcj0iI2ZmZmZhYSIgc3RvcC1vcGFjaXR5PSIxIi8+CiAgICA8c3RvcCBvZmZzZXQ9IjUwJSIgc3RvcC1jb2xvcj0iIzExNDQxMSIgc3RvcC1vcGFjaXR5PSIxIi8+CiAgICA8c3RvcCBvZmZzZXQ9Ijk5JSIgc3RvcC1jb2xvcj0iIzExNDQxMSIgc3RvcC1vcGFjaXR5PSIxIi8+CiAgPC9saW5lYXJHcmFkaWVudD4KICA8cmVjdCB4PSIwIiB5PSIwIiB3aWR0aD0iMSIgaGVpZ2h0PSIxIiBmaWxsPSJ1cmwoI2dyYWQtdWNnZy1nZW5lcmF0ZWQpIiAvPgo8L3N2Zz4=);background:linear-gradient(90deg,#ffa 0,#ffa 50%,#141 0,#141 99%);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#ffffaa\",endColorstr=\"#114411\",GradientType=1)}.reserva-table-year tbody td.day-hover.begin div{border-color:#474}.reserva-table-year tbody tr:hover td.day-hover.begin div{border-color:#585}.reserva-table-year tbody tr td.begin2{background:#141}.reserva-table-year tbody td.begin2 div{border-left:14px solid #363;border-right:14px solid #363;border-radius:14px 0 0 14px}.reserva-table-year tbody td.day-hover.begin2 div{border-left:14px solid #474;border-right:14px solid #474;border-radius:14px 0 0 14px}.reserva-table-year tbody tr:hover td.day-hover.begin2 div{border-left:14px solid #585;border-right:14px solid #585}.reserva-table-year tbody tr td.begin4{background:#141}.reserva-table-year tbody td.begin4 div{border-left:14px solid #363;border-right:14px solid #363;border-radius:14px 14px}.reserva-table-year tbody td.end div{border-left:14px solid #363}.reserva-table-year tbody td.end2 div,.reserva-table-year tbody td.end div{border-top:14px solid transparent;border-right:14px solid transparent;border-bottom:14px solid transparent}.reserva-table-year tbody td.end2 div{border-left:14px solid #141}.reserva-table-year tbody tr td.free-avail{background:#363}.reserva-table-year tbody tr td.day-hover.free-avail{background:#474}.reserva-table-year tbody tr:hover td.day-hover.free-avail{background:#585}.reserva-table-year tbody tr td.part2{background:#141}.reserva-table-year tbody tr td.step{background:#363}.reserva-table-year tbody td.step div{border-top:14px solid transparent;border-right:14px solid transparent;border-bottom:14px solid transparent;border-left:14px solid #575;border-radius:14px}.reserva-table-year tbody tr td.close2{background:#141}.reserva-table-year td.close2 div{border-left:14px solid #363;border-right:14px solid #363;border-radius:0 14px 14px 0}.reserva-table-year .months th{border-right:1px solid #ccc;border-top:1px solid #ccc}.reserva-table-year .days th{border-right:1px solid #ccc}.reserva-table-year th{font-weight:400}.reserva-table-year td,.reserva-table-year th{border-bottom:1px solid #ccc}.reserva-timetable-tooltip{z-index:71;position:absolute;padding:2px 8px;border:1px solid #000;background:#000;color:#fff;font-weight:700;font-size:14px;display:none}.reserva-table-year .selection span{display:block;position:absolute;top:8px;left:0;width:100%;height:50%;opacity:.75}.reserva-table-year .selection.selection-valid span{background:orange}.reserva-table-year .selection.selection-invalid span{background:red}.reserva-timetable-tooltip .selection-valid{color:orange}.reserva-timetable-tooltip .selection-invalid{color:red}.reserva-table-year .select-start span{left:12px;border-top-left-radius:14px;border-bottom-left-radius:14px}.reserva-table-year .select-end span{width:70%;border-top-right-radius:14px;border-bottom-right-radius:14px}.class-info{font-size:8pt}.reserva-table-year .day:not(.open){background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAABhGlDQ1BzUkdCIElFQzYxOTY2LTIuMQAAKJF1kb9LQlEUxz9qvzMakmhocJCGqCgLqa2UsEJErCCrRV/+CLQe7xkRjQ2tDg79oCWJlubaon8gCIJqiqA1GgpaIl7namBEnsu993O/95xz7z0X7AtZLWfWDUJuLW9Eg373QmzR3fhEA500A764ZuoTkUiImvZxh03Nt/0qV22/f611JWlqYGsSHtd0Iy88JRzezOuK94RdWia+Inwm3GfIBYUflJ6o8IvidJntKqfLmIsGhF3C7vQvTvxiLWPkhEeEPbnshvZzH/USZ3Jtflbp0rsxiRLEj5tpJgngY4gxGX3042VAVtSI95bjw6xLrCajzhYGq6TJkKdP1A3JnpQ5JXpSWlY8xNQf/K2tmRr2Vk5wzkD9s2W990LjIXztWtbnsWV9lcAhdbkqVuPXizD6KnqhqnmOoH0Hzi+rWuIELgrQ9ajHjXhZcki3p1LwdgptMei4gZalSt1+9indw9w2hK5h/wB6xL99+Rv6mGc1xmFV0gAAAAlwSFlzAAALEwAACxMBAJqcGAAAANtJREFUSIntk0EKwjAQRZ8K7kXpwk0voN5hTjbkZnMG8QLduBBFEEFx5SbFIE07SMFN3moaPvOSSQqFQuHfTIYCIYQ5UANnVb1mMgtgBTSq+urrN3VsqgbWwC6EsOyQLYFdzNRDzTzCc1JvUmmsN5lsJ4MjzTQ+tBtI11T1MoowI01xyQBmXqGZPUTkDlS/ysB3h6PiPmHPSCsRuZvZYzRh5tGc+IzXLR0Uxp96m8pU9dJxp5WI3Mzs2dfPc4erb1n7EetDJvuzsAGOwL7rNca1fcw0jn6FQuHPvAFCYlXCTqeEcgAAAABJRU5ErkJggg==)}.reserva-table-year .month-rest{border-left:1px solid #ccc}.reserva-table-year tbody tr td:last-child:not(.month-rest){border-right:1px solid #ccc}.reserva-table-year tbody td{border-left:1px solid #ccc}.reserva-table-year td.close2,.reserva-table-year td.free-avail{border-left:1px solid #474}.reserva-table-year td.begin4,.reserva-table-year td.end2,.reserva-table-year td.part2{border-left:1px solid #252}", ""]);
	
	// exports


/***/ }),
/* 100 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Tramino Analytics
	 *
	 * Sammelt Ereignisse die im Frontend passieren und pusht diese zum Server.
	 */
	
	"use strict";
	
	var _ = __webpack_require__(7);
	
	/**
	 * Client-Komponente für das Tramino Analytics System.
	 *
	 * @param $ {jQuery} jQuery Referenz
	 */
	var TraminoAnalytics = function TraminoAnalytics($) {
		_.bindAll(this, "send", "sendEvents");
	
		this.$ = $;
		this.api = '/api/tal/';
		this.dev = window.Tramino.user === "10";
	
		this.client = window.Tramino.client;
		this.page = window.Tramino.page;
		this.enabled = true;
		this.sendOnceBuffer = {};
	};
	
	/**
	 * Ein Event an das Analytics-Backend senden. 
	 * Events werden zwischengespeichert und in Paketen an den Server verschickt.
	 *
	 * @param betrieb {Number} ID des Betriebes/Clients
	 * @param action {String} Name der Aktion ([a-z]+)
	 */
	TraminoAnalytics.prototype.send = function (betrieb, action) {
		var event = {
			betrieb: betrieb,
			action: action,
			page: this.page
		};
	
		if (!event.page && this.enabled) {
			throw new Error("[TA] Event is missing a page (not defined in Analytics or window.Tramino)");
		}
	
		this.sendEvents([event]);
	};
	
	/**
	 * Ein Event an das Analytics-Backend senden. 
	 * Events werden zwischengespeichert und in Paketen an den Server verschickt.
	 * Falls dieses Event bereits gesendet wurde, wird es ignoriert.
	 *
	 * @param betrieb {Number} ID des Betriebes/Clients
	 * @param action {String} Name der Aktion ([a-z]+)
	 */
	TraminoAnalytics.prototype.sendOnce = function (betrieb, action) {
		var ref_type = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
		var ref = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];
	
		var event = {
			betrieb: betrieb,
			action: action,
			page: this.page
		};
		if (ref_type && ref) {
			event.ref_type = ref_type;
			event.ref = ref;
		}
	
		if (!event.page && this.enabled) {
			throw new Error("[TA] Event is missing a page (not defined in Analytics or window.Tramino)");
		}
	
		var key = betrieb + "-" + action + "-" + page + "-" + ref_type + "-" + ref;
		if (this.sendOnceBuffer[key]) {
			return;
		}
		this.sendOnceBuffer[key] = true;
	
		this.sendEvents([event]);
	};
	
	/**
	 * Events an den Server senden
	 */
	TraminoAnalytics.prototype.sendEvents = function (items) {
		if (!this.enabled) return;
	
		var json = JSON.stringify({
			client: window.Tramino.client,
			items: items
		});
	
		/* CORS is pretty broken on IE (Surprise!), so we use fake images */
		if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.userAgent.indexOf('Trident') !== -1) {
			var url = this.api + '?json=' + encodeURIComponent(json);
	
			var img = this.$('<img>');
			img[0].onload = function () {
				img.remove();
			};
			img[0].onerror = function (e) {
				img.remove();
			};
			img.css({
				position: 'fixed',
				top: '-1000px',
				left: '-1000px',
				width: '1px',
				height: '1px'
			});
			img.attr('src', url);
		} else {
	
			this.$.ajax(this.api, {
				type: "GET",
				data: {
					json: json
				},
				dataType: "json",
				success: function success(response) {},
				error: function error(jqXHR, textStatus, errorThrown) {}
			});
		}
	};
	
	module.exports = TraminoAnalytics;

/***/ }),
/* 103 */
/***/ (function(module, exports) {

	/*
		Die Konfiguration kann über den Parameter "config" an der ReservaApp definiert werden.
		Die MiniEngine schleift diesen Parameter sauber durch.
	
		Beispiel:
		window.reservaApp = new ReservaApp({
			...
			config: {
				"PeopleStructure.ShowRoomTypes": false,
			}
		});
	
		Abruf in Template:
			<% registry(key) %>
	
		Abruf in JS-Code:
			let Registry = require('registry');
			let value = Registry.get(key)
	*/
	
	"use strict";
	
	var client = window.Tramino.client;
	
	/* PeopleStructure.js */
	var defaults = {
		/* Soll die Auswahl für mehrere Unterkünfte aktiviert werden? */
		"PeopleStructure.ShowMultiRooms": false, /* temporär deaktiviert wegen Reserva API Bug */
	
		/* Sollen die Raumtypen bei der Personenauswahl angezeigt werden? */
		"PeopleStructure.ShowRoomTypes": true,
	
		/* Kürzere Personenangabe im PeopleSelect */
		"PeopleSelect.ShortText": false,
	
		/* Kürzere Datumsangaben in DateTime.textPeriod? */
		"DateTime.ShortTextPeriod": false,
	
		/* Reserva DatePicker: Option "Flexibel" */
		"DatePicker.EnableFlexible": false,
	
		/* Nachricht in der Engine */
		"Engine.NoResultTitle": "Keine Gastgeber gefunden",
		"Engine.NoResultMessage": "",
	
		/* Engine: Suchfilter nach Kategorien ermöglichen */
		"Engine.CategorySearch": false,
	
		/* MiniEngine: Alternative TimeTable aktivieren */
		"MiniEngine.UseTimeTableYear": true,
	
		/* result-template: Basis-URL für Partner */
		"PartnerBase": window.Tramino.lang === "de" ? "/partner/" : "/" + window.Tramino.lang + "/partner/",
	
		/* Limit fürs zusammenklappen von Tag-Gruppen (engine/SidebarTemplate.html) */
		"CollapseTagGroupsTreshhold": 5,
	
		/* Kundenspezifische Einstellungen */
		"Customer": {
			Alpentraum: client == 3254 || client == 3200 || client == 10494 || client == 3255,
			Bergwelt: client == 1301,
			Wertach: client == 9350,
			Scheidegg: client == 720,
			Oberstdorf: client == 100,
			Montana: client == 1525
		}
	};
	
	if (defaults.Customer.Alpentraum) defaults["Engine.CategorySearch"] = true;
	if (defaults.Customer.Wertach || defaults.Customer.Scheidegg) defaults["PeopleStructure.ShowMultiRooms"] = true;
	if (defaults.Customer.Wertach) defaults.CollapseTagGroupsTreshhold = 99;
	if (defaults.Customer.Oberstdorf) defaults["MiniEngine.UseTimeTableYear"] = false;
	
	module.exports = defaults;

/***/ }),
/* 104 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
		/* DatePicker */
		dayNames: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
		dayNamesMin: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
		dayNamesShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
		monthNames: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
		monthNamesShort: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
	
		/* Header Cart */
		"cart": "Warenkorb",
		"product": "Produkt",
		"product_plural": "Produkte",
	
		/* Header Favs */
		"favorite": "Favorit",
		"favorite_plural": "Favoriten",
	
		/* Collectible */
		"collectible.results": "Ergebnisse",
		"collectible.of": "von",
		"next": "Weiter",
		"prev": "Zurück",
		"remove": "Entfernen",
	
		/* SortOrderTemplate */
		sort_auto: "Aktualität",
		sort_booking: "Buchbar",
		sort_stars: "Sterne",
		sort_ratings: "Bewertung",
		sort_price: "Preis",
	
		/* SidebarTemplate */
		sidebar_more: "Mehr",
	
		/* result-template */
		result_validated: "Geprüfte Qualität",
		result_book_online: "Online buchen",
		like: "gefällt mir",
		unlike: "gefällt mir nicht mehr",
		result_recommentation: "Weiterempfehlung",
		add_spa_tax: "zzgl. Kurbeitrag",
		recommentation: "Empfehlung",
		zzgl: "zzgl.",
		inkl: "inkl.",
		spatax: "Kurbeitrag",
		item_includes: "inkl. {item}",
	
		breakfast_charge: "Frühstücks-Aufschlag, ",
		halfboard_charge: "Halbpensions-Aufschlag, ",
		fullboard_charge: "Vollpensions-Aufschlag, ",
	
		/* result-error */
		result_error_title: "Eine Suche ist momentan nicht möglich.",
		result_error_subtitle: "Es gibt Probleme mit ihrer Suchanfrage:",
		reset_search: "Suche zurücksetzen",
	
		/* no-results */
		searchquery_no_result_title: "Gastgeber ”{searchQuery}“ nicht gefunden",
		searchquery_no_result_match: "Im aktuellen Suchergebnis gibt es diesen Gastgeber nicht.",
	
		favsonly_empty_title: "Keine Favoriten gefunden",
		favsonly_empty_text: "Sie haben keine Favoriten, die den aktuellen Suchbedingungen entsprechen.",
	
		/* loader-results */
		loading_text: "Einen Augenblick bitte",
	
		/* datepicker-item-info */
		datepicker_item_tip: "Tipp: Klicken Sie erst auf den Anreisetag und dann auf den Abreisetag.",
		datepicker_item_selected: "Kalender hebt verfügbare Anreisetage für »{name}« hervor.",
	
		/* datepicker-controls */
		dp_controls_mode_none: "Ohne",
		dp_controls_mode_exact: "Exakt",
		dp_controls_mode_range: "Flexibel",
		dp_controls_from: "von",
		dp_controls_to: "bis",
		date_to: "bis",
	
		/* engine/main.js */
		dd_selected_none: "Ohne Zeitraum",
		dd_select_date: "Bitte Zeitraum auswählen",
		dd_select_date_short: "Zeitraum auswählen",
	
		favorites: "Favoriten",
		one_favorite: "1 Favorit",
	
		/* FormModel.js / PeopleStructure.js */
		people_any_count: "Beliebige Personenzahl",
	
		housing_any: "Zimmer / Fewo",
		housing_room: "Zimmer",
		housing_single: "Einzelzimmer",
		housing_double: "Doppelzimmer",
		housing_flat: "Ferienwohnung",
		housing_house: "Ferienhaus / Hütte",
		housing_campsite: "Stellplatz",
	
		bedroom_count: "Schlafzimmer",
		bedroom: "Schlafzimmer",
		bedrooms: "Schlafzimmer",
	
		adult: "Erwachsener",
		adults: "Erwachsene",
		no_adults: "keine Erwachsene",
	
		no_children: "Keine Kinder",
		one_child: "1 Kind",
		children: "Kinder",
		child: "Kind",
	
		housings: "Unterkünfte",
	
		/* NightsCompressor.js */
		night: "Nacht",
		nights: "Nächte",
		at_least: "mind.",
		nights_list: "{nights} und {last_item} Nächte",
		or: "oder",
		overnight: "Übernachtungen",
		available: "Verfügbar für",
		upon_arrival: "bei Anreise am",
		min_stay: "Mindestaufenthalt",
		max: "Maximal",
		nights_available: "Nächte verfügbar",
		no_arrival: "Keine Anreise an diesem Tag möglich.",
		departure_date: "Bitte Abreisedatum auswählen",
	
		/* timetable-template */
		today: "heute",
	
		/* ratings-template */
		add_rating: "Bewertung abgeben",
	
		rating_1: "Angebot",
		rating_2: "Sauberkeit",
		rating_3: "Freundlichkeit",
		rating_4: "Weiterempfehlung",
	
		age: "Alter",
		no_ratings: "Schade, keine Bewertungen gefunden...",
	
		for_one_week: "für 1 Woche",
		for_two_weeks: "für 2 Wochen",
		for_x_days: "für {days} Tage",
	
		in_winter: "im Winter",
		in_spring: "im Frühling",
		in_summer: "im Sommer",
		in_autumn: "im Herbst",
		rated_on: "Bewertet am",
		age_range: "{from} bis {to} Jahre",
	
		"traveled_as_Single": "verreist als Single",
		"traveled_as_Paar": "verreist als Paar",
		"traveled_as_Familie": "verreist als Familie",
		"traveled_as_Freunde": "verreist als Freunde",
	
		products_and_services: "Produkte &amp; Leistungen",
	
		/* DateTime.js */
		no_date: "Kein Zeitraum",
		one_night: "1 Nacht",
		x_nights: "{nights} Nächte",
	
		/* classes-template */
		item_focused: "Angebot im Fokus",
		order: "Buchen",
		inquiry: "Anfrage",
		total_price: "Gesamtpreis",
		price_no_query: "Preis abhängig von<br/>Zeitraum und Personenzahl",
		search: "Suchen",
		packages: "Angebote",
		'package': "Angebot",
		more_offers: "Weitere Angebote",
		occupancy_plan: "Belegungsplan",
	
		results_404_title: "Keine Kategorien gefunden",
		results_404_prefix: "Suchparameter ändern oder",
		results_404_link: "ohne Zeitraum suchen",
		price_from: "ab",
	
		showUnavailableClasses: "weitere {occupiedCount} nicht verfügbare Kategorien zeigen",
	
		/* cart-items-template */
		cart_empty: "Warenkorb ist leer",
	
		more_info: 'Mehr Info'
	};

/***/ }),
/* 105 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
		/* DatePicker */
		dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
		dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
		dayNamesShort: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
		monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
		monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	
		/* Header Cart */
		"cart": "Cart",
		"product": "product",
		"product_plural": "products",
	
		/* Header Favs */
		"favorite": "favorite",
		"favorite_plural": "favorites",
	
		/* Collectible */
		"collectible.results": "Results",
		"collectible.of": "of",
		"next": "Next",
		"prev": "Previous",
		"remove": "Remove",
	
		/* SortOrderTemplate */
		sort_auto: "Best Match",
		sort_booking: "Bookable",
		sort_stars: "Stars",
		sort_ratings: "Ratings",
		sort_price: "Price",
	
		/* SidebarTemplate */
		sidebar_more: "More",
	
		/* result-template */
		result_validated: "Certified Quality",
		result_book_online: "Book online",
		like: "like",
		unlike: "unlike",
		result_recommentation: "recommendation",
		add_spa_tax: "plus spa tax",
		recommentation: "recommendation",
		"Tel.": "Phone",
		zzgl: "add",
		inkl: "incl.",
		spatax: "spa tax",
		item_includes: "incl. {item}",
	
		breakfast_charge: "breakfast fee, ",
		halfboard_charge: "half board fee, ",
		fullboard_charge: "full board fee, ",
	
		/* result-error */
		result_error_title: "The requested search failed.",
		result_error_subtitle: "Theres a problem with your search:",
		reset_search: "Reset search",
	
		/* no-results */
		no_result_title: "Host ”{searchQuery}“ not found",
		no_result_match: "No host with this name in the current search results.",
	
		favsonly_empty_title: "No favorites found",
		favsonly_empty_text: "You have no favorites which match the current search filters.",
	
		/* loader-results */
		loading_text: "Finding the best accommodation for you...",
	
		/* datepicker-item-info */
		datepicker_item_tip: "Tip: Click first on the arrival date, then the departure date.",
		datepicker_item_selected: "Calender highlights valid arrival days for »{name}«.",
	
		/* datepicker-controls */
		dp_controls_mode_none: "None",
		dp_controls_mode_exact: "Exact",
		dp_controls_mode_range: "Flexible",
		dp_controls_from: "from",
		dp_controls_to: "to",
		date_to: "-",
	
		/* engine/main.js */
		dd_selected_none: "No date selected",
		dd_select_date: "Please select date",
		dd_select_date_short: "Select date",
	
		favorites: "Favorites",
		one_favorite: "1 favorite",
	
		/* FormModel.js */
		people_any_count: "No people selected",
	
		housing_any: "Room / Apartment",
		housing_room: "Any Room",
		housing_single: "Single room",
		housing_double: "Double room",
		housing_flat: "Holiday flat",
		housing_house: "Holiday house / Lodge",
		housing_campsite: "Campsite",
	
		bedroom_count: "Num. bedrooms",
		bedroom: "bedroom",
		bedrooms: "bedrooms",
	
		adult: "adult",
		adults: "adults",
		no_adults: "no adults",
		child: "child",
	
		no_children: "No children",
		one_child: "1 child",
		children: "children",
	
		housings: "housings",
	
		/* NightsCompressor.js */
		night: "night",
		nights: "nights",
		at_least: "min.",
		nights_list: "{nights} and {last_item} nights",
		or: "or",
		overnight: "Overnight stays",
		available: "Available for",
		upon_arrival: "upon arrival on",
		min_stay: "Minimum stay",
		max: "Maximum",
		nights_available: "nights available",
		no_arrival: "No arrival possible on this day.",
		departure_date: "Please select departure date",
	
		/* timetable-template */
		today: "today",
	
		/* ratings-template */
		add_rating: "Write rating",
	
		rating_1: "Offerings",
		rating_2: "Tidyiness",
		rating_3: "Friendliness",
		rating_4: "Recommendation",
	
		age: "Age",
		no_ratings: "Sorry, no ratings yet...",
	
		for_one_week: "For 1 week",
		for_two_weeks: "For 2 weeks",
		for_x_days: "For {days} days",
	
		in_winter: "In winter",
		in_spring: "In spring",
		in_summer: "In summer",
		in_autumn: "In autumn",
		rated_on: "Rated on",
		age_range: "{from} - {to} years",
	
		"traveled_as_Single": "travelled as single",
		"traveled_as_Paar": "travelled as couple",
		"traveled_as_Familie": "travelled as family",
		"traveled_as_Freunde": "travelled as friends",
	
		products_and_services: "Products &amp; Services",
	
		/* DateTime.js */
		no_date: "Nos‚election",
		one_night: "1 night",
		x_nights: "{nights} nights",
	
		/* classes-template */
		item_focused: "Angebot in focus",
		order: "Order now",
		inquiry: "Inquiry",
		total_price: "Total",
		price_no_query: "Price depends on<br/>date and people",
		search: "Search",
		packages: "Offers",
		'package': "Offer",
		more_offers: "More Offers",
		occupancy_plan: "Occupancy Plan",
	
		results_404_title: "No categories found",
		results_404_prefix: "Change search parameters or",
		results_404_link: "search without date",
		price_from: "from",
	
		showUnavailableClasses: "show {occupiedCount} not available room categories",
	
		/* cart-items-template */
		cart_empty: "Cart is empty",
	
		more_info: 'More information'
	};

/***/ }),
/* 106 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
		/* DatePicker */
		dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
		dayNamesMin: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
		dayNamesShort: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
		monthNames: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
		monthNamesShort: ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Jui', 'Jui', 'Aoû', 'Sep', 'Oct', 'Nov', 'Déc'],
	
		/* Header Cart */
		"cart": "Panier",
		"product": "produit",
		"product_plural": "produits",
	
		/* Header Favs */
		"favorite": "favori",
		"favorite_plural": "favoris",
	
		/* Collectible */
		"collectible.results": "Résultat",
		"collectible.of": "de",
		"next": "suivant",
		"prev": "précédent",
		"remove": "vider",
	
		/* SortOrderTemplate */
		sort_auto: "actuel",
		sort_booking: "réservable",
		sort_stars: "étoiles",
		sort_ratings: "avis",
		sort_price: "prix",
	
		/* SidebarTemplate */
		sidebar_more: "plus",
	
		/* result-template */
		result_validated: "Qualité vérifiée",
		result_book_online: "réservation en ligne",
		like: "J´aime",
		unlike: "Je n´aime pas",
		result_recommentation: "recommandation",
		add_spa_tax: "plus taxe de séjour",
		recommentation: "recommandation",
	
		/* result-error */
		result_error_title: "La recherche est erronée",
		result_error_subtitle: "Il y a un problème avec votre demande:",
		reset_search: "Annuler la recherche",
	
		/* no-results */
		no_result_title: "Hôte “{searchQuery}“ pas trouvé",
		no_result_match: "Aucun hôte trouvé selon vos critères.",
	
		favsonly_empty_title: "Aucun résultat trouvé",
		favsonly_empty_text: "Aucun résultat avec les critères selectionnés",
	
		/* loader-results */
		loading_text: "résultats en cours de téléchargement",
	
		/* datepicker-item-info */
		datepicker_item_tip: "Conseil: cliques en 1er sur la date d´arrivée puis sur la date de départ",
		datepicker_item_selected: "sorti par dates d´arrivée pour »{name}«",
	
		/* datepicker-controls */
		dp_controls_mode_none: "Aucune",
		dp_controls_mode_exact: "Exacte",
		dp_controls_mode_range: "Flexible",
		dp_controls_from: "du",
		dp_controls_to: "au",
		date_to: "-",
	
		/* engine/main.js */
		dd_selected_none: "Dates",
		dd_select_date: "Dates de séjour",
		dd_select_date_short: "Dates de séjour",
	
		favorites: "Favoris",
		one_favorite: "1 favoris",
	
		/* FormModel.js */
		people_any_count: "Personnes",
	
		housing_any: "Chambre / Appartement",
		housing_room: "Chambre",
		housing_single: "Chambre simple",
		housing_double: "Chambre double",
		housing_flat: "Appartement",
		housing_house: "Maison / Chalet",
		housing_campsite: "Parking",
	
		bedroom_count: "Num. chambres",
		bedroom: "chambre",
		bedrooms: "chambres",
	
		adult: "adulte",
		adults: "adultes",
		no_adults: "Pas d´ adultes",
		child: "enfant",
	
		no_children: "Pas d´ enfant",
		one_child: "1 enfant",
		children: "enfants",
	
		housings: "housings",
	
		/* NightsCompressor.js */
		night: "nuit",
		nights: "nuits",
		at_least: "min.",
		nights_list: "{nights} et {last_item} nuits",
		or: "ou",
		overnight: "Nuitées",
		available: "Disponible pour",
		upon_arrival: "à l'arrivée le",
		min_stay: "Durée de séjour minimum",
		max: "Maximum",
		nights_available: "Nuitées disponibles",
		no_arrival: "Aucune arrivée possible ce jour là.",
		departure_date: "Veuillez sélectionner la date de départ",
	
		/* timetable-template */
		today: "today",
	
		/* ratings-template */
		add_rating: "Bewertung schreiben",
	
		rating_1: "Offre",
		rating_2: "Propreté",
		rating_3: "Gentillesse",
		rating_4: "Je recommande",
	
		age: "Âge",
		no_ratings: "Dommage, aucun avis trouvé",
	
		for_one_week: "pour 1 semaine",
		for_two_weeks: "pour 2 semaines",
		for_x_days: "pour {days} hours",
	
		in_winter: "en hiver",
		in_spring: "au printemps",
		in_summer: "en été",
		in_autumn: "en automne",
		rated_on: "commenté le",
		age_range: "{from} jusqu´en {to} année",
	
		"traveled_as_Single": "Voyage tout seul",
		"traveled_as_Paar": "Voyage en couple",
		"traveled_as_Familie": "Voyage en famille",
		"traveled_as_Freunde": "Voyage avec des amis",
		products_and_services: "produits &amp; services",
	
		/* DateTime.js */
		no_date: "Dates",
		one_night: "1 nuit",
		x_nights: "{nights} nuits",
	
		/* classes-template */
		item_focused: "actuel Offre",
		order: "Réserver maintenant",
		inquiry: "Demande de réservation",
		total_price: "Prix total",
		price_no_query: "Prix selon dates et nombre de personnes",
		search: "Chercher",
		packages: "Offres",
		'package': "Offre",
		more_offers: "Plus d'Offres",
		occupancy_plan: "Plan d'Occupation",
	
		results_404_title: "pas de catégorie trouvée",
		results_404_prefix: "Changer les critères ou",
		results_404_link: "chercher sans dates",
		price_from: "À partir",
	
		/* cart-items-template */
		cart_empty: "La corbeille est vide"
	};

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Integriert die SiteSearch auf jede Oberstdorf-Seite
	 */
	
	'use strict';
	
	var $ = __webpack_require__(6);
	var TraminoSiteSearch = __webpack_require__(82);
	
	module.exports = function () {
		window.SiteSearch = new TraminoSiteSearch({
			api: '/api/search/',
			template_id: 'sitesearch-template',
			render_to: 'sitesearch-result'
		});
	
		var form = $('#header_search form');
		var input = $('#header_search input[type=text]');
		//var results = $('#sitesearch-result');
	
		var searching = false;
		var doSearch = function doSearch(e) {
			e.preventDefault();
			if (searching) return;
	
			var data = _.object(form.serializeArray().map(function (v) {
				return [v.name, v.value];
			}));
	
			if (data.query.length >= 3 || data.query === "N6" || data.query === "n6") {
				searching = true;
	
				SiteSearch.search(data).then(function () {
					//results.hide().fadeIn(100);
					setTimeout(function () {
						searching = false;
					}, 100);
				});
			}
		};
	
		input.on('keyup', _.debounce(doSearch, 1500));
		form.on('submit', doSearch);
	};

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// reserva.min.js